webpackJsonp([1],{

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0gU3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+jO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ljW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/thumbupload.103d58c.jpg";

/***/ }),

/***/ "CAEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N2ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/lodash.defaultsdeep/index.js
var lodash_defaultsdeep = __webpack_require__("nYKV");
var lodash_defaultsdeep_default = /*#__PURE__*/__webpack_require__.n(lodash_defaultsdeep);

// EXTERNAL MODULE: ./node_modules/fullcalendar/dist/fullcalendar.js
var fullcalendar = __webpack_require__("olwm");
var fullcalendar_default = /*#__PURE__*/__webpack_require__.n(fullcalendar);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-full-calendar/components/FullCalendar.vue







/* harmony default export */ var FullCalendar = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(toConsumableArray_default()(args)));
                },
                viewRender: function viewRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['view-render'].concat(toConsumableArray_default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(toConsumableArray_default()(args)));
                },
                eventMouseover: function eventMouseover() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-mouseover'].concat(toConsumableArray_default()(args)));
                },
                eventMouseout: function eventMouseout() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-mouseout'].concat(toConsumableArray_default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(toConsumableArray_default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                        args[_key7] = arguments[_key7];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(toConsumableArray_default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                        args[_key8] = arguments[_key8];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(toConsumableArray_default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                        args[_key9] = arguments[_key9];
                    }

                    self.$emit.apply(self, ['day-click'].concat(toConsumableArray_default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = jquery_default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                jquery_default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                jquery_default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            jquery_default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            jquery_default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            jquery_default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            jquery_default()(_this.$el).fullCalendar('removeEvents');
            jquery_default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            jquery_default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                jquery_default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(lodash_defaultsdeep_default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = jquery_default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                jquery_default()(this.$el).fullCalendar('removeEvents');
                jquery_default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e9886e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-full-calendar/components/FullCalendar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FullCalendar = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-full-calendar/components/FullCalendar.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FullCalendar,
  components_FullCalendar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_full_calendar_components_FullCalendar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/localforage/dist/localforage.js
var localforage = __webpack_require__("22C0");
var localforage_default = /*#__PURE__*/__webpack_require__.n(localforage);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/the-navigation.vue

//



/* harmony default export */ var the_navigation = ({
  mounted: function mounted() {
    $('.dropdown-button').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false,
      hover: true,
      gutter: 0,
      belowOrigin: false,
      alignment: 'right',
      stopPropagation: false
    });

    $('#toggle-sidebar').sideNav();
    $('#sidebar .item-sidebar').click(function () {
      if (!$(this).hasClass('active')) {
        $('#sidebar .item-sidebar').removeClass('active');
        $(this).addClass('active');
        $('#sidebar .collapsible-body').slideUp();
        $('.rotatearrow').html('keyboard_arrow_down');
        $('.collapsible-body', this).slideDown();
        $('.rotatearrow', this).html('keyboard_arrow_right');
      }
    });

    $('#sidebar .item-unico').click(function () {
      $('#sidebar .item-sidebar').removeClass('active');
      $(this).addClass('active');
      $('#sidebar .collapsible-body').slideUp();
      $('.collapsible-body ul li').removeClass('active');
      $('.rotatearrow').html('keyboard_arrow_down');
    });

    $('.collapsible-body ul li').click(function () {
      $('.collapsible-body ul li').removeClass('active');
      $(this).addClass('active');
    });

    $('#sidebar .to').click(function () {
      $('#sidebar .item-unico').removeClass('active');
      $('#toggle-sidebar').sideNav('hide');
    });
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nome', 'sobrenome', 'email', 'imagem', 'permissoes']), {
    showNav: function showNav() {
      return this.$route.name !== 'auth.index' && this.$route.name !== 'auth.recuperar-senha' && this.$route.name !== 'auth.redefinir-senha';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['removeToken']), {
    logout: function logout() {
      var _this = this;

      localforage_default.a.removeItem('token').then(function () {
        localforage_default.a.removeItem('imagem');
        localforage_default.a.removeItem('permissoes');
        _this.removeToken();
        _this.$router.push({ name: 'auth.index' });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd4bd31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/the-navigation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],staticClass:"nav-extended"},[_c('div',{staticClass:"nav-wrapper col s12"},[_c('router-link',{staticClass:"brand-logo center",attrs:{"to":{ name: 'dashboard' }}},[_c('img',{attrs:{"src":__webpack_require__("iQH9")}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"right hide-on-med-and-down",attrs:{"id":"nav-mobile"}},[_c('li',[_c('div',{staticClass:"avatar"},[(_vm.imagem)?_c('img',{staticClass:"circle dropdown-button responsive-img",attrs:{"src":_vm.imagem,"data-activates":"drop-avatar"}}):_vm._e(),_vm._v(" "),(!_vm.imagem)?_c('img',{staticClass:"circle dropdown-button responsive-img",attrs:{"src":__webpack_require__("0gU3"),"data-activates":"drop-avatar"}}):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"dropdown-content z-depth-3",attrs:{"id":"drop-avatar"}},[_c('li',[_c('router-link',{staticClass:"green-text text-darken-3",attrs:{"to":{ name: 'usuarios.perfil' }}},[_vm._v("Meu Perfil")])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"green-text text-darken-3",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v("Sair")])])])])])],1)]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],staticClass:"side-nav",attrs:{"id":"sidebar"}},[_c('li',{staticClass:"hide-on-med-and-down"},[_c('div',{staticClass:"user-view"},[_vm._m(1),_vm._v(" "),(_vm.imagem)?_c('img',{staticClass:"circle",attrs:{"src":_vm.imagem}}):_vm._e(),_vm._v(" "),(!_vm.imagem)?_c('img',{staticClass:"circle",attrs:{"src":__webpack_require__("0gU3")}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"white-text name"},[_vm._v(_vm._s(_vm.nome)+" "+_vm._s(_vm.sobrenome))]),_vm._v(" "),_c('span',{staticClass:"white-text email"},[_vm._v(_vm._s(_vm.email))])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('ata.visualizar') > -1),expression:"permissoes.indexOf('ata.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'atas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" ATA's")])],1),_vm._v(" "),_c('li',{staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")]),_vm._v(" Home")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cliente.visualizar') > -1 || _vm.permissoes.indexOf('como-conheceu.visualizar') > -1),expression:"permissoes.indexOf('cliente.visualizar') > -1 || permissoes.indexOf('como-conheceu.visualizar') > -1"}],staticClass:"item-sidebar"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('ul',[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cliente.visualizar') > -1),expression:"permissoes.indexOf('cliente.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'clientes.index' }}},[_vm._v("Clientes")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('como-conheceu.visualizar') > -1),expression:"permissoes.indexOf('como-conheceu.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'como-conheceu.index' }}},[_vm._v("Como Conheceu")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cargo.visualizar') > -1),expression:"permissoes.indexOf('cargo.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'cargos.index' }}},[_vm._v("Cargos")])],1)])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('fornecedor.visualizar') > -1),expression:"permissoes.indexOf('fornecedor.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'fornecedores.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Fornecedores")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('arte.visualizar') > -1),expression:"permissoes.indexOf('arte.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'artes.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("insert_photo")]),_vm._v(" Artes")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tipo-estabelecimento.visualizar') > -1),expression:"permissoes.indexOf('tipo-estabelecimento.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'tipos-estabelecimento.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("build")]),_vm._v(" Tipos de Estabelecimento")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-conta.visualizar') > -1 || _vm.permissoes.indexOf('financeiro-categoria.visualizar') > -1 || _vm.permissoes.indexOf('financeiro-forma.visualizar') > -1 || _vm.permissoes.indexOf('financeiro-pagar.visualizar') > -1 || _vm.permissoes.indexOf('financeiro-receber.visualizar') > -1 || _vm.permissoes.indexOf('financeiro-extrato.visualizar') > -1),expression:"permissoes.indexOf('financeiro-conta.visualizar') > -1 || permissoes.indexOf('financeiro-categoria.visualizar') > -1 || permissoes.indexOf('financeiro-forma.visualizar') > -1 || permissoes.indexOf('financeiro-pagar.visualizar') > -1 || permissoes.indexOf('financeiro-receber.visualizar') > -1 || permissoes.indexOf('financeiro-extrato.visualizar') > -1"}],staticClass:"item-sidebar"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('ul',[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-extrato.visualizar') > -1),expression:"permissoes.indexOf('financeiro-extrato.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'financeiro-extrato.index' }}},[_vm._v("Extrato")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-pagar.visualizar') > -1),expression:"permissoes.indexOf('financeiro-pagar.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'financeiro-pagar.index' }}},[_vm._v("Contas a Pagar")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-receber.visualizar') > -1),expression:"permissoes.indexOf('financeiro-receber.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'financeiro-receber.index' }}},[_vm._v("Contas a Receber")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-categoria.visualizar') > -1),expression:"permissoes.indexOf('financeiro-categoria.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'financeiro-categorias.index' }}},[_vm._v("Cadastros :: Categorias")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-conta.visualizar') > -1),expression:"permissoes.indexOf('financeiro-conta.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'financeiro-contas.index' }}},[_vm._v("Cadastros :: Contas Bancárias")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-conta.visualizar') > -1),expression:"permissoes.indexOf('financeiro-conta.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'financeiro-formas.index' }}},[_vm._v("Cadastros :: Formas de Pagamento")])],1)])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('contato.visualizar') > -1 || _vm.permissoes.indexOf('contato.visualizar') > -1 || _vm.permissoes.indexOf('contato.visualizar') > -1 || _vm.permissoes.indexOf('os.visualizar') > -1 || _vm.permissoes.indexOf('venda.visualizar') > -1 || _vm.permissoes.indexOf('compra.visualizar') > -1 || _vm.permissoes.indexOf('revisao-tipo.visualizar') > -1 || _vm.permissoes.indexOf('canal.visualizar') > -1),expression:"permissoes.indexOf('contato.visualizar') > -1 || permissoes.indexOf('contato.visualizar') > -1 || permissoes.indexOf('contato.visualizar') > -1 || permissoes.indexOf('os.visualizar') > -1 || permissoes.indexOf('venda.visualizar') > -1 || permissoes.indexOf('compra.visualizar') > -1 || permissoes.indexOf('revisao-tipo.visualizar') > -1 || permissoes.indexOf('canal.visualizar') > -1"}],staticClass:"item-sidebar"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('ul',[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('contato.visualizar') > -1),expression:"permissoes.indexOf('contato.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'contatos.index' }}},[_vm._v("Contatos")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento.visualizar') > -1),expression:"permissoes.indexOf('orcamento.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'orcamentos.index' }}},[_vm._v("Orçamentos")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.visualizar') > -1),expression:"permissoes.indexOf('os.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'os.index' }}},[_vm._v("OS's")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('revisao-tipo.visualizar') > -1),expression:"permissoes.indexOf('revisao-tipo.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'revisao-tipos.index' }}},[_vm._v("Tipos de revisão :: OS's")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('compra.visualizar') > -1),expression:"permissoes.indexOf('compra.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'compras.index' }}},[_vm._v("Compras")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('venda.visualizar') > -1),expression:"permissoes.indexOf('venda.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'vendas.index' }}},[_vm._v("Vendas")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('canal.visualizar') > -1),expression:"permissoes.indexOf('canal.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'canais.index' }}},[_vm._v("Canais de Vendas")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento-pagamento.visualizar') > -1),expression:"permissoes.indexOf('orcamento-pagamento.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'orcamentos-pagamentos.index' }}},[_vm._v("Cadastros :: Pagamento")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('motivo.visualizar') > -1),expression:"permissoes.indexOf('motivo.visualizar') > -1"}]},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'motivos.index' }}},[_vm._v("Motivos de Recusa")])],1)])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('equipamento.visualizar') > -1),expression:"permissoes.indexOf('equipamento.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'equipamentos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("build")]),_vm._v(" Equipamentos")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('produto.visualizar') > -1),expression:"permissoes.indexOf('produto.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'produtos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("shopping_cart")]),_vm._v(" Produtos")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('estoque.visualizar') > -1),expression:"permissoes.indexOf('estoque.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'estoque.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("move_to_inbox")]),_vm._v(" Estoque")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('grupo.visualizar') > -1),expression:"permissoes.indexOf('grupo.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'grupos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Grupos de Serviço")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('servico.visualizar') > -1),expression:"permissoes.indexOf('servico.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'servicos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Serviços")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('objetivo.visualizar') > -1),expression:"permissoes.indexOf('objetivo.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'objetivos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Objetivos")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tarefa.visualizar') > -1),expression:"permissoes.indexOf('tarefa.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'tarefas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle_outline")]),_vm._v(" Tarefas")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('marca.visualizar') > -1),expression:"permissoes.indexOf('marca.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'marcas.index' }}},[_c('i',{staticClass:"material-icons"}),_vm._v(" Marcas")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('familia.visualizar') > -1),expression:"permissoes.indexOf('familia.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'familias.index' }}},[_c('i',{staticClass:"material-icons"}),_vm._v(" Famílias")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('viatura.visualizar') > -1),expression:"permissoes.indexOf('viatura.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'viaturas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("directions_car")]),_vm._v(" Viaturas")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('reclamacao.visualizar') > -1),expression:"permissoes.indexOf('reclamacao.visualizar') > -1"}],staticClass:"item-unico"},[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'reclamacoes.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("description")]),_vm._v(" Área de Reclamação")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('usuario.visualizar') > -1),expression:"permissoes.indexOf('usuario.visualizar') > -1"}],staticClass:"item-sidebar"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('ul',[_c('li',[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'usuarios.index' }}},[_vm._v("Usuários")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'perfis.index' }}},[_vm._v("Perfis")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"to",attrs:{"to":{ name: 'usuarios-logs.index' }}},[_vm._v("Logs")])],1)])])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',{staticClass:"item-sidebar"},[_c('router-link',{attrs:{"to":{ name: 'usuarios.perfil' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_vm._v(" Meu Perfil")])],1),_vm._v(" "),_c('li',{staticClass:"item-sidebar"},[_c('a',{staticClass:"waves-effect",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("power_settings_new")]),_vm._v(" Sair")])]),_vm._v(" "),_vm._m(6)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"left"},[_c('li',[_c('a',{staticClass:"green-text text-darken-3",attrs:{"href":"#","data-activates":"sidebar","id":"toggle-sidebar"}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('img',{attrs:{"src":__webpack_require__("xvOB")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"waves-effect"},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Clientes "),_c('i',{staticClass:"material-icons right rotatearrow"},[_vm._v("keyboard_arrow_down")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"waves-effect"},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_money")]),_vm._v(" Financeiro "),_c('i',{staticClass:"material-icons right rotatearrow"},[_vm._v("keyboard_arrow_down")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"waves-effect"},[_c('i',{staticClass:"material-icons"},[_vm._v("build")]),_vm._v(" Operação "),_c('i',{staticClass:"material-icons right rotatearrow"},[_vm._v("keyboard_arrow_down")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"waves-effect"},[_c('i',{staticClass:"material-icons"},[_vm._v("person_pin")]),_vm._v(" Usuários "),_c('i',{staticClass:"material-icons right rotatearrow"},[_vm._v("keyboard_arrow_down")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"item-sidebar"},[_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("versão 1.3")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_the_navigation = (esExports);
// CONCATENATED MODULE: ./src/the-navigation.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  the_navigation,
  selectortype_template_index_0_src_the_navigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_the_navigation = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sweet-erro.vue
//

/* harmony default export */ var sweet_erro = ({
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('sweet-erro', function (obj) {
      var message = obj.message;

      _this.$swal({
        title: 'Ops, encontramos um erro!',
        html: message,
        type: 'error',
        cancelButtonText: 'Ok'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e1752d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sweet-erro.vue
var sweet_erro_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var sweet_erro_staticRenderFns = []
var sweet_erro_esExports = { render: sweet_erro_render, staticRenderFns: sweet_erro_staticRenderFns }
/* harmony default export */ var components_sweet_erro = (sweet_erro_esExports);
// CONCATENATED MODULE: ./src/components/sweet-erro.vue
var sweet_erro_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sweet_erro___vue_template_functional__ = false
/* styles */
var sweet_erro___vue_styles__ = null
/* scopeId */
var sweet_erro___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sweet_erro___vue_module_identifier__ = null
var sweet_erro_Component = sweet_erro_normalizeComponent(
  sweet_erro,
  components_sweet_erro,
  sweet_erro___vue_template_functional__,
  sweet_erro___vue_styles__,
  sweet_erro___vue_scopeId__,
  sweet_erro___vue_module_identifier__
)

/* harmony default export */ var src_components_sweet_erro = (sweet_erro_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/the-container.vue

//





/* harmony default export */ var the_container = ({
  name: 'TheContainer',
  components: {
    TheNavigation: src_the_navigation,
    TheErro: src_components_sweet_erro
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a22e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/the-container.vue
var the_container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"progress loading-geral"},[_c('div',{staticClass:"indeterminate green"})]),_vm._v(" "),_c('the-navigation'),_vm._v(" "),_c('the-erro'),_vm._v(" "),_c('transition',{attrs:{"name":"vux-pop-out"}},[_c('router-view')],1)],1)}
var the_container_staticRenderFns = []
var the_container_esExports = { render: the_container_render, staticRenderFns: the_container_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_the_container = (the_container_esExports);
// CONCATENATED MODULE: ./src/the-container.vue
function injectStyle (ssrContext) {
  __webpack_require__("CAEg")
}
var the_container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var the_container___vue_template_functional__ = false
/* styles */
var the_container___vue_styles__ = injectStyle
/* scopeId */
var the_container___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var the_container___vue_module_identifier__ = null
var the_container_Component = the_container_normalizeComponent(
  the_container,
  selectortype_template_index_0_src_the_container,
  the_container___vue_template_functional__,
  the_container___vue_styles__,
  the_container___vue_scopeId__,
  the_container___vue_module_identifier__
)

/* harmony default export */ var src_the_container = (the_container_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/jwt-decode/lib/index.js
var lib = __webpack_require__("ytdl");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/store/index.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  strict: "production" !== 'production',
  state: {
    token: null,
    imagem: null,
    permissoes: null,
    loading: false
  },
  actions: {
    setToken: function setToken(_ref, obj) {
      var commit = _ref.commit;

      commit('SET_TOKEN', obj);
    },
    setPermissoes: function setPermissoes(_ref2, obj) {
      var commit = _ref2.commit;

      commit('SET_PERMISSOES', obj);
    },
    removeToken: function removeToken(_ref3) {
      var commit = _ref3.commit;

      commit('REMOVE_TOKEN');
    },
    setImagem: function setImagem(_ref4, obj) {
      var commit = _ref4.commit;

      commit('SET_IMAGEM', obj);
    },
    setLoading: function setLoading(_ref5, obj) {
      var commit = _ref5.commit;

      commit('SET_LOADING', obj);
    }
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, obj) {
      state.token = obj.token;
    },
    SET_PERMISSOES: function SET_PERMISSOES(state, obj) {
      state.permissoes = obj.permissoes;
    },
    REMOVE_TOKEN: function REMOVE_TOKEN(state) {
      state.token = null;
      state.permissoes = null;
      state.imagem = null;
    },
    SET_IMAGEM: function SET_IMAGEM(state, obj) {
      state.imagem = obj.imagem;
    },
    SET_LOADING: function SET_LOADING(state, obj) {
      state.loading = obj.loading;
    }
  },
  getters: {
    email: function email(state) {
      var token = state.token;

      if (token != null) {
        var decoded = lib_default()(token);
        return decoded.user.email;
      }
      return '';
    },
    imagem: function imagem(state) {
      var imagem = state.imagem;

      if (imagem) {
        return "https://sistemakgb.com.br/uploads" + '/usuarios/' + imagem;
      }
      return '';
    },
    nome: function nome(state) {
      var token = state.token;

      if (token != null) {
        var decoded = lib_default()(token);
        return decoded.user.nome;
      }
      return '';
    },
    sobrenome: function sobrenome(state) {
      var token = state.token;

      if (token != null) {
        var decoded = lib_default()(token);
        return decoded.user.sobrenome;
      }
      return '';
    },
    permissoes: function permissoes(state) {
      var permissoes = state.permissoes;

      if (permissoes != null) {
        var decoded = lib_default()(permissoes);
        return decoded.permissoes;
      }
      return '';
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/plugins/event-bus.js



var bus = new vue_esm["a" /* default */]();



function install(Vue) {
  Object.defineProperty(Vue.prototype, '$bus', {
    get: function get() {
      return bus;
    }
  });
}
// CONCATENATED MODULE: ./src/service/http.js





var http__this = this;







var http = axios_default.a.create({
  baseURL: "https://sistemakgb.com.br/v1"
});

var http_setLoading = function setLoading(state) {
  store.dispatch('setLoading', { loading: state });
};

var interceptRequest = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(config) {
    var token;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            http_setLoading(true);
            _context.next = 3;
            return localforage_default.a.getItem('token');

          case 3:
            token = _context.sent;

            config.headers.common['Authorization'] = token;
            return _context.abrupt('return', config);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, http__this);
  }));

  return function interceptRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();
var http_interceptRequestError = function interceptRequestError(error) {
  http_setLoading(false);
  promise_default.a.reject(error);
};

var interceptResponse = function interceptResponse(response) {
  http_setLoading(false);
  return response;
};

var http_interceptResponseError = function interceptResponseError(error) {
  var message = error.message;

  if (error.response != null) {
    if (error.response.status === 401) {
      src_router.push({ name: 'dashboard', query: { forbidden: true } });
    }
    if (error.response.status === 403) {
      localforage_default.a.removeItem('token').then(function () {
        src_router.push({ name: 'auth.index', query: { expired: true } });
      });
    }
    var response = error.response.data;
    if (response.message === 'Token has expired') {
      localforage_default.a.removeItem('token').then(function () {
        src_router.push({ name: 'auth.index', query: { expired: true } });
      });
    }
    message = response.message + '<br />';
    if (response.errors != null && typeof_default()(response.errors) === 'object') {
      for (var m in response.errors) {
        message += response.errors[m] + '<br />';
      }
    }
  }

  bus.$emit('sweet-erro', {
    message: message
  });
  http_setLoading(false);
  return promise_default.a.reject(error);
};

http.interceptors.request.use(interceptRequest, http_interceptRequestError);
http.interceptors.response.use(interceptResponse, http_interceptResponseError);

/* harmony default export */ var service_http = (http);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/index.vue



//






/* harmony default export */ var auth = ({
  name: 'Auth',
  mounted: function mounted() {
    if (window.location.hash.indexOf('expired=true') > -1) {
      this.$bus.$emit('sweet-erro', {
        message: 'Token expirado, faça login novamente'
      });
    }
  },
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setToken', 'setPermissoes', 'setImagem']), {
    login: function login() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var email, password, response, token, permissoes, decoded, imagem;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                email = _this.email, password = _this.password;
                _context.next = 4;
                return service_http.post('/auth/login', { email: email, password: password });

              case 4:
                response = _context.sent;
                token = response.data.token;
                permissoes = response.data.permissoes;
                decoded = lib_default()(token);
                imagem = decoded.user.imagem;

                if (imagem) {
                  localforage_default.a.setItem('imagem', imagem);
                }
                localforage_default.a.setItem('permissoes', permissoes);
                localforage_default.a.setItem('token', token).then(function (token) {
                  _this.setToken({ token: token });
                  _this.setPermissoes({ permissoes: permissoes });
                  _this.setImagem({ imagem: imagem });
                  _this.$router.push({ name: 'dashboard' });
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 14]]);
      }))();
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2454dbe6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/index.vue
var auth_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-login"},[_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s10 offset-s1 m6 offset-m3 l4 offset-l4"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_c('div',{staticClass:"card white",staticStyle:{"background":"rgba(255,255,255,0.90) !important"}},[_c('div',{staticClass:"card-content center-align"},[_c('img',{attrs:{"src":__webpack_require__("UDbD")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('span',{staticClass:"card-title center-align"},[_vm._v("Entre com seu e-mail e senha")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","id":"email","required":"required","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","id":"password","required":"required"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 center-align"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("Entrar")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 right-align"},[_c('router-link',{attrs:{"to":{ name: 'auth.recuperar-senha' }}},[_vm._v("esqueci minha senha")])],1)])])])])])])])}
var auth_staticRenderFns = []
var auth_esExports = { render: auth_render, staticRenderFns: auth_staticRenderFns }
/* harmony default export */ var features_auth = (auth_esExports);
// CONCATENATED MODULE: ./src/features/auth/index.vue
function auth_injectStyle (ssrContext) {
  __webpack_require__("dxl2")
}
var auth_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var auth___vue_template_functional__ = false
/* styles */
var auth___vue_styles__ = auth_injectStyle
/* scopeId */
var auth___vue_scopeId__ = "data-v-2454dbe6"
/* moduleIdentifier (server only) */
var auth___vue_module_identifier__ = null
var auth_Component = auth_normalizeComponent(
  auth,
  features_auth,
  auth___vue_template_functional__,
  auth___vue_styles__,
  auth___vue_scopeId__,
  auth___vue_module_identifier__
)

/* harmony default export */ var src_features_auth = (auth_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/recuperar-senha.vue



//




/* harmony default export */ var recuperar_senha = ({
  name: 'RecuperarSenha',
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    recuperarSenha: function recuperarSenha() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var email;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                email = _this.email;
                _context.next = 3;
                return service_http.post('/auth/esqueci-senha', { email: email });

              case 3:
                window.Materialize.toast('Link para redefinir senha enviado por e-mail!', 4000);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-832760a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/recuperar-senha.vue
var recuperar_senha_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-login"},[_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s10 offset-s1 m6 offset-m3 l4 offset-l4"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.recuperarSenha()}}},[_c('div',{staticClass:"card white",staticStyle:{"background":"rgba(255,255,255,0.90) !important"}},[_c('div',{staticClass:"card-content center-align"},[_c('img',{attrs:{"src":__webpack_require__("UDbD")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('span',{staticClass:"card-title center-align"},[_vm._v("Entre com seu e-mail de cadastro")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","required":"required"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 center-align"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("Redefinir Senha")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 right-align"},[_c('router-link',{attrs:{"to":{ name: 'auth.index' }}},[_vm._v("fazer login")])],1)])])])])])])])}
var recuperar_senha_staticRenderFns = []
var recuperar_senha_esExports = { render: recuperar_senha_render, staticRenderFns: recuperar_senha_staticRenderFns }
/* harmony default export */ var auth_recuperar_senha = (recuperar_senha_esExports);
// CONCATENATED MODULE: ./src/features/auth/recuperar-senha.vue
function recuperar_senha_injectStyle (ssrContext) {
  __webpack_require__("4+jO")
}
var recuperar_senha_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recuperar_senha___vue_template_functional__ = false
/* styles */
var recuperar_senha___vue_styles__ = recuperar_senha_injectStyle
/* scopeId */
var recuperar_senha___vue_scopeId__ = "data-v-832760a6"
/* moduleIdentifier (server only) */
var recuperar_senha___vue_module_identifier__ = null
var recuperar_senha_Component = recuperar_senha_normalizeComponent(
  recuperar_senha,
  auth_recuperar_senha,
  recuperar_senha___vue_template_functional__,
  recuperar_senha___vue_styles__,
  recuperar_senha___vue_scopeId__,
  recuperar_senha___vue_module_identifier__
)

/* harmony default export */ var features_auth_recuperar_senha = (recuperar_senha_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/redefinir-senha.vue



//






/* harmony default export */ var redefinir_senha = ({
  name: 'RedefinirSenha',
  mounted: function mounted() {
    this.hash = this.$router.currentRoute.query.hash;
    this.email = this.$router.currentRoute.query.email;
  },
  data: function data() {
    return {
      email: '',
      password: '',
      hash: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setToken', 'setPermissoes', 'setImagem']), {
    login: function login() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var email, password, hash, response, token, permissoes, decoded, imagem;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                email = _this.email, password = _this.password, hash = _this.hash;
                _context.next = 4;
                return service_http.post('/auth/redefinir-senha', { email: email, password: password, hash: hash });

              case 4:
                response = _context.sent;
                token = response.data.token;
                permissoes = response.data.permissoes;
                decoded = lib_default()(token);
                imagem = decoded.user.imagem;

                if (imagem) {
                  localforage_default.a.setItem('imagem', imagem);
                }
                localforage_default.a.setItem('permissoes', permissoes);
                localforage_default.a.setItem('token', token).then(function (token) {
                  _this.setToken({ token: token });
                  _this.setPermissoes({ permissoes: permissoes });
                  _this.setImagem({ imagem: imagem });
                  _this.$router.push({ name: 'dashboard' });
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 14]]);
      }))();
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b896103","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/redefinir-senha.vue
var redefinir_senha_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-login"},[_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s10 offset-s1 m6 offset-m3 l4 offset-l4"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_c('div',{staticClass:"card white",staticStyle:{"background":"rgba(255,255,255,0.90) !important"}},[_c('div',{staticClass:"card-content center-align"},[_c('img',{attrs:{"src":__webpack_require__("UDbD")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('span',{staticClass:"card-title center-align"},[_vm._v("Defina sua senha")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","id":"email","required":"required"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail de cadastro")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","id":"password","required":"required"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Nova senha")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 center-align"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("Redefinir Senha")])])])])])])])])])}
var redefinir_senha_staticRenderFns = []
var redefinir_senha_esExports = { render: redefinir_senha_render, staticRenderFns: redefinir_senha_staticRenderFns }
/* harmony default export */ var auth_redefinir_senha = (redefinir_senha_esExports);
// CONCATENATED MODULE: ./src/features/auth/redefinir-senha.vue
function redefinir_senha_injectStyle (ssrContext) {
  __webpack_require__("ev9a")
}
var redefinir_senha_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var redefinir_senha___vue_template_functional__ = false
/* styles */
var redefinir_senha___vue_styles__ = redefinir_senha_injectStyle
/* scopeId */
var redefinir_senha___vue_scopeId__ = "data-v-3b896103"
/* moduleIdentifier (server only) */
var redefinir_senha___vue_module_identifier__ = null
var redefinir_senha_Component = redefinir_senha_normalizeComponent(
  redefinir_senha,
  auth_redefinir_senha,
  redefinir_senha___vue_template_functional__,
  redefinir_senha___vue_styles__,
  redefinir_senha___vue_scopeId__,
  redefinir_senha___vue_module_identifier__
)

/* harmony default export */ var features_auth_redefinir_senha = (redefinir_senha_Component.exports);

// CONCATENATED MODULE: ./src/features/auth/routes.js





/* harmony default export */ var routes = ([{
  path: '/auth/login',
  name: 'auth.index',
  component: src_features_auth
}, {
  path: '/auth/recuperar-senha',
  name: 'auth.recuperar-senha',
  component: features_auth_recuperar_senha
}, {
  path: '/auth/redefinir-senha',
  name: 'auth.redefinir-senha',
  component: features_auth_redefinir_senha
}]);
// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__("KgVm");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/usuarios/usuarios/index.vue



//




/* harmony default export */ var usuarios = ({
  name: 'Usuarios',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/usuarios?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/usuarios?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var usuario, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                usuario = obj.usuario;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: usuario.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, usuario);
                } else {
                  _this3.list.unshift(usuario);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(usuario) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + usuario.nome_completo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/usuarios/' + usuario.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: usuario.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'usuarios.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'usuarios.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa786e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/usuarios/usuarios/index.vue
var usuarios_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('usuario.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('usuario.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'usuarios.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'usuarios.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-usuarios-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(usuario){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('usuario.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'usuarios.form', params: { id: usuario.id } }}},[_vm._v(_vm._s(usuario.nome_completo))]):_c('span',[_vm._v(_vm._s(usuario.nome_completo))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(usuario.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((usuario.perfil) ? usuario.perfil.perfil : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!usuario.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('usuario.editar') > -1),expression:"permissoes.indexOf('usuario.editar') > -1"}],attrs:{"to":{ name: 'usuarios.form', params: { id: usuario.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('usuario.excluir') > -1),expression:"permissoes.indexOf('usuario.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(usuario)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var usuarios_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Usuários")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("E-mail")]),_vm._v(" "),_c('th',[_vm._v("Perfil")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var usuarios_esExports = { render: usuarios_render, staticRenderFns: usuarios_staticRenderFns }
/* harmony default export */ var usuarios_usuarios = (usuarios_esExports);
// CONCATENATED MODULE: ./src/features/usuarios/usuarios/index.vue
var usuarios_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var usuarios___vue_template_functional__ = false
/* styles */
var usuarios___vue_styles__ = null
/* scopeId */
var usuarios___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var usuarios___vue_module_identifier__ = null
var usuarios_Component = usuarios_normalizeComponent(
  usuarios,
  usuarios_usuarios,
  usuarios___vue_template_functional__,
  usuarios___vue_styles__,
  usuarios___vue_scopeId__,
  usuarios___vue_module_identifier__
)

/* harmony default export */ var features_usuarios_usuarios = (usuarios_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/usuarios/usuarios/form.vue



//



/* harmony default export */ var usuarios_form = ({
  name: 'Form',
  data: function data() {
    return {
      perfis: [{}],
      marcas: [{}],
      usuario: {
        id: '',
        perfil_id: '',
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirm_password: '',
        imagem: '',
        comissao: '',
        assinatura: '',
        cpf: '',
        rg: '',
        telefone: '',
        celular: '',
        ativo: true,
        anexos: [],
        marcas: [{}],
        parceiro_logo: '',
        parceiro_rodape: ''
      },
      progress: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      errorFile: false,
      errorFile2: false,
      errorFile3: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image-square',
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'usuarios',
          width: 200,
          height: 200,
          accept: 'all'
        }
      },
      options2: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image-area',
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'usuarios',
          width: 800,
          height: 600,
          accept: 'all'
        }
      },
      options3: {
        url: "https://sistemakgb.com.br/v1" + '/upload-file',
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'usuarios',
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        file.addAttribute('id', xhr.response.id);
        this.usuario.imagem = xhr.response;
        this.progress = 0;
      }
    },
    destroyImage: function destroyImage() {
      var _this = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this.usuario.imagem = '';
      });
    },
    totalProgress2: function totalProgress2(progress, totalBytes, bytesSent) {
      this.progress2 = progress;
    },
    complete2: function complete2(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute('id', xhr.response.id);
        this.usuario.assinatura = xhr.response;
        this.progress2 = 0;
      }
    },
    totalProgress4: function totalProgress4(progress, totalBytes, bytesSent) {
      this.progress4 = progress;
    },
    complete4: function complete4(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute('id', xhr.response.id);
        this.usuario.parceiro_logo = xhr.response;
        this.progress4 = 0;
      }
    },
    totalProgress3: function totalProgress3(progress, totalBytes, bytesSent) {
      this.progress3 = progress;
    },
    complete3: function complete3(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.usuario.anexos.push({ anexo: xhr.response, legenda: files.name });
        this.$nextTick(function () {
          window.Materialize.updateTextFields();
        });
        this.progress = 0;
      }
    },
    destroyAnexo: function destroyAnexo(indexAnexo) {
      var _this2 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma anexo \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this2.usuario.anexos[indexAnexo].id) {
          _this2.usuario.anexos.splice(indexAnexo, 1);
          window.Materialize.toast('Anexo excluído!', 4000);
        } else {
          service_http.delete('usuarios/anexo/' + _this2.usuario.anexos[indexAnexo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Anexo excluído!', 4000);
            _this2.usuario.anexos.splice(indexAnexo, 1);
          });
        }
      });
    },
    destroyImage2: function destroyImage2() {
      var _this3 = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this3.usuario.assinatura = '';
      });
    },
    destroyImageParceiro: function destroyImageParceiro() {
      var _this4 = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this4.usuario.parceiro_logo = '';
      });
    },
    fecth: function fecth() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data, _ref2, _data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.clear();
                id = _this5.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 5;
                return service_http.get('/usuarios/' + id + '/edit');

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                _this5.usuario = data.usuario;
                _this5.usuario.marcas = data.marcasSelect;
                _this5.perfis = data.perfis;
                _this5.marcas = data.marcas;
                _context.next = 19;
                break;

              case 13:
                _context.next = 15;
                return service_http.get('/usuarios/create');

              case 15:
                _ref2 = _context.sent;
                _data = _ref2.data;

                _this5.marcas = _data.marcas;
                _this5.perfis = _data.perfis;

              case 19:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    validate: function validate() {
      var _this6 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this6.submit();
        }
      });
    },
    submit: function submit() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref3, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = _this7.isNew ? 'post' : 'put';
                url = _this7.isNew ? '/usuarios' : '/usuarios/' + _this7.usuario.id;
                _context2.next = 4;
                return service_http[verb](url, _this7.usuario);

              case 4:
                _ref3 = _context2.sent;
                data = _ref3.data;

                if (data != null) {
                  _this7.$emit('update-usuarios-list', { usuario: data.usuario });
                  _this7.$router.push({ name: 'usuarios.index' });
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    clear: function clear() {
      this.usuario = {
        id: '',
        perfil_id: '',
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirm_password: '',
        imagem: '',
        comissao: '',
        cpf: '',
        rg: '',
        telefone: '',
        celular: '',
        ativo: true,
        anexos: [],
        marcas: [{}],
        parceiro_logo: '',
        parceiro_rodape: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.usuario.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },

    usuarioMarcas: {
      get: function get() {
        var _this8 = this;

        return this.marcas.filter(function (option) {
          return _this8.usuario.marcas.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.usuario.marcas = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4025858","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/usuarios/usuarios/form.vue
var form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m6"},[_c('label',{attrs:{"for":"perfil_id"}},[_vm._v("*Perfil")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.perfil_id),expression:"usuario.perfil_id"}],attrs:{"name":"perfil_id","id":"perfil_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuario, "perfil_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.perfis),function(perfil){return _c('option',{domProps:{"value":perfil.id}},[_vm._v(_vm._s(perfil.perfil))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('perfil_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.nome),expression:"usuario.nome"}],class:{invalid: _vm.errors.has('nome')},attrs:{"name":"nome","id":"nome","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.usuario.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "nome", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"nome"}},[_vm._v("*Nome")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('nome')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.sobrenome),expression:"usuario.sobrenome"}],class:{invalid: _vm.errors.has('sobrenome')},attrs:{"name":"sobrenome","id":"sobrenome","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.usuario.sobrenome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "sobrenome", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"sobrenome"}},[_vm._v("*Sobrenome")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('sobrenome')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.email),expression:"usuario.email"}],class:{invalid: _vm.errors.has('email')},attrs:{"name":"email","id":"email","type":"text","data-vv-rules":"required|email"},domProps:{"value":(_vm.usuario.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("*E-mail")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('email')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({'required': _vm.isNew}),expression:"{'required': isNew}"},{name:"model",rawName:"v-model",value:(_vm.usuario.password),expression:"usuario.password"}],ref:"password",class:{invalid: _vm.errors.has('password')},attrs:{"name":"password","id":"password","type":"password"},domProps:{"value":(_vm.usuario.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.confirm_password),expression:"usuario.confirm_password"}],class:{invalid: _vm.errors.has('confirm_password')},attrs:{"name":"confirm_password","id":"confirm_password","type":"password","data-vv-rules":"confirmed:password"},domProps:{"value":(_vm.usuario.confirm_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "confirm_password", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"confirm_password"}},[_vm._v("Confirmar senha")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('confirm_password')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 9999-9999'),expression:"'(99) 9999-9999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.telefone),expression:"usuario.telefone"}],class:{invalid: _vm.errors.has('telefone')},attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.usuario.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999-9999'),expression:"'(99) 99999-9999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.celular),expression:"usuario.celular"}],class:{invalid: _vm.errors.has('celular')},attrs:{"name":"celular","id":"celular","type":"text","data-vv-rules":"min:15"},domProps:{"value":(_vm.usuario.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "celular", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"celular"}},[_vm._v("Celular")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('celular')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.rg),expression:"usuario.rg"}],attrs:{"name":"rg","id":"rg","type":"text"},domProps:{"value":(_vm.usuario.rg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "rg", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"rg"}},[_vm._v("RG")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('rg')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.cpf),expression:"usuario.cpf"}],class:{invalid: _vm.errors.has('cpf')},attrs:{"name":"cpf","id":"cpf","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.usuario.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "cpf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cpf')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.comissao),expression:"usuario.comissao"}],class:{invalid: _vm.errors.has('comissao')},attrs:{"name":"comissao","id":"comissao","type":"number","step":"0.01"},domProps:{"value":(_vm.usuario.comissao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "comissao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"comissao"}},[_vm._v("% de Comissão")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('comissao')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Avatar")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.usuario.imagem)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/usuarios/" + (_vm.usuario.imagem))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.usuario.imagem)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options2,"on-complete":_vm.complete2,"on-total-progress":_vm.totalProgress2}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Assinatura")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.usuario.assinatura)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/usuarios/" + (_vm.usuario.assinatura))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress2 + "%"))})]),_vm._v(" "),(_vm.errorFile2)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.usuario.assinatura)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage2()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options3,"on-complete":_vm.complete3,"on-total-progress":_vm.totalProgress3}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card center"},[_c('span',{staticClass:"card-title"},[_vm._v("Anexo")])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress3 + "%"))})]),_vm._v(" "),(_vm.errorFile3)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.usuario.anexo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")]),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/usuarios/" + (_vm.usuario.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons pointer"},[_vm._v("search")])])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.usuario.anexos),function(anexo,indexAnexo){return _c('div',{staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/usuarios/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyAnexo(indexAnexo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m6"},[_c('label',[_vm._v("Marcas (Deixe vazio para liberar todas as marcas)")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"marca","track-by":"id","options":_vm.marcas},model:{value:(_vm.usuario.marcas),callback:function ($$v) {_vm.$set(_vm.usuario, "marcas", $$v)},expression:"usuario.marcas"}})],1),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.parceiro_rodape),expression:"usuario.parceiro_rodape"}],class:{invalid: _vm.errors.has('parceiro_rodape')},attrs:{"name":"parceiro_rodape","id":"parceiro_rodape","type":"text"},domProps:{"value":(_vm.usuario.parceiro_rodape)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "parceiro_rodape", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"parceiro_rodape"}},[_vm._v("Texto Rodapé")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('parceiro_rodape')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete4,"on-total-progress":_vm.totalProgress4}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Logo")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.usuario.parceiro_logo)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/usuarios/" + (_vm.usuario.parceiro_logo))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.usuario.parceiro_logo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImageParceiro()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.ativo),expression:"usuario.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.usuario.ativo)?_vm._i(_vm.usuario.ativo,null)>-1:(_vm.usuario.ativo)},on:{"change":function($event){var $$a=_vm.usuario.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.usuario, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.usuario, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.usuario, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('p',[_c('strong',[_vm._v("Parceiro")])])])])}]
var form_esExports = { render: form_render, staticRenderFns: form_staticRenderFns }
/* harmony default export */ var usuarios_usuarios_form = (form_esExports);
// CONCATENATED MODULE: ./src/features/usuarios/usuarios/form.vue
var form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form___vue_template_functional__ = false
/* styles */
var form___vue_styles__ = null
/* scopeId */
var form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form___vue_module_identifier__ = null
var form_Component = form_normalizeComponent(
  usuarios_form,
  usuarios_usuarios_form,
  form___vue_template_functional__,
  form___vue_styles__,
  form___vue_scopeId__,
  form___vue_module_identifier__
)

/* harmony default export */ var features_usuarios_usuarios_form = (form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/usuarios/usuarios/perfil.vue



//




/* harmony default export */ var usuarios_perfil = ({
  name: 'Usuarios',
  data: function data() {
    return {
      usuario: {
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirm_password: '',
        imagem: ''
      },
      progress: 0,
      errorFile: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image-square',
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'usuarios',
          width: 200,
          height: 200,
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return service_http.get('/usuarios/usuario');

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              _this.usuario = data.usuario;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        file.addAttribute('id', xhr.response.id);
        this.usuario.imagem = xhr.response;
        this.progress = 0;
      }
    },
    destroyImage: function destroyImage() {
      var _this2 = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this2.usuario.imagem = '';
      });
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this3.submit();
        }
      });
    },
    submit: function submit() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.put('usuarios/update/perfil', _this4.usuario);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  localforage_default.a.setItem('imagem', _this4.usuario.imagem);
                  window.Materialize.toast('Registro salvo com sucesso!!', 4000);
                  _this4.$router.push({ name: 'dashboard' });
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['nome', 'sobrenome']), {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e615267","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/usuarios/usuarios/perfil.vue
var perfil_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h5',[_vm._v(_vm._s(_vm.nome)+" "+_vm._s(_vm.sobrenome))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Avatar")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.usuario.imagem)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/usuarios/" + (_vm.usuario.imagem))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.usuario.imagem)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.password),expression:"usuario.password"}],attrs:{"name":"password","id":"password","type":"password"},domProps:{"value":(_vm.usuario.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Senha")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.usuario.confirm_password),expression:"usuario.confirm_password"}],class:{invalid: _vm.errors.has('confirm_password')},attrs:{"name":"confirm_password","id":"confirm_password","type":"password","data-vv-rules":"confirmed:password"},domProps:{"value":(_vm.usuario.confirm_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "confirm_password", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"confirm_password"}},[_vm._v("Confirmar senha")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('confirm_password')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])])])])}
var perfil_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Editar Perfil")])])])}]
var perfil_esExports = { render: perfil_render, staticRenderFns: perfil_staticRenderFns }
/* harmony default export */ var usuarios_usuarios_perfil = (perfil_esExports);
// CONCATENATED MODULE: ./src/features/usuarios/usuarios/perfil.vue
var perfil_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var perfil___vue_template_functional__ = false
/* styles */
var perfil___vue_styles__ = null
/* scopeId */
var perfil___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var perfil___vue_module_identifier__ = null
var perfil_Component = perfil_normalizeComponent(
  usuarios_perfil,
  usuarios_usuarios_perfil,
  perfil___vue_template_functional__,
  perfil___vue_styles__,
  perfil___vue_scopeId__,
  perfil___vue_module_identifier__
)

/* harmony default export */ var features_usuarios_usuarios_perfil = (perfil_Component.exports);

// CONCATENATED MODULE: ./src/features/usuarios/usuarios/routes.js





/* harmony default export */ var usuarios_routes = ([{
  path: '/usuarios',
  name: 'usuarios.index',
  component: features_usuarios_usuarios,
  children: [{
    path: 'form/:id?',
    name: 'usuarios.form',
    component: features_usuarios_usuarios_form
  }]
}, {
  path: '/usuarios/perfil',
  name: 'usuarios.perfil',
  component: features_usuarios_usuarios_perfil
}]);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/usuarios/logs/index.vue



//




/* harmony default export */ var logs = ({
  name: 'Logs',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/usuarios-log?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/usuarios-log?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY HH:mm');
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f359173","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/usuarios/logs/index.vue
var logs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasItens && !_vm.loading),expression:"!hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasItens),expression:"hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(log){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(log.created_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.nome_completo))])])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasItens),expression:"hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var logs_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m8"},[_c('h5',[_vm._v("Usuários :: Logs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data Acesso")]),_vm._v(" "),_c('th',[_vm._v("Usuário")])])])}]
var logs_esExports = { render: logs_render, staticRenderFns: logs_staticRenderFns }
/* harmony default export */ var usuarios_logs = (logs_esExports);
// CONCATENATED MODULE: ./src/features/usuarios/logs/index.vue
var logs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var logs___vue_template_functional__ = false
/* styles */
var logs___vue_styles__ = null
/* scopeId */
var logs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var logs___vue_module_identifier__ = null
var logs_Component = logs_normalizeComponent(
  logs,
  usuarios_logs,
  logs___vue_template_functional__,
  logs___vue_styles__,
  logs___vue_scopeId__,
  logs___vue_module_identifier__
)

/* harmony default export */ var features_usuarios_logs = (logs_Component.exports);

// CONCATENATED MODULE: ./src/features/usuarios/logs/routes.js



/* harmony default export */ var logs_routes = ([{
  path: '/usuarios/logs',
  name: 'usuarios-logs.index',
  component: features_usuarios_logs
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/usuarios/perfis/index.vue



//




/* harmony default export */ var perfis = ({
  name: 'Perfis',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/usuarios/perfis?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/usuarios/perfis?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var perfil, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                perfil = obj.perfil;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: perfil.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, perfil);
                } else {
                  _this3.list.unshift(perfil);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(perfil) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + perfil.perfil + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/usuarios/perfis/' + perfil.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: perfil.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'perfis.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'perfis.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d8a0d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/usuarios/perfis/index.vue
var perfis_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('usuario.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('usuario.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'perfis.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'perfis.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-perfis-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(perfil){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('usuario.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'perfis.form', params: { id: perfil.id } }}},[_vm._v(_vm._s(perfil.perfil))]):_c('span',[_vm._v(_vm._s(perfil.perfil))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!perfil.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(perfil.id < 2 || perfil.id > 3),expression:"perfil.id < 2 || perfil.id > 3"}]},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('usuario.editar') > -1),expression:"permissoes.indexOf('usuario.editar') > -1"}],attrs:{"to":{ name: 'perfis.form', params: { id: perfil.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('usuario.excluir') > -1),expression:"permissoes.indexOf('usuario.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(perfil)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var perfis_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Perfis de Usuário")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Perfil")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var perfis_esExports = { render: perfis_render, staticRenderFns: perfis_staticRenderFns }
/* harmony default export */ var usuarios_perfis = (perfis_esExports);
// CONCATENATED MODULE: ./src/features/usuarios/perfis/index.vue
var perfis_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var perfis___vue_template_functional__ = false
/* styles */
var perfis___vue_styles__ = null
/* scopeId */
var perfis___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var perfis___vue_module_identifier__ = null
var perfis_Component = perfis_normalizeComponent(
  perfis,
  usuarios_perfis,
  perfis___vue_template_functional__,
  perfis___vue_styles__,
  perfis___vue_scopeId__,
  perfis___vue_module_identifier__
)

/* harmony default export */ var features_usuarios_perfis = (perfis_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/usuarios/perfis/form.vue







/* harmony default export */ var perfis_form = ({
  name: 'Form',
  data: function data() {
    return {
      permissoes: ['usuario.visualizar', 'usuario.inserir', 'usuario.editar', 'usuario.excluir', 'cliente.visualizar', 'cliente.inserir', 'cliente.editar', 'cliente.excluir', 'como-conheceu.visualizar', 'como-conheceu.inserir', 'como-conheceu.editar', 'como-conheceu.excluir', 'financeiro-categoria.visualizar', 'financeiro-categoria.inserir', 'financeiro-categoria.editar', 'financeiro-categoria.excluir', 'financeiro-conta.visualizar', 'financeiro-conta.inserir', 'financeiro-conta.editar', 'financeiro-conta.excluir', 'financeiro-forma.visualizar', 'financeiro-forma.inserir', 'financeiro-forma.editar', 'financeiro-forma.excluir', 'financeiro-pagar.visualizar', 'financeiro-pagar.inserir', 'financeiro-pagar.editar', 'financeiro-pagar.excluir', 'financeiro-receber.visualizar', 'financeiro-receber.inserir', 'financeiro-receber.editar', 'financeiro-receber.excluir', 'financeiro-extrato.visualizar', 'fornecedor.visualizar', 'fornecedor.inserir', 'fornecedor.editar', 'fornecedor.excluir', 'contato.visualizar', 'contato.inserir', 'contato.editar', 'contato.excluir', 'produto.visualizar', 'produto.inserir', 'produto.editar', 'produto.excluir', 'servico.visualizar', 'servico.inserir', 'servico.editar', 'servico.excluir', 'orcamento.visualizar', 'orcamento.inserir', 'orcamento.editar', 'orcamento.excluir', 'orcamento-pagamento.visualizar', 'orcamento-pagamento.inserir', 'orcamento-pagamento.editar', 'orcamento-pagamento.excluir', 'os.visualizar', 'os.inserir', 'os.editar', 'os.excluir', 'os.trocar-revisao', 'equipamento.visualizar', 'equipamento.inserir', 'equipamento.editar', 'equipamento.excluir', 'tarefa.visualizar', 'tarefa.inserir', 'tarefa.editar', 'tarefa.excluir', 'marca.visualizar', 'marca.inserir', 'marca.editar', 'marca.excluir', 'venda.visualizar', 'venda.inserir', 'venda.editar', 'venda.excluir', 'estoque.visualizar', 'estoque.inserir', 'estoque.editar', 'estoque.excluir', 'compra.visualizar', 'compra.inserir', 'compra.editar', 'compra.excluir', 'revisao-tipo.visualizar', 'revisao-tipo.inserir', 'revisao-tipo.editar', 'revisao-tipo.excluir', 'viatura.visualizar', 'viatura.inserir', 'viatura.editar', 'viatura.excluir', 'grupo.visualizar', 'grupo.inserir', 'grupo.editar', 'grupo.excluir', 'objetivo.visualizar', 'objetivo.inserir', 'objetivo.editar', 'objetivo.excluir', 'cargo.visualizar', 'cargo.inserir', 'cargo.editar', 'cargo.excluir', 'marca.visualizar', 'marca.inserir', 'marca.editar', 'marca.excluir', 'canal.visualizar', 'canal.inserir', 'canal.editar', 'canal.excluir', 'arte.visualizar', 'arte.inserir', 'arte.editar', 'arte.excluir', 'tipo-estabelecimento.visualizar', 'tipo-estabelecimento.inserir', 'tipo-estabelecimento.editar', 'tipo-estabelecimento.excluir', 'ata.visualizar', 'ata.inserir', 'ata.editar', 'ata.excluir'],
      all: false,
      perfil: {
        id: '',
        perfil: '',
        ativo: true,
        permissao: [],
        permissoes: {}
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    selectAll: function selectAll() {
      var _this = this;

      this.all = !this.all;
      this.perfil.permissao = [];
      if (this.all) {
        this.permissoes.forEach(function (p) {
          _this.perfil.permissao.push(p);
        });
      }
    },
    setPermissoes: function setPermissoes(permissoes) {
      this.perfil.permissao = [];
      for (var p in permissoes) {
        this.perfil.permissao.push(permissoes[p].permissao);
      }
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this2.submit();
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this3.isNew ? 'post' : 'put';
                url = _this3.isNew ? '/usuarios/perfis' : '/usuarios/perfis/' + _this3.perfil.id;
                _context.next = 4;
                return service_http[verb](url, _this3.perfil);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this3.$emit('update-perfis-list', { perfil: data.perfil });
                  _this3.$router.push({ name: 'perfis.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fecth: function fecth() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.clear();
                id = _this4.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/usuarios/perfis/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this4.perfil = data.perfil;
                _this4.setPermissoes(data.perfil.permissoes);
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    clear: function clear() {
      this.perfil = {
        id: '',
        perfil: '',
        ativo: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.perfil.id === '';
    },
    hasAll: function hasAll() {
      return this.perfil.permissao && this.perfil.permissao.length === this.permissoes.length;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c823f1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/usuarios/perfis/form.vue
var perfis_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.perfil.perfil),expression:"perfil.perfil"}],class:{invalid: _vm.errors.has('perfil')},attrs:{"name":"perfil","id":"perfil","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.perfil.perfil)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.perfil, "perfil", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"perfil"}},[_vm._v("*Nome")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('perfil')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.all),expression:"all"}],attrs:{"type":"checkbox","id":"todas","primary":""},domProps:{"checked":Array.isArray(_vm.all)?_vm._i(_vm.all,null)>-1:(_vm.all)},on:{"click":_vm.selectAll,"change":function($event){var $$a=_vm.all,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.all=$$a.concat([$$v]))}else{$$i>-1&&(_vm.all=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.all=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"todas"}},[_vm._v("Todas as permissões")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Atas")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"ata.visualizar","value":"ata.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"ata.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="ata.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ata.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"ata.inserir","value":"ata.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"ata.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="ata.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ata.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"ata.editar","value":"ata.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"ata.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="ata.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ata.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"ata.excluir","value":"ata.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"ata.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="ata.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ata.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Clientes")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cliente.visualizar","value":"cliente.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cliente.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cliente.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cliente.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cliente.inserir","value":"cliente.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cliente.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cliente.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cliente.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cliente.editar","value":"cliente.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cliente.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cliente.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cliente.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cliente.excluir","value":"cliente.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cliente.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cliente.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cliente.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Clientes :: Como Conheceu")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"como-conheceu.visualizar","value":"como-conheceu.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"como-conheceu.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="como-conheceu.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"como-conheceu.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"como-conheceu.inserir","value":"como-conheceu.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"como-conheceu.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="como-conheceu.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"como-conheceu.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"como-conheceu.editar","value":"como-conheceu.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"como-conheceu.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="como-conheceu.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"como-conheceu.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"como-conheceu.excluir","value":"como-conheceu.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"como-conheceu.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="como-conheceu.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"como-conheceu.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Clientes :: Cargo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cargo.visualizar","value":"cargo.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cargo.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cargo.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cargo.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cargo.inserir","value":"cargo.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cargo.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cargo.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cargo.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cargo.editar","value":"cargo.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cargo.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cargo.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cargo.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"cargo.excluir","value":"cargo.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"cargo.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="cargo.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cargo.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Contatos")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"contato.visualizar","value":"contato.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"contato.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="contato.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"contato.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"contato.inserir","value":"contato.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"contato.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="contato.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"contato.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"contato.editar","value":"contato.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"contato.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="contato.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"contato.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"contato.excluir","value":"contato.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"contato.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="contato.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"contato.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Compras")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"compra.visualizar","value":"compra.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"compra.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="compra.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"compra.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"compra.inserir","value":"compra.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"compra.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="compra.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"compra.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"compra.editar","value":"compra.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"compra.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="compra.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"compra.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"compra.excluir","value":"compra.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"compra.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="compra.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"compra.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Equipamentos")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"equipamento.visualizar","value":"equipamento.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"equipamento.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="equipamento.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"equipamento.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"equipamento.inserir","value":"equipamento.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"equipamento.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="equipamento.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"equipamento.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"equipamento.editar","value":"equipamento.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"equipamento.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="equipamento.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"equipamento.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"equipamento.excluir","value":"equipamento.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"equipamento.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="equipamento.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"equipamento.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Financeiro :: Categorias")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-categoria.visualizar","value":"financeiro-categoria.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-categoria.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-categoria.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-categoria.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-categoria.inserir","value":"financeiro-categoria.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-categoria.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-categoria.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-categoria.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-categoria.editar","value":"financeiro-categoria.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-categoria.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-categoria.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-categoria.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-categoria.excluir","value":"financeiro-categoria.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-categoria.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-categoria.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-categoria.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Financeiro :: Contas")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-conta.visualizar","value":"financeiro-conta.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-conta.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-conta.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-conta.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-conta.inserir","value":"financeiro-conta.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-conta.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-conta.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-conta.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-conta.editar","value":"financeiro-conta.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-conta.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-conta.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-conta.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-conta.excluir","value":"financeiro-conta.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-conta.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-conta.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-conta.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Financeiro :: Extrato")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-extrato.visualizar","value":"financeiro-extrato.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-extrato.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-extrato.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-extrato.visualizar"}})]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Financeiro :: Formas de Pagamento")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-forma.visualizar","value":"financeiro-forma.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-forma.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-forma.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-forma.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-forma.inserir","value":"financeiro-forma.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-forma.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-forma.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-forma.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-forma.editar","value":"financeiro-forma.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-forma.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-forma.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-forma.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-forma.excluir","value":"financeiro-forma.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-forma.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-forma.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-forma.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Financeiro :: Pagar")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-pagar.visualizar","value":"financeiro-pagar.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-pagar.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-pagar.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-pagar.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-pagar.inserir","value":"financeiro-pagar.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-pagar.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-pagar.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-pagar.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-pagar.editar","value":"financeiro-pagar.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-pagar.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-pagar.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-pagar.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-pagar.excluir","value":"financeiro-pagar.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-pagar.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-pagar.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-pagar.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Financeiro :: Receber")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-receber.visualizar","value":"financeiro-receber.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-receber.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-receber.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-receber.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-receber.inserir","value":"financeiro-receber.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-receber.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-receber.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-receber.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-receber.editar","value":"financeiro-receber.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-receber.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-receber.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-receber.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"financeiro-receber.excluir","value":"financeiro-receber.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"financeiro-receber.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="financeiro-receber.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"financeiro-receber.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Fornecedores")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"fornecedor.visualizar","value":"fornecedor.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"fornecedor.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fornecedor.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"fornecedor.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"fornecedor.inserir","value":"fornecedor.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"fornecedor.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fornecedor.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"fornecedor.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"fornecedor.editar","value":"fornecedor.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"fornecedor.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fornecedor.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"fornecedor.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"fornecedor.excluir","value":"fornecedor.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"fornecedor.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="fornecedor.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"fornecedor.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Orçamentos")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento.visualizar","value":"orcamento.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento.inserir","value":"orcamento.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento.editar","value":"orcamento.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento.excluir","value":"orcamento.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Orçamentos :: Condições de Pagamento")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento-pagamento.visualizar","value":"orcamento-pagamento.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento-pagamento.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento-pagamento.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento-pagamento.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento-pagamento.inserir","value":"orcamento-pagamento.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento-pagamento.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento-pagamento.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento-pagamento.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento-pagamento.editar","value":"orcamento-pagamento.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento-pagamento.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento-pagamento.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento-pagamento.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"orcamento-pagamento.excluir","value":"orcamento-pagamento.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"orcamento-pagamento.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="orcamento-pagamento.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento-pagamento.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("OS's")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"os.visualizar","value":"os.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"os.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="os.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"os.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"os.inserir","value":"os.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"os.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="os.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"os.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"os.editar","value":"os.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"os.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="os.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"os.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"os.excluir","value":"os.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"os.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="os.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"os.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("OS's :: Revisão Tipo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"revisao-tipo.visualizar","value":"revisao-tipo.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"revisao-tipo.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="revisao-tipo.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"revisao-tipo.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"revisao-tipo.inserir","value":"revisao-tipo.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"revisao-tipo.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="revisao-tipo.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"revisao-tipo.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"revisao-tipo.editar","value":"revisao-tipo.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"revisao-tipo.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="revisao-tipo.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"revisao-tipo.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"revisao-tipo.excluir","value":"revisao-tipo.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"revisao-tipo.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="revisao-tipo.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"revisao-tipo.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("OS's :: Revisão, Alterar Revisões em OS's")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"os.trocar-revisao","value":"os.trocar-revisao"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"os.trocar-revisao")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="os.trocar-revisao",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"os.trocar-revisao"}})]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Produtos")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"produto.visualizar","value":"produto.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"produto.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="produto.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"produto.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"produto.inserir","value":"produto.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"produto.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="produto.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"produto.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"produto.editar","value":"produto.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"produto.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="produto.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"produto.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"produto.excluir","value":"produto.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"produto.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="produto.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"produto.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Produtos :: Estoque")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"estoque.visualizar","value":"estoque.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"estoque.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="estoque.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"estoque.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"estoque.inserir","value":"estoque.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"estoque.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="estoque.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"estoque.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"estoque.editar","value":"estoque.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"estoque.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="estoque.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"estoque.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"estoque.excluir","value":"estoque.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"estoque.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="estoque.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"estoque.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Grupos de Serviço")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"grupo.visualizar","value":"grupo.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"grupo.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="grupo.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"grupo.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"grupo.inserir","value":"grupo.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"grupo.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="grupo.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"grupo.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"grupo.editar","value":"grupo.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"grupo.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="grupo.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"grupo.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"grupo.excluir","value":"grupo.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"grupo.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="grupo.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"grupo.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Serviços")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"servico.visualizar","value":"servico.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"servico.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="servico.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"servico.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"servico.inserir","value":"servico.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"servico.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="servico.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"servico.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"servico.editar","value":"servico.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"servico.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="servico.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"servico.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"servico.excluir","value":"servico.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"servico.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="servico.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"servico.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Objetivos")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"objetivo.visualizar","value":"objetivo.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"objetivo.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="objetivo.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"objetivo.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"objetivo.inserir","value":"objetivo.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"objetivo.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="objetivo.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"objetivo.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"objetivo.editar","value":"objetivo.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"objetivo.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="objetivo.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"objetivo.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"objetivo.excluir","value":"objetivo.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"objetivo.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="objetivo.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"objetivo.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tarefas")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tarefa.visualizar","value":"tarefa.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tarefa.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tarefa.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tarefa.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tarefa.inserir","value":"tarefa.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tarefa.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tarefa.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tarefa.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tarefa.editar","value":"tarefa.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tarefa.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tarefa.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tarefa.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tarefa.excluir","value":"tarefa.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tarefa.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tarefa.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tarefa.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Marcas")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"marca.visualizar","value":"marca.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"marca.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="marca.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"marca.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"marca.inserir","value":"marca.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"marca.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="marca.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"marca.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"marca.editar","value":"marca.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"marca.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="marca.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"marca.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"marca.excluir","value":"marca.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"marca.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="marca.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"marca.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Famílias")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"familia.visualizar","value":"familia.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"familia.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="familia.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"familia.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"familia.inserir","value":"familia.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"familia.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="familia.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"familia.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"familia.editar","value":"familia.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"familia.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="familia.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"familia.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"familia.excluir","value":"familia.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"familia.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="familia.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"familia.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Usuários")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"usuario.visualizar","value":"usuario.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"usuario.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="usuario.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"usuario.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"usuario.inserir","value":"usuario.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"usuario.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="usuario.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"usuario.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"usuario.editar","value":"usuario.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"usuario.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="usuario.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"usuario.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"usuario.excluir","value":"usuario.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"usuario.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="usuario.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"usuario.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Canais de Venda")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"canal.visualizar","value":"canal.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"canal.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="canal.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"canal.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"canal.inserir","value":"canal.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"canal.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="canal.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"canal.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"canal.editar","value":"canal.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"canal.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="canal.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"canal.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"canal.excluir","value":"canal.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"canal.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="canal.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"canal.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Vendas")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"venda.visualizar","value":"venda.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"venda.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="venda.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"venda.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"venda.inserir","value":"venda.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"venda.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="venda.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"venda.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"venda.editar","value":"venda.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"venda.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="venda.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"venda.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"venda.excluir","value":"venda.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"venda.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="venda.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"venda.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Viaturas")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"viatura.visualizar","value":"viatura.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"viatura.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="viatura.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"viatura.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"viatura.inserir","value":"viatura.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"viatura.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="viatura.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"viatura.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"viatura.editar","value":"viatura.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"viatura.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="viatura.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"viatura.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"viatura.excluir","value":"viatura.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"viatura.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="viatura.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"viatura.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Área de Reclamação")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"reclamacao.visualizar","value":"reclamacao.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"reclamacao.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="reclamacao.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"reclamacao.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"reclamacao.inserir","value":"reclamacao.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"reclamacao.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="reclamacao.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"reclamacao.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"reclamacao.editar","value":"reclamacao.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"reclamacao.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="reclamacao.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"reclamacao.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"reclamacao.excluir","value":"reclamacao.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"reclamacao.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="reclamacao.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"reclamacao.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Motivos de Recusa")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"motivo.visualizar","value":"motivo.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"motivo.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="motivo.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"motivo.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"motivo.inserir","value":"motivo.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"motivo.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="motivo.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"motivo.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"motivo.editar","value":"motivo.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"motivo.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="motivo.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"motivo.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"motivo.excluir","value":"motivo.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"motivo.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="motivo.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"motivo.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Artes")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"arte.visualizar","value":"arte.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"arte.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="arte.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"arte.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"arte.inserir","value":"arte.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"arte.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="arte.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"arte.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"arte.editar","value":"arte.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"arte.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="arte.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"arte.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"arte.excluir","value":"arte.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"arte.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="arte.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"arte.excluir"}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tipos de Estabelecimento")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tipo-estabelecimento.visualizar","value":"tipo-estabelecimento.visualizar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tipo-estabelecimento.visualizar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tipo-estabelecimento.visualizar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo-estabelecimento.visualizar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tipo-estabelecimento.inserir","value":"tipo-estabelecimento.inserir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tipo-estabelecimento.inserir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tipo-estabelecimento.inserir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo-estabelecimento.inserir"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tipo-estabelecimento.editar","value":"tipo-estabelecimento.editar"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tipo-estabelecimento.editar")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tipo-estabelecimento.editar",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo-estabelecimento.editar"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.permissao),expression:"perfil.permissao"}],attrs:{"type":"checkbox","id":"tipo-estabelecimento.excluir","value":"tipo-estabelecimento.excluir"},domProps:{"checked":Array.isArray(_vm.perfil.permissao)?_vm._i(_vm.perfil.permissao,"tipo-estabelecimento.excluir")>-1:(_vm.perfil.permissao)},on:{"change":function($event){var $$a=_vm.perfil.permissao,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="tipo-estabelecimento.excluir",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "permissao", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "permissao", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "permissao", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo-estabelecimento.excluir"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perfil.ativo),expression:"perfil.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.perfil.ativo)?_vm._i(_vm.perfil.ativo,null)>-1:(_vm.perfil.ativo)},on:{"change":function($event){var $$a=_vm.perfil.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.perfil, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.perfil, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.perfil, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var perfis_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-xs-left"},[_vm._v("Permissões")]),_vm._v(" "),_c('th',{staticClass:"text-xs-center"},[_vm._v("Visualizar")]),_vm._v(" "),_c('th',{staticClass:"text-xs-center"},[_vm._v("Inserir")]),_vm._v(" "),_c('th',{staticClass:"text-xs-center"},[_vm._v("Editar")]),_vm._v(" "),_c('th',{staticClass:"text-xs-center"},[_vm._v("Excluir")])])])}]
var perfis_form_esExports = { render: perfis_form_render, staticRenderFns: perfis_form_staticRenderFns }
/* harmony default export */ var usuarios_perfis_form = (perfis_form_esExports);
// CONCATENATED MODULE: ./src/features/usuarios/perfis/form.vue
var perfis_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var perfis_form___vue_template_functional__ = false
/* styles */
var perfis_form___vue_styles__ = null
/* scopeId */
var perfis_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var perfis_form___vue_module_identifier__ = null
var perfis_form_Component = perfis_form_normalizeComponent(
  perfis_form,
  usuarios_perfis_form,
  perfis_form___vue_template_functional__,
  perfis_form___vue_styles__,
  perfis_form___vue_scopeId__,
  perfis_form___vue_module_identifier__
)

/* harmony default export */ var features_usuarios_perfis_form = (perfis_form_Component.exports);

// CONCATENATED MODULE: ./src/features/usuarios/perfis/routes.js




/* harmony default export */ var perfis_routes = ([{
  path: '/usuarios/perfis',
  name: 'perfis.index',
  component: features_usuarios_perfis,
  children: [{
    path: 'form/:id?',
    name: 'perfis.form',
    component: features_usuarios_perfis_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/dashboard/index.vue








/* harmony default export */ var dashboard = ({
  name: 'Dashboard',
  data: function data() {
    return {
      osNovo: 0,
      osNovoRevisao: 0,
      osAndamento: 0,
      osAndamentoRevisao: 0,
      tarefasHoje: 0,
      tarefasPendentesHoje: 0,
      tarefasExecucao: 0,
      tarefasAtraso: 0,
      tarefas: [],
      tarefa: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (window.location.hash.indexOf('forbidden=true') > -1) {
                _this.$bus.$emit('sweet-erro', {
                  message: 'Acesso não permitido'
                });
              }
              _context.next = 3;
              return service_http.get('/usuarios/check-login');

            case 3:
              _context.next = 5;
              return service_http.get('/dashboard');

            case 5:
              _ref = _context.sent;
              data = _ref.data;

              if (data != null) {
                _this.osNovo = data.osNovo;
                _this.osAndamento = data.osAndamento;
                _this.osNovoRevisao = data.osNovoRevisao;
                _this.osAndamentoRevisao = data.osAndamentoRevisao;
                _this.tarefasHoje = data.tarefasHoje;
                _this.tarefasPendentesHoje = data.tarefasPendentesHoje;
                _this.tarefasExecucao = data.tarefasExecucao;
                _this.tarefasAtraso = data.tarefasAtraso;
                _this.tarefas = data.tarefas;
              }
              _this.$nextTick(function () {
                $('.tooltipped').tooltip({ delay: 50 });
              });

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY HH:mm');
    },
    chipAtraso: function chipAtraso(data) {
      var vencimento = moment_default()(data).format('YYYY-MM-DD HH:mm');
      var hoje = moment_default()().format('YYYY-MM-DD HH:mm');
      if (hoje > vencimento) {
        return true;
      }
    },
    playTarefa: function playTarefa(obj, status) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$swal({
                  title: 'Deseja alterar o status da ' + obj.tarefa + '?',
                  html: 'Esta operação é irreversível',
                  type: 'warning',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Sim, quero alterar!',
                  reverseButtons: true
                }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                  var tarefa, _ref3, data;

                  return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          tarefa = {
                            status_id: status
                          };
                          _context2.next = 3;
                          return service_http.put('/tarefas/' + obj.id + '/status', tarefa);

                        case 3:
                          _ref3 = _context2.sent;
                          data = _ref3.data;

                          obj.status_id = data.tarefa.status_id;
                          obj.status = data.tarefa.status;

                        case 7:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    modalTarefa: function modalTarefa(obj) {
      this.tarefa = obj;
      $('#modalTarefa').modal('open');
      this.$nextTick(function () {
        return window.Materialize.updateTextFields();
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    hasTarefas: function hasTarefas() {
      return this.tarefas.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f7af645","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/dashboard/index.vue
var dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('contato.visualizar') > -1),expression:"permissoes.indexOf('contato.visualizar') > -1"}],staticClass:"col s12 m2 offset-m1"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'contatos.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("contacts")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Contatos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento.visualizar') > -1),expression:"permissoes.indexOf('orcamento.visualizar') > -1"}],staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'orcamentos.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("assignment_turned_in")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Orçamentos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.visualizar') > -1),expression:"permissoes.indexOf('os.visualizar') > -1"}],staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'os.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("build")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("OS's")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-receber.visualizar') > -1),expression:"permissoes.indexOf('financeiro-receber.visualizar') > -1"}],staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'financeiro-receber.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("attach_money")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Contas a Receber")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-pagar.visualizar') > -1),expression:"permissoes.indexOf('financeiro-pagar.visualizar') > -1"}],staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'financeiro-pagar.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("money_off")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Contas a Pagar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tarefa.visualizar') > -1),expression:"permissoes.indexOf('tarefa.visualizar') > -1"}],staticClass:"col s12 m2 offset-m1"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'cronograma' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("calendar_today")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Cronograma")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tarefa.visualizar') > -1),expression:"permissoes.indexOf('tarefa.visualizar') > -1"}],staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'tarefas.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("check_circle_outline")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Tarefas")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'vendas.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("shopping_cart")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Vendas")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'compras.index' }}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("add_shopping_cart")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Compras")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'relatorios.index'}}},[_c('div',{staticClass:"card center-align"},[_c('br'),_vm._v(" "),_c('i',{staticClass:"material-icons large"},[_vm._v("insert_chart")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Relatórios")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.visualizar') > -1),expression:"permissoes.indexOf('os.visualizar') > -1"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2 offset-m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'os.index', params: { status: 1, revisao: 3 } }}},[_c('div',{staticClass:"card center-align yellow darken-4 white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.osNovo))]),_vm._v(" "),_c('p',[_vm._v("\n              OS's\n              "),_c('br'),_vm._v("\n              aguardando início\n            ")]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'os.index', params: { status: 2, revisao: 3 } }}},[_c('div',{staticClass:"card center-align green white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.osAndamento))]),_vm._v(" "),_c('p',[_vm._v("\n              OS's\n              "),_c('br'),_vm._v("\n              em andamento\n            ")]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'os.index', params: { status: 1, revisao: 2 } }}},[_c('div',{staticClass:"card center-align yellow darken-4 white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.osNovoRevisao))]),_vm._v(" "),_c('p',[_vm._v("\n              OS's c/revisão\n              "),_c('br'),_vm._v("\n              aguardando início\n            ")]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'os.index', params: { status: 2, revisao: 2 } }}},[_c('div',{staticClass:"card center-align green white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.osAndamentoRevisao))]),_vm._v(" "),_c('p',[_vm._v("\n              OS's c/revisão\n              "),_c('br'),_vm._v("\n              em andamento\n            ")]),_vm._v(" "),_c('br')])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tarefa.visualizar') > -1),expression:"permissoes.indexOf('tarefa.visualizar') > -1"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2 offset-m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'tarefas.index', params: { filtro: 'hoje' } }}},[_c('div',{staticClass:"card center-align blue white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.tarefasHoje))]),_vm._v(" "),_c('p',[_vm._v("\n              Tarefas\n              "),_c('br'),_vm._v("\n              para hoje\n            ")]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'tarefas.index', params: { filtro: 'pendentes' } }}},[_c('div',{staticClass:"card center-align yellow darken-4 white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.tarefasPendentesHoje))]),_vm._v(" "),_c('p',[_vm._v("\n              Tarefas\n              "),_c('br'),_vm._v("\n              pendentes para hoje\n            ")]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'tarefas.index', params: { filtro: 'execucao' } }}},[_c('div',{staticClass:"card center-align green white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.tarefasExecucao))]),_vm._v(" "),_c('p',[_vm._v("\n              Tarefas\n              "),_c('br'),_vm._v("\n              em execução\n            ")]),_vm._v(" "),_c('br')])])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"btn-action green-text text-darken-3",attrs:{"to":{ name: 'tarefas.index', params: { filtro: 'atraso' } }}},[_c('div',{staticClass:"card center-align red white-text"},[_c('br'),_vm._v(" "),_c('h1',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(this.tarefasAtraso))]),_vm._v(" "),_c('p',[_vm._v("\n              Tarefas\n              "),_c('br'),_vm._v("\n              em atraso\n            ")]),_vm._v(" "),_c('br')])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasTarefas),expression:"hasTarefas"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.tarefas),function(tarefa){return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{ name: 'tarefas.form', params: { id: tarefa.id } }}},[_vm._v("\n                "+_vm._s(tarefa.id)+"\n              ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(tarefa.tarefa))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((tarefa.usuario) ? tarefa.usuario.nome_completo : '-'))]),_vm._v(" "),_c('td',[(tarefa.os)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: tarefa.os_id } }}},[_vm._v("\n                "+_vm._s(tarefa.os_id)+"\n              ")]):_c('span',[_vm._v("-")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(tarefa.prazo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tarefa.status.status))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(tarefa.status_id === 3)?_c('span',{staticClass:"new badge green",attrs:{"data-badge-caption":"concluída"}}):_vm._e(),_vm._v(" "),(tarefa.status_id < 3 && _vm.chipAtraso(tarefa.prazo) === true)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"atrasada"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"tooltipped",attrs:{"href":"#","data-label":tarefa.tarefa,"data-position":"left","data-delay":"50","data-tooltip":"Detalhes"},on:{"click":function($event){$event.preventDefault();return _vm.modalTarefa(tarefa)}}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("search")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(tarefa.status_id === 1),expression:"tarefa.status_id === 1"}],staticClass:"tooltipped",attrs:{"href":"#","data-label":tarefa.tarefa,"data-position":"left","data-delay":"50","data-tooltip":"Iniciar Tarefa"},on:{"click":function($event){$event.preventDefault();return _vm.playTarefa(tarefa, 2)}}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("play_circle_filled")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(tarefa.status_id === 2),expression:"tarefa.status_id === 2"}],staticClass:"tooltipped",attrs:{"href":"#","data-label":tarefa.tarefa,"data-position":"left","data-delay":"50","data-tooltip":"Finalizar Tarefa"},on:{"click":function($event){$event.preventDefault();return _vm.playTarefa(tarefa, 3)}}},[_c('i',{staticClass:"material-icons green-text"},[_vm._v("play_circle_filled")])])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"modalTarefa"}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_vm._v(_vm._s(_vm.tarefa.tarefa))]),_vm._v(" "),_c('div',{staticClass:"pre-formatted"},[_vm._v(_vm._s(_vm.tarefa.descricao))]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.tarefa.orcamento)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_vm._v("\n          Endereço: "),_c('strong',[_vm._v(_vm._s(_vm.tarefa.orcamento.logradouro)+", "+_vm._s(_vm.tarefa.orcamento.numero)+" "+_vm._s(_vm.tarefa.orcamento.complemento)+" - "+_vm._s(_vm.tarefa.orcamento.bairro)+" - "+_vm._s(_vm.tarefa.orcamento.cidade)+" / "+_vm._s(_vm.tarefa.orcamento.estado)+" - CEP: "+_vm._s(_vm.tarefa.orcamento.cep))])])]):_vm._e(),_vm._v(" "),(_vm.tarefa.orcamento && _vm.tarefa.orcamento.fotos)?_c('div',{staticClass:"row"},_vm._l((_vm.tarefa.orcamento.fotos),function(foto){return _c('div',{key:foto.id,staticClass:"col s12 m6"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%","height":"150px"},attrs:{"src":(_vm.api_url + "/orcamentos/" + (foto.foto))}}),_vm._v(" "),_c('br'),_c('br')])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.tarefa.anexos),function(anexo,indexAnexo){return _c('div',{staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/tarefa/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"disabled":"","type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0)])])])}
var dashboard_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Tarefa")]),_vm._v(" "),_c('th',[_vm._v("Solicitante")]),_vm._v(" "),_c('th',[_vm._v("# OS")]),_vm._v(" "),_c('th',[_vm._v("Prazo")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var dashboard_esExports = { render: dashboard_render, staticRenderFns: dashboard_staticRenderFns }
/* harmony default export */ var features_dashboard = (dashboard_esExports);
// CONCATENATED MODULE: ./src/features/dashboard/index.vue
var dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dashboard___vue_template_functional__ = false
/* styles */
var dashboard___vue_styles__ = null
/* scopeId */
var dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dashboard___vue_module_identifier__ = null
var dashboard_Component = dashboard_normalizeComponent(
  dashboard,
  features_dashboard,
  dashboard___vue_template_functional__,
  dashboard___vue_styles__,
  dashboard___vue_scopeId__,
  dashboard___vue_module_identifier__
)

/* harmony default export */ var src_features_dashboard = (dashboard_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-full-calendar/index.js
var vue_full_calendar = __webpack_require__("QaH6");

// EXTERNAL MODULE: ./node_modules/fullcalendar/dist/locale/pt-br.js
var pt_br = __webpack_require__("UGgp");
var pt_br_default = /*#__PURE__*/__webpack_require__.n(pt_br);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/dashboard/cronograma.vue







/* harmony default export */ var cronograma = ({
  name: 'Cronograma',
  components: {
    FullCalendar: vue_full_calendar["a" /* FullCalendar */]
  },
  data: function data() {
    return {
      config: {
        locale: 'pt-BR',
        lang: 'pt-br',
        defaultView: 'month',
        editable: false,
        header: {
          left: '',
          center: '',
          right: 'month,basicWeek,basicDay'
        }
      },
      eventos: [],
      filtro: {
        mes: '',
        ano: '',
        dia: '',
        usuario: ''
      },
      usuarios: [],
      usuario: null
    };
  },
  mounted: function mounted() {
    if (window.location.hash.indexOf('forbidden=true') > -1) {
      this.$bus.$emit('sweet-erro', {
        message: 'Acesso não permitido'
      });
    }
    this.filtrar();
  },

  methods: {
    filtrar: function filtrar() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service_http.get('/cronograma?mes=' + _this.filtro.mes + '&ano=' + _this.filtro.ano + '&usuario=' + _this.filtro.usuario);

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                _this.eventos = data.eventos;
                _this.filtro = data.filtro;
                _this.usuarios = data.usuarios;
                _this.config.defaultDate = _this.filtro.ano + '-' + _this.filtro.mes + '-' + _this.filtro.dia;
                _this.$refs.calendar.$emit('reload-events');
                _this.$refs.calendar.fireMethod('gotoDate', _this.filtro.ano + '-' + _this.filtro.mes + '-' + _this.filtro.dia);
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb1dea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/dashboard/cronograma.vue
var cronograma_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"filtro_mes"}},[_vm._v("Mês")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.mes),expression:"filtro.mes"}],attrs:{"name":"mes","id":"filtro_mes"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "mes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"01"}},[_vm._v("Janeiro")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("Fevereiro")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("Março")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("Abril")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("Maio")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("Junho")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("Julho")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("Agosto")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("Setembro")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Outubro")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Novembro")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Dezembro")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m1"},[_c('label',{attrs:{"for":"ano"}},[_vm._v("Ano")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ano),expression:"filtro.ano"}],attrs:{"type":"number","maxlength":"4","id":"ano"},domProps:{"value":(_vm.filtro.ano)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "ano", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"name":"usuario","id":"usuario","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(usuario){return _c('option',{domProps:{"value":usuario.id}},[_vm._v(_vm._s(usuario.nome_completo))])}),0)]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('full-calendar',{ref:"calendar",attrs:{"events":_vm.eventos,"config":_vm.config}})],1)])])])}
var cronograma_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Cronograma")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m3"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"submit"}},[_c('i',{staticClass:"material-icons left"},[_vm._v("filter_list")]),_vm._v(" Filtrar")])])}]
var cronograma_esExports = { render: cronograma_render, staticRenderFns: cronograma_staticRenderFns }
/* harmony default export */ var dashboard_cronograma = (cronograma_esExports);
// CONCATENATED MODULE: ./src/features/dashboard/cronograma.vue
function cronograma_injectStyle (ssrContext) {
  __webpack_require__("fNhs")
}
var cronograma_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cronograma___vue_template_functional__ = false
/* styles */
var cronograma___vue_styles__ = cronograma_injectStyle
/* scopeId */
var cronograma___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cronograma___vue_module_identifier__ = null
var cronograma_Component = cronograma_normalizeComponent(
  cronograma,
  dashboard_cronograma,
  cronograma___vue_template_functional__,
  cronograma___vue_styles__,
  cronograma___vue_scopeId__,
  cronograma___vue_module_identifier__
)

/* harmony default export */ var features_dashboard_cronograma = (cronograma_Component.exports);

// CONCATENATED MODULE: ./src/features/dashboard/routes.js




/* harmony default export */ var dashboard_routes = ([{
  path: '/',
  name: 'dashboard',
  component: src_features_dashboard
}, {
  path: '/cronograma',
  name: 'cronograma',
  component: features_dashboard_cronograma
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/clientes/clientes/index.vue








/* harmony default export */ var clientes = ({
  name: 'Clientes',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/clientes?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/clientes?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var cliente, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cliente = obj.cliente;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: cliente.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, cliente);
                } else {
                  _this3.list.unshift(cliente);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(cliente) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + cliente.cliente + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/clientes/' + cliente.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: cliente.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    telefones: function telefones(tel2, tel3) {
      var telefones = [];
      if (tel2) {
        telefones.push(tel2);
      }
      if (tel3) {
        telefones.push(tel3);
      }
      return telefones.join(', ');
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'clientes.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'clientes.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f61a690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/clientes/clientes/index.vue
var clientes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('cliente.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('cliente.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'clientes.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'clientes.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"btn-floating waves-effect waves-light",attrs:{"href":(_vm.api_url + "/clientes/exportar"),"download":"","target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-clientes-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(cliente){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('cliente.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'clientes.form', params: { id: cliente.id } }}},[_vm._v("\n                "+_vm._s(cliente.cliente)+"\n                "),(cliente.tipo === 1)?_c('small',[_c('br'),_vm._v(_vm._s(cliente.responsavel))]):_vm._e()]):_vm._e(),_vm._v(" "),(cliente.estrela > 0)?_c('small',[_c('br'),_vm._l((cliente.estrela),function(n){return _c('i',{key:n,staticClass:"material-icons",staticStyle:{"color":"#ffea00","font-size":"1.5em"}},[_vm._v("grade")])})],2):_c('span',[_vm._v(_vm._s(cliente.cliente))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(!cliente.copiar_dados),expression:"!cliente.copiar_dados"}]},[_vm._v(_vm._s(cliente.cobranca_nome))])],1),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(cliente.telefone)),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                "+_vm._s(_vm.telefones(cliente.telefone2, cliente.telefone3))+"\n              ")])]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(cliente.email)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(cliente.cargo ? cliente.cargo.cargo : '-')+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!cliente.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cliente.editar') > -1),expression:"permissoes.indexOf('cliente.editar') > -1"}],attrs:{"to":{ name: 'clientes.form', params: { id: cliente.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cliente.excluir') > -1),expression:"permissoes.indexOf('cliente.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(cliente)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var clientes_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Clientes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Cliente")]),_vm._v(" "),_c('th',[_vm._v("Telefones")]),_vm._v(" "),_c('th',[_vm._v("E-mail")]),_vm._v(" "),_c('th',[_vm._v("Cargo")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var clientes_esExports = { render: clientes_render, staticRenderFns: clientes_staticRenderFns }
/* harmony default export */ var clientes_clientes = (clientes_esExports);
// CONCATENATED MODULE: ./src/features/clientes/clientes/index.vue
var clientes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clientes___vue_template_functional__ = false
/* styles */
var clientes___vue_styles__ = null
/* scopeId */
var clientes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var clientes___vue_module_identifier__ = null
var clientes_Component = clientes_normalizeComponent(
  clientes,
  clientes_clientes,
  clientes___vue_template_functional__,
  clientes___vue_styles__,
  clientes___vue_scopeId__,
  clientes___vue_module_identifier__
)

/* harmony default export */ var features_clientes_clientes = (clientes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/clientes/clientes/form.vue







/* harmony default export */ var clientes_form = ({
  name: 'Form',
  data: function data() {
    return {
      comoConheceu: [{}],
      cargos: [],
      cliente: {
        id: '',
        cliente: '',
        tipo: 2,
        cnpj: '',
        razao_social: '',
        ie: '',
        responsavel: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        como_conheceu_id: '',
        cargo_id: '',
        obs: '',
        ativo: true,
        localizacao_imagem: '',
        localizacao_mapa: '',
        estrela: '',
        anexos: []
      },
      progress: 0,
      progress2: 0,
      progress3: 0,
      errorFile: false,
      errorFile2: false,
      errorFile3: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image-area',
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: 'image/*',
        headers: {
          path: 'orcamentos',
          width: 800,
          height: 600,
          accept: 'all'
        }
      },
      options3: {
        url: "https://sistemakgb.com.br/v1" + '/upload-file',
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'clientes',
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    setEndereco: function setEndereco() {
      var _this = this;

      window.$.getJSON('https://viacep.com.br/ws/' + this.cliente.cep + '/json/').then(function (response) {
        if (!response.erro) {
          _this.cliente.logradouro = response.logradouro;
          _this.cliente.bairro = response.bairro;
          _this.cliente.cidade = response.localidade;
          _this.cliente.estado = response.uf;
          $('#numero').focus();
        } else {
          _this.cliente.logradouro = '';
          _this.cliente.numero = '';
          _this.cliente.complemento = '';
          _this.cliente.bairro = '';
          _this.cliente.cidade = '';
          _this.cliente.estado = '';
        }
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 0);
      });
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this2.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this2.submit();
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this3.isNew ? 'post' : 'put';
                url = _this3.isNew ? '/clientes' : '/clientes/' + _this3.cliente.id;
                _context.next = 4;
                return service_http[verb](url, _this3.cliente);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this3.$emit('update-clientes-list', { cliente: data.cliente });
                  _this3.$router.push({ name: 'clientes.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fecth: function fecth() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.clear();
                id = _this4.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/clientes/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this4.cliente = data.cliente;
                _this4.comoConheceu = data.comoConheceu;
                _this4.cargos = data.cargos;
                _context2.next = 18;
                break;

              case 12:
                _context2.next = 14;
                return service_http.get('/clientes/create');

              case 14:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this4.comoConheceu = _data.comoConheceu;
                _this4.cargos = _data.cargos;

              case 18:
                setTimeout(function () {
                  $('.collapsible').collapsible();
                  $('.collapsible').collapsible('close', 0);
                  $('.collapsible').collapsible('close', 1);
                  $('.collapsible').collapsible('close', 2);
                  $('.collapsible').collapsible('close', 3);
                  $('.collapsible').collapsible('open', 0);
                  window.Materialize.updateTextFields();
                }, 0);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    clear: function clear() {
      this.cliente = {
        id: '',
        cliente: '',
        tipo: 2,
        cnpj: '',
        razao_social: '',
        ie: '',
        responsavel: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        como_conheceu_id: '',
        cargo_id: '',
        obs: '',
        ativo: true,
        localizacao_imagem: '',
        localizacao_mapa: '',
        estrela: '',
        anexos: []
      };
    },
    gerarLocalizacao: function gerarLocalizacao() {
      this.cliente.localizacao_mapa = this.cliente.logradouro + ', ' + this.cliente.numero + ' ' + this.cliente.bairro + ' ' + this.cliente.cidade + ' ' + this.cliente.estado + ' ' + this.cliente.cep;
    },
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete2: function complete2(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        file.addAttribute('id', xhr.response.id);
        this.cliente.localizacao_imagem = xhr.response;
        this.progress = 0;
      }
    },
    totalProgress3: function totalProgress3(progress, totalBytes, bytesSent) {
      this.progress3 = progress;
    },
    complete3: function complete3(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.cliente.anexos.push({ anexo: xhr.response, legenda: files.name });
        this.$nextTick(function () {
          window.Materialize.updateTextFields();
        });
        this.progress = 0;
      }
    },
    destroyAnexo: function destroyAnexo(indexAnexo) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma anexo \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this5.cliente.anexos[indexAnexo].id) {
          _this5.cliente.anexos.splice(indexAnexo, 1);
          window.Materialize.toast('Anexo excluído!', 4000);
        } else {
          service_http.delete('clientes/anexo/' + _this5.cliente.anexos[indexAnexo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Anexo excluído!', 4000);
            _this5.cliente.anexos.splice(indexAnexo, 1);
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.cliente.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    url_app: function url_app() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfd6eb78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/clientes/clientes/form.vue
var clientes_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('ul',{staticClass:"collapsible popout",attrs:{"data-collapsible":"accordion"}},[_c('li',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.cliente),expression:"cliente.cliente"}],class:{invalid: _vm.errors.has('cliente')},attrs:{"name":"cliente","id":"cliente","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.cliente.cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cliente", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cliente"}},[_vm._v("*Cliente")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cliente')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model.number",value:(_vm.cliente.tipo),expression:"cliente.tipo",modifiers:{"number":true}}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.cliente, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Pessoa Jurídica")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Pessoa Física")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.tipo === 1),expression:"cliente.tipo === 1"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.responsavel),expression:"cliente.responsavel"}],attrs:{"name":"responsavel","id":"responsavel","type":"text"},domProps:{"value":(_vm.cliente.responsavel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "responsavel", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"responsavel"}},[_vm._v("Responsável")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('responsavel')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.tipo === 1),expression:"cliente.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.razao_social),expression:"cliente.razao_social"}],attrs:{"name":"razao_social","id":"razao_social","type":"text"},domProps:{"value":(_vm.cliente.razao_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "razao_social", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"razao_social"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('razao_social')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.tipo === 1),expression:"cliente.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99.999.999/9999-99'),expression:"'99.999.999/9999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.cnpj),expression:"cliente.cnpj"}],class:{invalid: _vm.errors.has('cnpj')},attrs:{"name":"cnpj","id":"cnpj","type":"text","data-vv-rules":"min:18"},domProps:{"value":(_vm.cliente.cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cnpj", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cnpj')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.tipo === 1),expression:"cliente.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.ie),expression:"cliente.ie"}],class:{invalid: _vm.errors.has('ie')},attrs:{"name":"cnpj","id":"ie","type":"text"},domProps:{"value":(_vm.cliente.ie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "ie", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ie"}},[_vm._v("Inscrição Estadual")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('ie')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.tipo === 2),expression:"cliente.tipo === 2"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.rg),expression:"cliente.rg"}],attrs:{"name":"rg","id":"rg","type":"text"},domProps:{"value":(_vm.cliente.rg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "rg", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"rg"}},[_vm._v("RG")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('rg')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.tipo === 2),expression:"cliente.tipo === 2"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.cpf),expression:"cliente.cpf"}],class:{invalid: _vm.errors.has('cpf')},attrs:{"name":"cpf","id":"cpf","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.cliente.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cpf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cpf')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"estrela"}},[_vm._v("Estrelas")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model.number",value:(_vm.cliente.estrela),expression:"cliente.estrela",modifiers:{"number":true}}],class:{invalid: _vm.errors.has('estrela')},attrs:{"name":"estrela","id":"estrela","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.cliente, "estrela", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estrela')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"cargo_id"}},[_vm._v("Cargo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.cargo_id),expression:"cliente.cargo_id"}],attrs:{"name":"cargo_id","id":"cargo_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cliente, "cargo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.cargos),function(cargo){return _c('option',{domProps:{"value":cargo.id}},[_vm._v(_vm._s(cargo.cargo))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cargo_id')))])])])])]),_vm._v(" "),_c('li',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.telefone),expression:"cliente.telefone"}],class:{invalid: _vm.errors.has('telefone')},attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.cliente.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.telefone2),expression:"cliente.telefone2"}],class:{invalid: _vm.errors.has('telefone2')},attrs:{"name":"telefone2","id":"telefone2","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.cliente.telefone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "telefone2", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone2"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone2')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.telefone3),expression:"cliente.telefone3"}],class:{invalid: _vm.errors.has('telefone3')},attrs:{"name":"telefone3","id":"telefone3","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.cliente.telefone3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "telefone3", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone3"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone3')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.email),expression:"cliente.email"}],class:{invalid: _vm.errors.has('email')},attrs:{"name":"email","id":"email","type":"text","data-vv-rules":"email"},domProps:{"value":(_vm.cliente.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('email')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99999-999'),expression:"'99999-999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cliente.cep),expression:"cliente.cep"}],class:{invalid: _vm.errors.has('cep')},attrs:{"name":"cep","id":"cep","type":"text","data-vv-rules":"min:9"},domProps:{"value":(_vm.cliente.cep)},on:{"blur":_vm.setEndereco,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cep", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cep')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.logradouro),expression:"cliente.logradouro"}],attrs:{"name":"logradouro","id":"logradouro","type":"text"},domProps:{"value":(_vm.cliente.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "logradouro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Logradouro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('logradouro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.numero),expression:"cliente.numero"}],attrs:{"name":"numero","id":"numero","type":"text"},domProps:{"value":(_vm.cliente.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"numero"}},[_vm._v("Nº")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('numero')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.complemento),expression:"cliente.complemento"}],attrs:{"name":"complemento","id":"complemento","type":"text"},domProps:{"value":(_vm.cliente.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"complemento"}},[_vm._v("Compl.")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('complemento')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.bairro),expression:"cliente.bairro"}],attrs:{"name":"bairro","id":"bairro","type":"text"},domProps:{"value":(_vm.cliente.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "bairro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('bairro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.cidade),expression:"cliente.cidade"}],attrs:{"name":"cidade","id":"cidade","type":"text"},domProps:{"value":(_vm.cliente.cidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cidade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cidade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.estado),expression:"cliente.estado"}],attrs:{"name":"estado","id":"estado","type":"text"},domProps:{"value":(_vm.cliente.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "estado", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estado')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.referencia),expression:"cliente.referencia"}],attrs:{"name":"referencia","id":"referencia","type":"text"},domProps:{"value":(_vm.cliente.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "referencia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"referencia"}},[_vm._v("Ponto de Referência")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('referencia')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete2,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Foto Localização")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.cliente.localizacao_imagem)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/orcamentos/" + (_vm.cliente.localizacao_imagem))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.cliente.localizacao_imagem)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.localizacao_mapa),expression:"cliente.localizacao_mapa"}],attrs:{"name":"localizacao","id":"localizacao","type":"text"},domProps:{"value":(_vm.cliente.localizacao_mapa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "localizacao_mapa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"localizacao"}},[_vm._v("Mapa Localização")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('localizacao_mapa')))]),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.gerarLocalizacao.apply(null, arguments)}}},[_vm._v("Gerar\n                    Localização\n                  ")])])])])]),_vm._v(" "),_c('li',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"como_conheceu_id"}},[_vm._v("Como Conheceu")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.como_conheceu_id),expression:"cliente.como_conheceu_id"}],attrs:{"name":"como_conheceu_id","id":"como_conheceu_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cliente, "como_conheceu_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.comoConheceu),function(como){return _c('option',{domProps:{"value":como.id}},[_vm._v(_vm._s(como.como_conheceu))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('como_conheceu_id')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.obs),expression:"cliente.obs"}],staticClass:"materialize-textarea",attrs:{"name":"obs","id":"obs"},domProps:{"value":(_vm.cliente.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "obs", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"obs"}},[_vm._v("Observações")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('obs')))])])])])]),_vm._v(" "),_c('li',[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options3,"on-complete":_vm.complete3,"on-total-progress":_vm.totalProgress3}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card center"},[_c('span',{staticClass:"card-title"},[_vm._v("Anexo")])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress3 + "%"))})]),_vm._v(" "),(_vm.errorFile3)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.cliente.anexo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")]),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/clientes/" + (_vm.cliente.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons pointer"},[_vm._v("search")])])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.cliente.anexos),function(anexo,indexAnexo){return _c('div',{staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/clientes/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyAnexo(indexAnexo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.ativo),expression:"cliente.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cliente.ativo)?_vm._i(_vm.cliente.ativo,null)>-1:(_vm.cliente.ativo)},on:{"change":function($event){var $$a=_vm.cliente.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cliente, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cliente, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cliente, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var clientes_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Informações Gerais\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("location_on")]),_vm._v("Contato / Endereço\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("message")]),_vm._v("Informações Adicionais\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_file")]),_vm._v("Anexos")])}]
var clientes_form_esExports = { render: clientes_form_render, staticRenderFns: clientes_form_staticRenderFns }
/* harmony default export */ var clientes_clientes_form = (clientes_form_esExports);
// CONCATENATED MODULE: ./src/features/clientes/clientes/form.vue
var clientes_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clientes_form___vue_template_functional__ = false
/* styles */
var clientes_form___vue_styles__ = null
/* scopeId */
var clientes_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var clientes_form___vue_module_identifier__ = null
var clientes_form_Component = clientes_form_normalizeComponent(
  clientes_form,
  clientes_clientes_form,
  clientes_form___vue_template_functional__,
  clientes_form___vue_styles__,
  clientes_form___vue_scopeId__,
  clientes_form___vue_module_identifier__
)

/* harmony default export */ var features_clientes_clientes_form = (clientes_form_Component.exports);

// CONCATENATED MODULE: ./src/features/clientes/clientes/routes.js




/* harmony default export */ var clientes_routes = ([{
  path: '/clientes',
  name: 'clientes.index',
  component: features_clientes_clientes,
  children: [{
    path: 'form/:id?',
    name: 'clientes.form',
    component: features_clientes_clientes_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/clientes/como-conheceu/index.vue








/* harmony default export */ var como_conheceu = ({
  name: 'ComoConheceu',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/como-conheceu?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/como-conheceu?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var comoConheceu, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                comoConheceu = obj.comoConheceu;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: comoConheceu.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, comoConheceu);
                } else {
                  _this3.list.unshift(comoConheceu);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(comoConheceu) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + comoConheceu.cliente + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/como-conheceu/' + comoConheceu.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: comoConheceu.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'como-conheceu.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'como-conheceu.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68570ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/clientes/como-conheceu/index.vue
var como_conheceu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('como-conheceu.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('como-conheceu.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'como-conheceu.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'como-conheceu.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-como_conheceu-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(comoConheceu){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('como-conheceu.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'como-conheceu.form', params: { id: comoConheceu.id } }}},[_vm._v("\n                                "+_vm._s(comoConheceu.como_conheceu)+"\n                            ")]):_c('span',[_vm._v(_vm._s(comoConheceu.como_conheceu))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('como-conheceu.editar') > -1),expression:"permissoes.indexOf('como-conheceu.editar') > -1"}],attrs:{"to":{ name: 'como-conheceu.form', params: { id: comoConheceu.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('como-conheceu.excluir') > -1),expression:"permissoes.indexOf('como-conheceu.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(comoConheceu)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var como_conheceu_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Clientes :: Como Conheceu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Como Conheceu")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var como_conheceu_esExports = { render: como_conheceu_render, staticRenderFns: como_conheceu_staticRenderFns }
/* harmony default export */ var clientes_como_conheceu = (como_conheceu_esExports);
// CONCATENATED MODULE: ./src/features/clientes/como-conheceu/index.vue
var como_conheceu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var como_conheceu___vue_template_functional__ = false
/* styles */
var como_conheceu___vue_styles__ = null
/* scopeId */
var como_conheceu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var como_conheceu___vue_module_identifier__ = null
var como_conheceu_Component = como_conheceu_normalizeComponent(
  como_conheceu,
  clientes_como_conheceu,
  como_conheceu___vue_template_functional__,
  como_conheceu___vue_styles__,
  como_conheceu___vue_scopeId__,
  como_conheceu___vue_module_identifier__
)

/* harmony default export */ var features_clientes_como_conheceu = (como_conheceu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/clientes/como-conheceu/form.vue







/* harmony default export */ var como_conheceu_form = ({
  name: 'Form',
  data: function data() {
    return {
      comoConheceu: {
        id: '',
        como_conheceu: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/como-conheceu' : '/como-conheceu/' + _this2.comoConheceu.id;
                _context.next = 4;
                return service_http[verb](url, _this2.comoConheceu);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-como_conheceu-list', { comoConheceu: data.comoConheceu });
                  _this2.$router.push({ name: 'como-conheceu.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/como-conheceu/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.comoConheceu = data.comoConheceu;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.comoConheceu = {
        id: '',
        como_conheceu: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.comoConheceu.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47783cf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/clientes/como-conheceu/form.vue
var como_conheceu_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.comoConheceu.como_conheceu),expression:"comoConheceu.como_conheceu"}],class:{invalid: _vm.errors.has('como_conheceu')},attrs:{"name":"como_conheceu","id":"como_conheceu","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.comoConheceu.como_conheceu)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.comoConheceu, "como_conheceu", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"como_conheceu"}},[_vm._v("*Como Conheceu")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('como_conheceu')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var como_conheceu_form_staticRenderFns = []
var como_conheceu_form_esExports = { render: como_conheceu_form_render, staticRenderFns: como_conheceu_form_staticRenderFns }
/* harmony default export */ var clientes_como_conheceu_form = (como_conheceu_form_esExports);
// CONCATENATED MODULE: ./src/features/clientes/como-conheceu/form.vue
var como_conheceu_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var como_conheceu_form___vue_template_functional__ = false
/* styles */
var como_conheceu_form___vue_styles__ = null
/* scopeId */
var como_conheceu_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var como_conheceu_form___vue_module_identifier__ = null
var como_conheceu_form_Component = como_conheceu_form_normalizeComponent(
  como_conheceu_form,
  clientes_como_conheceu_form,
  como_conheceu_form___vue_template_functional__,
  como_conheceu_form___vue_styles__,
  como_conheceu_form___vue_scopeId__,
  como_conheceu_form___vue_module_identifier__
)

/* harmony default export */ var features_clientes_como_conheceu_form = (como_conheceu_form_Component.exports);

// CONCATENATED MODULE: ./src/features/clientes/como-conheceu/routes.js




/* harmony default export */ var como_conheceu_routes = ([{
  path: '/clientes/como-conheceu',
  name: 'como-conheceu.index',
  component: features_clientes_como_conheceu,
  children: [{
    path: 'form/:id?',
    name: 'como-conheceu.form',
    component: features_clientes_como_conheceu_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/fornecedores/fornecedores/index.vue



//




/* harmony default export */ var fornecedores = ({
  name: 'Fornecedores',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/fornecedores?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/fornecedores?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var fornecedor, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fornecedor = obj.fornecedor;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: fornecedor.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, fornecedor);
                } else {
                  _this3.list.unshift(fornecedor);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(fornecedor) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + fornecedor.fornecedor + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/fornecedores/' + fornecedor.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: fornecedor.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'fornecedores.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'fornecedores.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea23c80e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/fornecedores/fornecedores/index.vue
var fornecedores_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('fornecedor.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('fornecedor.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'fornecedores.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'fornecedores.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-fornecedores-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(fornecedor){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('fornecedor.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'fornecedores.form', params: { id: fornecedor.id } }}},[_vm._v(_vm._s(fornecedor.fornecedor))]):_c('span',[_vm._v(_vm._s(fornecedor.fornecedor))])],1),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(fornecedor.telefone)),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                    "+_vm._s(fornecedor.telefone2 ? fornecedor.telefone2 : '')+"\n                    "+_vm._s(fornecedor.telefone3 ? ', '+fornecedor.telefone3 : '')+"\n                  ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s((fornecedor.email) ? fornecedor.email : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!fornecedor.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('fornecedor.editar') > -1),expression:"permissoes.indexOf('fornecedor.editar') > -1"}],attrs:{"to":{ name: 'fornecedores.form', params: { id: fornecedor.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('fornecedor.excluir') > -1),expression:"permissoes.indexOf('fornecedor.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(fornecedor)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var fornecedores_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Fornecedores")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fornecedor")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("E-mail")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var fornecedores_esExports = { render: fornecedores_render, staticRenderFns: fornecedores_staticRenderFns }
/* harmony default export */ var fornecedores_fornecedores = (fornecedores_esExports);
// CONCATENATED MODULE: ./src/features/fornecedores/fornecedores/index.vue
var fornecedores_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fornecedores___vue_template_functional__ = false
/* styles */
var fornecedores___vue_styles__ = null
/* scopeId */
var fornecedores___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var fornecedores___vue_module_identifier__ = null
var fornecedores_Component = fornecedores_normalizeComponent(
  fornecedores,
  fornecedores_fornecedores,
  fornecedores___vue_template_functional__,
  fornecedores___vue_styles__,
  fornecedores___vue_scopeId__,
  fornecedores___vue_module_identifier__
)

/* harmony default export */ var features_fornecedores_fornecedores = (fornecedores_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/fornecedores/fornecedores/form.vue



//



/* harmony default export */ var fornecedores_form = ({
  name: 'Form',
  data: function data() {
    return {
      fornecedor: {
        id: '',
        fornecedor: '',
        tipo: 1,
        responsavel: '',
        cnpj: '',
        razao_social: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        obs: '',
        ativo: true
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    setEndereco: function setEndereco() {
      var _this = this;

      window.$.getJSON('https://viacep.com.br/ws/' + this.fornecedor.cep + '/json/').then(function (response) {
        if (!response.erro) {
          _this.fornecedor.logradouro = response.logradouro;
          _this.fornecedor.bairro = response.bairro;
          _this.fornecedor.cidade = response.localidade;
          _this.fornecedor.estado = response.uf;
          $('#numero').focus();
        } else {
          _this.fornecedor.logradouro = '';
          _this.fornecedor.numero = '';
          _this.fornecedor.complemento = '';
          _this.fornecedor.bairro = '';
          _this.fornecedor.cidade = '';
          _this.fornecedor.estado = '';
        }
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 0);
      });
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this2.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this2.submit();
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this3.isNew ? 'post' : 'put';
                url = _this3.isNew ? '/fornecedores' : '/fornecedores/' + _this3.fornecedor.id;
                _context.next = 4;
                return service_http[verb](url, _this3.fornecedor);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this3.$emit('update-fornecedores-list', { fornecedor: data.fornecedor });
                  _this3.$router.push({ name: 'fornecedores.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fecth: function fecth() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.clear();
                id = _this4.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/fornecedores/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this4.fornecedor = data.fornecedor;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
                $('.collapsible').collapsible();
                $('.collapsible').collapsible('close', 0);
                $('.collapsible').collapsible('close', 1);
                $('.collapsible').collapsible('close', 2);
                $('.collapsible').collapsible('open', 0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    clear: function clear() {
      this.fornecedor = {
        id: '',
        fornecedor: '',
        tipo: 1,
        responsavel: '',
        cnpj: '',
        razao_social: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        obs: '',
        ativo: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.fornecedor.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1d4d59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/fornecedores/fornecedores/form.vue
var fornecedores_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('ul',{staticClass:"collapsible popout",attrs:{"data-collapsible":"accordion"}},[_c('li',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.fornecedor),expression:"fornecedor.fornecedor"}],class:{invalid: _vm.errors.has('fornecedor')},attrs:{"name":"fornecedor","id":"fornecedor","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.fornecedor.fornecedor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "fornecedor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"fornecedor"}},[_vm._v("*Fornecedor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('fornecedor')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model.number",value:(_vm.fornecedor.tipo),expression:"fornecedor.tipo",modifiers:{"number":true}}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.fornecedor, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Pessoa Jurídica")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Pessoa Física")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.ativo),expression:"fornecedor.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.fornecedor.ativo)?_vm._i(_vm.fornecedor.ativo,null)>-1:(_vm.fornecedor.ativo)},on:{"change":function($event){var $$a=_vm.fornecedor.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.fornecedor, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.fornecedor, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.fornecedor, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fornecedor.tipo === 1),expression:"fornecedor.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.responsavel),expression:"fornecedor.responsavel"}],class:{invalid: _vm.errors.has('responsavel')},attrs:{"name":"responsavel","id":"responsavel","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.fornecedor.responsavel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "responsavel", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"responsavel"}},[_vm._v("*Responsável")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('responsavel')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fornecedor.tipo === 1),expression:"fornecedor.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.razao_social),expression:"fornecedor.razao_social"}],attrs:{"name":"razao_social","id":"razao_social","type":"text"},domProps:{"value":(_vm.fornecedor.razao_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "razao_social", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"razao_social"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('razao_social')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fornecedor.tipo === 1),expression:"fornecedor.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99.999.999/9999-99'),expression:"'99.999.999/9999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.cnpj),expression:"fornecedor.cnpj"}],class:{invalid: _vm.errors.has('cnpj')},attrs:{"name":"cnpj","id":"cnpj","type":"text","data-vv-rules":"min:18"},domProps:{"value":(_vm.fornecedor.cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "cnpj", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cnpj')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fornecedor.tipo === 2),expression:"fornecedor.tipo === 2"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.rg),expression:"fornecedor.rg"}],attrs:{"name":"rg","id":"rg","type":"text"},domProps:{"value":(_vm.fornecedor.rg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "rg", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"rg"}},[_vm._v("RG")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('rg')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fornecedor.tipo === 2),expression:"fornecedor.tipo === 2"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.cpf),expression:"fornecedor.cpf"}],class:{invalid: _vm.errors.has('cpf')},attrs:{"name":"cpf","id":"cpf","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.fornecedor.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "cpf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cpf')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.telefone),expression:"fornecedor.telefone"}],class:{invalid: _vm.errors.has('telefone')},attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.fornecedor.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.telefone2),expression:"fornecedor.telefone2"}],class:{invalid: _vm.errors.has('telefone2')},attrs:{"name":"telefone2","id":"telefone2","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.fornecedor.telefone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "telefone2", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone2"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone2')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.telefone3),expression:"fornecedor.telefone3"}],class:{invalid: _vm.errors.has('telefone3')},attrs:{"name":"telefone3","id":"telefone3","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.fornecedor.telefone3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "telefone3", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone3"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone3')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.email),expression:"fornecedor.email"}],class:{invalid: _vm.errors.has('responsavel')},attrs:{"name":"email","id":"email","type":"text","data-vv-rules":"required|email"},domProps:{"value":(_vm.fornecedor.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('email')))])])])])]),_vm._v(" "),_c('li',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99999-999'),expression:"'99999-999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.fornecedor.cep),expression:"fornecedor.cep"}],class:{invalid: _vm.errors.has('cep')},attrs:{"name":"cep","id":"cep","type":"text","data-vv-rules":"min:9"},domProps:{"value":(_vm.fornecedor.cep)},on:{"blur":_vm.setEndereco,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "cep", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cep')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.logradouro),expression:"fornecedor.logradouro"}],attrs:{"name":"logradouro","id":"logradouro","type":"text"},domProps:{"value":(_vm.fornecedor.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "logradouro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Logradouro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('logradouro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.numero),expression:"fornecedor.numero"}],attrs:{"name":"numero","id":"numero","type":"text"},domProps:{"value":(_vm.fornecedor.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"numero"}},[_vm._v("Nº")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('numero')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.complemento),expression:"fornecedor.complemento"}],attrs:{"name":"complemento","id":"complemento","type":"text"},domProps:{"value":(_vm.fornecedor.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"complemento"}},[_vm._v("Compl.")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('complemento')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.bairro),expression:"fornecedor.bairro"}],attrs:{"name":"bairro","id":"bairro","type":"text"},domProps:{"value":(_vm.fornecedor.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "bairro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('bairro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.cidade),expression:"fornecedor.cidade"}],attrs:{"name":"cidade","id":"cidade","type":"text"},domProps:{"value":(_vm.fornecedor.cidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "cidade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cidade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.estado),expression:"fornecedor.estado"}],attrs:{"name":"estado","id":"estado","type":"text"},domProps:{"value":(_vm.fornecedor.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "estado", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estado')))])])])])]),_vm._v(" "),_c('li',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor.obs),expression:"fornecedor.obs"}],staticClass:"materialize-textarea",attrs:{"name":"obs","id":"obs"},domProps:{"value":(_vm.fornecedor.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fornecedor, "obs", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"obs"}},[_vm._v("Obs")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('obs')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var fornecedores_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header"},[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_vm._v("Fornecedor")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header"},[_c('i',{staticClass:"material-icons"},[_vm._v("place")]),_vm._v(" Endereço")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header"},[_c('i',{staticClass:"material-icons"},[_vm._v("speaker_notes")]),_vm._v(" Observações")])}]
var fornecedores_form_esExports = { render: fornecedores_form_render, staticRenderFns: fornecedores_form_staticRenderFns }
/* harmony default export */ var fornecedores_fornecedores_form = (fornecedores_form_esExports);
// CONCATENATED MODULE: ./src/features/fornecedores/fornecedores/form.vue
var fornecedores_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fornecedores_form___vue_template_functional__ = false
/* styles */
var fornecedores_form___vue_styles__ = null
/* scopeId */
var fornecedores_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var fornecedores_form___vue_module_identifier__ = null
var fornecedores_form_Component = fornecedores_form_normalizeComponent(
  fornecedores_form,
  fornecedores_fornecedores_form,
  fornecedores_form___vue_template_functional__,
  fornecedores_form___vue_styles__,
  fornecedores_form___vue_scopeId__,
  fornecedores_form___vue_module_identifier__
)

/* harmony default export */ var features_fornecedores_fornecedores_form = (fornecedores_form_Component.exports);

// CONCATENATED MODULE: ./src/features/fornecedores/fornecedores/routes.js




/* harmony default export */ var fornecedores_routes = ([{
  path: '/fornecedores',
  name: 'fornecedores.index',
  component: features_fornecedores_fornecedores,
  children: [{
    path: 'form/:id?',
    name: 'fornecedores.form',
    component: features_fornecedores_fornecedores_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/contas/index.vue



//




/* harmony default export */ var contas = ({
  name: 'Contas',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/financeiro/contas?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/financeiro/contas?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var conta, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                conta = obj.conta;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: conta.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, conta);
                } else {
                  _this3.list.unshift(conta);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(conta) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + conta.conta + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/financeiro/contas/' + conta.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: conta.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'financeiro-contas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'financeiro-contas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eed0575","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/contas/index.vue
var contas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('financeiro-conta.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('financeiro-conta.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'financeiro-contas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-contas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-financeiro-contas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(conta){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('financeiro-conta.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-contas.form', params: { id: conta.id } }}},[_vm._v(_vm._s(conta.conta))]):_c('span',[_vm._v(_vm._s(conta.conta))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!conta.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-conta.editar') > -1),expression:"permissoes.indexOf('financeiro-conta.editar') > -1"}],attrs:{"to":{ name: 'financeiro-contas.form', params: { id: conta.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-conta.excluir') > -1),expression:"permissoes.indexOf('financeiro-conta.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(conta)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var contas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Financeiro :: Contas Bancárias")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Conta")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var contas_esExports = { render: contas_render, staticRenderFns: contas_staticRenderFns }
/* harmony default export */ var financeiro_contas = (contas_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/contas/index.vue
var contas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contas___vue_template_functional__ = false
/* styles */
var contas___vue_styles__ = null
/* scopeId */
var contas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var contas___vue_module_identifier__ = null
var contas_Component = contas_normalizeComponent(
  contas,
  financeiro_contas,
  contas___vue_template_functional__,
  contas___vue_styles__,
  contas___vue_scopeId__,
  contas___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_contas = (contas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/contas/form.vue



//



/* harmony default export */ var contas_form = ({
  name: 'Form',
  data: function data() {
    return {
      conta: {
        id: '',
        conta: '',
        ativo: true
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/financeiro/contas' : '/financeiro/contas/' + _this2.conta.id;
                _context.next = 4;
                return service_http[verb](url, _this2.conta);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-financeiro-contas-list', { conta: data.conta });
                  _this2.$router.push({ name: 'financeiro-contas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/financeiro/contas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.conta = data.conta;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.conta = {
        id: '',
        conta: '',
        ativo: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.conta.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d15066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/contas/form.vue
var contas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m10"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.conta),expression:"conta.conta"}],class:{invalid: _vm.errors.has('conta')},attrs:{"name":"conta","id":"conta","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.conta.conta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "conta", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"conta"}},[_vm._v("*Conta")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('conta')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.ativo),expression:"conta.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.conta.ativo)?_vm._i(_vm.conta.ativo,null)>-1:(_vm.conta.ativo)},on:{"change":function($event){var $$a=_vm.conta.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.conta, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.conta, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.conta, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var contas_form_staticRenderFns = []
var contas_form_esExports = { render: contas_form_render, staticRenderFns: contas_form_staticRenderFns }
/* harmony default export */ var financeiro_contas_form = (contas_form_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/contas/form.vue
var contas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contas_form___vue_template_functional__ = false
/* styles */
var contas_form___vue_styles__ = null
/* scopeId */
var contas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var contas_form___vue_module_identifier__ = null
var contas_form_Component = contas_form_normalizeComponent(
  contas_form,
  financeiro_contas_form,
  contas_form___vue_template_functional__,
  contas_form___vue_styles__,
  contas_form___vue_scopeId__,
  contas_form___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_contas_form = (contas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/financeiro/contas/routes.js




/* harmony default export */ var contas_routes = ([{
  path: '/financeiro/contas',
  name: 'financeiro-contas.index',
  component: features_financeiro_contas,
  children: [{
    path: 'form/:id?',
    name: 'financeiro-contas.form',
    component: features_financeiro_contas_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/categorias/index.vue



//




/* harmony default export */ var categorias = ({
  name: 'Categorias',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/financeiro/categorias?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/financeiro/categorias?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var categoria, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                categoria = obj.categoria;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: categoria.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, categoria);
                } else {
                  _this3.list.unshift(categoria);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(categoria) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + categoria.categoria + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/financeiro/categorias/' + categoria.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: categoria.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'financeiro-categorias.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'financeiro-categorias.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0214e52b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/categorias/index.vue
var categorias_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('financeiro-categoria.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('financeiro-categoria.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'financeiro-categorias.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-categorias.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-financeiro-categorias-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(categoria){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('financeiro-categoria.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-categorias.form', params: { id: categoria.id } }}},[_vm._v(_vm._s(categoria.categoria))]):_c('span',[_vm._v(_vm._s(categoria.categoria))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s((categoria.tipo === 1) ? 'Conta a Pagar' : 'Conta a Receber'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!categoria.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-categoria.editar') > -1),expression:"permissoes.indexOf('financeiro-categoria.editar') > -1"}],attrs:{"to":{ name: 'financeiro-categorias.form', params: { id: categoria.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-categoria.excluir') > -1),expression:"permissoes.indexOf('financeiro-categoria.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(categoria)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var categorias_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Financeiro :: Categorias")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Conta")]),_vm._v(" "),_c('th',[_vm._v("Tipo")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var categorias_esExports = { render: categorias_render, staticRenderFns: categorias_staticRenderFns }
/* harmony default export */ var financeiro_categorias = (categorias_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/categorias/index.vue
var categorias_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var categorias___vue_template_functional__ = false
/* styles */
var categorias___vue_styles__ = null
/* scopeId */
var categorias___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var categorias___vue_module_identifier__ = null
var categorias_Component = categorias_normalizeComponent(
  categorias,
  financeiro_categorias,
  categorias___vue_template_functional__,
  categorias___vue_styles__,
  categorias___vue_scopeId__,
  categorias___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_categorias = (categorias_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/categorias/form.vue



//



/* harmony default export */ var categorias_form = ({
  name: 'Form',
  data: function data() {
    return {
      categoria: {
        id: '',
        categoria: '',
        tipo: '',
        ativo: true
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/financeiro/categorias' : '/financeiro/categorias/' + _this2.categoria.id;
                _context.next = 4;
                return service_http[verb](url, _this2.categoria);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-financeiro-categorias-list', { categoria: data.categoria });
                  _this2.$router.push({ name: 'financeiro-categorias.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/financeiro/categorias/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.categoria = data.categoria;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.categoria = {
        id: '',
        categoria: '',
        tipo: '',
        ativo: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.categoria.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9d36bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/categorias/form.vue
var categorias_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.categoria.categoria),expression:"categoria.categoria"}],class:{invalid: _vm.errors.has('categoria')},attrs:{"name":"categoria","id":"categoria","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.categoria.categoria)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.categoria, "categoria", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"categoria"}},[_vm._v("*Categoria")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('categoria')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.categoria.tipo),expression:"categoria.tipo"}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.categoria, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Contas a Pagar")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Contas a Receber")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoria.ativo),expression:"categoria.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.categoria.ativo)?_vm._i(_vm.categoria.ativo,null)>-1:(_vm.categoria.ativo)},on:{"change":function($event){var $$a=_vm.categoria.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.categoria, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.categoria, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.categoria, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var categorias_form_staticRenderFns = []
var categorias_form_esExports = { render: categorias_form_render, staticRenderFns: categorias_form_staticRenderFns }
/* harmony default export */ var financeiro_categorias_form = (categorias_form_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/categorias/form.vue
var categorias_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var categorias_form___vue_template_functional__ = false
/* styles */
var categorias_form___vue_styles__ = null
/* scopeId */
var categorias_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var categorias_form___vue_module_identifier__ = null
var categorias_form_Component = categorias_form_normalizeComponent(
  categorias_form,
  financeiro_categorias_form,
  categorias_form___vue_template_functional__,
  categorias_form___vue_styles__,
  categorias_form___vue_scopeId__,
  categorias_form___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_categorias_form = (categorias_form_Component.exports);

// CONCATENATED MODULE: ./src/features/financeiro/categorias/routes.js




/* harmony default export */ var categorias_routes = ([{
  path: '/financeiro/categorias',
  name: 'financeiro-categorias.index',
  component: features_financeiro_categorias,
  children: [{
    path: 'form/:id?',
    name: 'financeiro-categorias.form',
    component: features_financeiro_categorias_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/formas/index.vue



//




/* harmony default export */ var formas = ({
  name: 'Formas',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/financeiro/formas?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/financeiro/formas?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var forma, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                forma = obj.forma;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: forma.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, forma);
                } else {
                  _this3.list.unshift(forma);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(forma) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + forma.forma + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/financeiro/formas/' + forma.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: forma.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'financeiro-formas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'financeiro-formas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5825d0ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/formas/index.vue
var formas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('financeiro-forma.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('financeiro-forma.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'financeiro-formas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-formas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-financeiro-formas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(forma){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('financeiro-forma.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-formas.form', params: { id: forma.id } }}},[_vm._v(_vm._s(forma.forma))]):_c('span',[_vm._v(_vm._s(forma.forma))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!forma.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-forma.editar') > -1),expression:"permissoes.indexOf('financeiro-forma.editar') > -1"}],attrs:{"to":{ name: 'financeiro-formas.form', params: { id: forma.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-forma.excluir') > -1),expression:"permissoes.indexOf('financeiro-forma.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(forma)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var formas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Financeiro :: Formas de Pagamento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Forma de Pagamento")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var formas_esExports = { render: formas_render, staticRenderFns: formas_staticRenderFns }
/* harmony default export */ var financeiro_formas = (formas_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/formas/index.vue
var formas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var formas___vue_template_functional__ = false
/* styles */
var formas___vue_styles__ = null
/* scopeId */
var formas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var formas___vue_module_identifier__ = null
var formas_Component = formas_normalizeComponent(
  formas,
  financeiro_formas,
  formas___vue_template_functional__,
  formas___vue_styles__,
  formas___vue_scopeId__,
  formas___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_formas = (formas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/formas/form.vue



//



/* harmony default export */ var formas_form = ({
  name: 'Form',
  data: function data() {
    return {
      forma: {
        id: '',
        forma: '',
        ativo: true
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/financeiro/formas' : '/financeiro/formas/' + _this2.forma.id;
                _context.next = 4;
                return service_http[verb](url, _this2.forma);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-financeiro-formas-list', { forma: data.forma });
                  _this2.$router.push({ name: 'financeiro-formas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/financeiro/formas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.forma = data.forma;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.forma = {
        id: '',
        forma: '',
        ativo: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.forma.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad37311c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/formas/form.vue
var formas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m10"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.forma.forma),expression:"forma.forma"}],class:{invalid: _vm.errors.has('forma')},attrs:{"name":"forma","id":"forma","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.forma.forma)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forma, "forma", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"forma"}},[_vm._v("*Forma de Pagamento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('forma')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forma.ativo),expression:"forma.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.forma.ativo)?_vm._i(_vm.forma.ativo,null)>-1:(_vm.forma.ativo)},on:{"change":function($event){var $$a=_vm.forma.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.forma, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.forma, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.forma, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var formas_form_staticRenderFns = []
var formas_form_esExports = { render: formas_form_render, staticRenderFns: formas_form_staticRenderFns }
/* harmony default export */ var financeiro_formas_form = (formas_form_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/formas/form.vue
var formas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var formas_form___vue_template_functional__ = false
/* styles */
var formas_form___vue_styles__ = null
/* scopeId */
var formas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var formas_form___vue_module_identifier__ = null
var formas_form_Component = formas_form_normalizeComponent(
  formas_form,
  financeiro_formas_form,
  formas_form___vue_template_functional__,
  formas_form___vue_styles__,
  formas_form___vue_scopeId__,
  formas_form___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_formas_form = (formas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/financeiro/formas/routes.js




/* harmony default export */ var formas_routes = ([{
  path: '/financeiro/formas',
  name: 'financeiro-formas.index',
  component: features_financeiro_formas,
  children: [{
    path: 'form/:id?',
    name: 'financeiro-formas.form',
    component: features_financeiro_formas_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/pagar/index.vue









/* harmony default export */ var financeiro_pagar = ({
  name: 'Pagar',
  data: function data() {
    return {
      list: [],
      filterList: [],
      busca: '',
      filtro: {
        inicio: moment_default()().format('YYYY-MM-DD'),
        termino: moment_default()().format('YYYY-MM-DD'),
        conta: '',
        busca: ''
      },
      totais: {
        geral: 0,
        pago: 0,
        atrasado: 0,
        hoje: 0,
        pendente: 0
      },
      show: {
        totais: false,
        filtro: false
      },
      contas: [],
      pago: [],
      status: 'geral'
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY');
    },
    chipAtraso: function chipAtraso(data) {
      var vencimento = moment_default()(data).format('YYYY-MM-DD');
      var hoje = moment_default()().format('YYYY-MM-DD');
      if (hoje > vencimento) {
        return true;
      }
    },
    chipHoje: function chipHoje(data) {
      var hoje = moment_default()().format('YYYY-MM-DD');
      if (data === hoje) {
        return true;
      }
    },
    inicioPicker: function inicioPicker(val) {
      this.filtro.inicio = val;
    },
    terminoPicker: function terminoPicker(val) {
      this.filtro.termino = val;
    },

    contaSelect: function contaSelect(value) {
      this.filtro.conta = value;
    },
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service_http.get('/financeiro/pagar');

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.rows.data;
                  _this.filterList = data.rows.data;
                  _this.filtro = data.filtro;
                  _this.totais = data.totais;
                  _this.contas = data.contas;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filtrar: function filtrar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.busca = '';
                _context2.next = 3;
                return service_http.get('financeiro/pagar?inicio=' + _this2.filtro.inicio + '&termino=' + _this2.filtro.termino + '&conta=' + _this2.filtro.conta + '&busca=' + _this2.filtro.busca);

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this2.list = data.rows.data;
                _this2.filterList = data.rows.data;
                _this2.filtro = data.filtro;
                _this2.totais = data.totais;
                _this2.contas = data.contas;
                _this2.changeStatus(_this2.status);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.filtrar();
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(pagar) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + pagar.descricao + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/financeiro/pagar/' + pagar.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.filterList, { id: pagar.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.filterList.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    pagamentoMassa: function pagamentoMassa() {
      var _this5 = this;

      service_http.post('/financeiro/pagar/massa', this.pago).then(function (data) {
        _this5.pago = [];
        _this5.busca = '';
        _this5.fecth();
      });
    },
    changeStatus: function changeStatus(status) {
      var _this6 = this;

      this.status = status;
      this.filterList = this.list.filter(function (item) {
        if (status === 'geral') {
          return item.id;
        }
        if (status === 'pago') {
          return item.pago;
        }
        if (status === 'pendente') {
          return !item.pago;
        }
        if (status === 'hoje') {
          return _this6.chipHoje(item.vencimento);
        }
        if (status === 'atrasado') {
          return _this6.chipAtraso(item.vencimento) && !item.pago;
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'financeiro-pagar.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'financeiro-pagar.form';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    },
    hasItens: function hasItens() {
      return this.filterList.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9120abd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/pagar/index.vue
var pagar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m11"},[_c('h5',[_vm._v("Financeiro :: Contas a Pagar "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busca && !_vm.loading && _vm.showBtNovo),expression:"!busca && !loading && showBtNovo"}]},[_vm._v(_vm._s(_vm.formatDate(_vm.filtro.inicio))+" a "+_vm._s(_vm.formatDate(_vm.filtro.termino)))])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('financeiro-pagar.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('financeiro-pagar.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'financeiro-pagar.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-pagar.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-financeiro-pagar-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m10"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"filtro_conta"}},[_vm._v("Conta Bancária")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.conta),expression:"filtro.conta"}],attrs:{"name":"conta","id":"filtro_conta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "conta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s((conta.id) ? conta.conta : 'Todas'))])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.busca),expression:"filtro.busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.filtro.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "busca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer blue-grey darken-1",on:{"click":function($event){return _vm.changeStatus('geral')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Geral "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'geral'),expression:"status === 'geral'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.geral))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer green accent-4",on:{"click":function($event){return _vm.changeStatus('pago')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Pago "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'pago'),expression:"status === 'pago'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.pago))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer amber darken-4",on:{"click":function($event){return _vm.changeStatus('pendente')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Pendente "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'pendente'),expression:"status === 'pendente'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.pendente))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer amber accent-4",on:{"click":function($event){return _vm.changeStatus('hoje')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Hoje "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'hoje'),expression:"status === 'hoje'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.hoje))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer deep-orange accent-3",on:{"click":function($event){return _vm.changeStatus('atrasado')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Atrasado "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'atrasado'),expression:"status === 'atrasado'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.atrasado))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"card pointer deep-orange accent-4",attrs:{"to":{ name: 'financeiro-pagar.atrasados' },"tag":"div"}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Atras. Geral")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.atrasadoGeral))])])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.filterList),function(pagar){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(pagar.vencimento)))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('financeiro-pagar.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-pagar.form', params: { id: pagar.id } }}},[_vm._v(_vm._s(pagar.descricao)+"\n              ")]):_c('span',[_vm._v(_vm._s(pagar.descricao))]),_vm._v("\n              "+_vm._s((pagar.parcela !== '1/1') ? pagar.parcela : '')),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(pagar.fornecedor ? pagar.fornecedor.fornecedor : '')+" "+_vm._s(pagar.fornecedor && pagar.conta ?
                '|' : '')+" "+_vm._s(pagar.conta ? pagar.conta.conta : '')+"\n              ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(pagar.valor_pago))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(pagar.pago)?_c('span',{staticClass:"new badge green",attrs:{"data-badge-caption":"pago"}}):_vm._e(),_vm._v(" "),(!pagar.pago && _vm.chipAtraso(pagar.vencimento))?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"atrasado"}}):_vm._e(),_vm._v(" "),(!pagar.pago && _vm.chipHoje(pagar.vencimento))?_c('span',{staticClass:"new badge orange",attrs:{"data-badge-caption":"vence hoje"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!pagar.pago && _vm.permissoes.indexOf('financeiro-pagar.editar') > -1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pago),expression:"pago"}],attrs:{"type":"checkbox","id":pagar.id},domProps:{"value":pagar.id,"checked":Array.isArray(_vm.pago)?_vm._i(_vm.pago,pagar.id)>-1:(_vm.pago)},on:{"change":function($event){var $$a=_vm.pago,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=pagar.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pago=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pago=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pago=$$c}}}}):_vm._e(),_c('label',{attrs:{"for":pagar.id}}),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-pagar.editar') > -1),expression:"permissoes.indexOf('financeiro-pagar.editar') > -1"}],attrs:{"to":{ name: 'financeiro-pagar.form', params: { id: pagar.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-pagar.excluir') > -1),expression:"permissoes.indexOf('financeiro-pagar.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(pagar)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pago.length > 0 && _vm.showBtNovo && _vm.hasItens),expression:"pago.length > 0 && showBtNovo && hasItens"}],staticClass:"row",staticStyle:{"position":"fixed","bottom":"10px","width":"100%"}},[_c('div',{staticClass:"col s12 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn",on:{"click":function($event){$event.preventDefault();return _vm.pagamentoMassa()}}},[_c('i',{staticClass:"material-icons left"},[_vm._v("refresh")]),_vm._v("\n          definir item(s) como pagos")])])])])])}
var pagar_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m1"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_vm._v("Filtrar\n              ")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',[_vm._v("R$ Pagar")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var pagar_esExports = { render: pagar_render, staticRenderFns: pagar_staticRenderFns }
/* harmony default export */ var features_financeiro_pagar = (pagar_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/pagar/index.vue
var pagar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pagar___vue_template_functional__ = false
/* styles */
var pagar___vue_styles__ = null
/* scopeId */
var pagar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pagar___vue_module_identifier__ = null
var pagar_Component = pagar_normalizeComponent(
  financeiro_pagar,
  features_financeiro_pagar,
  pagar___vue_template_functional__,
  pagar___vue_styles__,
  pagar___vue_scopeId__,
  pagar___vue_module_identifier__
)

/* harmony default export */ var src_features_financeiro_pagar = (pagar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/pagar/form.vue







/* harmony default export */ var pagar_form = ({
  name: 'Form',
  data: function data() {
    return {
      categorias: [{}],
      contas: [{}],
      formas: [{}],
      fornecedores: [{}],
      vencimento: false,
      periodicidade: [{ id: 'dia', periodo: 'Diariamente' }, { id: 'semana', periodo: 'Semanalmente' }, {
        id: 'quinzena',
        periodo: 'Quinzenalmente'
      }, { id: 'mes', periodo: 'Mensalmente' }, { id: 'bimestre', periodo: 'Bimestralmente' }, {
        id: 'trimestre',
        periodo: 'Trimestralmente'
      }, { id: 'semestre', periodo: 'Semestralmente' }, { id: 'ano', periodo: 'Anualmente' }],
      conta: {
        id: '',
        categoria_id: '',
        conta_id: '',
        forma_id: '',
        fornecedor_id: '',
        descricao: '',
        observacoes: '',
        vencimento: '',
        valor: '',
        pago: false,
        data_pagamento: '',
        desconto: 0,
        juros: 0,
        valor_pago: '',
        repetir: false,
        periodicidade: 'mes',
        vezes: 1,
        anexos: [],
        anexo: ''
      },
      progress: 0,
      errorFile: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image',
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'financeiro',
          width: 2000,
          height: 2000,
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.conta.anexos.push({ anexo: xhr.response, legenda: files.name });
        this.$nextTick(function () {
          window.Materialize.updateTextFields();
        });
        this.progress = 0;
      }
    },
    destroyAnexo: function destroyAnexo(indexAnexo) {
      var _this = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma anexo \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this.conta.anexos[indexAnexo].id) {
          _this.conta.anexos.splice(indexAnexo, 1);
          window.Materialize.toast('Anexo excluído!', 4000);
        } else {
          service_http.delete('financeiro/pagar/anexo/' + _this.conta.anexos[indexAnexo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Anexo excluído!', 4000);
            _this.conta.anexos.splice(indexAnexo, 1);
          });
        }
      });
    },
    destroyImage: function destroyImage() {
      var _this2 = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this2.conta.anexo = '';
      });
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data, _ref2, _data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 5;
                return service_http.get('/financeiro/pagar/' + id + '/edit');

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                _this3.conta = data.conta;
                _this3.categorias = data.categorias;
                _this3.contas = data.contas;
                _this3.formas = data.formas;
                _this3.fornecedores = data.fornecedores;
                _context.next = 22;
                break;

              case 14:
                _context.next = 16;
                return service_http.get('/financeiro/pagar/create');

              case 16:
                _ref2 = _context.sent;
                _data = _ref2.data;

                _this3.categorias = _data.categorias;
                _this3.contas = _data.contas;
                _this3.formas = _data.formas;
                _this3.fornecedores = _data.fornecedores;

              case 22:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    validate: function validate() {
      var _this4 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this4.submit();
        }
      });
    },
    submit: function submit() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref3, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = _this5.isNew ? 'post' : 'put';
                url = _this5.isNew ? '/financeiro/pagar' : '/financeiro/pagar/' + _this5.conta.id;
                _context2.next = 4;
                return service_http[verb](url, _this5.conta);

              case 4:
                _ref3 = _context2.sent;
                data = _ref3.data;

                if (data != null) {
                  _this5.$emit('update-financeiro-pagar-list', { conta: data.conta });
                  _this5.$router.push({ name: 'financeiro-pagar.index' });
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    clear: function clear() {
      this.conta = {
        id: '',
        categoria_id: '',
        conta_id: '',
        forma_id: '',
        fornecedor_id: '',
        descricao: '',
        observacoes: '',
        vencimento: '',
        valor: '',
        pago: false,
        anexos: [],
        data_pagamento: '',
        desconto: 0,
        juros: 0,
        valor_pago: '',
        repetir: false,
        periodicidade: 'mes',
        vezes: 1,
        anexo: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.conta.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    valorpago: function valorpago() {
      if (this.conta.valor) {
        return parseFloat(this.conta.valor) + parseFloat(this.conta.juros) - parseFloat(this.conta.desconto);
      } else {
        return parseFloat(this.conta.juros) - parseFloat(this.conta.desconto);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8bc875e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/pagar/form.vue
var pagar_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.descricao),expression:"conta.descricao"}],class:{invalid: _vm.errors.has('descricao')},attrs:{"name":"descricao","id":"descricao","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.conta.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"descricao"}},[_vm._v("*Descrição")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"categoria_id"}},[_vm._v("*Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.categoria_id),expression:"conta.categoria_id"}],class:{invalid: _vm.errors.has('categoria_id')},attrs:{"name":"categoria_id","id":"categoria_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "categoria_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categorias),function(categoria){return _c('option',{domProps:{"value":categoria.id}},[_vm._v(_vm._s(categoria.categoria))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('categoria_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"fornecedor_id"}},[_vm._v("Fornecedor")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.fornecedor_id),expression:"conta.fornecedor_id"}],attrs:{"name":"fornecedor_id","id":"fornecedor_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "fornecedor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.fornecedores),function(fornecedor){return _c('option',{domProps:{"value":fornecedor.id}},[_vm._v(_vm._s(fornecedor.fornecedor))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"conta_id"}},[_vm._v("*Conta")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.conta_id),expression:"conta.conta_id"}],class:{invalid: _vm.errors.has('conta_id')},attrs:{"name":"conta_id","id":"conta_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "conta_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s(conta.conta))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('conta_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"forma_id"}},[_vm._v("*Forma de Pagamento")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.forma_id),expression:"conta.forma_id"}],class:{invalid: _vm.errors.has('forma_id')},attrs:{"name":"forma_id","id":"forma_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "forma_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.formas),function(forma){return _c('option',{domProps:{"value":forma.id}},[_vm._v(_vm._s(forma.forma))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('forma_id')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.vencimento),expression:"conta.vencimento"}],class:{invalid: _vm.errors.has('vencimento')},attrs:{"name":"vencimento","id":"icon_vencimento","type":"date","data-vv-rules":"required","data-value":_vm.conta.vencimento},domProps:{"value":(_vm.conta.vencimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "vencimento", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_vencimento"}},[_vm._v("*Vencimento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('vencimento')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.valor),expression:"conta.valor"}],class:{invalid: _vm.errors.has('valor')},attrs:{"name":"valor","id":"valor","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(_vm.conta.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*Valor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.repetir),expression:"conta.repetir"}],attrs:{"name":"repetir","id":"repetir","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.conta.repetir)?_vm._i(_vm.conta.repetir,null)>-1:(_vm.conta.repetir)},on:{"change":function($event){var $$a=_vm.conta.repetir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.conta, "repetir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.conta, "repetir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.conta, "repetir", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"repetir"}},[_vm._v("Repetir")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conta.repetir),expression:"conta.repetir"}],staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"periodicidade"}},[_vm._v("Periodicidade")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.periodicidade),expression:"conta.periodicidade"}],attrs:{"name":"periodicidade","id":"periodicidade"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "periodicidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.periodicidade),function(periodo){return _c('option',{domProps:{"value":periodo.id}},[_vm._v(_vm._s(periodo.periodo))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conta.repetir),expression:"conta.repetir"}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.vezes),expression:"conta.vezes"}],attrs:{"name":"vezes","id":"vezes","type":"text"},domProps:{"value":(_vm.conta.vezes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "vezes", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"vezes"}},[_vm._v("Nº de Vezes")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('vezes')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.pago),expression:"conta.pago"}],attrs:{"name":"pago","id":"pago","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.conta.pago)?_vm._i(_vm.conta.pago,null)>-1:(_vm.conta.pago)},on:{"change":function($event){var $$a=_vm.conta.pago,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.conta, "pago", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.conta, "pago", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.conta, "pago", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pago"}},[_vm._v("Pago")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conta.pago),expression:"conta.pago"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.conta.pago === true ? 'required' : ''),expression:"conta.pago === true ? 'required' : ''"},{name:"model",rawName:"v-model",value:(_vm.conta.data_pagamento),expression:"conta.data_pagamento"}],class:{invalid: _vm.errors.has('data_pagamento')},attrs:{"name":"data_pagamento","id":"icon_data_pagamento","type":"date","data-value":_vm.conta.data_pagamento},domProps:{"value":(_vm.conta.data_pagamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "data_pagamento", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_data_pagamento"}},[_vm._v("*Data Pagamento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('data_pagamento')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.desconto),expression:"conta.desconto"}],class:{invalid: _vm.errors.has('desconto')},attrs:{"name":"desconto","id":"desconto","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(_vm.conta.desconto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "desconto", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"desconto"}},[_vm._v("*Desconto")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('desconto')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.juros),expression:"conta.juros"}],class:{invalid: _vm.errors.has('juros')},attrs:{"name":"juros","id":"juros","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(_vm.conta.juros)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "juros", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"juros"}},[_vm._v("*Juros")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('juros')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorpago),expression:"valorpago"}],attrs:{"type":"number","id":"valorpago","step":"any","min":"0","readonly":"readonly"},domProps:{"value":(_vm.valorpago)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorpago=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"valorpago"}},[_vm._v("*Valor Pago")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.conta.anexos),function(anexo,indexAnexo){return _c('div',{staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/financeiro/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyAnexo(indexAnexo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card center"},[_c('span',{staticClass:"card-title"},[_vm._v("Anexo")])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.conta.anexo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")]),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/financeiro/" + (_vm.conta.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons pointer"},[_vm._v("search")])])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var pagar_form_staticRenderFns = []
var pagar_form_esExports = { render: pagar_form_render, staticRenderFns: pagar_form_staticRenderFns }
/* harmony default export */ var financeiro_pagar_form = (pagar_form_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/pagar/form.vue
var pagar_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pagar_form___vue_template_functional__ = false
/* styles */
var pagar_form___vue_styles__ = null
/* scopeId */
var pagar_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pagar_form___vue_module_identifier__ = null
var pagar_form_Component = pagar_form_normalizeComponent(
  pagar_form,
  financeiro_pagar_form,
  pagar_form___vue_template_functional__,
  pagar_form___vue_styles__,
  pagar_form___vue_scopeId__,
  pagar_form___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_pagar_form = (pagar_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/pagar/atrasado.vue









/* harmony default export */ var atrasado = ({
  name: 'Pagar',
  data: function data() {
    return {
      list: [],
      filtro: {
        busca: '',
        conta: ''
      },
      total: '0,00',
      contas: [],
      pago: []
    };
  },
  mounted: function mounted() {
    this.filtrar();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY');
    },
    filtrar: function filtrar() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.busca = '';
                _context.next = 3;
                return service_http.get('financeiro/pagar/atraso?conta=' + _this.filtro.conta + '&busca=' + _this.filtro.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.list = data.rows.data;
                _this.filtro = data.filtro;
                _this.total = data.total;
                _this.contas = data.contas;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateList: function updateList(obj) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.filtrar();
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    destroy: function destroy(pagar) {
      var _this3 = this;

      this.$swal({
        title: 'Deseja remover ' + pagar.descricao + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref3, data, index;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return service_http.delete('/financeiro/pagar/' + pagar.id);

              case 2:
                _ref3 = _context3.sent;
                data = _ref3.data;

                if (!(data != null)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 7;
                return findIndex_default()(_this3.list, { id: pagar.id });

              case 7:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      })));
    },
    pagamentoMassa: function pagamentoMassa() {
      var _this4 = this;

      service_http.post('/financeiro/pagar/massa', this.pago).then(function (data) {
        _this4.pago = [];
        _this4.busca = '';
        _this4.fecth();
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f2b8fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/pagar/atrasado.vue
var atrasado_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m11"},[_c('h5',[_vm._v("Financeiro :: Contas a Pagar em Atraso :: R$ "+_vm._s(_vm.total))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m1 input-field right-align"},[_c('router-link',{staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-pagar.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"filtro_conta"}},[_vm._v("Conta Bancária")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.conta),expression:"filtro.conta"}],attrs:{"name":"conta","id":"filtro_conta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "conta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s((conta.id) ? conta.conta : 'Todas'))])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.busca),expression:"filtro.busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.filtro.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "busca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasItens && !_vm.loading),expression:"!hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasItens),expression:"hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(pagar){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(pagar.vencimento)))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('financeiro-pagar.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-pagar.form', params: { id: pagar.id } }}},[_vm._v(_vm._s(pagar.descricao)+"\n              ")]):_c('span',[_vm._v(_vm._s(pagar.descricao))]),_vm._v("\n              "+_vm._s((pagar.parcela !== '1/1') ? pagar.parcela : '')),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(pagar.fornecedor ? pagar.fornecedor.fornecedor : '')+" "+_vm._s(pagar.fornecedor && pagar.conta ?
                '|' : '')+" "+_vm._s(pagar.conta ? pagar.conta.conta : '')+"\n              ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(pagar.valor_pago))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!pagar.pago && _vm.permissoes.indexOf('financeiro-pagar.editar') > -1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pago),expression:"pago"}],attrs:{"type":"checkbox","id":pagar.id},domProps:{"value":pagar.id,"checked":Array.isArray(_vm.pago)?_vm._i(_vm.pago,pagar.id)>-1:(_vm.pago)},on:{"change":function($event){var $$a=_vm.pago,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=pagar.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pago=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pago=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pago=$$c}}}}):_vm._e(),_c('label',{attrs:{"for":pagar.id}}),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-pagar.editar') > -1),expression:"permissoes.indexOf('financeiro-pagar.editar') > -1"}],attrs:{"to":{ name: 'financeiro-pagar.form', params: { id: pagar.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-pagar.excluir') > -1),expression:"permissoes.indexOf('financeiro-pagar.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(pagar)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pago.length > 0 && _vm.showBtNovo && _vm.hasItens),expression:"pago.length > 0 && showBtNovo && hasItens"}],staticClass:"row",staticStyle:{"position":"fixed","bottom":"10px","width":"100%"}},[_c('div',{staticClass:"col s12 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn",on:{"click":function($event){$event.preventDefault();return _vm.pagamentoMassa()}}},[_c('i',{staticClass:"material-icons left"},[_vm._v("refresh")]),_vm._v("\n          definir item(s) como pagos")])])])])])}
var atrasado_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m1"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_vm._v("Filtrar\n              ")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',[_vm._v("R$ Pagar")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var atrasado_esExports = { render: atrasado_render, staticRenderFns: atrasado_staticRenderFns }
/* harmony default export */ var pagar_atrasado = (atrasado_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/pagar/atrasado.vue
var atrasado_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var atrasado___vue_template_functional__ = false
/* styles */
var atrasado___vue_styles__ = null
/* scopeId */
var atrasado___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var atrasado___vue_module_identifier__ = null
var atrasado_Component = atrasado_normalizeComponent(
  atrasado,
  pagar_atrasado,
  atrasado___vue_template_functional__,
  atrasado___vue_styles__,
  atrasado___vue_scopeId__,
  atrasado___vue_module_identifier__
)

/* harmony default export */ var financeiro_pagar_atrasado = (atrasado_Component.exports);

// CONCATENATED MODULE: ./src/features/financeiro/pagar/routes.js





/* harmony default export */ var pagar_routes = ([{
  path: '/financeiro/pagar',
  name: 'financeiro-pagar.index',
  component: src_features_financeiro_pagar,
  children: [{
    path: 'form/:id?',
    name: 'financeiro-pagar.form',
    component: features_financeiro_pagar_form
  }]
}, {
  path: '/financeiro/pagar/atrasados',
  name: 'financeiro-pagar.atrasados',
  component: financeiro_pagar_atrasado
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/receber/index.vue



//





/* harmony default export */ var financeiro_receber = ({
  name: 'Receber',
  data: function data() {
    return {
      list: [],
      filterList: [],
      busca: '',
      filtro: {
        inicio: moment_default()().format('YYYY-MM-DD'),
        termino: moment_default()().format('YYYY-MM-DD'),
        conta: '',
        busca: ''
      },
      totais: {
        geral: 0,
        pago: 0,
        atrasado: 0,
        hoje: 0,
        pendente: 0
      },
      show: {
        totais: false,
        filtro: false
      },
      contas: [],
      pago: [],
      status: 'geral'
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY');
    },
    chipAtraso: function chipAtraso(data) {
      var vencimento = moment_default()(data).format('YYYY-MM-DD');
      var hoje = moment_default()().format('YYYY-MM-DD');
      if (hoje > vencimento) {
        return true;
      }
    },
    chipHoje: function chipHoje(data) {
      var hoje = moment_default()().format('YYYY-MM-DD');
      if (data === hoje) {
        return true;
      }
    },
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service_http.get('/financeiro/receber');

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.rows.data;
                  _this.filterList = data.rows.data;
                  _this.filtro = data.filtro;
                  _this.totais = data.totais;
                  _this.contas = data.contas;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filtrar: function filtrar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.busca = '';
                _context2.next = 3;
                return service_http.get('financeiro/receber?inicio=' + _this2.filtro.inicio + '&termino=' + _this2.filtro.termino + '&conta=' + _this2.filtro.conta + '&busca=' + _this2.filtro.busca);

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this2.list = data.rows.data;
                _this2.filterList = data.rows.data;
                _this2.filtro = data.filtro;
                _this2.totais = data.totais;
                _this2.contas = data.contas;
                _this2.changeStatus(_this2.status);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.filtrar();
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(receber) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + receber.descricao + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/financeiro/receber/' + receber.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.filterList, { id: receber.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.filterList.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    pagamentoMassa: function pagamentoMassa() {
      var _this5 = this;

      service_http.post('/financeiro/receber/massa', this.pago).then(function (data) {
        _this5.pago = [];
        _this5.busca = '';
        _this5.fecth();
      });
    },
    changeStatus: function changeStatus(status) {
      var _this6 = this;

      this.status = status;
      this.filterList = this.list.filter(function (item) {
        if (status === 'geral') {
          return item.id;
        }
        if (status === 'pago') {
          return item.pago;
        }
        if (status === 'pendente') {
          return !item.pago;
        }
        if (status === 'hoje') {
          return _this6.chipHoje(item.vencimento);
        }
        if (status === 'atrasado') {
          return _this6.chipAtraso(item.vencimento) && !item.pago;
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'financeiro-receber.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'financeiro-receber.form';
    },
    hasItens: function hasItens() {
      return this.filterList.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e9b18a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/receber/index.vue
var receber_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m11"},[_c('h5',[_vm._v("Financeiro :: Contas a Receber "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.busca && !_vm.loading && _vm.showBtNovo),expression:"!busca && !loading && showBtNovo"}]},[_vm._v(_vm._s(_vm.formatDate(_vm.filtro.inicio))+" a "+_vm._s(_vm.formatDate(_vm.filtro.termino)))])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('financeiro-receber.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('financeiro-receber.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'financeiro-receber.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-receber.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-financeiro-receber-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m10"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"filtro_conta"}},[_vm._v("Conta Bancária")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.conta),expression:"filtro.conta"}],attrs:{"name":"conta","id":"filtro_conta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "conta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s((conta.id) ? conta.conta : 'Todas'))])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.busca),expression:"filtro.busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.filtro.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "busca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer blue-grey darken-1",on:{"click":function($event){return _vm.changeStatus('geral')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Geral "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'geral'),expression:"status === 'geral'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.geral))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer green accent-4",on:{"click":function($event){return _vm.changeStatus('pago')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Pago "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'pago'),expression:"status === 'pago'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.pago))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer amber darken-4",on:{"click":function($event){return _vm.changeStatus('pendente')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Pendente "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'pendente'),expression:"status === 'pendente'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.pendente))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer amber accent-4",on:{"click":function($event){return _vm.changeStatus('hoje')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Hoje "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'hoje'),expression:"status === 'hoje'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.hoje))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer deep-orange accent-3",on:{"click":function($event){return _vm.changeStatus('atrasado')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Atrasado "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'atrasado'),expression:"status === 'atrasado'"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.atrasado))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('router-link',{staticClass:"card pointer deep-orange accent-4",attrs:{"to":{ name: 'financeiro-receber.atrasados', params: { geral: 'geral' } },"tag":"div"}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Atras. Geral")]),_vm._v(" "),_c('p',[_vm._v("R$ "+_vm._s(_vm.totais.atrasadoGeral))])])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.filterList),function(receber){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(receber.vencimento)))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('financeiro-receber.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-receber.form', params: { id: receber.id } }}},[_vm._v(_vm._s(receber.descricao))]):_c('span',[_vm._v(_vm._s(receber.descricao))]),_vm._v("\n                  "+_vm._s((receber.parcela !== '1/1') ? receber.parcela : '')),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(receber.cliente ? receber.cliente.cliente : '')+" "+_vm._s(receber.cliente && receber.conta ? '|' : '')+" "+_vm._s(receber.conta ? receber.conta.conta : ''))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(receber.valor_pago))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(receber.pago)?_c('span',{staticClass:"new badge green",attrs:{"data-badge-caption":"pago"}}):_vm._e(),_vm._v(" "),(!receber.pago && _vm.chipAtraso(receber.vencimento))?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"atrasado"}}):_vm._e(),_vm._v(" "),(!receber.pago && _vm.chipHoje(receber.vencimento))?_c('span',{staticClass:"new badge orange",attrs:{"data-badge-caption":"vence hoje"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!receber.pago && _vm.permissoes.indexOf('financeiro-receber.editar') > -1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pago),expression:"pago"}],attrs:{"type":"checkbox","id":receber.id},domProps:{"value":receber.id,"checked":Array.isArray(_vm.pago)?_vm._i(_vm.pago,receber.id)>-1:(_vm.pago)},on:{"change":function($event){var $$a=_vm.pago,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=receber.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pago=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pago=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pago=$$c}}}}):_vm._e(),_c('label',{attrs:{"for":receber.id}}),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-receber.editar') > -1),expression:"permissoes.indexOf('financeiro-receber.editar') > -1"}],attrs:{"to":{ name: 'financeiro-receber.form', params: { id: receber.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-receber.excluir') > -1),expression:"permissoes.indexOf('financeiro-receber.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(receber)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pago.length > 0 && _vm.showBtNovo && _vm.hasItens),expression:"pago.length > 0 && showBtNovo && hasItens"}],staticClass:"row",staticStyle:{"position":"fixed","bottom":"10px","width":"100%"}},[_c('div',{staticClass:"col s12 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn",on:{"click":function($event){$event.preventDefault();return _vm.pagamentoMassa()}}},[_c('i',{staticClass:"material-icons left"},[_vm._v("refresh")]),_vm._v(" definir item(s) como pagos")])])])])])}
var receber_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m1"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_vm._v("Filtrar")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m3"},[_c('a',{staticClass:"waves-effect waves-light btn blue",attrs:{"href":"https://sistemakgb.com.br/integracao/conta-azul","target":"_blank"}},[_vm._v("Sync Conta Azul")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',[_vm._v("R$ Receber")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var receber_esExports = { render: receber_render, staticRenderFns: receber_staticRenderFns }
/* harmony default export */ var features_financeiro_receber = (receber_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/receber/index.vue
var receber_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var receber___vue_template_functional__ = false
/* styles */
var receber___vue_styles__ = null
/* scopeId */
var receber___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var receber___vue_module_identifier__ = null
var receber_Component = receber_normalizeComponent(
  financeiro_receber,
  features_financeiro_receber,
  receber___vue_template_functional__,
  receber___vue_styles__,
  receber___vue_scopeId__,
  receber___vue_module_identifier__
)

/* harmony default export */ var src_features_financeiro_receber = (receber_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/receber/form.vue



//



/* harmony default export */ var receber_form = ({
  name: 'Form',
  data: function data() {
    return {
      categorias: [{}],
      contas: [{}],
      formas: [{}],
      clientes: [{}],
      fornecedores: [{}],
      vencimento: false,
      periodicidade: [{ id: 'dia', periodo: 'Diariamente' }, { id: 'semana', periodo: 'Semanalmente' }, { id: 'quinzena', periodo: 'Quinzenalmente' }, { id: 'mes', periodo: 'Mensalmente' }, { id: 'bimestre', periodo: 'Bimestralmente' }, { id: 'trimestre', periodo: 'Trimestralmente' }, { id: 'semestre', periodo: 'Semestralmente' }, { id: 'ano', periodo: 'Anualmente' }],
      conta: {
        id: '',
        categoria_id: '',
        conta_id: '',
        forma_id: '',
        cliente_id: '',
        descricao: '',
        observacoes: '',
        vencimento: '',
        valor: '',
        anexos: [],
        pago: false,
        data_pagamento: '',
        desconto: 0,
        juros: 0,
        valor_pago: '',
        repetir: false,
        periodicidade: 'mes',
        vezes: 1,
        anexo: ''
      },
      progress: 0,
      errorFile: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-file',
        uploadMultiple: false,
        headers: {
          path: 'financeiro',
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.conta.anexos.push({ anexo: xhr.response, legenda: files.name });
        this.$nextTick(function () {
          window.Materialize.updateTextFields();
        });
        this.progress = 0;
      }
    },
    destroyImage: function destroyImage() {
      var _this = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this.conta.anexo = '';
      });
    },
    fecth: function fecth() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data, _ref2, _data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.clear();
                id = _this2.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 5;
                return service_http.get('/financeiro/receber/' + id + '/edit');

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                _this2.conta = data.conta;
                _this2.categorias = data.categorias;
                _this2.contas = data.contas;
                _this2.formas = data.formas;
                _this2.clientes = data.clientes;
                _context.next = 22;
                break;

              case 14:
                _context.next = 16;
                return service_http.get('/financeiro/receber/create');

              case 16:
                _ref2 = _context.sent;
                _data = _ref2.data;

                _this2.categorias = _data.categorias;
                _this2.contas = _data.contas;
                _this2.formas = _data.formas;
                _this2.clientes = _data.clientes;

              case 22:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this3.submit();
        }
      });
    },
    submit: function submit() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref3, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = _this4.isNew ? 'post' : 'put';
                url = _this4.isNew ? '/financeiro/receber' : '/financeiro/receber/' + _this4.conta.id;
                _context2.next = 4;
                return service_http[verb](url, _this4.conta);

              case 4:
                _ref3 = _context2.sent;
                data = _ref3.data;

                if (data != null) {
                  _this4.$emit('update-financeiro-receber-list', { conta: data.conta });
                  _this4.$router.push({ name: 'financeiro-receber.index' });
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    destroyAnexo: function destroyAnexo(indexAnexo) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma anexo \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this5.conta.anexos[indexAnexo].id) {
          _this5.conta.anexos.splice(indexAnexo, 1);
          window.Materialize.toast('Anexo excluído!', 4000);
        } else {
          service_http.delete('financeiro/receber/anexo/' + _this5.conta.anexos[indexAnexo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Anexo excluído!', 4000);
            _this5.conta.anexos.splice(indexAnexo, 1);
          });
        }
      });
    },
    clear: function clear() {
      this.conta = {
        id: '',
        categoria_id: '',
        conta_id: '',
        forma_id: '',
        cliente_id: '',
        descricao: '',
        observacoes: '',
        vencimento: '',
        anexos: [],
        valor: '',
        pago: false,
        data_pagamento: '',
        desconto: 0,
        juros: 0,
        valor_pago: '',
        repetir: false,
        periodicidade: 'mes',
        vezes: 1,
        anexo: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.conta.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    valorpago: function valorpago() {
      if (this.conta.valor) {
        return parseFloat(this.conta.valor) + parseFloat(this.conta.juros) - parseFloat(this.conta.desconto);
      } else {
        return parseFloat(this.conta.juros) - parseFloat(this.conta.desconto);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f5aaf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/receber/form.vue
var receber_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.descricao),expression:"conta.descricao"}],class:{invalid: _vm.errors.has('descricao')},attrs:{"name":"descricao","id":"descricao","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.conta.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"descricao"}},[_vm._v("*Descrição")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"categoria_id"}},[_vm._v("*Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.categoria_id),expression:"conta.categoria_id"}],class:{invalid: _vm.errors.has('categoria_id')},attrs:{"name":"categoria_id","id":"categoria_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "categoria_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categorias),function(categoria){return _c('option',{domProps:{"value":categoria.id}},[_vm._v(_vm._s(categoria.categoria))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('categoria_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"cliente_id"}},[_vm._v("Cliente")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.cliente_id),expression:"conta.cliente_id"}],attrs:{"name":"cliente_id","id":"cliente_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "cliente_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.clientes),function(cliente){return _c('option',{domProps:{"value":cliente.id}},[_vm._v(_vm._s(cliente.cliente))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"conta_id"}},[_vm._v("*Conta")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.conta_id),expression:"conta.conta_id"}],class:{invalid: _vm.errors.has('conta_id')},attrs:{"name":"conta_id","id":"conta_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "conta_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s(conta.conta))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('conta_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"forma_id"}},[_vm._v("*Forma de Pagamento")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.forma_id),expression:"conta.forma_id"}],class:{invalid: _vm.errors.has('forma_id')},attrs:{"name":"forma_id","id":"forma_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "forma_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.formas),function(forma){return _c('option',{domProps:{"value":forma.id}},[_vm._v(_vm._s(forma.forma))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('forma_id')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.vencimento),expression:"conta.vencimento"}],class:{invalid: _vm.errors.has('vencimento')},attrs:{"name":"vencimento","id":"icon_vencimento","type":"date","data-vv-rules":"required","data-value":_vm.conta.vencimento},domProps:{"value":(_vm.conta.vencimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "vencimento", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_vencimento"}},[_vm._v("*Vencimento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('vencimento')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.valor),expression:"conta.valor"}],class:{invalid: _vm.errors.has('valor')},attrs:{"name":"valor","id":"valor","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(_vm.conta.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*Valor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.repetir),expression:"conta.repetir"}],attrs:{"name":"repetir","id":"repetir","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.conta.repetir)?_vm._i(_vm.conta.repetir,null)>-1:(_vm.conta.repetir)},on:{"change":function($event){var $$a=_vm.conta.repetir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.conta, "repetir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.conta, "repetir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.conta, "repetir", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"repetir"}},[_vm._v("Repetir")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conta.repetir),expression:"conta.repetir"}],staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"periodicidade"}},[_vm._v("Periodicidade")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.periodicidade),expression:"conta.periodicidade"}],attrs:{"name":"periodicidade","id":"periodicidade"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "periodicidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.periodicidade),function(periodo){return _c('option',{domProps:{"value":periodo.id}},[_vm._v(_vm._s(periodo.periodo))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conta.repetir),expression:"conta.repetir"}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.vezes),expression:"conta.vezes"}],attrs:{"name":"vezes","id":"vezes","type":"text"},domProps:{"value":(_vm.conta.vezes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "vezes", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"vezes"}},[_vm._v("Nº de Vezes")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('vezes')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.pago),expression:"conta.pago"}],attrs:{"name":"pago","id":"pago","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.conta.pago)?_vm._i(_vm.conta.pago,null)>-1:(_vm.conta.pago)},on:{"change":function($event){var $$a=_vm.conta.pago,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.conta, "pago", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.conta, "pago", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.conta, "pago", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pago"}},[_vm._v("Pago")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.conta.pago),expression:"conta.pago"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.conta.pago === true ? 'required' : ''),expression:"conta.pago === true ? 'required' : ''"},{name:"model",rawName:"v-model",value:(_vm.conta.data_pagamento),expression:"conta.data_pagamento"}],class:{invalid: _vm.errors.has('data_pagamento')},attrs:{"name":"data_pagamento","id":"icon_data_pagamento","type":"date","data-value":_vm.conta.data_pagamento},domProps:{"value":(_vm.conta.data_pagamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "data_pagamento", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_data_pagamento"}},[_vm._v("*Data Pagamento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('data_pagamento')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.desconto),expression:"conta.desconto"}],class:{invalid: _vm.errors.has('desconto')},attrs:{"name":"desconto","id":"desconto","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(_vm.conta.desconto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "desconto", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"desconto"}},[_vm._v("*Desconto")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('desconto')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.juros),expression:"conta.juros"}],class:{invalid: _vm.errors.has('juros')},attrs:{"name":"juros","id":"juros","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(_vm.conta.juros)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "juros", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"juros"}},[_vm._v("*Juros")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('juros')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valorpago),expression:"valorpago"}],attrs:{"type":"number","id":"valorpago","step":"any","min":"0","readonly":"readonly"},domProps:{"value":(_vm.valorpago)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valorpago=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"valorpago"}},[_vm._v("*Valor Pago")])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.conta.anexos),function(anexo,indexAnexo){return _c('div',{staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/financeiro/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyAnexo(indexAnexo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card center"},[_c('span',{staticClass:"card-title"},[_vm._v("Anexo")])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.conta.anexo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")]),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/financeiro/" + (_vm.conta.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons pointer"},[_vm._v("search")])])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var receber_form_staticRenderFns = []
var receber_form_esExports = { render: receber_form_render, staticRenderFns: receber_form_staticRenderFns }
/* harmony default export */ var financeiro_receber_form = (receber_form_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/receber/form.vue
var receber_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var receber_form___vue_template_functional__ = false
/* styles */
var receber_form___vue_styles__ = null
/* scopeId */
var receber_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var receber_form___vue_module_identifier__ = null
var receber_form_Component = receber_form_normalizeComponent(
  receber_form,
  financeiro_receber_form,
  receber_form___vue_template_functional__,
  receber_form___vue_styles__,
  receber_form___vue_scopeId__,
  receber_form___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_receber_form = (receber_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/receber/formOs.vue



//



/* harmony default export */ var formOs = ({
  name: 'Form',
  data: function data() {
    return {
      categorias: [],
      contas: [],
      formas: [],
      vencimento: false,
      cliente: {
        cliente: ''
      },
      conta: {
        id: '',
        categoria_id: '',
        os_id: '',
        orcamento_id: '',
        conta_id: '',
        forma_id: '',
        cliente_id: '',
        descricao: '',
        observacoes: '',
        parcelas: []
      },
      os: {
        valor: 0,
        proposta: {
          pagamento: {
            pagamento: ''
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.clear();
                id = _this.$route.params.id;
                _context.next = 4;
                return service_http.get('/financeiro/receber/' + id + '/os');

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                _this.os = data.os;
                _this.conta.os_id = data.os.id;
                _this.conta.orcamento_id = data.os.orcamento_id;
                _this.conta.cliente_id = data.os.cliente_id;
                _this.conta.forma_id = data.os && data.os.proposta && data.os.proposta.pagamento ? data.os.proposta.pagamento.forma_id : '';
                _this.conta.descricao = 'Faturamento OS #' + data.os.id;
                _this.conta.categoria_id = 76;
                _this.categorias = data.categorias;
                _this.contas = data.contas;
                _this.formas = data.formas;
                _this.cliente = data.os.cliente;
                _this.conta.parcelas = data.parcelas;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this2.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this2.submit();
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = 'post';
                url = '/financeiro/receber/os';
                _context2.next = 4;
                return service_http[verb](url, _this3.conta);

              case 4:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this3.$emit('update-financeiro-receber-list', { conta: data.conta });
                  _this3.$router.push({ name: 'os.form', params: { id: _this3.conta.os_id } });
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.conta = {
        id: '',
        categoria_id: '',
        os_id: '',
        orcamento_id: '',
        conta_id: '',
        forma_id: '',
        cliente_id: '',
        descricao: '',
        observacoes: '',
        parcelas: []
      };
    },
    destroyParcela: function destroyParcela(index) {
      var _this4 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma Parcela \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this4.conta.parcelas.splice(index, 1);
        window.Materialize.toast('Parcela excluída!', 4000);
      });
    },
    addParcela: function addParcela() {
      this.conta.parcelas.push({ vencimento: '', valor: '' });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    valorTotal: function valorTotal() {
      var valor = 0;
      if (this.conta.parcelas.length > 0) {
        this.conta.parcelas.forEach(function (item) {
          if (item.valor) {
            valor += parseFloat(item.valor);
          }
        });
      }
      return parseFloat(valor);
    },
    pagamentoLabel: function pagamentoLabel() {
      return this.os && this.os.proposta && this.os.proposta.pagamento ? this.os.proposta.pagamento.pagamento : '-';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7d36a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/receber/formOs.vue
var formOs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.cliente),expression:"cliente.cliente"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.cliente.cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cliente", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Cliente")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conta.os_id),expression:"conta.os_id"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.conta.os_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "os_id", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"descricao"}},[_vm._v("#OS")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.valor),expression:"os.valor"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.os.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("R$")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagamentoLabel),expression:"pagamentoLabel"}],attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.pagamentoLabel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pagamentoLabel=$event.target.value}}}),_vm._v(" "),_c('label',[_vm._v("Forma de Pagamento")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.descricao),expression:"conta.descricao"}],class:{invalid: _vm.errors.has('descricao')},attrs:{"name":"descricao","id":"descricao","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.conta.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.conta, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"descricao"}},[_vm._v("*Descrição")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"categoria_id"}},[_vm._v("*Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.categoria_id),expression:"conta.categoria_id"}],class:{invalid: _vm.errors.has('categoria_id')},attrs:{"name":"categoria_id","id":"categoria_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "categoria_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categorias),function(categoria){return _c('option',{domProps:{"value":categoria.id}},[_vm._v(_vm._s(categoria.categoria))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('categoria_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"conta_id"}},[_vm._v("*Conta")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.conta_id),expression:"conta.conta_id"}],class:{invalid: _vm.errors.has('conta_id')},attrs:{"name":"conta_id","id":"conta_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "conta_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s(conta.conta))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('conta_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"forma_id"}},[_vm._v("*Forma de Pagamento")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.conta.forma_id),expression:"conta.forma_id"}],class:{invalid: _vm.errors.has('forma_id')},attrs:{"name":"forma_id","id":"forma_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.conta, "forma_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.formas),function(forma){return _c('option',{domProps:{"value":forma.id}},[_vm._v(_vm._s(forma.forma))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('forma_id')))])])]),_vm._v(" "),_vm._l((_vm.conta.parcelas),function(parcela,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(parcela.vencimento),expression:"parcela.vencimento"}],class:{invalid: _vm.errors.has('vencimento' + index)},attrs:{"name":"vencimento","id":("icon_vencimento" + index),"type":"date","data-vv-rules":"required","data-value":parcela.vencimento},domProps:{"value":(parcela.vencimento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(parcela, "vencimento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("icon_vencimento" + index)}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('vencimento'+index)))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(parcela.valor),expression:"parcela.valor"}],class:{invalid: _vm.errors.has('valor'+index)},attrs:{"name":"valor","id":"valor","type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(parcela.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(parcela, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*Valor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor'+index)))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m1"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyParcela(index)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addParcela()}}},[_vm._v("Adicionar Parcela")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(parseFloat(_vm.os.valor) !== _vm.valorTotal),expression:"parseFloat(os.valor) !== valorTotal"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('span',{staticClass:"red-text"},[_vm._v("Valor total das parcelas "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.valorTotal))]),_vm._v(" não corresponde com o valor da OS "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.os.valor))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(parseFloat(_vm.os.valor) > _vm.valorTotal),expression:"parseFloat(os.valor) > valorTotal"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('span',{staticClass:"red-text"},[_vm._v("Pendente "),_c('strong',[_vm._v("R$ "+_vm._s(parseFloat(_vm.os.valor) - _vm.valorTotal))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading || parseFloat(_vm.os.valor) !== _vm.valorTotal},on:{"click":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_vm._v("Salvar")])])])],2)])])])}
var formOs_staticRenderFns = []
var formOs_esExports = { render: formOs_render, staticRenderFns: formOs_staticRenderFns }
/* harmony default export */ var receber_formOs = (formOs_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/receber/formOs.vue
var formOs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var formOs___vue_template_functional__ = false
/* styles */
var formOs___vue_styles__ = null
/* scopeId */
var formOs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var formOs___vue_module_identifier__ = null
var formOs_Component = formOs_normalizeComponent(
  formOs,
  receber_formOs,
  formOs___vue_template_functional__,
  formOs___vue_styles__,
  formOs___vue_scopeId__,
  formOs___vue_module_identifier__
)

/* harmony default export */ var financeiro_receber_formOs = (formOs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/receber/atrasado.vue









/* harmony default export */ var receber_atrasado = ({
  name: 'Pagar',
  data: function data() {
    return {
      list: [],
      filtro: {
        busca: '',
        conta: ''
      },
      total: '0,00',
      contas: [],
      pago: []
    };
  },
  mounted: function mounted() {
    this.filtrar();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY');
    },
    filtrar: function filtrar() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.busca = '';
                _context.next = 3;
                return service_http.get('financeiro/receber/atraso?conta=' + _this.filtro.conta + '&busca=' + _this.filtro.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.list = data.rows.data;
                _this.filtro = data.filtro;
                _this.total = data.total;
                _this.contas = data.contas;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateList: function updateList(obj) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.filtrar();
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    destroy: function destroy(receber) {
      var _this3 = this;

      this.$swal({
        title: 'Deseja remover ' + receber.descricao + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref3, data, index;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return service_http.delete('/financeiro/receber/' + receber.id);

              case 2:
                _ref3 = _context3.sent;
                data = _ref3.data;

                if (!(data != null)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 7;
                return findIndex_default()(_this3.list, { id: receber.id });

              case 7:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      })));
    },
    pagamentoMassa: function pagamentoMassa() {
      var _this4 = this;

      service_http.post('/financeiro/receber/massa', this.pago).then(function (data) {
        _this4.pago = [];
        _this4.busca = '';
        _this4.fecth();
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbaa55a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/receber/atrasado.vue
var receber_atrasado_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m11"},[_c('h5',[_vm._v("Financeiro :: Contas a Receber em Atraso :: R$ "+_vm._s(_vm.total))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m1 input-field right-align"},[_c('router-link',{staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'financeiro-receber.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"filtro_conta"}},[_vm._v("Conta Bancária")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.conta),expression:"filtro.conta"}],attrs:{"name":"conta","id":"filtro_conta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "conta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s((conta.id) ? conta.conta : 'Todas'))])}),0)]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.busca),expression:"filtro.busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.filtro.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "busca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasItens && !_vm.loading),expression:"!hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasItens),expression:"hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(receber){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(receber.vencimento)))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('financeiro-receber.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'financeiro-receber.form', params: { id: receber.id } }}},[_vm._v(_vm._s(receber.descricao)+"\n              ")]):_c('span',[_vm._v(_vm._s(receber.descricao))]),_vm._v("\n              "+_vm._s((receber.parcela !== '1/1') ? receber.parcela : '')),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(receber.fornecedor ? receber.fornecedor.fornecedor : '')+" "+_vm._s(receber.fornecedor && receber.conta ?
                '|' : '')+" "+_vm._s(receber.conta ? receber.conta.conta : '')+"\n              ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(receber.valor_pago))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!receber.pago && _vm.permissoes.indexOf('financeiro-receber.editar') > -1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pago),expression:"pago"}],attrs:{"type":"checkbox","id":receber.id},domProps:{"value":receber.id,"checked":Array.isArray(_vm.pago)?_vm._i(_vm.pago,receber.id)>-1:(_vm.pago)},on:{"change":function($event){var $$a=_vm.pago,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=receber.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pago=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pago=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pago=$$c}}}}):_vm._e(),_c('label',{attrs:{"for":receber.id}}),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-receber.editar') > -1),expression:"permissoes.indexOf('financeiro-receber.editar') > -1"}],attrs:{"to":{ name: 'financeiro-receber.form', params: { id: receber.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('financeiro-receber.excluir') > -1),expression:"permissoes.indexOf('financeiro-receber.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(receber)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pago.length > 0 && _vm.showBtNovo && _vm.hasItens),expression:"pago.length > 0 && showBtNovo && hasItens"}],staticClass:"row",staticStyle:{"position":"fixed","bottom":"10px","width":"100%"}},[_c('div',{staticClass:"col s12 center-align"},[_c('a',{staticClass:"waves-effect waves-light btn",on:{"click":function($event){$event.preventDefault();return _vm.pagamentoMassa()}}},[_c('i',{staticClass:"material-icons left"},[_vm._v("refresh")]),_vm._v("\n          definir item(s) como pagos")])])])])])}
var receber_atrasado_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m1"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_vm._v("Filtrar\n              ")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',[_vm._v("R$ Pagar")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var receber_atrasado_esExports = { render: receber_atrasado_render, staticRenderFns: receber_atrasado_staticRenderFns }
/* harmony default export */ var financeiro_receber_atrasado = (receber_atrasado_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/receber/atrasado.vue
var receber_atrasado_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var receber_atrasado___vue_template_functional__ = false
/* styles */
var receber_atrasado___vue_styles__ = null
/* scopeId */
var receber_atrasado___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var receber_atrasado___vue_module_identifier__ = null
var receber_atrasado_Component = receber_atrasado_normalizeComponent(
  receber_atrasado,
  financeiro_receber_atrasado,
  receber_atrasado___vue_template_functional__,
  receber_atrasado___vue_styles__,
  receber_atrasado___vue_scopeId__,
  receber_atrasado___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_receber_atrasado = (receber_atrasado_Component.exports);

// CONCATENATED MODULE: ./src/features/financeiro/receber/routes.js






/* harmony default export */ var receber_routes = ([{
  path: '/financeiro/receber',
  name: 'financeiro-receber.index',
  component: src_features_financeiro_receber,
  children: [{
    path: 'form/:id?',
    name: 'financeiro-receber.form',
    component: features_financeiro_receber_form
  }, {
    path: 'os/:id?',
    name: 'financeiro-receber.os',
    component: financeiro_receber_formOs
  }]
}, {
  path: '/financeiro/receber/atrasados',
  name: 'financeiro-receber.atrasados',
  component: features_financeiro_receber_atrasado
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/financeiro/extrato/index.vue



//




/* harmony default export */ var extrato = ({
  name: 'Receber',
  data: function data() {
    return {
      list: [],
      filtro: {
        inicio: moment_default()().format('DD/MM/YYYY'),
        termino: moment_default()().format('DD/MM/YYYY'),
        conta: ''
      },
      show: {
        filtro: false
      },
      contas: [{}],
      saldoAnterior: 0
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY');
    },
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service_http.get('financeiro/extrato');

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.rows.data;
                  _this.filtro = data.filtro;
                  _this.contas = data.contas;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                  $('select').material_select();
                }, 0);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filtrar: function filtrar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('financeiro/extrato?inicio=' + _this2.filtro.inicio + '&termino=' + _this2.filtro.termino + '&conta=' + _this2.filtro.conta);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.rows.data;
                  _this2.filtro = data.filtro;
                  _this2.contas = data.contas;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                  $('select').material_select();
                }, 0);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8642934c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/financeiro/extrato/index.vue
var extrato_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h5',[_vm._v("Financeiro :: Extrato "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._v(_vm._s(_vm.filtro.inicio)+" a "+_vm._s(_vm.filtro.termino))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn-floating waves-effect waves-light",on:{"click":function($event){$event.preventDefault();_vm.show.filtro = !_vm.show.filtro}}},[_c('i',{staticClass:"material-icons"},[_vm._v("filter_list")])])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show.filtro),expression:"show.filtro"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"filtro_conta"}},[_vm._v("Conta Bancária")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.conta),expression:"filtro.conta"}],attrs:{"name":"conta","id":"filtro_conta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "conta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s((conta.id) ? conta.conta : 'Todas'))])}),0)]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasItens && !_vm.loading),expression:"!hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasItens),expression:"hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v("Saldo anterior")]),_vm._v(" "),_c('td',{staticClass:"right-align"}),_vm._v(" "),_c('td',{staticClass:"right-align"}),_vm._v(" "),_c('td',{staticClass:"right-align"}),_vm._v(" "),_c('td',{staticClass:"right-align"},[_vm._v(_vm._s(_vm.saldoAnterior))])]),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(item.data_pagamento)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.descricao)+" "+_vm._s((item.parcela !== '1/1') ? item.parcela : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.conta.conta))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_vm._v(_vm._s((item.tipo == 2) ? item.valor_pago : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_vm._v(_vm._s((item.tipo == 1) ? item.valor_pago : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_vm._v(_vm._s(item.saldo))])])})],2)])])])])])}
var extrato_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m4"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_c('i',{staticClass:"material-icons left"},[_vm._v("filter_list")]),_vm._v(" Filtrar")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',[_vm._v("Conta")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("R$ Crédito")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("R$ Débito")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("R$ Saldo")])])])}]
var extrato_esExports = { render: extrato_render, staticRenderFns: extrato_staticRenderFns }
/* harmony default export */ var financeiro_extrato = (extrato_esExports);
// CONCATENATED MODULE: ./src/features/financeiro/extrato/index.vue
var extrato_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var extrato___vue_template_functional__ = false
/* styles */
var extrato___vue_styles__ = null
/* scopeId */
var extrato___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var extrato___vue_module_identifier__ = null
var extrato_Component = extrato_normalizeComponent(
  extrato,
  financeiro_extrato,
  extrato___vue_template_functional__,
  extrato___vue_styles__,
  extrato___vue_scopeId__,
  extrato___vue_module_identifier__
)

/* harmony default export */ var features_financeiro_extrato = (extrato_Component.exports);

// CONCATENATED MODULE: ./src/features/financeiro/extrato/routes.js



/* harmony default export */ var extrato_routes = ([{
  path: '/financeiro/extrato',
  name: 'financeiro-extrato.index',
  component: features_financeiro_extrato
}]);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/orcamentos/orcamentos/index.vue










moment_default.a.locale('pt-br');
/* harmony default export */ var orcamentos = ({
  name: 'Orcamentos',
  data: function data() {
    return {
      list: [],
      modal: [],
      busca: '',
      ordenar: 'id',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    var status = this.$route.params.status;

    if (status !== undefined) {
      this.busca = status;
    }
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/orcamentos?page=' + _this.pagination.current_page + '&busca=' + _this.busca + '&order=' + _this.ordenar);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/orcamentos?&busca=' + _this2.busca + '&order=' + _this2.ordenar);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var orcamento, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orcamento = obj.orcamento;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: orcamento.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, orcamento);
                } else {
                  _this3.list.unshift(orcamento);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(orcamento) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + orcamento.nome + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/orcamentos/' + orcamento.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: orcamento.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM HH:mm');
    },
    formatDateFrom: function formatDateFrom(date) {
      return moment_default()(date).fromNow();
    },
    modalProposta: function modalProposta(propostas, proposta) {
      if (!isEmpty_default()(propostas)) {
        this.modal = propostas;
      }
      if (!isEmpty_default()(proposta)) {
        this.modal = proposta;
      }
      if (!isEmpty_default()(this.modal)) {
        $('#modalProposta').modal('open');
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'orcamentos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'orcamentos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f76922c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/orcamentos/orcamentos/index.vue
var orcamentos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s3 m2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ordenar),expression:"ordenar"}],attrs:{"id":"ordenar"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ordenar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.buscar]}},[_c('option',{attrs:{"value":"id"}},[_vm._v("Ordenar por Data")]),_vm._v(" "),_c('option',{attrs:{"value":"valor"}},[_vm._v("Ordenar por Valor")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('orcamento.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('orcamento.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'orcamentos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'orcamentos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-orcamentos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(orcamento){return _c('tr',{class:{ 'green lighten-2': orcamento.status_id === 5, 'red lighten-2': orcamento.status_id === 6, 'amber lighten-1 black-text': orcamento.status_id === 4, 'amber lighten-1 black-text': orcamento.status_id === 1,  'blue lighten-2': orcamento.status_id === 2, 'amber lighten-1 black-text': orcamento.status_id === 3 }},[_c('td',[(_vm.permissoes.indexOf('orcamento.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'orcamentos.form', params: { id: orcamento.id } }}},[_vm._v(_vm._s(orcamento.id)+"\n              ")]):_c('span',[_vm._v(_vm._s(orcamento.id))])],1),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(_vm.formatDate(orcamento.created_at))+"\n              "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.formatDateFrom(orcamento.created_at)))])]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('orcamento.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'orcamentos.form', params: { id: orcamento.id } }}},[_vm._v(_vm._s(orcamento.responsavel)+"\n              ")]):_c('span',[_vm._v(_vm._s(orcamento.responsavel))]),_vm._v(" "),(orcamento.razao_social)?_c('small',[_c('br'),_vm._v(_vm._s(orcamento.razao_social))]):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(orcamento.telefone)),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                "+_vm._s(orcamento.telefone2 ? orcamento.telefone2 : '')+"\n                "+_vm._s(orcamento.telefone3 ? ', '+orcamento.telefone3 : '')+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(orcamento.email))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(orcamento.localizacao_mapa))])]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(orcamento.leitura ? _vm.formatDate(orcamento.leitura) : '-')+"\n            ")]),_vm._v(" "),_c('td',[_c('select',_vm._l((orcamento.propostas),function(proposta){return _c('option',[_vm._v(_vm._s(proposta.valor_total))])}),0)]),_vm._v(" "),_c('td',[_vm._v(_vm._s((orcamento.status) ? orcamento.status.status : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"tooltipped",attrs:{"href":"#","data-label":"Abrir","data-position":"left","data-delay":"50","data-tooltip":"Detalhes"},on:{"click":function($event){$event.preventDefault();return _vm.modalProposta(orcamento.propostas, orcamento.proposta)}}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("search")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/orcamento/" + (orcamento.id) + "/pdf"),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento.editar') > -1),expression:"permissoes.indexOf('orcamento.editar') > -1"}],attrs:{"to":{ name: 'orcamentos.form', params: { id: orcamento.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento.excluir') > -1),expression:"permissoes.indexOf('orcamento.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(orcamento)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"modalProposta"}},[_c('div',{staticClass:"modal-content"},[_c('h4',[(Array.isArray(_vm.modal))?_c('span',[_vm._v("Propostas")]):_c('span',[_vm._v("Proposta Aprovada")])]),_vm._v(" "),(Array.isArray(_vm.modal))?_c('div',{staticClass:"propostas"},_vm._l((_vm.modal),function(proposta,indexProposta){return _c('div',{staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(proposta.servicos && proposta.servicos.length > 0),expression:"proposta.servicos && proposta.servicos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(2,true),_vm._v(" "),_vm._l((proposta.servicos),function(servico,indexServico){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((servico.servico) ? servico.servico.servico : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(servico.qtd),expression:"servico.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"disabled":"","type":"number","id":("qtdServico" + indexServico),"min":"1"},domProps:{"value":(servico.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(servico, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(servico.valor),expression:"servico.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"disabled":"","type":"number","id":("valorServico" + indexServico),"min":"1"},domProps:{"value":(servico.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(servico, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"disabled":"","type":"number","id":("valorTotalServico" + indexServico),"readonly":""},domProps:{"value":servico.valor * servico.qtd}})])])})],2)])])])])}),0):_c('div',{staticClass:"proposta"},[_c('div',{staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.servicos && _vm.modal.servicos.length > 0),expression:"modal.servicos && modal.servicos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.modal.servicos),function(servico,indexServico){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((servico.servico) ? servico.servico.servico : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(servico.qtd),expression:"servico.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"disabled":"","type":"number","id":("qtdServico" + indexServico),"min":"1"},domProps:{"value":(servico.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(servico, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(servico.valor),expression:"servico.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"disabled":"","type":"number","id":("valorServico" + indexServico),"min":"1"},domProps:{"value":(servico.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(servico, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"disabled":"","type":"number","id":("valorTotalServico" + indexServico),"readonly":""},domProps:{"value":servico.valor * servico.qtd}})])])})],2)])])])])])])])])}
var orcamentos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m6"},[_c('h5',[_vm._v("Orçamentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Responsável")]),_vm._v(" "),_c('th',[_vm._v("Contatos")]),_vm._v(" "),_c('th',[_vm._v("Lido")]),_vm._v(" "),_c('th',[_vm._v("Propostas")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Serviços da Proposta")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Serviços da Proposta")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")])])}]
var orcamentos_esExports = { render: orcamentos_render, staticRenderFns: orcamentos_staticRenderFns }
/* harmony default export */ var orcamentos_orcamentos = (orcamentos_esExports);
// CONCATENATED MODULE: ./src/features/orcamentos/orcamentos/index.vue
var orcamentos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orcamentos___vue_template_functional__ = false
/* styles */
var orcamentos___vue_styles__ = null
/* scopeId */
var orcamentos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var orcamentos___vue_module_identifier__ = null
var orcamentos_Component = orcamentos_normalizeComponent(
  orcamentos,
  orcamentos_orcamentos,
  orcamentos___vue_template_functional__,
  orcamentos___vue_styles__,
  orcamentos___vue_scopeId__,
  orcamentos___vue_module_identifier__
)

/* harmony default export */ var features_orcamentos_orcamentos = (orcamentos_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-search-select/dist/VueSearchSelect.common.js
var VueSearchSelect_common = __webpack_require__("A1eF");
var VueSearchSelect_common_default = /*#__PURE__*/__webpack_require__.n(VueSearchSelect_common);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("kvU2");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/orcamentos/orcamentos/form.vue









/* harmony default export */ var orcamentos_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      clientes: [],
      objetivos: [],
      status: [],
      motivos: [],
      pagamentos: [],
      servicos: [],
      produtos: [],
      grupos: [],
      gerar_os: false,
      status_os_id: '',
      totalOsStatus: [],
      enviar_orcamento: false,
      editorDescricao: {
        placeholder: 'Descrição',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['clean']]
        }
      },
      item: {
        id: '',
        servico: '',
        qtd: '',
        valor: '',
        descricao: ''
      },
      itemProduto: {
        id: '',
        produto: '',
        valor: '',
        qtd: ''
      },
      itemCliente: {
        id: '',
        cliente: ''
      },
      itemObjetivo: {
        id: '',
        titulo: '',
        objetivo: '',
        resp_kitgas: '',
        resp_cliente: '',
        disposicoes_finais: ''
      },
      propostaIndex: 0,
      paginas: 1,
      paginas1: 1,
      paginas2: 1,
      paginas3: 1,
      paginas4: 1,
      orcamento: {
        id: '',
        cliente_id: '',
        orcamento: '',
        tipo: 1,
        cnpj: '',
        razao_social: '',
        ie: '',
        responsavel: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        isometrico: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        blocos: '',
        visita: false,
        visita_data: '',
        visita_hora: '',
        status_id: 1,
        localizacao_imagem: '',
        localizacao_mapa: '',
        propostas: [],
        fotos: [],
        videos: [],
        update_cliente: false,
        os_ids: [],
        documento_assinado: '',
        motivo_id: '',
        titulo: '',
        objetivo: '',
        resp_kitgas: '',
        resp_cliente: '',
        disposicoes_finais: ''
      },
      progress: 0,
      progress2: 0,
      errorFile: false,
      errorFile2: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image-area',
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: 'image/*',
        headers: {
          path: 'orcamentos',
          width: 800,
          height: 600,
          accept: 'all'
        }
      },
      options2: {
        url: "https://sistemakgb.com.br/v1" + '/upload-documento-assinado',
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
          path: 'orcamento',
          accept: 'all'
        }
      },
      video: ''
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    onEditorChange: function onEditorChange(_ref, indexProposta, indexServico, content) {
      var quill = _ref.quill,
          html = _ref.html,
          text = _ref.text;

      if (this.orcamento.propostas[indexProposta].servicos[indexServico].descricao === '') {
        this.orcamento.propostas[indexProposta].servicos[indexServico].descricao = content;
      }
    },
    totalProgressIsometrico: function totalProgressIsometrico(progress, totalBytes, bytesSent) {
      this.progress2 = progress;
    },
    completeIsometrico: function completeIsometrico(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute('id', xhr.response.id);
        this.orcamento.isometrico = xhr.response;
        this.progress2 = 0;
      }
    },
    destroyIsometrico: function destroyIsometrico() {
      var _this = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this.orcamento.isometrico = '';
      });
    },
    setEndereco: function setEndereco() {
      var _this2 = this;

      window.$.getJSON('https://viacep.com.br/ws/' + this.orcamento.cep + '/json/').then(function (response) {
        if (!response.erro) {
          _this2.orcamento.logradouro = response.logradouro;
          _this2.orcamento.bairro = response.bairro;
          _this2.orcamento.cidade = response.localidade;
          _this2.orcamento.estado = response.uf;
          $('#numero').focus();
        } else {
          _this2.orcamento.logradouro = '';
          _this2.orcamento.numero = '';
          _this2.orcamento.complemento = '';
          _this2.orcamento.bairro = '';
          _this2.orcamento.cidade = '';
          _this2.orcamento.estado = '';
        }
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 0);
      });
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref2, data, totalPaginas, totalPaginas1, totalPaginas2, totalPaginas3, totalPaginas4, _ref3, _data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 29;
                  break;
                }

                _context.next = 5;
                return service_http.get('/orcamentos/' + id + '/edit');

              case 5:
                _ref2 = _context.sent;
                data = _ref2.data;

                _this3.orcamento = data.orcamento;
                _this3.status = data.status;
                _this3.pagamentos = data.pagamentos;
                _this3.servicos = data.servicos;
                _this3.produtos = data.produtos;
                _this3.clientes = data.clientes;
                _this3.motivos = data.motivos;
                _this3.grupos = data.grupos;
                _this3.objetivos = data.objetivos;
                _this3.totalOsStatus = data.totalOsStatus;
                totalPaginas = _this3.orcamento.os_ids.length / 30;

                _this3.paginas = Math.ceil(totalPaginas);
                totalPaginas1 = _this3.totalOsStatus[1] / 30;

                _this3.paginas1 = Math.ceil(totalPaginas1);
                totalPaginas2 = _this3.totalOsStatus[2] / 30;

                _this3.paginas2 = Math.ceil(totalPaginas2);
                totalPaginas3 = _this3.totalOsStatus[3] / 30;

                _this3.paginas3 = Math.ceil(totalPaginas3);
                totalPaginas4 = _this3.totalOsStatus[4] / 30;

                _this3.paginas4 = Math.ceil(totalPaginas4);
                _context.next = 41;
                break;

              case 29:
                _context.next = 31;
                return service_http.get('/orcamentos/create');

              case 31:
                _ref3 = _context.sent;
                _data = _ref3.data;

                _this3.status = _data.status;
                _this3.pagamentos = _data.pagamentos;
                _this3.servicos = _data.servicos;
                _this3.produtos = _data.produtos;
                _this3.clientes = _data.clientes;
                _this3.motivos = _data.motivos;
                _this3.grupos = _data.grupos;
                _this3.objetivos = _data.objetivos;

              case 41:
                setTimeout(function () {
                  $('.collapsible').collapsible();
                  $('.collapsible').collapsible('close', 0);
                  $('.collapsible').collapsible('close', 1);
                  $('.collapsible').collapsible('close', 2);
                  $('.collapsible').collapsible('close', 3);
                  $('.collapsible').collapsible('open', 0);
                  window.Materialize.updateTextFields();
                }, 0);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    validate: function validate() {
      var _this4 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          var msg = '';
          _this4.errors.items.forEach(function (item) {
            msg += item.msg + '<br>';
          });
          _this4.$swal({
            title: 'Ops, encontramos um erro!',
            html: msg,
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        }
        if (_this4.orcamento.status_id === 5) {
          if (_this4.orcamento.cliente_id === '' && _this4.orcamento.tipo === 1 && (_this4.orcamento.cnpj === '' || _this4.orcamento.responsavel === '' || _this4.orcamento.razao_social === '')) {
            _this4.$swal({
              title: 'Ops, encontramos um erro!',
              html: 'Campos Responsável, Razão Social e CNPJ são obrigatórios para aprovação desse orçamento',
              type: 'error',
              cancelButtonText: 'Ok'
            });
            return false;
          }
          if (_this4.orcamento.cliente_id === '' && _this4.orcamento.tipo === 2 && (_this4.orcamento.cpf === '' || _this4.orcamento.responsavel === '')) {
            _this4.$swal({
              title: 'Ops, encontramos um erro!',
              html: 'Campos Responsável e CPF sãp obrigatórios para aprovação desse orçamento',
              type: 'error',
              cancelButtonText: 'Ok'
            });
            return false;
          }
          var propostasAprovadas = 0;
          _this4.orcamento.propostas.forEach(function (item) {
            if (item.aprovado === true) {
              propostasAprovadas++;
            }
          });
          if (propostasAprovadas === 0) {
            _this4.$swal({
              title: 'Ops, encontramos um erro!',
              html: 'O status aprovado requer ao menos uma proposta aprovada',
              type: 'error',
              cancelButtonText: 'Ok'
            });
            return false;
          }
        }
        _this4.submit();
      });
    },
    submit: function submit() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref4, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = _this5.isNew ? 'post' : 'put';
                url = _this5.isNew ? '/orcamentos' : '/orcamentos/' + _this5.orcamento.id;
                _context2.next = 4;
                return service_http[verb](url, _this5.orcamento);

              case 4:
                _ref4 = _context2.sent;
                data = _ref4.data;

                console.log(data);

                if (!(data != null)) {
                  _context2.next = 13;
                  break;
                }

                if (!(_this5.enviar_orcamento === true)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 11;
                return service_http.post('/orcamentos/send-orcamento/' + data.orcamento.id);

              case 11:
                window.Materialize.toast('E-mail enviado com sucesso!!', 4000);

              case 12:
                if (_this5.gerar_os === true && _this5.orcamento.status_id === 5) {
                  _this5.$router.push({ name: 'os.orcamento', params: { id: data.orcamento.id } });
                } else {
                  _this5.$emit('update-orcamentos-list', { orcamento: data.orcamento });
                  _this5.$router.push({ name: 'orcamentos.index' });
                }

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    onSelectCliente: function onSelectCliente(item) {
      if (item) {
        this.setCliente(item.id);
      }
    },
    onSelectObjetivo: function onSelectObjetivo(item) {
      if (item) {
        this.orcamento.titulo = item.titulo;
        this.orcamento.objetivo = item.objetivo;
        this.orcamento.resp_kitgas = item.resp_kitgas;
        this.orcamento.resp_cliente = item.resp_cliente;
        this.orcamento.disposicoes_finais = item.disposicoes_finais;
      }
    },
    setCliente: function setCliente(value) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref5, data;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.orcamento.cliente_id = value;

                if (!value) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return service_http.get('/clientes/' + value);

              case 4:
                _ref5 = _context4.sent;
                data = _ref5.data;

                _this6.$swal({
                  title: 'Deseja atualizar tipo de pessoa/raz\xE3o social/rg/cpf/cnpj/ie e dados em branco com os dados do cliente ' + data.cliente.cliente + '?',
                  html: 'Caso os dados estejam errados é necessário atualizar a página',
                  type: 'warning',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Sim, quero atualizar!',
                  reverseButtons: true
                }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                  return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this6.orcamento.tipo = data.cliente.tipo;
                          _this6.orcamento.cnpj = data.cliente.cnpj;
                          _this6.orcamento.razao_social = data.cliente.razao_social;
                          _this6.orcamento.ie = data.cliente.ie;
                          _this6.orcamento.responsavel = _this6.orcamento.responsavel ? _this6.orcamento.responsavel : data.cliente.responsavel;
                          _this6.orcamento.cpf = data.cliente.cpf;
                          _this6.orcamento.rg = data.cliente.rg;
                          _this6.orcamento.email = _this6.orcamento.email ? _this6.orcamento.email : data.cliente.email;
                          _this6.orcamento.telefone = _this6.orcamento.telefone ? _this6.orcamento.telefone : data.cliente.telefone;
                          _this6.orcamento.telefone2 = _this6.orcamento.telefone2 ? _this6.orcamento.telefone2 : data.cliente.telefone2;
                          _this6.orcamento.telefone3 = _this6.orcamento.telefone3 ? _this6.orcamento.telefone3 : data.cliente.telefone3;
                          _this6.orcamento.cep = _this6.orcamento.cep ? _this6.orcamento.cep : data.cliente.cep;
                          _this6.orcamento.logradouro = _this6.orcamento.logradouro ? _this6.orcamento.logradouro : data.cliente.logradouro;
                          _this6.orcamento.numero = _this6.orcamento.numero ? _this6.orcamento.numero : data.cliente.numero;
                          _this6.orcamento.complemento = _this6.orcamento.complemento ? _this6.orcamento.complemento : data.cliente.complemento;
                          _this6.orcamento.bairro = _this6.orcamento.bairro ? _this6.orcamento.bairro : data.cliente.bairro;
                          _this6.orcamento.cidade = _this6.orcamento.cidade ? _this6.orcamento.cidade : data.cliente.cidade;
                          _this6.orcamento.estado = _this6.orcamento.estado ? _this6.orcamento.estado : data.cliente.estado;
                          _this6.orcamento.referencia = _this6.orcamento.referencia ? _this6.orcamento.referencia : data.cliente.referencia;
                          _this6.orcamento.localizacao_imagem = _this6.orcamento.localizacao_imagem ? _this6.orcamento.localizacao_imagem : data.cliente.localizacao_imagem;
                          _this6.orcamento.localizacao_mapa = _this6.orcamento.localizacao_mapa ? _this6.orcamento.localizacao_mapa : data.cliente.localizacao_mapa;
                          setTimeout(function () {
                            window.Materialize.updateTextFields();
                          }, 0);

                        case 22:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this6);
                })));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    clear: function clear() {
      this.orcamento = {
        id: '',
        cliente_id: '',
        orcamento: '',
        tipo: 1,
        cnpj: '',
        razao_social: '',
        ie: '',
        responsavel: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        blocos: '',
        visita: false,
        isometrico: '',
        visita_data: '',
        visita_hora: '',
        status_id: 1,
        localizacao_imagem: '',
        localizacao_mapa: '',
        propostas: [],
        fotos: [],
        videos: [],
        update_cliente: false,
        os_ids: [],
        documento_assinado: '',
        motivo_id: '',
        titulo: '',
        objetivo: '',
        resp_kitgas: '',
        resp_cliente: '',
        disposicoes_finais: ''
      };
    },
    addProposta: function addProposta() {
      this.orcamento.propostas.push({
        valor_total: 0,
        desconto: 0,
        pagamento_id: '',
        tempo_execucao: '',
        validade: 30,
        aprovado: false,
        servicos: [],
        produtos: [],
        grupos: []
      });
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 300);
    },
    destroyProposta: function destroyProposta(index) {
      var _this7 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma Proposta \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this7.orcamento.propostas[index].id) {
          _this7.orcamento.propostas.splice(index, 1);
          window.Materialize.toast('Proposta excluída!', 4000);
        } else {
          service_http.delete('orcamentos/proposta/' + _this7.orcamento.propostas[index].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Proposta excluída!', 4000);
            _this7.orcamento.propostas.splice(index, 1);
          });
        }
      });
    },
    onSelectServico: function onSelectServico(item) {
      if (item) {
        var servico = {
          servico_id: item.id,
          servico: item,
          qtd: 1,
          valor: item.valor,
          produtos: item.produtos
        };
        this.addServico(servico);
      }
    },
    onSelectGrupo: function onSelectGrupo(item) {
      var _this8 = this;

      if (item) {
        item.servicos.forEach(function (data) {
          _this8.addServico({
            servico_id: data.servico.id,
            servico: data.servico,
            qtd: 1,
            valor: data.servico.valor,
            produtos: data.servico.produtos
          });
        });
      }
    },
    setPropostaIndex: function setPropostaIndex(index) {
      this.propostaIndex = index;
    },
    addServico: function addServico(servico) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (typeof _this9.orcamento.propostas[_this9.propostaIndex].servicos === 'undefined') {
                  _this9.orcamento.propostas[_this9.propostaIndex].servicos = [];
                }
                _context5.next = 3;
                return _this9.orcamento.propostas[_this9.propostaIndex].servicos.push(servico);

              case 3:
                if (servico.produtos.length) {
                  servico.produtos.forEach(function (data) {
                    if (data.produto) {
                      _this9.addProduto({
                        produto_id: data.produto_id,
                        produto: data.produto,
                        valor: data.produto.valor_venda,
                        qtd: data.quantidade
                      });
                    }
                  });
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    destroyServico: function destroyServico(indexProposta, indexServico) {
      var _this10 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um Servi\xE7o \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this10.orcamento.propostas[indexProposta].servicos[indexServico].id) {
          _this10.orcamento.propostas[indexProposta].servicos.splice(indexServico, 1);
          window.Materialize.toast('Serviço excluído!', 4000);
        } else {
          service_http.delete('orcamentos/proposta/servico/' + _this10.orcamento.propostas[indexProposta].servicos[indexServico].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Serviço excluído!', 4000);
            _this10.orcamento.propostas[indexProposta].servicos.splice(indexServico, 1);
          });
        }
      });
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        var produto = {
          produto_id: item.id,
          produto: item,
          valor: item.valor_venda,
          qtd: 1
        };
        this.addProduto(produto);
      }
    },
    addProduto: function addProduto(produto) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (typeof _this11.orcamento.propostas[_this11.propostaIndex].produtos === 'undefined') {
                  _this11.orcamento.propostas[_this11.propostaIndex].produtos = [];
                }
                _context6.next = 3;
                return _this11.orcamento.propostas[_this11.propostaIndex].produtos.push(produto);

              case 3:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this11);
      }))();
    },
    destroyProduto: function destroyProduto(indexProposta, indexProduto) {
      var _this12 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um Produto \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this12.orcamento.propostas[indexProposta].produtos[indexProduto].id) {
          _this12.orcamento.propostas[indexProposta].produtos.splice(indexProduto, 1);
          window.Materialize.toast('Produto excluído!', 4000);
        } else {
          service_http.delete('orcamentos/proposta/produto/' + _this12.orcamento.propostas[indexProposta].produtos[indexProduto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Produto excluído!', 4000);
            _this12.orcamento.propostas[indexProposta].produtos.splice(indexProduto, 1);
          });
        }
      });
    },
    valor_proposta: function valor_proposta(index) {
      var valor = 0;
      var desconto = this.orcamento.propostas[index].desconto;
      if (typeof this.orcamento.propostas[index].servicos !== 'undefined') {
        this.orcamento.propostas[index].servicos.forEach(function (servico) {
          valor += parseFloat(servico.valor) * parseInt(servico.qtd);
        });
      }
      if (typeof this.orcamento.propostas[index].produtos !== 'undefined') {
        this.orcamento.propostas[index].produtos.forEach(function (produto) {
          valor += parseFloat(produto.valor) * parseInt(produto.qtd);
        });
      }
      return valor - desconto;
    },
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.orcamento.fotos.push({ foto: xhr.response, legenda: '', ordem: '' });
        this.progress = 0;
      }
    },
    complete2: function complete2(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        file.addAttribute('id', xhr.response.id);
        this.orcamento.localizacao_imagem = xhr.response;
        this.progress = 0;
      }
    },
    totalProgress2: function totalProgress2(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete3: function complete3(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.orcamento.documento_assinado = xhr.response;
        this.progress = 0;
      }
    },
    destroyFoto: function destroyFoto(index, indexFoto) {
      var _this13 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma foto \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this13.orcamento.fotos[indexFoto].id) {
          _this13.orcamento.fotos.splice(indexFoto, 1);
          window.Materialize.toast('Foto excluída!', 4000);
        } else {
          service_http.delete('orcamentos/foto/' + _this13.orcamento.fotos[indexFoto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Foto excluída!', 4000);
            _this13.orcamento.fotos.splice(indexFoto, 1);
          });
        }
      });
    },
    destroyVideo: function destroyVideo(index, indexVideo) {
      var _this14 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um video \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this14.orcamento.videos[indexVideo].id) {
          _this14.orcamento.videos.splice(indexVideo, 1);
          window.Materialize.toast('Video excluído!', 4000);
        } else {
          service_http.delete('orcamentos/video/' + _this14.orcamento.videos[indexVideo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Video excluído!', 4000);
            _this14.orcamento.videos.splice(indexVideo, 1);
          });
        }
      });
    },
    destroyImage: function destroyImage() {
      var _this15 = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this15.orcamento.localizacao_imagem = '';
      });
    },
    gerarLocalizacao: function gerarLocalizacao() {
      this.orcamento.localizacao_mapa = this.orcamento.logradouro + ', ' + this.orcamento.numero + ' ' + this.orcamento.bairro + ' ' + this.orcamento.cidade + ' ' + this.orcamento.estado + ' ' + this.orcamento.cep;
    },
    setAprovado: function setAprovado(indexProposta) {
      this.orcamento.propostas.forEach(function (item, index) {
        if (indexProposta !== index) {
          item.aprovado = false;
        }
      });
    },
    deleteOs: function deleteOs() {
      var _this16 = this;

      this.$swal({
        title: 'Atenção',
        text: 'Essa a\xE7\xE3o apagar\xE1 todas as OS\'s deste or\xE7amento, \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        service_http.delete('orcamentos/os/' + _this16.orcamento.id).then(function (response) {
          return response.data;
        }).then(function (data) {
          window.Materialize.toast('Operação concluída!', 4000);
          _this16.orcamento.os_ids = [];
        });
      });
    },
    duplicarProposta: function duplicarProposta(index) {
      var _this17 = this;

      this.$swal({
        title: 'Atenção',
        text: 'Essa a\xE7\xE3o Duplicar\xE1 o registro selecionado!',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero duplicar!',
        reverseButtons: true
      }).then(function () {
        var clone = cloneDeep_default()(_this17.orcamento.propostas[index]);
        if ('id' in clone) {
          delete clone.id;
          clone.servicos.map(function (item) {
            delete item.id;
            delete item.proposta_id;
            return item;
          });
          clone.produtos.map(function (item) {
            delete item.proposta_id;
            delete item.id;
            return item;
          });
        }
        _this17.orcamento.propostas.push(clone);
        _this17.$nextTick(function () {
          return window.Materialize.updateTextFields();
        });
      }).catch(this.$swal.noop);
    },
    addVideo: function addVideo() {
      if (this.video) {
        this.orcamento.videos.push({
          video: this.video
        });
        this.video = '';
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 300);
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    isNew: function isNew() {
      return this.orcamento.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    url_app: function url_app() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7355a207","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/orcamentos/orcamentos/form.vue
var orcamentos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('ul',{staticClass:"collapsible popout",attrs:{"data-collapsible":"accordion"}},[_c('li',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('list-select',{attrs:{"list":_vm.clientes,"option-value":"id","option-text":"cliente","selected-item":_vm.itemCliente,"placeholder":"Buscar Cliente"},on:{"select":_vm.onSelectCliente}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.cliente_id),expression:"orcamento.cliente_id"}],staticClass:"col s12 m6"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.update_cliente),expression:"orcamento.update_cliente"}],attrs:{"name":"update_cliente","id":"update_cliente","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.orcamento.update_cliente)?_vm._i(_vm.orcamento.update_cliente,null)>-1:(_vm.orcamento.update_cliente)},on:{"change":function($event){var $$a=_vm.orcamento.update_cliente,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.orcamento, "update_cliente", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.orcamento, "update_cliente", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.orcamento, "update_cliente", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"update_cliente"}},[_vm._v("Atualizar Cliente com dados do orçamento")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.responsavel),expression:"orcamento.responsavel"}],attrs:{"name":"responsavel","id":"responsavel","type":"text"},domProps:{"value":(_vm.orcamento.responsavel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "responsavel", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"responsavel"}},[_vm._v("Responsável")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('responsavel')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model.number",value:(_vm.orcamento.tipo),expression:"orcamento.tipo",modifiers:{"number":true}}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.orcamento, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Pessoa Jurídica")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Pessoa Física")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.razao_social),expression:"orcamento.razao_social"}],attrs:{"name":"razao_social","id":"razao_social","type":"text"},domProps:{"value":(_vm.orcamento.razao_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "razao_social", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"razao_social"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('razao_social')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.tipo === 1),expression:"orcamento.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99.999.999/9999-99'),expression:"'99.999.999/9999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.cnpj),expression:"orcamento.cnpj"}],class:{invalid: _vm.errors.has('cnpj')},attrs:{"name":"cnpj","id":"cnpj","type":"text","data-vv-rules":"min:18"},domProps:{"value":(_vm.orcamento.cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "cnpj", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cnpj')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.tipo === 1),expression:"orcamento.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.ie),expression:"orcamento.ie"}],class:{invalid: _vm.errors.has('ie')},attrs:{"name":"ie","id":"ie","type":"text"},domProps:{"value":(_vm.orcamento.ie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "ie", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ie"}},[_vm._v("Inscrição Estadual")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('ie')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.tipo === 2),expression:"orcamento.tipo === 2"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.cpf),expression:"orcamento.cpf"}],class:{invalid: _vm.errors.has('cpf')},attrs:{"name":"cpf","id":"cpf","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.orcamento.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "cpf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cpf')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.telefone),expression:"orcamento.telefone"}],class:{invalid: _vm.errors.has('telefone')},attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.orcamento.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.telefone2),expression:"orcamento.telefone2"}],class:{invalid: _vm.errors.has('telefone2')},attrs:{"name":"telefone2","id":"telefone2","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.orcamento.telefone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "telefone2", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone2"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone2')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.telefone3),expression:"orcamento.telefone3"}],class:{invalid: _vm.errors.has('telefone3')},attrs:{"name":"telefone3","id":"telefone3","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.orcamento.telefone3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "telefone3", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone3"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone3')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.email),expression:"orcamento.email"}],class:{invalid: _vm.errors.has('email')},attrs:{"name":"email","id":"email","type":"text","data-vv-rules":"email"},domProps:{"value":(_vm.orcamento.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('email')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99999-999'),expression:"'99999-999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.cep),expression:"orcamento.cep"}],class:{invalid: _vm.errors.has('cep')},attrs:{"name":"cep","id":"cep","type":"text","data-vv-rules":"min:9"},domProps:{"value":(_vm.orcamento.cep)},on:{"blur":_vm.setEndereco,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "cep", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cep')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.logradouro),expression:"orcamento.logradouro"}],attrs:{"name":"logradouro","id":"logradouro","type":"text"},domProps:{"value":(_vm.orcamento.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "logradouro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Logradouro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('logradouro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.numero),expression:"orcamento.numero"}],attrs:{"name":"numero","id":"numero","type":"text"},domProps:{"value":(_vm.orcamento.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"numero"}},[_vm._v("Nº")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('numero')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.complemento),expression:"orcamento.complemento"}],attrs:{"name":"complemento","id":"complemento","type":"text"},domProps:{"value":(_vm.orcamento.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"complemento"}},[_vm._v("Compl.")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('complemento')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.bairro),expression:"orcamento.bairro"}],attrs:{"name":"bairro","id":"bairro","type":"text"},domProps:{"value":(_vm.orcamento.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "bairro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('bairro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.cidade),expression:"orcamento.cidade"}],attrs:{"name":"cidade","id":"cidade","type":"text"},domProps:{"value":(_vm.orcamento.cidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "cidade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cidade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.estado),expression:"orcamento.estado"}],attrs:{"name":"estado","id":"estado","type":"text"},domProps:{"value":(_vm.orcamento.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "estado", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estado')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.blocos),expression:"orcamento.blocos"}],attrs:{"name":"blocos","id":"blocos","type":"text"},domProps:{"value":(_vm.orcamento.blocos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "blocos", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"blocos"}},[_vm._v("Blocos (separados por \",\")")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('blocos')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.referencia),expression:"orcamento.referencia"}],attrs:{"name":"referencia","id":"referencia","type":"text"},domProps:{"value":(_vm.orcamento.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "referencia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"referencia"}},[_vm._v("Ponto de Referência")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('referencia')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete2,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Foto Localização")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.orcamento.localizacao_imagem)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/orcamentos/" + (_vm.orcamento.localizacao_imagem))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.orcamento.localizacao_imagem)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.localizacao_mapa),expression:"orcamento.localizacao_mapa"}],attrs:{"name":"localizacao","id":"localizacao","type":"text"},domProps:{"value":(_vm.orcamento.localizacao_mapa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "localizacao_mapa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"localizacao"}},[_vm._v("Mapa Localização")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('localizacao_mapa')))]),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.gerarLocalizacao.apply(null, arguments)}}},[_vm._v("Gerar\n                    Localização\n                  ")])])])])]),_vm._v(" "),_c('li',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.visita),expression:"orcamento.visita"}],attrs:{"name":"visita","id":"visita","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.orcamento.visita)?_vm._i(_vm.orcamento.visita,null)>-1:(_vm.orcamento.visita)},on:{"change":function($event){var $$a=_vm.orcamento.visita,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.orcamento, "visita", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.orcamento, "visita", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.orcamento, "visita", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"visita"}},[_vm._v("Visita")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.visita),expression:"orcamento.visita"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.orcamento.visita === true ? 'required' : ''),expression:"orcamento.visita === true ? 'required' : ''"},{name:"model",rawName:"v-model",value:(_vm.orcamento.visita_data),expression:"orcamento.visita_data"}],class:{invalid: _vm.errors.has('visita_data')},attrs:{"name":"visita_data","id":"icon_visita_data","type":"date","data-value":_vm.orcamento.visita_data},domProps:{"value":(_vm.orcamento.visita_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "visita_data", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_visita_data"}},[_vm._v("*Data")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('visita_data')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"visita_hora"}},[_vm._v("Hora")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.visita_hora),expression:"orcamento.visita_hora"},{name:"validate",rawName:"v-validate",value:(_vm.orcamento.visita === true ? 'required' : ''),expression:"orcamento.visita === true ? 'required' : ''"}],staticClass:"browser-default",class:{invalid: _vm.errors.has('visita_data')},attrs:{"name":"visita_hora","id":"visita_hora"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orcamento, "visita_hora", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Manhã"}},[_vm._v("Manhã")]),_vm._v(" "),_c('option',{attrs:{"value":"Tarde"}},[_vm._v("Tarde")]),_vm._v(" "),_c('option',{attrs:{"value":"Noite"}},[_vm._v("Noite")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('visita_hora')))])])])])]),_vm._v(" "),_c('li',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('list-select',{attrs:{"list":_vm.objetivos,"option-value":"id","option-text":"titulo","selected-item":_vm.itemObjetivo,"placeholder":"Buscar Objetivo"},on:{"select":_vm.onSelectObjetivo}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.titulo),expression:"orcamento.titulo"}],class:{invalid: _vm.errors.has('titulo')},attrs:{"name":"titulo","id":"titulo","type":"text"},domProps:{"value":(_vm.orcamento.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "titulo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"titulo"}},[_vm._v("*Título")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('titulo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.objetivo),expression:"orcamento.objetivo"}],staticClass:"materialize-textarea",attrs:{"name":"objetivo","id":"objetivo","type":"text"},domProps:{"value":(_vm.orcamento.objetivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "objetivo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"objetivo"}},[_vm._v("Objetivo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('objetivo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.resp_kitgas),expression:"orcamento.resp_kitgas"}],staticClass:"materialize-textarea",attrs:{"name":"resp_kitgas","id":"resp_kitgas","type":"text"},domProps:{"value":(_vm.orcamento.resp_kitgas)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "resp_kitgas", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"resp_kitgas"}},[_vm._v("Responsabilidade Kit Gás")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('resp_kitgas')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.resp_cliente),expression:"orcamento.resp_cliente"}],staticClass:"materialize-textarea",attrs:{"name":"resp_cliente","id":"resp_cliente","type":"text"},domProps:{"value":(_vm.orcamento.resp_cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "resp_cliente", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"resp_cliente"}},[_vm._v("Responsabilidade Cliente")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('resp_cliente')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.disposicoes_finais),expression:"orcamento.disposicoes_finais"}],staticClass:"materialize-textarea",attrs:{"name":"disposicoes_finais","id":"disposicoes_finais","type":"text"},domProps:{"value":(_vm.orcamento.disposicoes_finais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orcamento, "disposicoes_finais", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"disposicoes_finais"}},[_vm._v("Disposições Finais")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('disposicoes_finais')))])])])])]),_vm._v(" "),_c('li',[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_vm._l((_vm.orcamento.propostas),function(proposta,indexProposta){return _c('div',{staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12",on:{"click":function($event){return _vm.setPropostaIndex(indexProposta)}}},[_c('list-select',{attrs:{"list":_vm.grupos,"option-value":"id","option-text":"grupo","selected-item":_vm.item,"placeholder":"Adicionar Grupo de Serviços"},on:{"select":_vm.onSelectGrupo}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12",on:{"click":function($event){return _vm.setPropostaIndex(indexProposta)}}},[_c('list-select',{attrs:{"list":_vm.servicos,"option-value":"id","option-text":"servico","selected-item":_vm.item,"placeholder":"Adicionar Serviço"},on:{"select":_vm.onSelectServico}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(proposta.servicos && proposta.servicos.length > 0),expression:"proposta.servicos && proposta.servicos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(4,true),_vm._v(" "),_vm._l((proposta.servicos),function(servico,indexServico){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((servico.servico) ? servico.servico.servico : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(servico.qtd),expression:"servico.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdServico" + indexServico),"min":"1"},domProps:{"value":(servico.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(servico, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(servico.valor),expression:"servico.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("valorServico" + indexServico),"min":"1"},domProps:{"value":(servico.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(servico, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("valorTotalServico" + indexServico),"readonly":""},domProps:{"value":servico.valor * servico.qtd}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyServico(indexProposta, indexServico)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12",on:{"click":function($event){return _vm.setPropostaIndex(indexProposta)}}},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","selected-item":_vm.item,"placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(proposta.produtos && proposta.produtos.length > 0),expression:"proposta.produtos && proposta.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(5,true),_vm._v(" "),_vm._l((proposta.produtos),function(produto,indexProduto){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((produto.produto) ? produto.produto.produto : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1"},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.valor),expression:"produto.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("valorProduto" + indexProduto),"min":"1"},domProps:{"value":(produto.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("valorTotalProduto" + indexProduto),"readonly":""},domProps:{"value":produto.valor * produto.qtd}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(indexProposta, indexProduto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m6"},[_c('label',{attrs:{"for":("pagamento_id" + indexProposta)}},[_vm._v("*Condição de Pagamento")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(proposta.pagamento_id),expression:"proposta.pagamento_id"}],staticClass:"browser-default",attrs:{"name":("pagamento_id" + indexProposta),"id":("pagamento_id" + indexProposta),"data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(proposta, "pagamento_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.pagamentos),function(pagamento){return _c('option',{domProps:{"value":pagamento.id}},[_vm._v(_vm._s(pagamento.pagamento))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('pagamento_id'+indexProposta)))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(proposta.desconto),expression:"proposta.desconto"}],class:{invalid: _vm.errors.has(("desconto" + indexProposta))},attrs:{"name":("desconto" + indexProposta),"id":("desconto" + indexProposta),"type":"number","step":"any","min":"0","data-vv-rules":"required"},domProps:{"value":(proposta.desconto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(proposta, "desconto", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("desconto" + indexProposta)}},[_vm._v("*Desconto")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('desconto')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has(("valor_total" + indexProposta))},attrs:{"name":("valor_total" + indexProposta),"id":("valor_total" + indexProposta),"type":"number","step":"any","min":"0","data-vv-rules":"required","readonly":""},domProps:{"value":_vm.valor_proposta(indexProposta)}}),_vm._v(" "),_c('label',{attrs:{"for":("valor_total" + indexProposta)}},[_vm._v("*Valor Total")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor_total')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(proposta.validade),expression:"proposta.validade"}],attrs:{"name":("validade" + indexProposta),"id":("validade" + indexProposta),"type":"number","step":"any","min":"0"},domProps:{"value":(proposta.validade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(proposta, "validade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("validade" + indexProposta)}},[_vm._v("Validade da Proposta (dias)")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('validade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(proposta.tempo_execucao),expression:"proposta.tempo_execucao"}],attrs:{"name":("tempo_execucao" + indexProposta),"id":("tempo_execucao" + indexProposta),"type":"text"},domProps:{"value":(proposta.tempo_execucao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(proposta, "tempo_execucao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("tempo_execucao" + indexProposta)}},[_vm._v("Tempo de Execução")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tempo_execucao')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(proposta.aprovado),expression:"proposta.aprovado"}],attrs:{"name":("obs" + indexProposta),"id":("obs" + indexProposta),"type":"checkbox"},domProps:{"checked":Array.isArray(proposta.aprovado)?_vm._i(proposta.aprovado,null)>-1:(proposta.aprovado)},on:{"click":function($event){return _vm.setAprovado(indexProposta)},"change":function($event){var $$a=proposta.aprovado,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(proposta, "aprovado", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(proposta, "aprovado", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(proposta, "aprovado", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":("obs" + indexProposta)}},[_vm._v("Aprovar Proposta")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('label',{attrs:{"for":("obs" + indexProposta)}},[_vm._v("Obs KitGás (não aparece na proposta)")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(proposta.obs),expression:"proposta.obs"}],staticClass:"materialize-textarea",attrs:{"name":("obs" + indexProposta),"id":("obs" + indexProposta)},domProps:{"value":(proposta.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(proposta, "obs", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(proposta.servicos && proposta.servicos.length > 0),expression:"proposta.servicos && proposta.servicos.length > 0"}],staticClass:"row"},_vm._l((proposta.servicos),function(servico,indexServico){return _c('div',{staticClass:"col s12"},[_c('label',{attrs:{"for":("descricao" + indexServico)}},[_vm._v("Descrição do "+_vm._s(servico.servico ?
                        servico.servico.servico : ''))]),_vm._v(" "),_c('quill-editor',{attrs:{"content":servico.servico ? servico.servico.descricao : '',"options":_vm.editorDescricao},on:{"ready":function($event){return _vm.onEditorChange($event, indexProposta, indexServico, servico.servico ? servico.servico.descricao: '')}},model:{value:(servico.descricao),callback:function ($$v) {_vm.$set(servico, "descricao", $$v)},expression:"servico.descricao"}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(proposta.break_page),expression:"proposta.break_page"}],attrs:{"name":("break_page" + indexProposta),"id":("break_page" + indexProposta),"type":"checkbox"},domProps:{"checked":Array.isArray(proposta.break_page)?_vm._i(proposta.break_page,null)>-1:(proposta.break_page)},on:{"change":function($event){var $$a=proposta.break_page,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(proposta, "break_page", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(proposta, "break_page", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(proposta, "break_page", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":("break_page" + indexProposta)}},[_vm._v("Forçar quebra de página PDF")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 right-align"},[_c('a',{staticClass:"btn blue darken-1",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.duplicarProposta(indexProposta)}}},[_vm._v("Duplicar")]),_vm._v(" "),_c('a',{staticClass:"btn red",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProposta(indexProposta)}}},[_vm._v("\n                        Excluir Proposta\n                      ")])])])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 right-align"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":_vm.addProposta}},[_vm._v("Adicionar Proposta\n                  ")])])])],2)]),_vm._v(" "),_c('li',[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.completeIsometrico,"on-total-progress":_vm.totalProgressIsometrico}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.orcamento.isometrico)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/orcamentos/" + (_vm.orcamento.isometrico))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress2 + "%"))})]),_vm._v(" "),(_vm.errorFile2)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.orcamento.isometrico)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyIsometrico()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1)])])]),_vm._v(" "),_c('li',[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.orcamento.fotos),function(foto,indexFoto){return _c('div',{staticClass:"col s12 m4 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%","height":"150px"},attrs:{"src":(_vm.api_url + "/orcamentos/" + (foto.foto))}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":("legenda" + indexFoto)}},[_vm._v("Legenda")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(foto.legenda),expression:"foto.legenda"}],staticClass:"materialize-textarea",attrs:{"name":"legenda{indexFoto}","id":"legenda{indexFoto}"},domProps:{"value":(foto.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(foto, "legenda", $event.target.value)}}}),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyFoto(_vm.index, indexFoto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"center-align"},[_vm._v("clique para inserir imagens")])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e()])])])],2)],1)])])]),_vm._v(" "),_c('li',[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.orcamento.videos),function(video,indexVideo){return _c('div',{staticClass:"col s12 center-align"},[_c('span',{domProps:{"innerHTML":_vm._s(video.video)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyVideo(_vm.index, indexVideo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Embed Vídeo")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.video),expression:"video"}],staticClass:"materialize-textarea",domProps:{"value":(_vm.video)},on:{"input":function($event){if($event.target.composing){ return; }_vm.video=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addVideo.apply(null, arguments)}}},[_vm._v("\n                    Adicionar Vídeo\n                  ")])])])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.os_ids.length > 0 && _vm.permissoes.indexOf('os.excluir') > -1),expression:"orcamento.os_ids.length > 0 && permissoes.indexOf('os.excluir') > -1"}]},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.orcamento.os_ids),function(os){return _c('div',{staticClass:"input-field col s12 m3"},[_c('input',{attrs:{"name":"os","id":"os","type":"text","disabled":""},domProps:{"value":("#" + (os.id) + " - " + (os.apartamento))}}),_vm._v(" "),_c('label',{attrs:{"for":"os"}},[_vm._v("OS")])])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"status_os_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status_os_id),expression:"status_os_id"}],attrs:{"name":"status_os_id","id":"status_os_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status_os_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos os Status")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Novo")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Em andamento")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Finalizada")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Cancelada")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('status_os_id')))])])]),_vm._v(" "),_vm._l((_vm.paginas),function(n,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status_os_id === ''),expression:"status_os_id === ''"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"white-text btn btn-large btn-block blue",attrs:{"href":(_vm.url_app + "/orcamento/" + (_vm.orcamento.id) + "/oss?status=1&page=" + n),"target":"_blank"}},[_vm._v("\n                    Imprimir Ordens de Serviço ("+_vm._s(index * 30 + 1)+" - "+_vm._s(((n*30) < _vm.orcamento.os_ids.length) ? n * 30 : _vm.orcamento.os_ids.length)+")\n                  ")])])])}),_vm._v(" "),_vm._l((_vm.paginas1),function(n,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status_os_id === '1'),expression:"status_os_id === '1'"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"white-text btn btn-large btn-block blue",attrs:{"href":(_vm.url_app + "/orcamento/" + (_vm.orcamento.id) + "/oss?status=1&page=" + n),"target":"_blank"}},[_vm._v("\n                    Imprimir Ordens de Serviço ("+_vm._s(index * 30 + 1)+" - "+_vm._s(((n*30) < _vm.orcamento.os_ids.length) ? n * 30 : _vm.orcamento.os_ids.length)+")\n                  ")])])])}),_vm._v(" "),_vm._l((_vm.paginas2),function(n,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status_os_id === '2'),expression:"status_os_id === '2'"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"white-text btn btn-large btn-block blue",attrs:{"href":(_vm.url_app + "/orcamento/" + (_vm.orcamento.id) + "/oss?status=2&page=" + n),"target":"_blank"}},[_vm._v("\n                    Imprimir Ordens de Serviço ("+_vm._s(index * 30 + 1)+" - "+_vm._s(((n*30) < _vm.orcamento.os_ids.length) ? n * 30 : _vm.orcamento.os_ids.length)+")\n                  ")])])])}),_vm._v(" "),_vm._l((_vm.paginas3),function(n,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status_os_id === '3'),expression:"status_os_id === '3'"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"white-text btn btn-large btn-block blue",attrs:{"href":(_vm.url_app + "/orcamento/" + (_vm.orcamento.id) + "/oss?status=3&page=" + n),"target":"_blank"}},[_vm._v("\n                    Imprimir Ordens de Serviço ("+_vm._s(index * 30 + 1)+" - "+_vm._s(((n*30) < _vm.orcamento.os_ids.length) ? n * 30 : _vm.orcamento.os_ids.length)+")\n                  ")])])])}),_vm._v(" "),_vm._l((_vm.paginas4),function(n,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status_os_id === '4'),expression:"status_os_id === '4'"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"white-text btn btn-large btn-block blue",attrs:{"href":(_vm.url_app + "/orcamento/" + (_vm.orcamento.id) + "/oss?status=4&page=" + n),"target":"_blank"}},[_vm._v("\n                    Imprimir Ordens de Serviço ("+_vm._s(index * 30 + 1)+" - "+_vm._s(((n*30) < _vm.orcamento.os_ids.length) ? n * 30 : _vm.orcamento.os_ids.length)+")\n                  ")])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn red btn-large",staticStyle:{"width":"100%"},attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.deleteOs.apply(null, arguments)}}},[_vm._v("Deletar Ordens de\n                    Serviço\n                  ")])])])],2)]),_vm._v(" "),_c('li',[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.documento_assinado),expression:"orcamento.documento_assinado"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"blue-text",attrs:{"href":(_vm.url_app + "/orcamento/" + (_vm.orcamento.id) + "/download"),"target":"_blank"}},[_c('i',{staticClass:"material-icons left"},[_vm._v("file_download")]),_vm._v(" Baixar Documento Assinado\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options2,"on-complete":_vm.complete3,"on-total-progress":_vm.totalProgress2}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"center-align"},[_vm._v("clique para inserir o documento assinado pelo cliente")])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e()])])])],2)],1)])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"status_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.orcamento.status_id),expression:"orcamento.status_id"}],attrs:{"name":"status_id","id":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orcamento, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.status),function(status){return _c('option',{domProps:{"value":status.id}},[_vm._v(_vm._s(status.status))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('status_id')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.status_id === 5),expression:"orcamento.status_id === 5"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gerar_os),expression:"gerar_os"}],attrs:{"name":"gerar_os","id":"gerar_os","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.gerar_os)?_vm._i(_vm.gerar_os,null)>-1:(_vm.gerar_os)},on:{"change":function($event){var $$a=_vm.gerar_os,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.gerar_os=$$a.concat([$$v]))}else{$$i>-1&&(_vm.gerar_os=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.gerar_os=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"gerar_os"}},[_vm._v("Gerar OS")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orcamento.status_id === 6),expression:"orcamento.status_id === 6"}],staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"motivo_id"}},[_vm._v("Motivo de Recusa")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento.motivo_id),expression:"orcamento.motivo_id"}],attrs:{"name":"motivo_id","id":"motivo_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orcamento, "motivo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.motivos),function(motivo){return _c('option',{domProps:{"value":motivo.id}},[_vm._v(_vm._s(motivo.motivo_recusa))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('motivos')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.enviar_orcamento),expression:"enviar_orcamento"}],attrs:{"name":"enviar_orcamento","id":"enviar_orcamento","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.enviar_orcamento)?_vm._i(_vm.enviar_orcamento,null)>-1:(_vm.enviar_orcamento)},on:{"change":function($event){var $$a=_vm.enviar_orcamento,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.enviar_orcamento=$$a.concat([$$v]))}else{$$i>-1&&(_vm.enviar_orcamento=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.enviar_orcamento=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"enviar_orcamento"}},[_vm._v("Enviar por e-mail")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_vm._v("\n              Salvar\n            ")])])])])])])])}
var orcamentos_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Informações Gerais\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("date_range")]),_vm._v(" Visita\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("double_arrow")]),_vm._v(" Objetivo\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment_turned_in")]),_vm._v(" Propostas\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Serviços da Proposta")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Produtos da Proposta")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("add_a_photo")]),_vm._v(" Isométrico\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("add_a_photo")]),_vm._v(" Fotos\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("video_library")]),_vm._v(" Vídeos\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("build")]),_vm._v(" OS's\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")]),_vm._v(" Documento Assinado\n            ")])}]
var orcamentos_form_esExports = { render: orcamentos_form_render, staticRenderFns: orcamentos_form_staticRenderFns }
/* harmony default export */ var orcamentos_orcamentos_form = (orcamentos_form_esExports);
// CONCATENATED MODULE: ./src/features/orcamentos/orcamentos/form.vue
var orcamentos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orcamentos_form___vue_template_functional__ = false
/* styles */
var orcamentos_form___vue_styles__ = null
/* scopeId */
var orcamentos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var orcamentos_form___vue_module_identifier__ = null
var orcamentos_form_Component = orcamentos_form_normalizeComponent(
  orcamentos_form,
  orcamentos_orcamentos_form,
  orcamentos_form___vue_template_functional__,
  orcamentos_form___vue_styles__,
  orcamentos_form___vue_scopeId__,
  orcamentos_form___vue_module_identifier__
)

/* harmony default export */ var features_orcamentos_orcamentos_form = (orcamentos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/orcamentos/orcamentos/routes.js




/* harmony default export */ var orcamentos_routes = ([{
  path: '/orcamentos/:status?',
  name: 'orcamentos.index',
  component: features_orcamentos_orcamentos,
  children: [{
    path: 'form/:id?',
    name: 'orcamentos.form',
    component: features_orcamentos_orcamentos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/orcamentos/pagamentos/index.vue



//




/* harmony default export */ var pagamentos = ({
  name: 'Pagamento',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/orcamentos/pagamentos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/orcamentos/pagamentos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var pagamento, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pagamento = obj.pagamento;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: pagamento.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, pagamento);
                } else {
                  _this3.list.unshift(pagamento);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(pagamento) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + pagamento.pagamento + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/orcamentos/pagamentos/' + pagamento.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: pagamento.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'orcamentos-pagamentos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'orcamentos-pagamentos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798727bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/orcamentos/pagamentos/index.vue
var pagamentos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('orcamento-pagamento.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('orcamento-pagamento.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'orcamentos-pagamentos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'orcamentos-pagamentos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-orcamentos-pagamentos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(pagamento){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('orcamento-pagamento.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'orcamentos-pagamentos.form', params: { id: pagamento.id } }}},[_vm._v(_vm._s(pagamento.pagamento))]):_c('span',[_vm._v(_vm._s(pagamento.pagamento))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!pagamento.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento-pagamento.editar') > -1),expression:"permissoes.indexOf('orcamento-pagamento.editar') > -1"}],attrs:{"to":{ name: 'orcamentos-pagamentos.form', params: { id: pagamento.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('orcamento-pagamento.excluir') > -1),expression:"permissoes.indexOf('orcamento-pagamento.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(pagamento)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var pagamentos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Orçamentos :: Condições de Pagamento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Condição de Pagamento")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var pagamentos_esExports = { render: pagamentos_render, staticRenderFns: pagamentos_staticRenderFns }
/* harmony default export */ var orcamentos_pagamentos = (pagamentos_esExports);
// CONCATENATED MODULE: ./src/features/orcamentos/pagamentos/index.vue
var pagamentos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pagamentos___vue_template_functional__ = false
/* styles */
var pagamentos___vue_styles__ = null
/* scopeId */
var pagamentos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pagamentos___vue_module_identifier__ = null
var pagamentos_Component = pagamentos_normalizeComponent(
  pagamentos,
  orcamentos_pagamentos,
  pagamentos___vue_template_functional__,
  pagamentos___vue_styles__,
  pagamentos___vue_scopeId__,
  pagamentos___vue_module_identifier__
)

/* harmony default export */ var features_orcamentos_pagamentos = (pagamentos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/orcamentos/pagamentos/form.vue



//



/* harmony default export */ var pagamentos_form = ({
  name: 'Form',
  data: function data() {
    return {
      formas: [],
      pagamento: {
        id: '',
        pagamento: '',
        percentual_entrada: 100,
        parcelas_saldo: 0,
        forma_id: '',
        ativo: true
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/orcamentos/pagamentos' : '/orcamentos/pagamentos/' + _this2.pagamento.id;
                _context.next = 4;
                return service_http[verb](url, _this2.pagamento);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-orcamentos-pagamentos-list', { pagamento: data.pagamento });
                  _this2.$router.push({ name: 'orcamentos-pagamentos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/orcamentos/pagamentos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.pagamento = data.pagamento;
                _this3.formas = data.formas;
                _context2.next = 16;
                break;

              case 11:
                _context2.next = 13;
                return service_http.get('/orcamentos/pagamentos/create');

              case 13:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.formas = _data.formas;

              case 16:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.pagamento = {
        id: '',
        pagamento: '',
        percentual_entrada: 100,
        parcelas_saldo: 0,
        forma_id: '',
        ativo: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.pagamento.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a3f84a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/orcamentos/pagamentos/form.vue
var pagamentos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.pagamento.pagamento),expression:"pagamento.pagamento"}],class:{invalid: _vm.errors.has('pagamento')},attrs:{"name":"pagamento","id":"pagamento","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.pagamento.pagamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pagamento, "pagamento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"pagamento"}},[_vm._v("*Condição de Pagamento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('pagamento')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.pagamento.percentual_entrada),expression:"pagamento.percentual_entrada"}],class:{invalid: _vm.errors.has('percentual_entrada')},attrs:{"name":"percentual_entrada","id":"percentual_entrada","type":"number","min":"0","max":"100","data-vv-rules":"required"},domProps:{"value":(_vm.pagamento.percentual_entrada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pagamento, "percentual_entrada", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"percentual_entrada"}},[_vm._v("*Entrada (%)")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('percentual_entrada')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.pagamento.parcelas_saldo),expression:"pagamento.parcelas_saldo"}],class:{invalid: _vm.errors.has('parcelas_saldo')},attrs:{"name":"pagamento","id":"parcelas_saldo","type":"number","min":"0","data-vv-rules":"required","disabled":_vm.pagamento.percentual_entrada === 100 ? true : false},domProps:{"value":(_vm.pagamento.parcelas_saldo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pagamento, "parcelas_saldo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"parcelas_saldo"}},[_vm._v("*Nº Parcelas Saldo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('parcelas_saldo')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"forma_id"}},[_vm._v("*Forma de Pagamento")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagamento.forma_id),expression:"pagamento.forma_id"}],attrs:{"name":"forma_id","id":"forma_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pagamento, "forma_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.formas),function(forma){return _c('option',{domProps:{"value":forma.id}},[_vm._v(_vm._s(forma.forma))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagamento.ativo),expression:"pagamento.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.pagamento.ativo)?_vm._i(_vm.pagamento.ativo,null)>-1:(_vm.pagamento.ativo)},on:{"change":function($event){var $$a=_vm.pagamento.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.pagamento, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.pagamento, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.pagamento, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var pagamentos_form_staticRenderFns = []
var pagamentos_form_esExports = { render: pagamentos_form_render, staticRenderFns: pagamentos_form_staticRenderFns }
/* harmony default export */ var orcamentos_pagamentos_form = (pagamentos_form_esExports);
// CONCATENATED MODULE: ./src/features/orcamentos/pagamentos/form.vue
var pagamentos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pagamentos_form___vue_template_functional__ = false
/* styles */
var pagamentos_form___vue_styles__ = null
/* scopeId */
var pagamentos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pagamentos_form___vue_module_identifier__ = null
var pagamentos_form_Component = pagamentos_form_normalizeComponent(
  pagamentos_form,
  orcamentos_pagamentos_form,
  pagamentos_form___vue_template_functional__,
  pagamentos_form___vue_styles__,
  pagamentos_form___vue_scopeId__,
  pagamentos_form___vue_module_identifier__
)

/* harmony default export */ var features_orcamentos_pagamentos_form = (pagamentos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/orcamentos/pagamentos/routes.js




/* harmony default export */ var pagamentos_routes = ([{
  path: '/orcamentos/pagamentos',
  name: 'orcamentos-pagamentos.index',
  component: features_orcamentos_pagamentos,
  children: [{
    path: 'form/:id?',
    name: 'orcamentos-pagamentos.form',
    component: features_orcamentos_pagamentos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/contatos/contatos/index.vue



//





moment_default.a.locale('pt-br');
/* harmony default export */ var contatos = ({
  name: 'Contatos',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    var status = this.$route.params.status;

    if (status !== undefined) {
      this.busca = status;
    }
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/contatos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/contatos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var contato, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contato = obj.contato;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: contato.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, contato);
                } else {
                  _this3.list.unshift(contato);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(contato) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + contato.nome + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/contatos/' + contato.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: contato.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM HH:mm');
    },
    formatDateFrom: function formatDateFrom(date) {
      return moment_default()(date).fromNow();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'contatos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'contatos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b8ed04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/contatos/contatos/index.vue
var contatos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('contato.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('contato.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'contatos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'contatos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-contatos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(contato){return _c('tr',[_c('td',[_vm._v("\n                  "+_vm._s(_vm.formatDate(contato.created_at))+"\n                  "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.formatDateFrom(contato.created_at)))])]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('contato.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'contatos.form', params: { id: contato.id } }}},[_vm._v(_vm._s(contato.nome))]):_c('span',[_vm._v(_vm._s(contato.nome))])],1),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(contato.telefone)),_c('br'),_vm._v(" "),_c('small',[_vm._v("\n                    "+_vm._s(contato.telefone2 ? contato.telefone2 : '')+"\n                    "+_vm._s(contato.telefone3 ? ', '+contato.telefone3 : '')+"\n                  ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s((contato.email) ? contato.email : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((contato.condominio) ? contato.condominio : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((contato.status) ? contato.status.status : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('contato.editar') > -1),expression:"permissoes.indexOf('contato.editar') > -1"}],attrs:{"to":{ name: 'contatos.form', params: { id: contato.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('contato.excluir') > -1),expression:"permissoes.indexOf('contato.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(contato)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var contatos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Contatos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("E-mail")]),_vm._v(" "),_c('th',[_vm._v("Condomínio")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var contatos_esExports = { render: contatos_render, staticRenderFns: contatos_staticRenderFns }
/* harmony default export */ var contatos_contatos = (contatos_esExports);
// CONCATENATED MODULE: ./src/features/contatos/contatos/index.vue
var contatos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contatos___vue_template_functional__ = false
/* styles */
var contatos___vue_styles__ = null
/* scopeId */
var contatos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var contatos___vue_module_identifier__ = null
var contatos_Component = contatos_normalizeComponent(
  contatos,
  contatos_contatos,
  contatos___vue_template_functional__,
  contatos___vue_styles__,
  contatos___vue_scopeId__,
  contatos___vue_module_identifier__
)

/* harmony default export */ var features_contatos_contatos = (contatos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/contatos/contatos/form.vue



//




/* harmony default export */ var contatos_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      comoConheceu: [{}],
      status: [{}],
      clientes: [],
      itemCliente: {
        id: '',
        cliente: ''
      },
      contato: {
        id: '',
        cliente_id: '',
        tipo: 1,
        nome: '',
        cpf: '',
        cnpj: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        tipo_residencia: '',
        condominio: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        mensagem: '',
        obs: '',
        como_conheceu_id: '',
        status_id: 1,
        foto1: '',
        foto2: '',
        foto3: '',
        foto4: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    setEndereco: function setEndereco() {
      var _this = this;

      window.$.getJSON('https://viacep.com.br/ws/' + this.contato.cep + '/json/').then(function (response) {
        if (!response.erro) {
          _this.contato.logradouro = response.logradouro;
          _this.contato.bairro = response.bairro;
          _this.contato.cidade = response.localidade;
          _this.contato.estado = response.uf;
          $('#numero').focus();
        } else {
          _this.contato.logradouro = '';
          _this.contato.numero = '';
          _this.contato.complemento = '';
          _this.contato.bairro = '';
          _this.contato.cidade = '';
          _this.contato.estado = '';
        }
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 0);
      });
    },
    fecth: function fecth() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data, _ref2, _data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.clear();
                id = _this2.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 5;
                return service_http.get('/contatos/' + id + '/edit');

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                _this2.contato = data.contato;
                _this2.status = data.status;
                _this2.comoConheceu = data.comoConheceu;
                _this2.clientes = data.clientes;
                _context.next = 20;
                break;

              case 13:
                _context.next = 15;
                return service_http.get('/contatos/create');

              case 15:
                _ref2 = _context.sent;
                _data = _ref2.data;

                _this2.status = _data.status;
                _this2.comoConheceu = _data.comoConheceu;
                _this2.clientes = _data.clientes;

              case 20:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this3.submit();
        }
      });
    },
    submit: function submit() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref3, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = _this4.isNew ? 'post' : 'put';
                url = _this4.isNew ? '/contatos' : '/contatos/' + _this4.contato.id;
                _context2.next = 4;
                return service_http[verb](url, _this4.contato);

              case 4:
                _ref3 = _context2.sent;
                data = _ref3.data;

                if (data != null) {
                  if (data.orcamento != null) {
                    _this4.$router.push({ name: 'orcamentos.form', params: { id: data.orcamento.id } });
                  } else {
                    _this4.$emit('update-contatos-list', { contato: data.contato });
                    _this4.$router.push({ name: 'contatos.index' });
                  }
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    onSelectCliente: function onSelectCliente(item) {
      if (item) {
        this.setCliente(item.id);
      }
    },
    setCliente: function setCliente(value) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.contato.cliente_id = value;

                if (!value) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return service_http.get('/clientes/' + value);

              case 4:
                _ref4 = _context4.sent;
                data = _ref4.data;

                _this5.$swal({
                  title: 'Deseja utilizar os dados do cliente ' + data.cliente.cliente + '?',
                  html: '',
                  type: 'warning',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Sim, quero atualizar!',
                  reverseButtons: true
                }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                  return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this5.contato.tipo = data.cliente.tipo;
                          _this5.contato.cnpj = data.cliente.cnpj;
                          _this5.contato.condominio = data.cliente.razao_social;
                          _this5.contato.nome = data.cliente.tipo === 1 ? data.cliente.responsavel : data.cliente.cliente;
                          _this5.contato.cpf = data.cliente.cpf;
                          _this5.contato.email = data.cliente.email;
                          _this5.contato.telefone = data.cliente.telefone;
                          _this5.contato.telefone2 = data.cliente.telefone2;
                          _this5.contato.telefone3 = data.cliente.telefone3;
                          _this5.contato.cep = data.cliente.cep;
                          _this5.contato.logradouro = data.cliente.logradouro;
                          _this5.contato.numero = data.cliente.numero;
                          _this5.contato.complemento = data.cliente.complemento;
                          _this5.contato.bairro = data.cliente.bairro;
                          _this5.contato.cidade = data.cliente.cidade;
                          _this5.contato.estado = data.cliente.estado;
                          _this5.contato.referencia = data.cliente.referencia;
                          setTimeout(function () {
                            window.Materialize.updateTextFields();
                          }, 0);

                        case 18:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this5);
                })));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    clear: function clear() {
      this.contato = {
        id: '',
        cliente_id: '',
        tipo: 1,
        nome: '',
        cpf: '',
        cnpj: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        tipo_residencia: '',
        condominio: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        mensagem: '',
        obs: '',
        como_conheceu_id: '',
        status_id: 1
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.contato.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1206403a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/contatos/contatos/form.vue
var contatos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('list-select',{staticStyle:{"margin-top":"10px"},attrs:{"list":_vm.clientes,"option-value":"id","option-text":"cliente","selected-item":_vm.itemCliente,"placeholder":"Buscar Cliente"},on:{"select":_vm.onSelectCliente}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model.number",value:(_vm.contato.tipo),expression:"contato.tipo",modifiers:{"number":true}}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.contato, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Pessoa Jurídica")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Pessoa Física")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contato.tipo === 1),expression:"contato.tipo === 1"}],staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99.999.999/9999-99'),expression:"'99.999.999/9999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.cnpj),expression:"contato.cnpj"}],class:{invalid: _vm.errors.has('cnpj')},attrs:{"name":"cnpj","id":"cnpj","type":"text","data-vv-rules":"min:18"},domProps:{"value":(_vm.contato.cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "cnpj", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cnpj')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contato.tipo === 2),expression:"contato.tipo === 2"}],staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.cpf),expression:"contato.cpf"}],class:{invalid: _vm.errors.has('cpf')},attrs:{"name":"cpf","id":"cpf","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.contato.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "cpf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cpf')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.nome),expression:"contato.nome"}],class:{invalid: _vm.errors.has('nome')},attrs:{"name":"nome","id":"nome","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.contato.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "nome", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"nome"}},[_vm._v("*Nome")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('nome')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.tipo_residencia),expression:"contato.tipo_residencia"}],class:{invalid: _vm.errors.has('tipo_residencia')},attrs:{"name":"tipo_residencia","id":"tipo_residencia","type":"text"},domProps:{"value":(_vm.contato.tipo_residencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "tipo_residencia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo_residencia"}},[_vm._v("Tipo de Residência")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo_residencia')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.condominio),expression:"contato.condominio"}],class:{invalid: _vm.errors.has('condominio')},attrs:{"name":"condominio","id":"condominio","type":"text"},domProps:{"value":(_vm.contato.condominio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "condominio", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"condominio"}},[_vm._v("Condomínio")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('condominio')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.telefone),expression:"contato.telefone"}],class:{invalid: _vm.errors.has('telefone')},attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.contato.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.telefone2),expression:"contato.telefone2"}],class:{invalid: _vm.errors.has('telefone2')},attrs:{"name":"telefone2","id":"telefone2","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.contato.telefone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "telefone2", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone2"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone2')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.telefone3),expression:"contato.telefone3"}],class:{invalid: _vm.errors.has('telefone3')},attrs:{"name":"telefone3","id":"telefone3","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.contato.telefone3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "telefone3", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone3"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('telefone3')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.email),expression:"contato.email"}],class:{invalid: _vm.errors.has('email')},attrs:{"name":"email","id":"email","type":"text","data-vv-rules":"email"},domProps:{"value":(_vm.contato.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('email')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99999-999'),expression:"'99999-999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.cep),expression:"contato.cep"}],class:{invalid: _vm.errors.has('cep')},attrs:{"name":"cep","id":"cep","type":"text","data-vv-rules":"min:9"},domProps:{"value":(_vm.contato.cep)},on:{"blur":_vm.setEndereco,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "cep", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cep')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.logradouro),expression:"contato.logradouro"}],attrs:{"name":"logradouro","id":"logradouro","type":"text"},domProps:{"value":(_vm.contato.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "logradouro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Logradouro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('logradouro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.numero),expression:"contato.numero"}],attrs:{"name":"numero","id":"numero","type":"text"},domProps:{"value":(_vm.contato.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"numero"}},[_vm._v("Nº")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('numero')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.complemento),expression:"contato.complemento"}],attrs:{"name":"complemento","id":"complemento","type":"text"},domProps:{"value":(_vm.contato.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"complemento"}},[_vm._v("Compl.")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('complemento')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.bairro),expression:"contato.bairro"}],attrs:{"name":"bairro","id":"bairro","type":"text"},domProps:{"value":(_vm.contato.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "bairro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('bairro')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.cidade),expression:"contato.cidade"}],attrs:{"name":"cidade","id":"cidade","type":"text"},domProps:{"value":(_vm.contato.cidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "cidade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cidade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.estado),expression:"contato.estado"}],attrs:{"name":"estado","id":"estado","type":"text"},domProps:{"value":(_vm.contato.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "estado", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estado')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.referencia),expression:"contato.referencia"}],attrs:{"name":"referencia","id":"referencia","type":"text"},domProps:{"value":(_vm.contato.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "referencia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"referencia"}},[_vm._v("Ponto de Referência")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('referencia')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.mensagem),expression:"contato.mensagem"}],staticClass:"materialize-textarea",attrs:{"name":"mensagem","id":"mensagem"},domProps:{"value":(_vm.contato.mensagem)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "mensagem", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"mensagem"}},[_vm._v("Mensagem Cliente")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('mensagem')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.obs),expression:"contato.obs"}],staticClass:"materialize-textarea",attrs:{"name":"obs","id":"obs"},domProps:{"value":(_vm.contato.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contato, "obs", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"obs"}},[_vm._v("Observações KitGás")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('obs')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.contato.foto1)?_c('div',{staticClass:"col s12 m3 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%"},attrs:{"src":(_vm.api_url + "/" + (_vm.contato.foto1))}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})]):_vm._e(),_vm._v(" "),(_vm.contato.foto2)?_c('div',{staticClass:"col s12 m3 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%"},attrs:{"src":(_vm.api_url + "/" + (_vm.contato.foto2))}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})]):_vm._e(),_vm._v(" "),(_vm.contato.foto3)?_c('div',{staticClass:"col s12 m3 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%"},attrs:{"src":(_vm.api_url + "/" + (_vm.contato.foto3))}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})]):_vm._e(),_vm._v(" "),(_vm.contato.foto4)?_c('div',{staticClass:"col s12 m3 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%"},attrs:{"src":(_vm.api_url + "/" + (_vm.contato.foto4))}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"como_conheceu_id"}},[_vm._v("Como Conheceu")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contato.como_conheceu_id),expression:"contato.como_conheceu_id"}],attrs:{"name":"como_conheceu_id","id":"como_conheceu_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contato, "como_conheceu_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.comoConheceu),function(como){return _c('option',{domProps:{"value":como.id}},[_vm._v(_vm._s(como.como_conheceu))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('como_conheceu_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"status_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.contato.status_id),expression:"contato.status_id"}],attrs:{"name":"status_id","id":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contato, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.status),function(status){return _c('option',{domProps:{"value":status.id}},[_vm._v(_vm._s(status.status))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('status_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var contatos_form_staticRenderFns = []
var contatos_form_esExports = { render: contatos_form_render, staticRenderFns: contatos_form_staticRenderFns }
/* harmony default export */ var contatos_contatos_form = (contatos_form_esExports);
// CONCATENATED MODULE: ./src/features/contatos/contatos/form.vue
var contatos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contatos_form___vue_template_functional__ = false
/* styles */
var contatos_form___vue_styles__ = null
/* scopeId */
var contatos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var contatos_form___vue_module_identifier__ = null
var contatos_form_Component = contatos_form_normalizeComponent(
  contatos_form,
  contatos_contatos_form,
  contatos_form___vue_template_functional__,
  contatos_form___vue_styles__,
  contatos_form___vue_scopeId__,
  contatos_form___vue_module_identifier__
)

/* harmony default export */ var features_contatos_contatos_form = (contatos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/contatos/contatos/routes.js




/* harmony default export */ var contatos_routes = ([{
  path: '/contatos/:status?',
  name: 'contatos.index',
  component: features_contatos_contatos,
  children: [{
    path: 'form/:id?',
    name: 'contatos.form',
    component: features_contatos_contatos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/servicos/index.vue








/* harmony default export */ var servicos = ({
  name: 'Servicos',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/servicos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/servicos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var servico, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                servico = obj.servico;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: servico.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, servico);
                } else {
                  _this3.list.unshift(servico);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(servico) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + servico.servico + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/servicos/' + servico.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: servico.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'servicos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'servicos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40073b92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/servicos/index.vue
var servicos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('servico.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('servico.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'servicos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'servicos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-servicos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(servico){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('servico.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'servicos.form', params: { id: servico.id } }}},[_vm._v("\n                "+_vm._s(servico.servico)+"\n                "),(servico.observacao)?_c('small',[_c('br'),_vm._v(_vm._s(servico.observacao))]):_vm._e(),_vm._v(" "),(servico.tipo === 1)?_c('small',[_c('br'),_vm._v(_vm._s(servico.responsavel))]):_vm._e()]):_c('span',[_vm._v(_vm._s(servico.servico)),_c('br'),(servico.observacao)?_c('small',[_vm._v(_vm._s(servico.observacao))]):_vm._e()])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(servico.valor))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!servico.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('servico.editar') > -1),expression:"permissoes.indexOf('servico.editar') > -1"}],attrs:{"to":{ name: 'servicos.form', params: { id: servico.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('servico.excluir') > -1),expression:"permissoes.indexOf('servico.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(servico)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var servicos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Serviços")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Serviço")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var servicos_esExports = { render: servicos_render, staticRenderFns: servicos_staticRenderFns }
/* harmony default export */ var features_servicos = (servicos_esExports);
// CONCATENATED MODULE: ./src/features/servicos/index.vue
var servicos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var servicos___vue_template_functional__ = false
/* styles */
var servicos___vue_styles__ = null
/* scopeId */
var servicos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var servicos___vue_module_identifier__ = null
var servicos_Component = servicos_normalizeComponent(
  servicos,
  features_servicos,
  servicos___vue_template_functional__,
  servicos___vue_styles__,
  servicos___vue_scopeId__,
  servicos___vue_module_identifier__
)

/* harmony default export */ var src_features_servicos = (servicos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/servicos/form.vue









/* harmony default export */ var servicos_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      produtos: [],
      item: {
        id: '',
        produto: {},
        valor: '',
        qtd: ''
      },
      servico: {
        id: '',
        servico: '',
        descricao: '',
        observacao: '',
        valor: '',
        ativo: true,
        produtos: []
      },
      editorOption: {
        placeholder: 'Descrição',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['clean']]
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/servicos' : '/servicos/' + _this2.servico.id;
                _context.next = 4;
                return service_http[verb](url, _this2.servico);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-servicos-list', { servico: data.servico });
                  _this2.$router.push({ name: 'servicos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/servicos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.servico = data.servico;
                _this3.produtos = data.produtos;
                _context2.next = 16;
                break;

              case 11:
                _context2.next = 13;
                return service_http.get('/servicos/create');

              case 13:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.produtos = _data.produtos;

              case 16:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.servico = {
        id: '',
        servico: '',
        descricao: '',
        valor: '',
        observacao: '',
        ativo: true,
        produtos: []
      };
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        var index = findIndex_default()(this.servico.produtos, { produto_id: item.id });
        if (index > -1) {
          window.Materialize.toast(item.produto + ' j\xE1 faz parte da proposta', 2000);
        } else {
          var produto = {
            produto_id: item.id,
            produto: item,
            valor: item.valor_venda,
            quantidade: 1
          };
          this.addProduto(produto);
        }
      }
    },
    addProduto: function addProduto(produto) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (typeof _this4.servico.produtos === 'undefined') {
                  _this4.servico.produtos = [];
                }
                _context3.next = 3;
                return _this4.servico.produtos.push(produto);

              case 3:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    destroyProduto: function destroyProduto(index) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um produto \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.servico.produtos[index].id) {
                  _context4.next = 5;
                  break;
                }

                _this5.servico.produtos.splice(index, 1);
                window.Materialize.toast('Produto excluído!', 4000);
                _context4.next = 9;
                break;

              case 5:
                _context4.next = 7;
                return service_http.delete('servicos/produtos/' + _this5.servico.produtos[index].id);

              case 7:
                _this5.servico.produtos.splice(index, 1);
                window.Materialize.toast('Produto excluído!', 4000);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.servico.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd183f2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/servicos/form.vue
var servicos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.servico.servico),expression:"servico.servico"}],class:{invalid: _vm.errors.has('servico')},attrs:{"name":"servico","id":"servico","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.servico.servico)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.servico, "servico", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"servico"}},[_vm._v("*Serviço")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('servico')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.servico.valor),expression:"servico.valor"}],class:{invalid: _vm.errors.has('valor')},attrs:{"name":"valor","id":"valor","type":"number","step":"any","data-vv-rules":"required"},domProps:{"value":(_vm.servico.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.servico, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*Valor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.servico.observacao),expression:"servico.observacao"}],class:{invalid: _vm.errors.has('observacao')},attrs:{"name":"observacao","id":"observacao","type":"text"},domProps:{"value":(_vm.servico.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.servico, "observacao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"observacao"}},[_vm._v("Observação")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('observacao')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('quill-editor',{ref:"servico.descricao",attrs:{"options":_vm.editorOption},model:{value:(_vm.servico.descricao),callback:function ($$v) {_vm.$set(_vm.servico, "descricao", $$v)},expression:"servico.descricao"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","selected-item":_vm.item,"placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.servico.produtos.length > 0),expression:"servico.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.servico.produtos),function(produto,index){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((produto.produto) ? produto.produto.produto : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.quantidade),expression:"produto.quantidade"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("quantidade" + index),"min":"1"},domProps:{"value":(produto.quantidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "quantidade", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(index)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.servico.ativo),expression:"servico.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.servico.ativo)?_vm._i(_vm.servico.ativo,null)>-1:(_vm.servico.ativo)},on:{"change":function($event){var $$a=_vm.servico.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.servico, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.servico, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.servico, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.validate}},[_vm._v("Salvar\n            ")])])])])])])])}
var servicos_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th',{attrs:{"width":"10"}},[_vm._v("Quantidade")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var servicos_form_esExports = { render: servicos_form_render, staticRenderFns: servicos_form_staticRenderFns }
/* harmony default export */ var features_servicos_form = (servicos_form_esExports);
// CONCATENATED MODULE: ./src/features/servicos/form.vue
var servicos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var servicos_form___vue_template_functional__ = false
/* styles */
var servicos_form___vue_styles__ = null
/* scopeId */
var servicos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var servicos_form___vue_module_identifier__ = null
var servicos_form_Component = servicos_form_normalizeComponent(
  servicos_form,
  features_servicos_form,
  servicos_form___vue_template_functional__,
  servicos_form___vue_styles__,
  servicos_form___vue_scopeId__,
  servicos_form___vue_module_identifier__
)

/* harmony default export */ var src_features_servicos_form = (servicos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/servicos/routes.js




/* harmony default export */ var servicos_routes = ([{
  path: '/servicos',
  name: 'servicos.index',
  component: src_features_servicos,
  children: [{
    path: 'form/:id?',
    name: 'servicos.form',
    component: src_features_servicos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/produtos/index.vue








/* harmony default export */ var produtos = ({
  name: 'Produtos',
  data: function data() {
    return {
      list: [],
      marcas: [{}],
      fornecedores: [],
      familias: [{}],
      categorias: [{}],
      tipo_pdf: 'compra_venda',
      marca_id: '',
      sem_familia: '0',
      fornecedor_id: '',
      familia_id: '',
      categoria_id: '',
      ordenacao: 'asc',
      mostrar_estoque: '0',
      mostrar_marca: '0',
      mostrar_fornecedor: '0',
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/produtos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.listagem.data;
                  _this.pagination.current_page = data.listagem.current_page;
                  _this.pagination.last_page = data.listagem.last_page;
                  _this.marcas = data.marcas;
                  _this.fornecedores = data.fornecedores;
                  _this.familias = data.familias;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/produtos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.listagem.data;
                  _this2.pagination.current_page = data.listagem.current_page;
                  _this2.pagination.last_page = data.listagem.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    submitForm: function submitForm() {
      $('#form-pdf').submit();
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var produto, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                produto = obj.produto;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: produto.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, produto);
                } else {
                  _this3.list.unshift(produto);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    familiaChange: function familiaChange() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref3, data;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.post('/familias/categorias/familias/ajax?familias=' + _this4.familia_id);

              case 2:
                _ref3 = _context4.sent;
                data = _ref3.data;

                _this4.categorias = data.categorias;
                _this4.produto.categoria_id = '';
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    destroy: function destroy(produto) {
      var _this5 = this;

      this.$swal({
        title: 'Deseja remover ' + produto.produto + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _ref5, data, index;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return service_http.delete('/produtos/' + produto.id);

              case 2:
                _ref5 = _context5.sent;
                data = _ref5.data;

                if (!(data != null)) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 7;
                return findIndex_default()(_this5.list, { id: produto.id });

              case 7:
                index = _context5.sent;

                if (index > -1) {
                  _this5.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this5.checkListTotal();
                }

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes', 'email']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'produtos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'produtos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    },

    familiasIds: {
      get: function get() {
        var _this6 = this;

        return this.familias.filter(function (option) {
          return _this6.familia_id.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.familia_id = newSelectedOptions.map(function (option) {
          return option.id;
        });
        this.familiaChange();
      }
    },
    marcasIds: {
      get: function get() {
        var _this7 = this;

        return this.marcas.filter(function (option) {
          return _this7.marca_id.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.marca_id = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    },
    categoriasIds: {
      get: function get() {
        var _this8 = this;

        return this.categorias.filter(function (option) {
          return _this8.categoria_id.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.categoria_id = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2786c562","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/produtos/index.vue
var produtos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{staticClass:"btn-floating waves-effect waves-light",attrs:{"href":(_vm.api_url + "/produtos/inventario"),"download":"","target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('produto.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('produto.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'produtos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'produtos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('form',{attrs:{"action":(_vm.api_url + "/produtos/pdf"),"method":"get","id":"form-pdf","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"hidden","name":"usuario"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('p',[_vm._v("Relatório")]),_vm._v(" "),_c('div',{staticClass:"col s6 m4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fornecedor_id),expression:"fornecedor_id"}],attrs:{"name":"fornecedor_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fornecedor_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Fornecedor")]),_vm._v(" "),_vm._l((_vm.fornecedores),function(fornecedor){return _c('option',{domProps:{"value":fornecedor.id}},[_vm._v(_vm._s(fornecedor.fornecedor))])})],2),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('fornecedor_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s6 m4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sem_familia),expression:"sem_familia"}],attrs:{"name":"sem_familia"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sem_familia=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Ocultar Produtos Sem Família")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Inlcuir Produtos Sem Família")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('sem_familia')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.marca_id),expression:"marca_id"}],attrs:{"type":"hidden","name":"marcas"},domProps:{"value":(_vm.marca_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.marca_id=$event.target.value}}}),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Todas as Marcas","closeOnSelect":false,"label":"marca","track-by":"id","options":_vm.marcas},model:{value:(_vm.marcasIds),callback:function ($$v) {_vm.marcasIds=$$v},expression:"marcasIds"}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familia_id),expression:"familia_id"}],attrs:{"type":"hidden","name":"familias"},domProps:{"value":(_vm.familia_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familia_id=$event.target.value}}}),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Todas as Famílias","closeOnSelect":false,"label":"familia","track-by":"id","options":_vm.familias},model:{value:(_vm.familiasIds),callback:function ($$v) {_vm.familiasIds=$$v},expression:"familiasIds"}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoria_id),expression:"categoria_id"}],attrs:{"type":"hidden","name":"categorias"},domProps:{"value":(_vm.categoria_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.categoria_id=$event.target.value}}}),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Todas as Categorias","closeOnSelect":false,"label":"categoria","track-by":"id","options":_vm.categorias},model:{value:(_vm.categoriasIds),callback:function ($$v) {_vm.categoriasIds=$$v},expression:"categoriasIds"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mostrar_fornecedor),expression:"mostrar_fornecedor"}],attrs:{"name":"fornecedor"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mostrar_fornecedor=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Mostrar Fornecedor")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ocultar Fornecedor")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mostrar_estoque),expression:"mostrar_estoque"}],attrs:{"name":"estoque"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mostrar_estoque=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Mostrar Estoque")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ocultar Estoque")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mostrar_marca),expression:"mostrar_marca"}],attrs:{"name":"marca"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mostrar_marca=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Mostrar Marca")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ocultar Marca")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo_pdf),expression:"tipo_pdf"}],attrs:{"name":"tipo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipo_pdf=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"compra"}},[_vm._v("Preço de Compra")]),_vm._v(" "),_c('option',{attrs:{"value":"venda"}},[_vm._v("Preço de Venda")]),_vm._v(" "),_c('option',{attrs:{"value":"compra_venda"}},[_vm._v("Preço de Compra e Venda")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ordenacao),expression:"ordenacao"}],attrs:{"name":"ordenacao"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ordenacao=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"asc"}},[_vm._v("Ordenar por Menor Valor")]),_vm._v(" "),_c('option',{attrs:{"value":"desc"}},[_vm._v("Ordenar por Maior Valor")]),_vm._v(" "),_c('option',{attrs:{"value":"tudo"}},[_vm._v("Mostrar Todos")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('button',{staticClass:"btn",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("Relatório")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-produtos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(produto){return _c('tr',[_c('td',[_vm._v(_vm._s(produto.codigo ? produto.codigo : '-'))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('produto.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'produtos.form', params: { id: produto.id } }}},[_vm._v("\n                "+_vm._s(produto.produto)+"\n                "),(produto.tipo === 1)?_c('small',[_c('br'),_vm._v(_vm._s(produto.responsavel))]):_vm._e()]):_c('span',[_vm._v(_vm._s(produto.produto))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.marca ? produto.marca.marca : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.familia ? produto.familia.familia : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.unidade ? produto.unidade.unidade : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.estoque))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.estoque_minimo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.valor_compra))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.valor_venda))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(produto.loja ? produto.valor_loja : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!produto.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e(),_vm._v(" "),(produto.ativo && produto.estoque > 0 && produto.estoque < produto.estoque_minimo)?_c('span',{staticClass:"new badge yellow darken-4",attrs:{"data-badge-caption":"estoque mínimo"}}):_vm._e(),_vm._v(" "),(produto.ativo && produto.estoque == 0)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"estoque zero"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('produto.editar') > -1),expression:"permissoes.indexOf('produto.editar') > -1"}],attrs:{"to":{ name: 'produtos.form', params: { id: produto.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('produto.excluir') > -1),expression:"permissoes.indexOf('produto.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(produto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var produtos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m5"},[_c('h5',[_vm._v("Produtos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th',[_vm._v("Marca")]),_vm._v(" "),_c('th',[_vm._v("Família")]),_vm._v(" "),_c('th',[_vm._v("Unidade")]),_vm._v(" "),_c('th',[_vm._v("Estoque")]),_vm._v(" "),_c('th',[_vm._v("Estoque mínimo")]),_vm._v(" "),_c('th',[_vm._v("R$ Compra")]),_vm._v(" "),_c('th',[_vm._v("R$ Venda")]),_vm._v(" "),_c('th',[_vm._v("R$ Loja")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var produtos_esExports = { render: produtos_render, staticRenderFns: produtos_staticRenderFns }
/* harmony default export */ var features_produtos = (produtos_esExports);
// CONCATENATED MODULE: ./src/features/produtos/index.vue
var produtos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var produtos___vue_template_functional__ = false
/* styles */
var produtos___vue_styles__ = null
/* scopeId */
var produtos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var produtos___vue_module_identifier__ = null
var produtos_Component = produtos_normalizeComponent(
  produtos,
  features_produtos,
  produtos___vue_template_functional__,
  produtos___vue_styles__,
  produtos___vue_scopeId__,
  produtos___vue_module_identifier__
)

/* harmony default export */ var src_features_produtos = (produtos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/produtos/form.vue







/* harmony default export */ var produtos_form = ({
  name: 'Form',
  data: function data() {
    return {
      unidades: [{}],
      marcas: [{}],
      fornecedores: [{}],
      familias: [],
      categorias: [],
      produto: {
        id: '',
        unidade_id: '',
        codigo: '',
        produto: '',
        descricao: '',
        foto: '',
        fotos: [],
        marca_id: '',
        fornecedor_id: '',
        familia_id: '',
        categoria_id: '',
        ncm: '',
        unidade: '',
        estoque: '',
        estoque_minimo: '',
        valor_compra: '',
        valor_venda: '',
        valor_loja: '',
        loja: true,
        ativo: true
      },
      progress: 0,
      errorFile: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-image',
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'produtos',
          width: 800,
          height: 600,
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/produtos' : '/produtos/' + _this2.produto.id;
                _context.next = 4;
                return service_http[verb](url, _this2.produto);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-produtos-list', { produto: data.produto });
                  _this2.$router.push({ name: 'produtos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/produtos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.produto = data.produto;
                _this3.unidades = data.unidades;
                _this3.marcas = data.marcas;
                _this3.fornecedores = data.fornecedores;
                _this3.familias = data.familias;
                _this3.categorias = data.categorias;
                _context2.next = 23;
                break;

              case 15:
                _context2.next = 17;
                return service_http.get('/produtos/create');

              case 17:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.unidades = _data.unidades;
                _this3.marcas = _data.marcas;
                _this3.fornecedores = _data.fornecedores;
                _this3.familias = _data.familias;

              case 23:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    familiaChange: function familiaChange() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref4, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return service_http.get('/familias/categorias/' + _this4.produto.familia_id + '/ajax');

              case 2:
                _ref4 = _context3.sent;
                data = _ref4.data;

                _this4.categorias = data.categorias;
                _this4.produto.categoria_id = '';
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    setCapa: function setCapa(indexFoto) {
      this.produto.fotos.forEach(function (item) {
        item.capa = false;
      });
      this.produto.fotos[indexFoto].capa = true;
    },
    clear: function clear() {
      this.produto = {
        id: '',
        unidade_id: '',
        codigo: '',
        produto: '',
        descricao: '',
        foto: '',
        fotos: [],
        marca_id: '',
        fornecedor_id: '',
        familia_id: '',
        categoria_id: '',
        unidade: '',
        ncm: '',
        estoque: '',
        estoque_minimo: '',
        valor_compra: '',
        valor_venda: '',
        valor_loja: '',
        loja: true,
        ativo: true
      };
    },
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.produto.fotos.push({ foto: xhr.response, capa: false });
        this.progress = 0;
        if (this.produto.fotos.length === 1) {
          this.produto.fotos[0].capa = true;
        }
      }
    },
    destroyImage: function destroyImage() {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'deseja excluir a imagem?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this5.produto.foto = '';
      });
    },
    destroyFoto: function destroyFoto(indexFoto) {
      var _this6 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma foto \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        var foto = _this6.produto.fotos[indexFoto];
        if (!_this6.produto.fotos[indexFoto].id) {
          _this6.produto.fotos.splice(indexFoto, 1);
          window.Materialize.toast('Foto excluída!', 4000);
        } else {
          service_http.delete('produtos/foto/' + _this6.produto.fotos[indexFoto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Foto excluída!', 4000);
            _this6.produto.fotos.splice(indexFoto, 1);
          });
        }
        if (foto.capa) {
          _this6.$nextTick(function () {
            _this6.produto.fotos[0].capa = true;
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.produto.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e87bbe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/produtos/form.vue
var produtos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.produto),expression:"produto.produto"}],class:{invalid: _vm.errors.has('produto')},attrs:{"name":"produto","id":"produto","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.produto.produto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "produto", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"produto"}},[_vm._v("*Produto")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('produto')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto.codigo),expression:"produto.codigo"}],attrs:{"name":"codigo","id":"codigo","type":"text"},domProps:{"value":(_vm.produto.codigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "codigo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"codigo"}},[_vm._v("Código")])]),_vm._v(" "),_c('div',{staticClass:"col s6 m3"},[_c('label',{attrs:{"for":"perfil_id"}},[_vm._v("*Unidade")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.unidade_id),expression:"produto.unidade_id"}],attrs:{"name":"perfil_id","id":"perfil_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.produto, "unidade_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.unidades),function(unidade){return _c('option',{domProps:{"value":unidade.id}},[_vm._v(_vm._s(unidade.unidade))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('unidade_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 m6"},[_c('label',{attrs:{"for":"marca_id"}},[_vm._v("*Marca")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.marca_id),expression:"produto.marca_id"}],attrs:{"name":"marca_id","id":"marca_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.produto, "marca_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.marcas),function(marca){return _c('option',{domProps:{"value":marca.id}},[_vm._v(_vm._s(marca.marca))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('marca_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s6 m6"},[_c('label',{attrs:{"for":"fornecedor_id"}},[_vm._v("Fornecedor")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.fornecedor_id),expression:"produto.fornecedor_id"}],attrs:{"name":"fornecedor_id","id":"fornecedor_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.produto, "fornecedor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.fornecedores),function(fornecedor){return _c('option',{domProps:{"value":fornecedor.id}},[_vm._v(_vm._s(fornecedor.fornecedor))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('fornecedor_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 m6"},[_c('label',{attrs:{"for":"familia_id"}},[_vm._v("Família")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto.familia_id),expression:"produto.familia_id"}],attrs:{"name":"familia_id","id":"familia_id"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.produto, "familia_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.familiaChange()}]}},_vm._l((_vm.familias),function(familia){return _c('option',{domProps:{"value":familia.id}},[_vm._v(_vm._s(familia.familia))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('familia_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s6 m6"},[_c('label',{attrs:{"for":"categoria_id"}},[_vm._v("Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto.categoria_id),expression:"produto.categoria_id"}],attrs:{"name":"categoria_id","id":"categoria_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.produto, "categoria_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categorias),function(categoria){return _c('option',{domProps:{"value":categoria.id}},[_vm._v(_vm._s(categoria.categoria))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('categoria_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s6 m3"},[(_vm.isNew)?_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.estoque),expression:"produto.estoque"}],class:{invalid: _vm.errors.has('estoque')},attrs:{"name":"estoque","id":"estoque","type":"number","data-vv-rules":"required"},domProps:{"value":(_vm.produto.estoque)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "estoque", $event.target.value)}}}):_vm._e(),_vm._v(" "),(!_vm.isNew)?_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.estoque),expression:"produto.estoque"}],class:{invalid: _vm.errors.has('estoque')},attrs:{"readonly":"","name":"estoque","id":"estoque","type":"number","data-vv-rules":"required"},domProps:{"value":(_vm.produto.estoque)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "estoque", $event.target.value)}}}):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"estoque"}},[_vm._v("*Estoque")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estoque')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.estoque_minimo),expression:"produto.estoque_minimo"}],class:{invalid: _vm.errors.has('estoque_minimo')},attrs:{"name":"estoque_minimo","id":"estoque_minimo","type":"number","data-vv-rules":"required"},domProps:{"value":(_vm.produto.estoque_minimo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "estoque_minimo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"estoque_minimo"}},[_vm._v("*Estoque Mínimo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estoque_minimo')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.valor_compra),expression:"produto.valor_compra"}],class:{invalid: _vm.errors.has('valor_compra')},attrs:{"name":"valor_compra","id":"valor_compra","type":"number","step":"any","data-vv-rules":"required"},domProps:{"value":(_vm.produto.valor_compra)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "valor_compra", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_compra"}},[_vm._v("*Valor Compra")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor_compra')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.valor_venda),expression:"produto.valor_venda"}],class:{invalid: _vm.errors.has('valor_venda')},attrs:{"name":"valor_venda","id":"valor_venda","type":"number","step":"any","data-vv-rules":"required"},domProps:{"value":(_vm.produto.valor_venda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "valor_venda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_venda"}},[_vm._v("*Valor Venda")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor_venda')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto.loja),expression:"produto.loja"}],attrs:{"name":"loja","id":"loja","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.produto.loja)?_vm._i(_vm.produto.loja,null)>-1:(_vm.produto.loja)},on:{"change":function($event){var $$a=_vm.produto.loja,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.produto, "loja", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.produto, "loja", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.produto, "loja", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"loja"}},[_vm._v("Disponível na Loja")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.produto.loja),expression:"produto.loja"}],staticClass:"input-field col s6 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.produto.loja === true ? 'required' : ''),expression:"produto.loja === true ? 'required' : ''"},{name:"model",rawName:"v-model",value:(_vm.produto.valor_loja),expression:"produto.valor_loja"}],class:{invalid: _vm.errors.has('valor_loja')},attrs:{"name":"valor_loja","id":"valor_loja","type":"number","step":"any"},domProps:{"value":(_vm.produto.valor_loja)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "valor_loja", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_loja"}},[_vm._v("*Valor Loja")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor_loja')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.produto.ncm),expression:"produto.ncm"}],class:{invalid: _vm.errors.has('ncm')},attrs:{"name":"ncm","id":"ncm","type":"text"},domProps:{"value":(_vm.produto.ncm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "ncm", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ncm"}},[_vm._v("NCM")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('ncm')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto.descricao),expression:"produto.descricao"}],staticClass:"materialize-textarea",attrs:{"name":"descricao","id":"descricao"},domProps:{"value":(_vm.produto.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produto, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"descricao"}},[_vm._v("Descrição")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.produto.fotos),function(foto,indexFoto){return _c('div',{staticClass:"col s12 m3 l2 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%","height":"50px"},attrs:{"src":(_vm.api_url + "/produtos/" + (foto.foto))},on:{"click":function($event){return _vm.setCapa(indexFoto)}}}),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(foto.capa),expression:"foto.capa"}],attrs:{"type":"checkbox","id":("capa-" + indexFoto)},domProps:{"checked":foto.capa,"checked":Array.isArray(foto.capa)?_vm._i(foto.capa,null)>-1:(foto.capa)},on:{"click":function($event){return _vm.setCapa(indexFoto)},"change":function($event){var $$a=foto.capa,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(foto, "capa", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(foto, "capa", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(foto, "capa", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":("capa-" + indexFoto)}},[_vm._v("Capa")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(foto.legenda),expression:"foto.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexFoto),"type":"text"},domProps:{"value":(foto.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(foto, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexFoto)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyFoto(indexFoto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"center-align"},[_vm._v("clique para inserir imagens")])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto.ativo),expression:"produto.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.produto.ativo)?_vm._i(_vm.produto.ativo,null)>-1:(_vm.produto.ativo)},on:{"change":function($event){var $$a=_vm.produto.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.produto, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.produto, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.produto, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var produtos_form_staticRenderFns = []
var produtos_form_esExports = { render: produtos_form_render, staticRenderFns: produtos_form_staticRenderFns }
/* harmony default export */ var features_produtos_form = (produtos_form_esExports);
// CONCATENATED MODULE: ./src/features/produtos/form.vue
var produtos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var produtos_form___vue_template_functional__ = false
/* styles */
var produtos_form___vue_styles__ = null
/* scopeId */
var produtos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var produtos_form___vue_module_identifier__ = null
var produtos_form_Component = produtos_form_normalizeComponent(
  produtos_form,
  features_produtos_form,
  produtos_form___vue_template_functional__,
  produtos_form___vue_styles__,
  produtos_form___vue_scopeId__,
  produtos_form___vue_module_identifier__
)

/* harmony default export */ var src_features_produtos_form = (produtos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/produtos/routes.js



/* harmony default export */ var produtos_routes = ([{
  path: '/produtos',
  name: 'produtos.index',
  component: src_features_produtos,
  children: [{
    path: 'form/:id?',
    name: 'produtos.form',
    component: src_features_produtos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/produtos/estoque/index.vue









/* harmony default export */ var produtos_estoque = ({
  name: 'Estoque',
  data: function data() {
    return {
      list: [],
      usuarios: [],
      viaturas: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      },
      filtro: {
        inicio: '',
        termino: '',
        operacao: '',
        usuario: '',
        viatura: '',
        os: '',
        venda: ''
      },
      show: {
        filtro: false
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY HH:mm');
    },
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/produtos/estoque?page=' + _this.pagination.current_page + '&inicio=' + _this.filtro.inicio + '&termino=' + _this.filtro.termino + '&operacao=' + _this.filtro.operacao + '&usuario=' + _this.filtro.usuario + '&viatura=' + _this.filtro.viatura + '&os=' + _this.filtro.os + '&venda=' + _this.filtro.venda);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.rows.data;
                  _this.pagination.current_page = data.rows.current_page;
                  _this.pagination.last_page = data.rows.last_page;
                  _this.filtro = data.filtro;
                  _this.usuarios = data.usuarios;
                  _this.viaturas = data.viaturas;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filtrar: function filtrar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.busca = '';
                _context2.next = 3;
                return service_http.get('/produtos/estoque?inicio=' + _this2.filtro.inicio + '&termino=' + _this2.filtro.termino + '&operacao=' + _this2.filtro.operacao + '&usuario=' + _this2.filtro.usuario + '&viatura=' + _this2.filtro.viatura + '&os=' + _this2.filtro.os + '&venda=' + _this2.filtro.venda);

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this2.list = data.rows.data;
                _this2.pagination.current_page = data.rows.current_page;
                _this2.pagination.last_page = data.rows.last_page;
                _this2.filtro = data.filtro;
                _this2.usuarios = data.usuarios;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var estoque, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                estoque = obj.estoque;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: estoque.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, estoque);
                } else {
                  _this3.list.unshift(estoque);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    submitForm: function submitForm() {
      $('#form-pdf').submit();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'estoque.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'estoque.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731a55a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/produtos/estoque/index.vue
var estoque_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('estoque.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('estoque.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'estoque.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'estoque.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn-floating waves-effect waves-light",on:{"click":function($event){$event.preventDefault();_vm.show.filtro = !_vm.show.filtro}}},[_c('i',{staticClass:"material-icons"},[_vm._v("filter_list")])])])]),_vm._v(" "),_c('form',{attrs:{"action":(_vm.api_url + "/estoque/pdf"),"method":"get","id":"form-pdf","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"type":"hidden","name":"inicio","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"type":"hidden","name":"termino","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.os),expression:"filtro.os"}],attrs:{"type":"hidden","name":"os","data-value":_vm.filtro.os},domProps:{"value":(_vm.filtro.os)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "os", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.venda),expression:"filtro.venda"}],attrs:{"type":"hidden","name":"venda","data-value":_vm.filtro.venda},domProps:{"value":(_vm.filtro.venda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "venda", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.operacao),expression:"filtro.operacao"}],attrs:{"type":"hidden","name":"operacao","data-value":_vm.filtro.operacao},domProps:{"value":(_vm.filtro.operacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "operacao", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.viatura),expression:"filtro.viatura"}],attrs:{"type":"hidden","name":"viatura","data-value":_vm.filtro.viatura},domProps:{"value":(_vm.filtro.viatura)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "viatura", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"type":"hidden","name":"usuario","data-value":_vm.filtro.usuario},domProps:{"value":(_vm.filtro.usuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "usuario", $event.target.value)}}})]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show.filtro && _vm.showBtNovo),expression:"show.filtro && showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.os),expression:"filtro.os"}],attrs:{"id":"input_os","type":"number","step":"1","data-value":_vm.filtro.os},domProps:{"value":(_vm.filtro.os)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "os", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"input_os"}},[_vm._v("OS")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.venda),expression:"filtro.venda"}],attrs:{"id":"input_venda","type":"number","step":"1","data-value":_vm.filtro.venda},domProps:{"value":(_vm.filtro.venda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "venda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"input_venda"}},[_vm._v("Venda")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show.filtro && _vm.showBtNovo),expression:"show.filtro && showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"filtro_operacao"}},[_vm._v("Operação")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.operacao),expression:"filtro.operacao"}],attrs:{"name":"operacao","id":"filtro_operacao"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "operacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Entrada")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Saída")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"filtro_viatura"}},[_vm._v("Viatura")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.viatura),expression:"filtro.viatura"}],attrs:{"name":"viatura","id":"filtro_viatura"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "viatura", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.viaturas),function(viatura){return _c('option',{domProps:{"value":viatura.id}},[_vm._v(_vm._s((viatura.id) ? viatura.viatura : 'Todas'))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"filtro_usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"name":"usuario","id":"filtro_usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(usuario){return _c('option',{domProps:{"value":usuario.id}},[_vm._v(_vm._s((usuario.id) ? usuario.nome_completo : 'Todos'))])}),0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("Relatório")]),_vm._v(" "),_c('label')])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-estoque-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(estoque){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('estoque.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'estoque.form', params: { id: estoque.id } }}},[_vm._v("\n                  "+_vm._s(estoque.id)+"\n                ")]):_c('span',[_vm._v(_vm._s(estoque.id))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(estoque.created_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(estoque.produto ? estoque.produto.produto : '-')),_c('br'),_c('small',[_vm._v(_vm._s(estoque.obs)+" / "+_vm._s(estoque.viatura ? estoque.viatura.viatura : '-'))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(estoque.operacao == 1 ? 'Entrada' : 'Saída'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(estoque.quantidade))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(estoque.valor).toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(estoque.valor*estoque.quantidade).toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(estoque.usuario ? estoque.usuario.nome_completo : '-'))])])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var estoque_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m11"},[_c('h5',[_vm._v("Estoque")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m2"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_c('i',{staticClass:"material-icons left"},[_vm._v("filter_list")]),_vm._v(" Filtrar")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th',[_vm._v("Operação")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("R$ Unitário")]),_vm._v(" "),_c('th',[_vm._v("R$ Total")]),_vm._v(" "),_c('th',[_vm._v("Usuário")])])])}]
var estoque_esExports = { render: estoque_render, staticRenderFns: estoque_staticRenderFns }
/* harmony default export */ var features_produtos_estoque = (estoque_esExports);
// CONCATENATED MODULE: ./src/features/produtos/estoque/index.vue
var estoque_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var estoque___vue_template_functional__ = false
/* styles */
var estoque___vue_styles__ = null
/* scopeId */
var estoque___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var estoque___vue_module_identifier__ = null
var estoque_Component = estoque_normalizeComponent(
  produtos_estoque,
  features_produtos_estoque,
  estoque___vue_template_functional__,
  estoque___vue_styles__,
  estoque___vue_scopeId__,
  estoque___vue_module_identifier__
)

/* harmony default export */ var src_features_produtos_estoque = (estoque_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/produtos/estoque/form.vue








/* harmony default export */ var estoque_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      produtos: [],
      produto: '',
      estoque: {
        id: '',
        produto_id: '',
        operacao: 1,
        quantidade: '',
        valor: '',
        obs: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/produtos/estoque' : '/produtos/estoque/' + _this2.estoque.id;
                _context.next = 4;
                return service_http[verb](url, _this2.estoque);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-estoque-list', { estoque: data.estoque });
                  _this2.$router.push({ name: 'estoque.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                _context2.next = 3;
                return service_http.get('/produtos/estoque/create');

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.produtos = data.produtos;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.estoque = {
        id: '',
        produto_id: '',
        operacao: 1,
        quantidade: '',
        valor: '',
        obs: ''
      };
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        this.estoque.produto_id = item.id;
        this.produto = item.produto;
      } else {
        this.estoque.produto_id = '';
        this.produto = '';
      }
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 0);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.estoque.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5be204d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/produtos/estoque/form.vue
var estoque_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produto),expression:"produto"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('produto_id')},attrs:{"type":"text","readonly":"","id":"produto","name":"produto_id","data-vv-rules":"required"},domProps:{"value":(_vm.produto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.produto=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"produto"}},[_vm._v("Produto")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('produto_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"operacao"}},[_vm._v("*Operação")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.estoque.operacao),expression:"estoque.operacao"}],class:{invalid: _vm.errors.has('operacap')},attrs:{"name":"operacao","id":"operacao","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.estoque, "operacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Entrada")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Saída")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('operacao')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.estoque.quantidade),expression:"estoque.quantidade"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('quantidade')},attrs:{"type":"number","name":"quantidade","id":"quantidade","data-vv-rules":"required"},domProps:{"value":(_vm.estoque.quantidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.estoque, "quantidade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"quantidade"}},[_vm._v("*Quantidade")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('quantidade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.estoque.valor),expression:"estoque.valor"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('valor')},attrs:{"type":"number","step":"any","name":"valor","id":"valor","data-vv-rules":"required"},domProps:{"value":(_vm.estoque.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.estoque, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*R$ Valor Unitário")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.estoque.obs),expression:"estoque.obs"}],attrs:{"type":"text","id":"obs"},domProps:{"value":(_vm.estoque.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.estoque, "obs", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"obs"}},[_vm._v("Obs")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])])}
var estoque_form_staticRenderFns = []
var estoque_form_esExports = { render: estoque_form_render, staticRenderFns: estoque_form_staticRenderFns }
/* harmony default export */ var produtos_estoque_form = (estoque_form_esExports);
// CONCATENATED MODULE: ./src/features/produtos/estoque/form.vue
var estoque_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var estoque_form___vue_template_functional__ = false
/* styles */
var estoque_form___vue_styles__ = null
/* scopeId */
var estoque_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var estoque_form___vue_module_identifier__ = null
var estoque_form_Component = estoque_form_normalizeComponent(
  estoque_form,
  produtos_estoque_form,
  estoque_form___vue_template_functional__,
  estoque_form___vue_styles__,
  estoque_form___vue_scopeId__,
  estoque_form___vue_module_identifier__
)

/* harmony default export */ var features_produtos_estoque_form = (estoque_form_Component.exports);

// CONCATENATED MODULE: ./src/features/produtos/estoque/routes.js



/* harmony default export */ var estoque_routes = ([{
  path: '/produtos/estoque',
  name: 'estoque.index',
  component: src_features_produtos_estoque,
  children: [{
    path: 'form/:id?',
    name: 'estoque.form',
    component: features_produtos_estoque_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/equipamentos/index.vue








/* harmony default export */ var equipamentos = ({
  name: 'Equipamentos',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/equipamentos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/equipamentos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var equipamento, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                equipamento = obj.equipamento;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: equipamento.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, equipamento);
                } else {
                  _this3.list.unshift(equipamento);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(equipamento) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + equipamento.equipamento + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/equipamentos/' + equipamento.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: equipamento.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'equipamentos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'equipamentos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3fd854","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/equipamentos/index.vue
var equipamentos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{staticClass:"btn-floating waves-effect waves-light",attrs:{"href":(_vm.api_url + "/equipamentos/inventario"),"download":"","target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s7 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('equipamento.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('equipamento.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'equipamentos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'equipamentos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-equipamentos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(equipamento){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('equipamento.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'equipamentos.form', params: { id: equipamento.id } }}},[_vm._v("\n                "+_vm._s(equipamento.equipamento)+"\n              ")]):_c('span',[_vm._v(_vm._s(equipamento.equipamento))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(equipamento.inventario ? equipamento.inventario : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(equipamento.inspecao_formatted ? equipamento.inspecao_formatted : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(equipamento.validade ? equipamento.validade : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(equipamento.calibracao ? equipamento.calibracao : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(equipamento.viatura ? equipamento.viatura.viatura : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(!equipamento.ativo)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"inativo"}}):_vm._e(),_vm._v(" "),(equipamento.ativo && equipamento.estoque > 0 && equipamento.estoque < equipamento.estoque_minimo)?_c('span',{staticClass:"new badge yellow darken-4",attrs:{"data-badge-caption":"estoque mínimo"}}):_vm._e(),_vm._v(" "),(equipamento.ativo && equipamento.estoque == 0)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"estoque zero"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('equipamento.editar') > -1),expression:"permissoes.indexOf('equipamento.editar') > -1"}],attrs:{"to":{ name: 'equipamentos.form', params: { id: equipamento.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('equipamento.excluir') > -1),expression:"permissoes.indexOf('equipamento.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(equipamento)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var equipamentos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m5"},[_c('h5',[_vm._v("Equipamentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Equipamento")]),_vm._v(" "),_c('th',[_vm._v("N. Inventário")]),_vm._v(" "),_c('th',[_vm._v("Inspeção")]),_vm._v(" "),_c('th',[_vm._v("Validade (meses)")]),_vm._v(" "),_c('th',[_vm._v("Certificado Calibração")]),_vm._v(" "),_c('th',[_vm._v("Viatura")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var equipamentos_esExports = { render: equipamentos_render, staticRenderFns: equipamentos_staticRenderFns }
/* harmony default export */ var features_equipamentos = (equipamentos_esExports);
// CONCATENATED MODULE: ./src/features/equipamentos/index.vue
var equipamentos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var equipamentos___vue_template_functional__ = false
/* styles */
var equipamentos___vue_styles__ = null
/* scopeId */
var equipamentos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var equipamentos___vue_module_identifier__ = null
var equipamentos_Component = equipamentos_normalizeComponent(
  equipamentos,
  features_equipamentos,
  equipamentos___vue_template_functional__,
  equipamentos___vue_styles__,
  equipamentos___vue_scopeId__,
  equipamentos___vue_module_identifier__
)

/* harmony default export */ var src_features_equipamentos = (equipamentos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/equipamentos/form.vue







/* harmony default export */ var equipamentos_form = ({
  name: 'Form',
  data: function data() {
    return {
      viaturas: [],
      equipamento: {
        id: '',
        equipamento: '',
        inventario: '',
        inspecao: '',
        validade: '',
        calibracao: '',
        viatura_id: '',
        valor: '',
        ativo: true,
        disponivel_os: true
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/equipamentos' : '/equipamentos/' + _this2.equipamento.id;
                _context.next = 4;
                return service_http[verb](url, _this2.equipamento);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-equipamentos-list', { equipamento: data.equipamento });
                  _this2.$router.push({ name: 'equipamentos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/equipamentos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.equipamento = data.equipamento;
                _this3.viaturas = data.viaturas;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);
                _context2.next = 18;
                break;

              case 12:
                _context2.next = 14;
                return service_http.get('/equipamentos/create');

              case 14:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.viaturas = _data.viaturas;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.equipamento = {
        id: '',
        equipamento: '',
        inventario: '',
        inspecao: '',
        validade: '',
        calibracao: '',
        viatura_id: '',
        valor: '',
        ativo: true,
        disponivel_os: true
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.equipamento.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2b2a26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/equipamentos/form.vue
var equipamentos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.equipamento.equipamento),expression:"equipamento.equipamento"}],class:{invalid: _vm.errors.has('equipamento')},attrs:{"name":"equipamento","id":"equipamento","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.equipamento.equipamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipamento, "equipamento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"equipamento"}},[_vm._v("*Equipamento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('equipamento')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m4"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.equipamento.inventario),expression:"equipamento.inventario"}],class:{invalid: _vm.errors.has('inventario')},attrs:{"name":"inventario","id":"inventario","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.equipamento.inventario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipamento, "inventario", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"inventario"}},[_vm._v("*N. Inventário")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('inventario')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"viatura_id"}},[_vm._v("Viatura")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipamento.viatura_id),expression:"equipamento.viatura_id"}],attrs:{"name":"viatura_id","id":"viatura_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.equipamento, "viatura_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione")]),_vm._v(" "),_vm._l((_vm.viaturas),function(viatura){return _c('option',{domProps:{"value":viatura.id}},[_vm._v(_vm._s(viatura.viatura))])})],2),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('viatura_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipamento.inspecao),expression:"equipamento.inspecao"}],attrs:{"name":"inspecao","id":"icon_inspecao","type":"date","data-value":_vm.equipamento.inspecao},domProps:{"value":(_vm.equipamento.inspecao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipamento, "inspecao", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inspecao"}},[_vm._v("Última Inspeção")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('inspecao')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipamento.validade),expression:"equipamento.validade"}],attrs:{"name":"validade","id":"validade","type":"number"},domProps:{"value":(_vm.equipamento.validade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipamento, "validade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"validade"}},[_vm._v("Validade (meses)")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('validade')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipamento.calibracao),expression:"equipamento.calibracao"}],attrs:{"name":"calibracao","id":"calibracao","type":"text"},domProps:{"value":(_vm.equipamento.calibracao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipamento, "calibracao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"calibracao"}},[_vm._v("Certificado de Calibração")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('calibracao')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s6 m2"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.equipamento.valor),expression:"equipamento.valor"}],class:{invalid: _vm.errors.has('valor')},attrs:{"name":"valor","id":"valor","type":"number","step":"any","data-vv-rules":"required"},domProps:{"value":(_vm.equipamento.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipamento, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*Valor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipamento.disponivel_os),expression:"equipamento.disponivel_os"}],attrs:{"name":"disponivel_os","id":"disponivel_os","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.equipamento.disponivel_os)?_vm._i(_vm.equipamento.disponivel_os,null)>-1:(_vm.equipamento.disponivel_os)},on:{"change":function($event){var $$a=_vm.equipamento.disponivel_os,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.equipamento, "disponivel_os", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.equipamento, "disponivel_os", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.equipamento, "disponivel_os", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"disponivel_os"}},[_vm._v("Disponível OS's")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipamento.ativo),expression:"equipamento.ativo"}],attrs:{"name":"ativo","id":"ativo","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.equipamento.ativo)?_vm._i(_vm.equipamento.ativo,null)>-1:(_vm.equipamento.ativo)},on:{"change":function($event){var $$a=_vm.equipamento.ativo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.equipamento, "ativo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.equipamento, "ativo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.equipamento, "ativo", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ativo"}},[_vm._v("Ativo")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var equipamentos_form_staticRenderFns = []
var equipamentos_form_esExports = { render: equipamentos_form_render, staticRenderFns: equipamentos_form_staticRenderFns }
/* harmony default export */ var features_equipamentos_form = (equipamentos_form_esExports);
// CONCATENATED MODULE: ./src/features/equipamentos/form.vue
var equipamentos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var equipamentos_form___vue_template_functional__ = false
/* styles */
var equipamentos_form___vue_styles__ = null
/* scopeId */
var equipamentos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var equipamentos_form___vue_module_identifier__ = null
var equipamentos_form_Component = equipamentos_form_normalizeComponent(
  equipamentos_form,
  features_equipamentos_form,
  equipamentos_form___vue_template_functional__,
  equipamentos_form___vue_styles__,
  equipamentos_form___vue_scopeId__,
  equipamentos_form___vue_module_identifier__
)

/* harmony default export */ var src_features_equipamentos_form = (equipamentos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/equipamentos/routes.js



/* harmony default export */ var equipamentos_routes = ([{
  path: '/equipamentos',
  name: 'equipamentos.index',
  component: src_features_equipamentos,
  children: [{
    path: 'form/:id?',
    name: 'equipamentos.form',
    component: src_features_equipamentos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/os/os/index.vue









moment_default.a.locale('pt-br');
/* harmony default export */ var os_os = ({
  name: 'Os',
  data: function data() {
    return {
      list: [],
      usuarios: [{}],
      usuario_id: '',
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      },
      status: {
        geral: '',
        novo: '',
        andamento: '',
        cancelada: '',
        finalizada: ''
      },
      show: {
        filtro: false
      },
      filtro: {
        status: '',
        revisao: ''
      },
      statusList: [],
      statusActive: '',
      tipo: 1
    };
  },
  mounted: function mounted() {
    var status = this.$route.params.status;
    var revisao = this.$route.params.revisao;

    if (status !== undefined) {
      this.filtro.status = status;
      this.filtro.revisao = revisao;
      this.show.filtro = true;
      this.tipo = revisao;
      this.statusActive = status;
      this.filtrar();
    } else {
      this.filtro.status = '';
      this.filtro.revisao = 1;
      this.paginate();
    }
  },

  watch: {
    usuario_id: function usuario_id() {
      this.buscar();
    }
  },
  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/os?page=' + _this.pagination.current_page + '&busca=' + _this.busca + '&status=' + _this.filtro.status + '&revisao=' + _this.filtro.revisao + '&usuarios=' + _this.usuario_id);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.rows.data;
                  _this.usuarios = data.usuarios;
                  _this.statusList = data.statusList;
                  _this.pagination.current_page = data.rows.current_page;
                  _this.pagination.last_page = data.rows.last_page;
                  _this.filtro = data.filtro;
                  _this.status = data.status;
                  setTimeout(function () {
                    window.Materialize.updateTextFields();
                  }, 0);
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.show.filtro = false;
                _context2.next = 3;
                return service_http.get('/os?&busca=' + _this2.busca + '&usuarios=' + _this2.usuario_id);

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.rows.data;
                  _this2.usuarios = data.usuarios;
                  _this2.statusList = data.statusList;
                  _this2.pagination.current_page = data.rows.current_page;
                  _this2.pagination.last_page = data.rows.last_page;
                  _this2.filtro = data.filtro;
                  _this2.status = data.status;
                  setTimeout(function () {
                    window.Materialize.updateTextFields();
                  }, 0);
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filtrar: function filtrar() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref3, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.busca = '';
                _context3.next = 3;
                return service_http.get('/os?&status=' + _this3.filtro.status + '&revisao=' + _this3.filtro.revisao);

              case 3:
                _ref3 = _context3.sent;
                data = _ref3.data;

                if (data != null) {
                  _this3.statusList = data.statusList;
                  _this3.list = data.rows.data;
                  _this3.filtro = data.filtro;
                  _this3.pagination.current_page = data.rows.current_page;
                  _this3.pagination.last_page = data.rows.last_page;
                  _this3.status = data.status;
                  setTimeout(function () {
                    window.Materialize.updateTextFields();
                  }, 0);
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.usuario_id = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this4 = this;

      var os = obj.os;

      os.forEach(function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(item) {
          var index;
          return regenerator_default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return findIndex_default()(_this4.list, { id: item.id });

                case 2:
                  index = _context4.sent;

                  if (index > -1) {
                    _this4.list[index] = extends_default()({}, item);
                  } else {
                    _this4.list.unshift(item);
                  }

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this4);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
      window.Materialize.toast('Registro salvo com sucesso!!', 4000);
    },
    destroy: function destroy(os) {
      var _this5 = this;

      this.$swal({
        title: 'Deseja remover ' + os.id + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _ref6, data, index;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return service_http.delete('/os/' + os.id);

              case 2:
                _ref6 = _context5.sent;
                data = _ref6.data;

                if (!(data != null)) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 7;
                return findIndex_default()(_this5.list, { id: os.id });

              case 7:
                index = _context5.sent;

                if (index > -1) {
                  _this5.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this5.checkListTotal();
                }

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      })));
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM HH:mm');
    },
    formatDateFrom: function formatDateFrom(date) {
      return moment_default()(date).fromNow();
    },
    changeStatus: function changeStatus(status) {
      this.statusActive = status;
      this.filtro.status = status;
      this.filtrar();
    },
    changeRevisao: function changeRevisao() {
      this.filtro.revisao = this.tipo;
      this.filtrar();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'os.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'os.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    },

    usuariosIds: {
      get: function get() {
        var _this6 = this;

        return this.usuarios.filter(function (option) {
          return _this6.usuario_id.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.usuario_id = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b652f6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/os/os/index.vue
var os_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'os.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-os-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tipo),expression:"tipo",modifiers:{"number":true}}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.tipo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.changeRevisao()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Com revisão")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Sem revisão")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m10"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("Responsável Técnico")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario_id),expression:"usuario_id"}],attrs:{"type":"hidden","name":"usuarios"},domProps:{"value":(_vm.usuario_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.usuario_id=$event.target.value}}}),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Todos os Técnicos","closeOnSelect":false,"label":"nome_completo","track-by":"id","options":_vm.usuarios},model:{value:(_vm.usuariosIds),callback:function ($$v) {_vm.usuariosIds=$$v},expression:"usuariosIds"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer blue-grey darken-1",on:{"click":function($event){return _vm.changeStatus('')}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("\n              Geral "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusActive === ''),expression:"statusActive === ''"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.status[0]))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer",on:{"click":function($event){return _vm.changeStatus(1)}}},[_c('div',{staticClass:"card-content white-text yellow accent-4"},[_c('span',{staticClass:"card-title"},[_vm._v("Novo "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusActive === 1),expression:"statusActive === 1"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.status[1]))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer amber darken-4",on:{"click":function($event){return _vm.changeStatus(2)}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Andamento "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusActive === 2),expression:"statusActive === 2"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.status[2]))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer amber accent-4",on:{"click":function($event){return _vm.changeStatus(3)}}},[_c('div',{staticClass:"card-content white-text green accent-4"},[_c('span',{staticClass:"card-title"},[_vm._v("Finalizada "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusActive === 3),expression:"statusActive === 3"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.status[3]))])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('div',{staticClass:"card pointer deep-orange accent-4",on:{"click":function($event){return _vm.changeStatus(4)}}},[_c('div',{staticClass:"card-content white-text"},[_c('span',{staticClass:"card-title"},[_vm._v("Cancelada "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusActive === 4),expression:"statusActive === 4"}],staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.status[4]))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(os){return _c('tr',{class:{ 'green lighten-2': os.status_id === 3, 'red lighten-2': os.status_id === 4, 'amber lighten-1 black-text': os.status_id === 2, 'white': os.status_id === 1 }},[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id)+"\n              ")]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('orcamento.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'orcamentos.form', params: { id: os.orcamento_id } }}},[_vm._v(_vm._s(os.orcamento_id)+"\n              ")]):_c('span',[_vm._v(_vm._s(os.orcamento_id))])],1),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(_vm.formatDate(os.created_at))+"\n              "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.formatDateFrom(os.created_at)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s((os.cliente) ? os.cliente.cliente : '-')+_vm._s(os.apartamento ? (" - " + (os.apartamento)) : '')),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s((os.orcamento) ? os.orcamento.responsavel : '-'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s((os.orcamento) ? os.orcamento.localizacao_mapa : '-'))]),_vm._v(" "),(os.cliente && os.cliente.estrela > 0)?_c('small',[_c('br'),_vm._l((os.cliente.estrela),function(n){return _c('i',{key:n,staticClass:"material-icons",staticStyle:{"color":"#ffea00","font-size":"1.5em","text-shadow":"0 0 3px #000"}},[_vm._v("star")])})],2):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s((os.responsavel) ? os.responsavel.nome_completo : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((os.inicio) ? os.inicio : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((os.termino) ? os.termino : '-'))]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s((os.status) ? os.status.status : '-')),_c('br'),(os.financeiro.length === 0)?_c('span',{},[_vm._v("pendente financeiro")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.excluir') > -1),expression:"permissoes.indexOf('os.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(os)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var os_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Ordens de Serviço")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("#Orç")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Cliente")]),_vm._v(" "),_c('th',[_vm._v("Resp. Técnico")]),_vm._v(" "),_c('th',[_vm._v("Início")]),_vm._v(" "),_c('th',[_vm._v("Previsão Término")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var os_esExports = { render: os_render, staticRenderFns: os_staticRenderFns }
/* harmony default export */ var features_os_os = (os_esExports);
// CONCATENATED MODULE: ./src/features/os/os/index.vue
var os_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var os___vue_template_functional__ = false
/* styles */
var os___vue_styles__ = null
/* scopeId */
var os___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var os___vue_module_identifier__ = null
var os_Component = os_normalizeComponent(
  os_os,
  features_os_os,
  os___vue_template_functional__,
  os___vue_styles__,
  os___vue_scopeId__,
  os___vue_module_identifier__
)

/* harmony default export */ var src_features_os_os = (os_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/truncate.js
var lodash_truncate = __webpack_require__("GRSR");
var truncate_default = /*#__PURE__*/__webpack_require__.n(lodash_truncate);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/os/os/form.vue







// import VueGoogleAutocomplete from 'vue-google-autocomplete'



/* harmony default export */ var os_form = ({
  name: "Form",
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
    // VueGoogleAutocomplete
  },
  data: function data() {
    return {
      hospitais: [],
      hospital: {},
      usuarios: [],
      status: [],
      produtos: [],
      equipamentos: [],
      lancar_financeiro: false,
      gerar_texto: false,
      mesmo_cliente: false,
      revisoes: [],
      viatura: {},
      historico: {
        data: "-",
        usuario: false,
        conteudo: ""
      },
      os: {
        gerar_orcamento: false,
        id: "",
        cliente_id: "",
        orcamento_id: "",
        proposta_id: "",
        revisao_id: null,
        servico: "",
        apartamento: "",
        medidor: "",
        medidor_marca: "",
        medidor_numero: "",
        medidor_leitura: "",
        descricao: "",
        dificuldades: "",
        solucao: "",
        valor: "",
        inicio: "",
        tempo_execucao: "",
        responsavel_id: "",
        cliente: {},
        orcamento: {},
        orcamentos: [],
        proposta: {},
        fotos: [],
        videos: [],
        historico: [],
        produtos: [],
        tarefas: [],
        envolvidos: [],
        pt_planejamento: [],
        pt_epis: [],
        pt_antes: [],
        pt_depois: [],
        pt_responsavel_id: "",
        pt_data_aprovacao: "",
        ip1: true,
        ip2: true,
        ip3: true,
        ip4: true,
        if1: true,
        if2: true,
        if3: true,
        if4: true,
        endereco: "",
        lat: "",
        long: "",
        le_data: "",
        le_instalacao: "",
        le_ponto_medicao: "Rede Interna",
        le_gas: "Gás Natural",
        le_teste1_casa: "",
        le_teste1_complemento: "",
        le_teste1_duracao: "",
        le_teste1_mmca: "",
        le_teste1_kgf: "",
        le_teste1_mmcab: "",
        le_teste1_kgfb: "",
        le_teste1_aprovado: true,
        le_teste2_gas: "",
        le_teste2_casa: "",
        le_teste2_complemento: "",
        le_teste2_duracao: "",
        le_teste2_mmca: "",
        le_teste2_kgf: "",
        le_teste2_mmcab: "",
        le_teste2_kgfb: "",
        le_teste2_aprovado: true,
        le_aprovado: true,
        le_responsavel_id: "",
        le_dados: "",
        equipamentosUtilizados: [],
        documento_assinado: "",
        financeiro: [],
        revisoes: [],
        revisao_aprovada: null,
        vistoria_realizada: false,
        vistoria_aprovada: false,
        tipo: "1",
        cnpj: "",
        razao_social: "",
        ie: "",
        responsavel: "",
        cpf: "",
        rg: "",
        email: "",
        telefone: "",
        telefone2: "",
        telefone3: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        isometrico: "",
        bairro: "",
        cidade: "",
        estado: "",
        referencia: "",
        mesmo_cliente: false,
        caracteristicas: [],
        isometricos: "",
        aprovacao_kitgas: 0,
        aprovacao_comgas: 0,
        comprovante_pagamento: "",
        hospital: "",
        endereco_hospital: "",
        telefone_hospital: ""
      },
      item: {
        id: "",
        produto: "",
        valor: "",
        qtd: ""
      },
      progress: 0,
      progress2: 0,
      errorFile: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + "/upload-image-area",
        uploadMultiple: true,
        parallelUploads: 1,
        acceptedFiles: "image/*",
        headers: {
          path: "os",
          width: 800,
          height: 600,
          accept: "all"
        }
      },
      options2: {
        url: "https://sistemakgb.com.br/v1" + "/upload-documento-assinado",
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
          path: "os",
          accept: "all"
        }
      },
      options3: {
        url: "https://sistemakgb.com.br/v1" + "/upload-image",
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: "image/*",
        headers: {
          path: "os",
          width: 1920,
          height: 1080,
          accept: "all"
        }
      },
      options4: {
        url: "https://sistemakgb.com.br/v1" + "/upload-image",
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: "image/*",
        headers: {
          path: "os",
          width: 1920,
          height: 1080,
          accept: "all"
        }
      },
      editorDescricao: {
        placeholder: "Descrição",
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], [{ align: [] }], ["clean"]]
        }
      },
      editorDificuldades: {
        placeholder: "Dificuldades Encontradas",
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], [{ align: [] }], ["clean"]]
        }
      },
      editorSolucao: {
        placeholder: "Solução Proposta",
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], [{ align: [] }], ["clean"]]
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    $route: function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format("DD/MM/YYYY");
    },
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.clear();
                id = _this.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 5;
                return service_http.get("/os/" + id + "/edit");

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                _this.os = data.os;
                _this.status = data.status;
                _this.produtos = data.produtos;
                _this.usuarios = data.usuarios;
                _this.equipamentos = data.equipamentos;
                _this.revisoes = data.revisoes;
                _this.viatura = data.viatura;
                _this.hospitais = data.hospitais;
                // this.$refs.address.update(data.os.endereco)
                if (!_this.os.le_teste1_casa && _this.os.orcamento) {
                  _this.os.le_teste1_casa = _this.os.orcamento.numero;
                  _this.os.le_teste1_complemento = _this.os.orcamento.complemento;
                  _this.os.le_teste2_casa = _this.os.orcamento.numero;
                  _this.os.le_teste2_complemento = _this.os.orcamento.complemento;
                }

                if (_this.os.cliente) {
                  _this.os.tipo = 2;
                  _this.os.cnpj = "";
                  _this.os.razao_social = _this.os.cliente.razao_social;
                  _this.os.ie = "";
                  _this.os.responsavel = "";
                  _this.os.cpf = "";
                  _this.os.rg = "";
                  _this.os.email = "";
                  _this.os.telefone = "";
                  _this.os.telefone2 = "";
                  _this.os.telefone3 = "";
                  _this.os.cep = _this.os.cliente.cep;
                  _this.os.logradouro = _this.os.cliente.logradouro;
                  _this.os.numero = _this.os.cliente.numero;
                  _this.os.complemento = _this.os.apartamento;
                  _this.os.bairro = _this.os.cliente.bairro;
                  _this.os.cidade = _this.os.cliente.cidade;
                  _this.os.estado = _this.os.cliente.estado;
                  _this.os.referencia = _this.os.cliente.referencia;
                }
                _context.next = 20;
                break;

              case 19:
                _this.$router.push({ name: "os.index" });

              case 20:
                setTimeout(function () {
                  $(".collapsible").collapsible();
                  $(".collapsible").collapsible("close", 0);
                  $(".collapsible").collapsible("close", 1);
                  $(".collapsible").collapsible("close", 2);
                  $(".collapsible").collapsible("close", 3);
                  $(".collapsible").collapsible("close", 4);
                  $(".collapsible").collapsible("close", 5);
                  $(".collapsible").collapsible("close", 6);
                  $(".collapsible").collapsible("close", 7);
                  $(".collapsible").collapsible("close", 8);
                  $(".collapsible").collapsible("close", 9);
                  $(".collapsible").collapsible("close", 10);
                  $(".collapsible").collapsible("close", 11);
                  $(".collapsible").collapsible("close", 12);
                  $(".collapsible").collapsible("open", 0);
                  window.Materialize.updateTextFields();
                }, 0);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setEndereco: function setEndereco() {
      var _this2 = this;

      window.$.getJSON("https://viacep.com.br/ws/" + this.orcamento.cep + "/json/").then(function (response) {
        if (!response.erro) {
          _this2.orcamento.logradouro = response.logradouro;
          _this2.orcamento.bairro = response.bairro;
          _this2.orcamento.cidade = response.localidade;
          _this2.orcamento.estado = response.uf;
          $("#numero").focus();
        } else {
          _this2.orcamento.logradouro = "";
          _this2.orcamento.numero = "";
          _this2.orcamento.complemento = "";
          _this2.orcamento.bairro = "";
          _this2.orcamento.cidade = "";
          _this2.orcamento.estado = "";
        }
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 0);
      });
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this3.$swal({
            title: "Ops, encontramos um erro!",
            html: "Um ou mais campos estão com seu preenchimento incorreto",
            type: "error",
            cancelButtonText: "Ok"
          });
          return false;
        }
        _this3.submit();
      });
    },
    submit: function submit() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = "put";
                url = "/os/" + _this4.os.id;
                _context2.next = 4;
                return service_http[verb](url, _this4.os);

              case 4:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (!(data != null)) {
                  _context2.next = 19;
                  break;
                }

                _this4.$emit("update-os-list", { os: data.os });

                if (!(_this4.lancar_financeiro === true)) {
                  _context2.next = 12;
                  break;
                }

                _this4.$router.push({
                  name: "financeiro-receber.os",
                  params: { id: data.os[0].id }
                });
                _context2.next = 19;
                break;

              case 12:
                if (!(_this4.os.gerar_orcamento === true)) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 15;
                return service_http.post("/os/gerar-orcamento/" + _this4.os.id, _this4.os);

              case 15:
                _this4.$router.push({ name: "os.index" });
                _context2.next = 19;
                break;

              case 18:
                _this4.$router.push({ name: "os.index" });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    adicionarRevisao: function adicionarRevisao() {
      var _this5 = this;

      if (this.os.revisao_id) {
        this.$swal({
          title: "Iniciar Revis\xE3o",
          text: "Caso já exista itens na revisão eles serão removidos",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Iniciar",
          reverseButtons: true
        }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
          var _ref4, data;

          return regenerator_default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return service_http.get("revisao-itens/" + _this5.os.revisao_id + "/" + _this5.os.id);

                case 2:
                  _ref4 = _context3.sent;
                  data = _ref4.data;

                  if (data != null) {
                    _this5.os.revisoes = data.revisoes;
                  }

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this5);
        }))).catch(this.$swal.noop);
      }
    },
    gerarOrcamento: function gerarOrcamento() {
      var _this6 = this;

      if (this.os) {
        this.$swal({
          title: "Gerar Or\xE7amento?",
          // text: 'Caso já exista itens na revisão eles serão removidos',
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Gerar",
          reverseButtons: true
        }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
          var _ref6, data;

          return regenerator_default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return service_http.get("/os/gerar-orcamento/" + _this6.os.id);

                case 2:
                  _ref6 = _context4.sent;
                  data = _ref6.data;

                  if (data != null) {
                    window.Materialize.toast("Orçamento gerado!", 4000);
                  }

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, _this6);
        })));
      }
    },
    truncate: function truncate() {
      var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      return truncate_default()(string);
    },
    clear: function clear() {
      this.os = {
        id: "",
        cliente_id: "",
        orcamento_id: "",
        proposta_id: "",
        revisao_id: null,
        servico: "",
        apartamento: "",
        medidor: "",
        medidor_marca: "",
        medidor_numero: "",
        medidor_leitura: "",
        descricao: "",
        dificuldades: "",
        solucao: "",
        valor: "",
        inicio: "",
        tempo_execucao: "",
        responsavel_id: "",
        cliente: {},
        orcamento: {},
        orcamentos: [],
        proposta: {},
        fotos: [],
        videos: [],
        produtos: [],
        tarefas: [],
        envolvidos: [],
        viatura: [],
        pt_planejamento: [],
        pt_epis: [],
        pt_antes: [],
        pt_depois: [],
        pt_responsavel_id: "",
        pt_data_aprovacao: "",
        ip1: true,
        ip2: true,
        ip3: true,
        ip4: true,
        if1: true,
        if2: true,
        if3: true,
        if4: true,
        endereco: "",
        lat: "",
        long: "",
        le_data: "",
        le_instalacao: "",
        le_ponto_medicao: "Rede Interna",
        le_gas: "Gás Natural",
        le_teste1_casa: "",
        le_teste1_complemento: "",
        le_teste1_duracao: "",
        le_teste1_mmca: "",
        le_teste1_kgf: "",
        le_teste1_mmcab: "",
        le_teste1_kgfb: "",
        le_teste1_aprovado: true,
        le_teste2_gas: "",
        le_teste2_casa: "",
        le_teste2_complemento: "",
        le_teste2_duracao: "",
        le_teste2_mmca: "",
        le_teste2_kgf: "",
        le_teste2_mmcab: "",
        le_teste2_kgfb: "",
        le_teste2_aprovado: true,
        le_aprovado: true,
        le_responsavel_id: "",
        le_dados: "",
        equipamentosUtilizados: [],
        revisoes: [],
        documento_assinado: "",
        revisao_aprovada: null,
        vistoria_realizada: false,
        vistoria_aprovada: false,
        tipo: "1",
        cnpj: "",
        razao_social: "",
        ie: "",
        responsavel: "",
        cpf: "",
        rg: "",
        email: "",
        telefone: "",
        telefone2: "",
        telefone3: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        isometrico: "",
        bairro: "",
        cidade: "",
        estado: "",
        referencia: "",
        mesmo_cliente: false,
        caracteristicas: [],
        isometricos: "",
        aprovacao_kitgas: 0,
        aprovacao_comgas: 0,
        comprovante_pagamento: "",
        hospital: "",
        endereco_hospital: "",
        telefone_hospital: ""
      };
    },
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(files, status, xhr) {
      var _this7 = this;

      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        var response = JSON.parse(xhr.response);
        if (Array.isArray(response)) {
          response.forEach(function (item) {
            _this7.os.fotos.push({ foto: item, legenda: "", ordem: "" });
          });
        } else {
          this.os.fotos.push({ foto: xhr.response, legenda: "", ordem: "" });
        }
        this.progress = 0;
      }
    },
    destroyFoto: function destroyFoto(index, indexFoto) {
      var _this8 = this;

      this.$swal({
        title: "Atenção",
        text: "excluir uma foto \xE9 uma opera\xE7\xE3o irrevers\xEDvel",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        if (!_this8.os.fotos[indexFoto].id) {
          _this8.os.fotos.splice(indexFoto, 1);
          window.Materialize.toast("Foto excluída!", 4000);
        } else {
          service_http.delete("os/foto/" + _this8.os.fotos[indexFoto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast("Foto excluída!", 4000);
            _this8.os.fotos.splice(indexFoto, 1);
          });
        }
      });
    },
    totalProgressIsometrico: function totalProgressIsometrico(progress, totalBytes, bytesSent) {
      this.progress2 = progress;
    },
    completeIsometrico: function completeIsometrico(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute("id", xhr.response.id);
        this.os.isometricos = xhr.response;
        this.progress2 = 0;
      }
    },
    destroyIsometrico: function destroyIsometrico() {
      var _this9 = this;

      this.$swal({
        title: "Atenção",
        text: "deseja excluir a imagem?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        _this9.os.isometricos = "";
      });
    },
    totalProgressPagamento: function totalProgressPagamento(progress, totalBytes, bytesSent) {
      this.progress2 = progress;
    },
    completePagamento: function completePagamento(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile2 = true;
      } else {
        this.errorFile2 = false;
        file.addAttribute("id", xhr.response.id);
        this.os.comprovante_pagamento = xhr.response;
        this.progress2 = 0;
      }
    },
    destroyPagamento: function destroyPagamento() {
      var _this10 = this;

      this.$swal({
        title: "Atenção",
        text: "deseja excluir a imagem?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        _this10.os.comprovante_pagamento = "";
      });
    },
    destroyVideo: function destroyVideo(index, indexVideo) {
      var _this11 = this;

      this.$swal({
        title: "Atenção",
        text: "excluir uma video \xE9 uma opera\xE7\xE3o irrevers\xEDvel",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        if (!_this11.os.videos[indexVideo].id) {
          _this11.os.videos.splice(indexVideo, 1);
          window.Materialize.toast("Video excluído!", 4000);
        } else {
          service_http.delete("os/video/" + _this11.os.videos[indexVideo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast("Video excluído!", 4000);
            _this11.os.videos.splice(indexVideo, 1);
          });
        }
      });
    },
    addVideo: function addVideo() {
      if (this.video) {
        this.os.videos.push({
          video: this.video
        });
        this.video = "";
        setTimeout(function () {
          window.Materialize.updateTextFields();
        }, 300);
      }
    },
    totalProgress2: function totalProgress2(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete2: function complete2(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.os.documento_assinado = xhr.response;
        this.progress = 0;
      }
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        var viaturaId = null;
        if (this.viatura) {
          viaturaId = this.viatura.id;
        }
        var produto = {
          produto_id: item.id,
          produto: item,
          valor: item.valor_venda,
          qtd: 1,
          viatura_id: viaturaId
        };
        this.addProduto(produto);
      }
    },
    addProduto: function addProduto(produto) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (typeof _this12.os.produtos === "undefined") {
                  _this12.os.produtos = [];
                }
                _context5.next = 3;
                return _this12.os.produtos.push(produto);

              case 3:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this12);
      }))();
    },
    destroyProduto: function destroyProduto(indexProduto) {
      var _this13 = this;

      this.$swal({
        title: "Atenção",
        text: "excluir um Produto \xE9 uma opera\xE7\xE3o irrevers\xEDvel e vai restabelecer estoques nas viaturas de origem",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        if (!_this13.os.produtos[indexProduto].id) {
          _this13.os.produtos.splice(indexProduto, 1);
          window.Materialize.toast("Produto excluído!", 4000);
        } else {
          service_http.delete("os/produto/" + _this13.os.produtos[indexProduto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast("Produto excluído!", 4000);
            _this13.os.produtos.splice(indexProduto, 1);
          });
        }
      });
    },
    destroyTarefa: function destroyTarefa(indexTarefa) {
      var _this14 = this;

      this.$swal({
        title: "Atenção",
        text: "excluir um tarefa \xE9 uma opera\xE7\xE3o irrevers\xEDvel e vai restabelecer estoques nas viaturas de origem",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        if (!_this14.os.tarefas[indexTarefa].id) {
          _this14.os.tarefas.splice(indexTarefa, 1);
          window.Materialize.toast("Tarefa excluído!", 4000);
        } else {
          service_http.delete("tarefas/" + _this14.os.tarefas[indexTarefa].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast("Tarefa excluído!", 4000);
            _this14.os.tarefas.splice(indexTarefa, 1);
          });
        }
      });
    },
    destroyHistorico: function destroyHistorico(indexRegistro) {
      var _this15 = this;

      this.$swal({
        title: "Atenção",
        text: "excluir um registro \xE9 uma opera\xE7\xE3o irrevers\xEDvel",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, quero excluir!",
        reverseButtons: true
      }).then(function () {
        if (!_this15.os.historico[indexRegistro].id) {
          _this15.os.historico.splice(indexRegistro, 1);
          window.Materialize.toast("Registro excluído!", 4000);
        } else {
          service_http.delete("orcamentos/historico/" + _this15.os.historico[indexRegistro].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast("Registro excluído!", 4000);
            _this15.os.historico.splice(indexRegistro, 1);
          });
        }
      });
    },

    // async procurarHospitais() {
    //   const { data } = await http.get(`os/anexo-emergencia/${this.os.id}`);
    //   this.hospitais = data;
    // },
    selectHospital: function selectHospital() {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this16.hospital.name;

              case 2:
                _this16.os.hospital = _context6.sent;
                _context6.next = 5;
                return _this16.hospital.vicinity;

              case 5:
                _this16.os.endereco_hospital = _context6.sent;
                _context6.next = 8;
                return _this16.hospital.phone;

              case 8:
                _this16.os.telefone_hospital = _context6.sent;
                _context6.next = 11;
                return window.Materialize.updateTextFields();

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this16);
      }))();
    },
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.os.endereco = placeResultData.formatted_address;
      this.os.lat = addressData.latitude;
      this.os.long = addressData.longitude;
    },
    addTarefa: function addTarefa() {
      this.os.tarefas.push({
        status_id: 1,
        usuarios: []
      });
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 300);
    },
    addHistorico: function addHistorico() {
      this.os.historico.push({
        data: this.historico.data,
        usuario: this.historico.usuario,
        conteudo: this.historico.conteudo
      });
      this.historico.conteudo = "";
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 300);
    },
    chunkArray: function chunkArray(myArray, chunkSize) {
      var index = 0;
      var arrayLength = myArray.length;
      var tempArray = [];
      if (arrayLength > chunkSize) {
        for (index = 0; index < arrayLength; index += chunkSize) {
          var myChunk = myArray.slice(index, index + chunkSize);
          // Do something if you want with the group
          tempArray.push(myChunk);
        }
      } else {
        tempArray.push(myArray);
      }
      return tempArray;
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(["loading"]), Object(vuex_esm["c" /* mapGetters */])(["permissoes"]), {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    url_app: function url_app() {
      return "https://sistemakgb.com.br/v1";
    },

    usuarioEnvolvidos: {
      get: function get() {
        var _this17 = this;

        return this.usuarios.filter(function (option) {
          return _this17.os.envolvidos.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.os.envolvidos = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    },
    osEquipamentos: {
      get: function get() {
        var _this18 = this;

        return this.equipamentos.filter(function (option) {
          return _this18.os.equipamentosUtilizados.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.os.equipamentosUtilizados = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503d28f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/os/os/form.vue
var os_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('ul',{staticClass:"collapsible popout",attrs:{"data-collapsible":"accordion"}},[_c('li',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{attrs:{"name":"orcamento","id":"orcamento","type":"text","disabled":""},domProps:{"value":("#" + (_vm.os.orcamento.id))}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento"}},[_vm._v("Orçamento")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('label',{attrs:{"for":"responsavel_id"}},[_vm._v("*Responsável Técnico")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.responsavel_id),expression:"os.responsavel_id"}],attrs:{"name":"responsavel_id","id":"responsavel_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "responsavel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(responsavel){return _c('option',{domProps:{"value":responsavel.id}},[_vm._v(_vm._s(responsavel.nome_completo)+"\n                    ")])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("responsavel_id")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.apartamento),expression:"os.apartamento"}],attrs:{"name":"apartamento","id":"apartamento","type":"text"},domProps:{"value":(_vm.os.apartamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "apartamento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"apartamento"}},[_vm._v("Referência (Bloco - Apartamento)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor),expression:"os.medidor"}],attrs:{"name":"medidor","id":"medidor","type":"text"},domProps:{"value":(_vm.os.medidor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor"}},[_vm._v("Medidor de Gás")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor_marca),expression:"os.medidor_marca"}],attrs:{"name":"medidor_marca","id":"medidor_marca","type":"text"},domProps:{"value":(_vm.os.medidor_marca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor_marca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor_marca"}},[_vm._v("Marca do Medidor")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor_numero),expression:"os.medidor_numero"}],attrs:{"name":"medidor_numero","id":"medidor_numero","type":"text"},domProps:{"value":(_vm.os.medidor_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor_numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor_numero"}},[_vm._v("Número do Medidor")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor_leitura),expression:"os.medidor_leitura"}],attrs:{"name":"medidor_leitura","id":"medidor_leitura","type":"text"},domProps:{"value":(_vm.os.medidor_leitura)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor_leitura", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor_leitura"}},[_vm._v("Leitura do Medidor")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.valor),expression:"os.valor"}],attrs:{"name":"valor","id":"valor","type":"number","step":"any","min":"0"},domProps:{"value":(_vm.os.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*R$ da Obra")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.inicio),expression:"os.inicio"}],attrs:{"name":"inicio","id":"icon_inicio","type":"date","data-value":_vm.os.inicio},domProps:{"value":(_vm.os.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Data de Início")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("inicio")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.tempo_execucao),expression:"os.tempo_execucao"}],attrs:{"name":"tempo_execucao","id":"tempo_execucao","type":"number"},domProps:{"value":(_vm.os.tempo_execucao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "tempo_execucao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"tempo_execucao"}},[_vm._v("Tempo de Execução (horas)")])])])])]),_vm._v(" "),_c('li',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('quill-editor',{ref:"os.descricao",attrs:{"options":_vm.editorDescricao},model:{value:(_vm.os.descricao),callback:function ($$v) {_vm.$set(_vm.os, "descricao", $$v)},expression:"os.descricao"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("descricao")))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Dificuldades Encontradas")]),_vm._v(" "),_c('quill-editor',{ref:"os.dificuldades",attrs:{"options":_vm.editorDificuldades},model:{value:(_vm.os.dificuldades),callback:function ($$v) {_vm.$set(_vm.os, "dificuldades", $$v)},expression:"os.dificuldades"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("dificuldades")))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Solução Proposta")]),_vm._v(" "),_c('quill-editor',{ref:"os.solucao",attrs:{"options":_vm.editorSolucao},model:{value:(_vm.os.solucao),callback:function ($$v) {_vm.$set(_vm.os, "solucao", $$v)},expression:"os.solucao"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("solucao")))])],1)])])]),_vm._v(" "),_c('li',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","selected-item":_vm.item,"placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.produtos && _vm.os.produtos.length > 0),expression:"os.produtos && os.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.os.produtos),function(produto,indexProduto){return _c('tr',[_c('td',[_c('p',[_vm._v("\n                            "+_vm._s(produto.produto ? produto.produto.produto : "-")+"\n                          ")])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1","readonly":produto.hasOwnProperty('id')},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.valor),expression:"produto.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("valorProduto" + indexProduto),"min":"1","readonly":produto.hasOwnProperty('id')},domProps:{"value":(produto.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("valorTotalProduto" + indexProduto),"readonly":""},domProps:{"value":produto.valor * produto.qtd}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(indexProduto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])]),_vm._v(" "),_c('li',[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_c('thead',[_vm._m(5),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Planejamento da Tarefa")]),_vm._v(" "),_c('td',[_vm._v("Gerador de Calor ou Faísca")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas[
                                  'Gerador de Calor ou Faísca'
                                ]
                              ),expression:"\n                                os.caracteristicas[\n                                  'Gerador de Calor ou Faísca'\n                                ]\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 
                                  'Gerador de Calor ou Faísca'
                                , $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Gerador de Calor ou Faísca___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Gerador de Calor ou Faísca___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Gerador de Calor ou Faísca___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Gerador de Calor ou Faísca___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Planejamento da Tarefa")]),_vm._v(" "),_c('td',[_vm._v("Produtos Perigosos")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Produtos Perigosos']
                              ),expression:"\n                                os.caracteristicas['Produtos Perigosos']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Produtos Perigosos', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Produtos Perigosos___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Produtos Perigosos___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Produtos Perigosos___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Produtos Perigosos___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Aparelho Respiratório")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Aparelho Respiratório']
                              ),expression:"\n                                os.caracteristicas['Aparelho Respiratório']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Aparelho Respiratório', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Aparelho Respiratório___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Aparelho Respiratório___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Aparelho Respiratório___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Aparelho Respiratório___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Botina")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.caracteristicas['Botina']),expression:"os.caracteristicas['Botina']"}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Botina', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Botina___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Botina___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Botina___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Botina___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Capacete")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.caracteristicas['Capacete']),expression:"os.caracteristicas['Capacete']"}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Capacete', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Capacete___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Capacete___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Capacete___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Capacete___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Luvas")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.caracteristicas['Luvas']),expression:"os.caracteristicas['Luvas']"}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Luvas', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Luvas___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Luvas___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Luvas___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Luvas___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Óculos de Proteção")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Óculos de Proteção']
                              ),expression:"\n                                os.caracteristicas['Óculos de Proteção']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Óculos de Proteção', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Óculos de Proteção___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Óculos de Proteção___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Óculos de Proteção___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Óculos de Proteção___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Protetor Auricular")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Protetor Auricular']
                              ),expression:"\n                                os.caracteristicas['Protetor Auricular']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Protetor Auricular', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Protetor Auricular___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Protetor Auricular___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Protetor Auricular___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Protetor Auricular___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("EPI's Obrigatórios")]),_vm._v(" "),_c('td',[_vm._v("Uniforme Completo")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Uniforme Completo']
                              ),expression:"\n                                os.caracteristicas['Uniforme Completo']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Uniforme Completo', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Uniforme Completo___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Uniforme Completo___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Uniforme Completo___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Uniforme Completo___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências antes de Iniciar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Avaliar Explosividade = 0%")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas[
                                  'Avaliar Explosividade = 0%'
                                ]
                              ),expression:"\n                                os.caracteristicas[\n                                  'Avaliar Explosividade = 0%'\n                                ]\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 
                                  'Avaliar Explosividade = 0%'
                                , $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Avaliar Explosividade = 0%___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Avaliar Explosividade = 0%___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Avaliar Explosividade = 0%___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Avaliar Explosividade = 0%___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências antes de Iniciar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Bloquear Válvulas")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Bloquear Válvulas']
                              ),expression:"\n                                os.caracteristicas['Bloquear Válvulas']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Bloquear Válvulas', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Bloquear Válvulas___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Bloquear Válvulas___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Bloquear Válvulas___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Bloquear Válvulas___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências antes de Iniciar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Constatar Ausência de Tensão")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas[
                                  'Constatar Ausência de Tensão'
                                ]
                              ),expression:"\n                                os.caracteristicas[\n                                  'Constatar Ausência de Tensão'\n                                ]\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 
                                  'Constatar Ausência de Tensão'
                                , $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Constatar Ausência de Tensão___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Constatar Ausência de Tensão___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Constatar Ausência de Tensão___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Constatar Ausência de Tensão___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências antes de Iniciar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Isolar a Área")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.caracteristicas['Isolar a Área']),expression:"os.caracteristicas['Isolar a Área']"}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Isolar a Área', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Isolar a Área___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Isolar a Área___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Isolar a Área___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Isolar a Área___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências antes de Iniciar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Proteger Riscos Vizinhos e Equip.")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas[
                                  'Proteger Riscos Vizinhos e Equip.'
                                ]
                              ),expression:"\n                                os.caracteristicas[\n                                  'Proteger Riscos Vizinhos e Equip.'\n                                ]\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 
                                  'Proteger Riscos Vizinhos e Equip.'
                                , $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Proteger Riscos Vizinhos e Equip.___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Proteger Riscos Vizinhos e Equip.___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Proteger Riscos Vizinhos e Equip.___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Proteger Riscos Vizinhos e Equip.___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências antes de Iniciar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Sinalizar Área e Equipamentos")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas[
                                  'Sinalizar Área e Equipamentos'
                                ]
                              ),expression:"\n                                os.caracteristicas[\n                                  'Sinalizar Área e Equipamentos'\n                                ]\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 
                                  'Sinalizar Área e Equipamentos'
                                , $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Sinalizar Área e Equipamentos___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Sinalizar Área e Equipamentos___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Sinalizar Área e Equipamentos___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Sinalizar Área e Equipamentos___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências ao Finalizar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Limpar o Local")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.caracteristicas['Limpar o Local']),expression:"os.caracteristicas['Limpar o Local']"}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Limpar o Local', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Limpar o Local___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Limpar o Local___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Limpar o Local___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Limpar o Local___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências ao Finalizar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Retirar Bloqueios")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Retirar Bloqueios']
                              ),expression:"\n                                os.caracteristicas['Retirar Bloqueios']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Retirar Bloqueios', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Retirar Bloqueios___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Retirar Bloqueios___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Retirar Bloqueios___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Retirar Bloqueios___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências ao Finalizar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Retirar Isolamentos")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Retirar Isolamentos']
                              ),expression:"\n                                os.caracteristicas['Retirar Isolamentos']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Retirar Isolamentos', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Retirar Isolamentos___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Retirar Isolamentos___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Retirar Isolamentos___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Retirar Isolamentos___NA"}},[_vm._v("Não Aplicável")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Providências ao Finalizar o Serviço")]),_vm._v(" "),_c('td',[_vm._v("Guardar Ferramentas")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(
                                _vm.os.caracteristicas['Guardar Ferramentas']
                              ),expression:"\n                                os.caracteristicas['Guardar Ferramentas']\n                              "}],attrs:{"name":"caracteristicas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os.caracteristicas, 'Guardar Ferramentas', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Guardar Ferramentas___-"}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{attrs:{"value":"Guardar Ferramentas___C"}},[_vm._v("Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Guardar Ferramentas___NC"}},[_vm._v("Não Conforme")]),_vm._v(" "),_c('option',{attrs:{"value":"Guardar Ferramentas___NA"}},[_vm._v("Não Aplicável")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s8"},[_c('label',[_vm._v("Usuários Envolvidos na OS")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"nome_completo","track-by":"id","options":_vm.usuarios},model:{value:(_vm.usuarioEnvolvidos),callback:function ($$v) {_vm.usuarioEnvolvidos=$$v},expression:"usuarioEnvolvidos"}})],1),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.pt_data_aprovacao),expression:"os.pt_data_aprovacao"}],attrs:{"name":"pt_data_aprovacao","id":"icon_pt_data_aprovacao","type":"date","data-value":_vm.os.pt_data_aprovacao},domProps:{"value":(_vm.os.pt_data_aprovacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "pt_data_aprovacao", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_pt_data_aprovacao"}},[_vm._v("Data de Aprovação")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("pt_data_aprovacao")))])])])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m6"},[_c('p',[_vm._v("Inspeção Pré Obra")]),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_vm._v("Adequação do local para início da obra")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.ip1),expression:"os.ip1"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.ip1)?_vm._i(_vm.os.ip1,null)>-1:(_vm.os.ip1)},on:{"change":function($event){var $$a=_vm.os.ip1,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "ip1", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "ip1", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "ip1", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.ip1 ? "Adequado" : "Inadequado")+"\n                          ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Execução da obra")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.ip2),expression:"os.ip2"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.ip2)?_vm._i(_vm.os.ip2,null)>-1:(_vm.os.ip2)},on:{"change":function($event){var $$a=_vm.os.ip2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "ip2", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "ip2", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "ip2", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.ip2 ? "Adequado" : "Inadequado")+"\n                          ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Preenchimento de documentação")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.ip3),expression:"os.ip3"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.ip3)?_vm._i(_vm.os.ip3,null)>-1:(_vm.os.ip3)},on:{"change":function($event){var $$a=_vm.os.ip3,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "ip3", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "ip3", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "ip3", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.ip3 ? "Adequado" : "Inadequado")+"\n                          ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Conhecimento das regras internas")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.ip4),expression:"os.ip4"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.ip4)?_vm._i(_vm.os.ip4,null)>-1:(_vm.os.ip4)},on:{"change":function($event){var $$a=_vm.os.ip4,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "ip4", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "ip4", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "ip4", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.ip4 ? "Adequado" : "Inadequado")+"\n                          ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('p',[_vm._v("Inspeção Final")]),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_vm._v("Inspeção visual da obra")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.if1),expression:"os.if1"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.if1)?_vm._i(_vm.os.if1,null)>-1:(_vm.os.if1)},on:{"change":function($event){var $$a=_vm.os.if1,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "if1", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "if1", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "if1", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.if1 ? "Adequado" : "Inadequado")+"\n                          ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Inspeção do servico executado")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.if2),expression:"os.if2"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.if2)?_vm._i(_vm.os.if2,null)>-1:(_vm.os.if2)},on:{"change":function($event){var $$a=_vm.os.if2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "if2", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "if2", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "if2", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.if2 ? "Adequado" : "Inadequado")+"\n                          ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Finalização da obra")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.if3),expression:"os.if3"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.if3)?_vm._i(_vm.os.if3,null)>-1:(_vm.os.if3)},on:{"change":function($event){var $$a=_vm.os.if3,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "if3", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "if3", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "if3", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.if3 ? "Adequado" : "Inadequado")+"\n                          ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Adequação do local para entrega da obra")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.if4),expression:"os.if4"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.if4)?_vm._i(_vm.os.if4,null)>-1:(_vm.os.if4)},on:{"change":function($event){var $$a=_vm.os.if4,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "if4", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "if4", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "if4", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                            "+_vm._s(_vm.os.if4 ? "Adequado" : "Inadequado")+"\n                          ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6"},[_c('label',[_vm._v("Aprovação KitGás")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.aprovacao_kitgas),expression:"os.aprovacao_kitgas"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "aprovacao_kitgas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Sim")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("Não")])])]),_vm._v(" "),_c('div',{staticClass:"col s6"},[_c('label',[_vm._v("Aprovação Com Gás")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.aprovacao_comgas),expression:"os.aprovacao_comgas"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "aprovacao_comgas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("Selecione")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Sim")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("Não")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])]),_vm._v(" "),_c('li',[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_data),expression:"os.le_data"}],attrs:{"name":"le_data","id":"icon_le_data","type":"date","data-value":_vm.os.le_data},domProps:{"value":(_vm.os.le_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_data", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_le_data"}},[_vm._v("Data do Teste")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("le_data")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_instalacao),expression:"os.le_instalacao"}],attrs:{"name":"le_instalacao","id":"le_instalacao","type":"text"},domProps:{"value":(_vm.os.le_instalacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_instalacao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_instalacao"}},[_vm._v("Tipo de Instalação")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"le_ponto_medicao"}},[_vm._v("Ponto de Medição")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_ponto_medicao),expression:"os.le_ponto_medicao"}],attrs:{"name":"le_ponto_medicao","id":"le_ponto_medicao"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "le_ponto_medicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Rede Interna"}},[_vm._v("Rede Interna")]),_vm._v(" "),_c('option',{attrs:{"value":"Rede e Prumada Coletiva"}},[_vm._v("Rede e Prumada Coletiva")]),_vm._v(" "),_c('option',{attrs:{"value":"Rede e Prumada Individual"}},[_vm._v("Rede e Prumada Individual")]),_vm._v(" "),_c('option',{attrs:{"value":"Ramal de Entrada"}},[_vm._v("Ramal de Entrada")]),_vm._v(" "),_c('option',{attrs:{"value":"Ramal Interno"}},[_vm._v("Ramal Interno")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("le_ponto_medicao")))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"le_gas"}},[_vm._v("Tipo de Gás")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_gas),expression:"os.le_gas"}],attrs:{"name":"le_gas","id":"le_gas"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "le_gas", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Gás Natural"}},[_vm._v("Gás Natural")]),_vm._v(" "),_c('option',{attrs:{"value":"Gás L.P MMCA"}},[_vm._v("Gás L.P MMCA")]),_vm._v(" "),_c('option',{attrs:{"value":"Gás L.P KGF/cm2"}},[_vm._v("Gás L.P KGF/cm2")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("le_gas")))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',[_vm._v("Equipamentos Utilizados")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"equipamento","track-by":"id","options":_vm.equipamentos},model:{value:(_vm.osEquipamentos),callback:function ($$v) {_vm.osEquipamentos=$$v},expression:"osEquipamentos"}})],1)]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_casa),expression:"os.le_teste1_casa"}],attrs:{"name":"le_teste1_casa","id":"le_teste1_casa","type":"text"},domProps:{"value":(_vm.os.le_teste1_casa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_casa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_casa"}},[_vm._v("N. Casa")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_complemento),expression:"os.le_teste1_complemento"}],attrs:{"name":"le_teste1_complemento","id":"le_teste1_complemento","type":"text"},domProps:{"value":(_vm.os.le_teste1_complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_complemento"}},[_vm._v("Compl.")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_duracao),expression:"os.le_teste1_duracao"}],attrs:{"name":"le_teste1_duracao","id":"le_teste1_duracao","type":"text"},domProps:{"value":(_vm.os.le_teste1_duracao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_duracao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_duracao"}},[_vm._v("Duração (min)")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                      _vm.os.le_gas === 'Gás Natural' ||
                        _vm.os.le_gas === 'Gás L.P MMCA'
                    ),expression:"\n                      os.le_gas === 'Gás Natural' ||\n                        os.le_gas === 'Gás L.P MMCA'\n                    "}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_mmca),expression:"os.le_teste1_mmca"}],attrs:{"name":"le_teste1_mmca","id":"le_teste1_mmca","type":"text"},domProps:{"value":(_vm.os.le_teste1_mmca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_mmca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_mmca"}},[_vm._v("MMCA Pressão")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                      _vm.os.le_gas === 'Gás Natural' ||
                        _vm.os.le_gas === 'Gás L.P MMCA'
                    ),expression:"\n                      os.le_gas === 'Gás Natural' ||\n                        os.le_gas === 'Gás L.P MMCA'\n                    "}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_mmcab),expression:"os.le_teste1_mmcab"}],attrs:{"name":"le_teste1_mmcab","id":"le_teste1_mmcab","type":"text"},domProps:{"value":(_vm.os.le_teste1_mmcab)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_mmcab", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_mmcab"}},[_vm._v("MMCA Perda")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.le_gas === 'Gás L.P KGF/cm2'),expression:"os.le_gas === 'Gás L.P KGF/cm2'"}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_kgf),expression:"os.le_teste1_kgf"}],attrs:{"name":"le_teste1_kgf","id":"le_teste1_kgf","type":"text"},domProps:{"value":(_vm.os.le_teste1_kgf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_kgf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_kgf"}},[_vm._v("KGF/cm2")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.le_gas === 'Gás L.P KGF/cm2'),expression:"os.le_gas === 'Gás L.P KGF/cm2'"}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_kgfb),expression:"os.le_teste1_kgfb"}],attrs:{"name":"le_teste1_kgfb","id":"le_teste1_kgfb","type":"text"},domProps:{"value":(_vm.os.le_teste1_kgfb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste1_kgfb", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste1_kgfb"}},[_vm._v("KGF/cm2 Perda")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste1_aprovado),expression:"os.le_teste1_aprovado"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.le_teste1_aprovado)?_vm._i(_vm.os.le_teste1_aprovado,null)>-1:(_vm.os.le_teste1_aprovado)},on:{"change":function($event){var $$a=_vm.os.le_teste1_aprovado,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "le_teste1_aprovado", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "le_teste1_aprovado", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "le_teste1_aprovado", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                        "+_vm._s(_vm.os.le_teste1_aprovado ? "Aprovado" : "Reprovado")+"\n                      ")])])])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_casa),expression:"os.le_teste2_casa"}],attrs:{"name":"le_teste2_casa","id":"le_teste2_casa","type":"text"},domProps:{"value":(_vm.os.le_teste2_casa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_casa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_casa"}},[_vm._v("N. Casa")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_complemento),expression:"os.le_teste2_complemento"}],attrs:{"name":"le_teste2_complemento","id":"le_teste2_complemento","type":"text"},domProps:{"value":(_vm.os.le_teste2_complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_complemento"}},[_vm._v("Compl.")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_duracao),expression:"os.le_teste2_duracao"}],attrs:{"name":"le_teste2_duracao","id":"le_teste2_duracao","type":"text"},domProps:{"value":(_vm.os.le_teste2_duracao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_duracao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_duracao"}},[_vm._v("Duração (min)")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                      _vm.os.le_gas === 'Gás Natural' ||
                        _vm.os.le_gas === 'Gás L.P MMCA'
                    ),expression:"\n                      os.le_gas === 'Gás Natural' ||\n                        os.le_gas === 'Gás L.P MMCA'\n                    "}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_mmca),expression:"os.le_teste2_mmca"}],attrs:{"name":"le_teste2_mmca","id":"le_teste2_mmca","type":"text"},domProps:{"value":(_vm.os.le_teste2_mmca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_mmca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_mmca"}},[_vm._v("MMCA Pressão")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                      _vm.os.le_gas === 'Gás Natural' ||
                        _vm.os.le_gas === 'Gás L.P MMCA'
                    ),expression:"\n                      os.le_gas === 'Gás Natural' ||\n                        os.le_gas === 'Gás L.P MMCA'\n                    "}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_mmcab),expression:"os.le_teste2_mmcab"}],attrs:{"name":"le_teste2_mmcab","id":"le_teste2_mmcab","type":"text"},domProps:{"value":(_vm.os.le_teste2_mmcab)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_mmcab", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_mmcab"}},[_vm._v("MMCA Perda")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.le_gas === 'Gás L.P KGF/cm2'),expression:"os.le_gas === 'Gás L.P KGF/cm2'"}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_kgf),expression:"os.le_teste2_kgf"}],attrs:{"name":"le_teste2_kgf","id":"le_teste2_kgf","type":"text"},domProps:{"value":(_vm.os.le_teste2_kgf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_kgf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_kgf"}},[_vm._v("KGF/cm2")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.le_gas === 'Gás L.P KGF/cm2'),expression:"os.le_gas === 'Gás L.P KGF/cm2'"}],staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_kgfb),expression:"os.le_teste2_kgfb"}],attrs:{"name":"le_teste2_kgfb","id":"le_teste2_kgfb","type":"text"},domProps:{"value":(_vm.os.le_teste2_kgfb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_teste2_kgfb", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_teste2_kgfb"}},[_vm._v("KGF/cm2 Perda")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('div',{staticClass:"switch"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_teste2_aprovado),expression:"os.le_teste2_aprovado"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.le_teste2_aprovado)?_vm._i(_vm.os.le_teste2_aprovado,null)>-1:(_vm.os.le_teste2_aprovado)},on:{"change":function($event){var $$a=_vm.os.le_teste2_aprovado,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "le_teste2_aprovado", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "le_teste2_aprovado", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "le_teste2_aprovado", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                        "+_vm._s(_vm.os.le_teste2_aprovado ? "Aprovado" : "Reprovado")+"\n                      ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_dados),expression:"os.le_dados"}],staticClass:"materialize-textarea",attrs:{"name":"le_dados","id":"le_dados","type":"text"},domProps:{"value":(_vm.os.le_dados)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "le_dados", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_dados"}},[_vm._v("Dados Técnicos")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"switch"},[_c('label',{staticClass:"right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.le_aprovado),expression:"os.le_aprovado"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.le_aprovado)?_vm._i(_vm.os.le_aprovado,null)>-1:(_vm.os.le_aprovado)},on:{"change":function($event){var $$a=_vm.os.le_aprovado,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "le_aprovado", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "le_aprovado", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "le_aprovado", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                        "+_vm._s(_vm.os.le_aprovado
                            ? "Teste Aprovado"
                            : "Teste Reprovado")+"\n                      ")])])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])]),_vm._v(" "),_c('li',[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"col s12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hospitais.length),expression:"hospitais.length"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Hospital")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.hospital),expression:"hospital"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.hospital=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectHospital()}]}},[_c('option',{domProps:{"value":{}}},[_vm._v("Selecione")]),_vm._v(" "),_vm._l((_vm.hospitais),function(row){return _c('option',{domProps:{"value":row}},[_vm._v(_vm._s(row.label)+" - "+_vm._s(row.name)+", "+_vm._s(row.vicinity))])})],2),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("status_id")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.hospital),expression:"os.hospital"}],attrs:{"name":"hospital","id":"hospital","type":"text"},domProps:{"value":(_vm.os.hospital)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "hospital", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"hospital"}},[_vm._v("Hospital")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.endereco_hospital),expression:"os.endereco_hospital"}],attrs:{"name":"endereco_hospital","id":"endereco_hospital","type":"text"},domProps:{"value":(_vm.os.endereco_hospital)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "endereco_hospital", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"endereco_hospital"}},[_vm._v("Endereço")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.telefone_hospital),expression:"os.telefone_hospital"}],attrs:{"name":"telefone_hospital","id":"telefone_hospital","type":"text"},domProps:{"value":(_vm.os.telefone_hospital)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "telefone_hospital", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone_hospital"}},[_vm._v("Telefone")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])]),_vm._v(" "),_c('li',[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options3,"on-complete":_vm.completeIsometrico,"on-total-progress":_vm.totalProgressIsometrico}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.os.isometricos)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/os/" + (_vm.os.isometricos))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress2 + "%"))})]),_vm._v(" "),(_vm.errorFile2)?_c('div',{staticClass:"center-align"},[_vm._v("\n                            Tipo de arquivo inválido\n                          ")]):_vm._e(),_vm._v(" "),(_vm.os.isometricos)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyIsometrico()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1)])])]),_vm._v(" "),_c('li',[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_vm._l((_vm.chunkArray(_vm.os.fotos, 3)),function(fotos){return _c('div',{staticClass:"row"},_vm._l((fotos),function(foto,indexFoto){return _c('div',{staticClass:"col s12 m4 center-align"},[_c('img',{staticClass:"pointer center-align",staticStyle:{"max-width":"90%","height":"150px"},attrs:{"src":(_vm.api_url + "/os/" + (foto.foto))}}),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":("legenda" + indexFoto)}},[_vm._v("Legenda")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(foto.legenda),expression:"foto.legenda"}],staticClass:"materialize-textarea",attrs:{"name":"legenda{indexFoto}","id":"legenda{indexFoto}"},domProps:{"value":(foto.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(foto, "legenda", $event.target.value)}}}),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyFoto(_vm.index, indexFoto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0)}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"center-align"},[_vm._v("\n                                  clique para inserir imagens\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("\n                            Tipo de arquivo inválido\n                          ")]):_vm._e()])])])],2)],1)])],2)]),_vm._v(" "),_c('li',[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.os.videos),function(video,indexVideo){return _c('div',{staticClass:"col s12 center-align"},[_c('span',{domProps:{"innerHTML":_vm._s(video.video)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyVideo(_vm.index, indexVideo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Embed Vídeo")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.video),expression:"video"}],staticClass:"materialize-textarea",domProps:{"value":(_vm.video)},on:{"input":function($event){if($event.target.composing){ return; }_vm.video=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addVideo.apply(null, arguments)}}},[_vm._v("\n                    Adicionar Vídeo\n                  ")])])])])]),_vm._v(" "),_c('li',[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.documento_assinado),expression:"os.documento_assinado"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{staticClass:"blue-text",attrs:{"href":(_vm.url_app + "/os/" + (_vm.os.id) + "/download"),"target":"_blank"}},[_c('i',{staticClass:"material-icons left"},[_vm._v("file_download")]),_vm._v(" Baixar\n                    Documento Assinado\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options2,"on-complete":_vm.complete2,"on-total-progress":_vm.totalProgress2}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"center-align"},[_vm._v("\n                                  clique para inserir o documento assinado\n                                  pelo cliente\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("\n                            Tipo de arquivo inválido\n                          ")]):_vm._e()])])])],2)],1)])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.financeiro && _vm.os.financeiro.length > 0),expression:"os.financeiro && os.financeiro.length > 0"}]},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.os.financeiro),function(conta){return _c('div',{staticClass:"col s12 m2"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(conta.pago),expression:"conta.pago"}],staticClass:"material-icons left green-text"},[_vm._v("check")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!conta.pago),expression:"!conta.pago"}],staticClass:"material-icons left white-text"},[_vm._v("check")]),_vm._v("\n                  "+_vm._s(_vm.formatDate(conta.vencimento))),_c('br'),_vm._v(" "),_c('strong',[_vm._v("R$ "+_vm._s(conta.valor_pago))]),_c('br'),_c('br')])}),0)])]),_vm._v(" "),_c('li',[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.vistoria_realizada),expression:"os.vistoria_realizada"}],attrs:{"name":"vistoria_realizada","id":"vistoria_realizada","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.vistoria_realizada)?_vm._i(_vm.os.vistoria_realizada,null)>-1:(_vm.os.vistoria_realizada)},on:{"change":function($event){var $$a=_vm.os.vistoria_realizada,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "vistoria_realizada", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "vistoria_realizada", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "vistoria_realizada", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"vistoria_realizada"}},[_vm._v("Vistoria Realizada")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.vistoria_realizada === true),expression:"os.vistoria_realizada === true"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"switch"},[_c('label',{staticStyle:{"display":"inline-flex"}},[_vm._v("\n                      Reprovado\n                      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.vistoria_aprovada),expression:"os.vistoria_aprovada"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.vistoria_aprovada)?_vm._i(_vm.os.vistoria_aprovada,null)>-1:(_vm.os.vistoria_aprovada)},on:{"change":function($event){var $$a=_vm.os.vistoria_aprovada,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "vistoria_aprovada", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "vistoria_aprovada", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "vistoria_aprovada", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"lever"}),_vm._v("\n                      Aprovado\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.trocar-revisao') > -1),expression:"permissoes.indexOf('os.trocar-revisao') > -1"}],staticClass:"col s12 m6"},[_c('label',{attrs:{"for":"revisao_id"}},[_vm._v("Revisão")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.revisao_id),expression:"os.revisao_id"}],attrs:{"name":"revisao_id","id":"revisao_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "revisao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.revisoes),function(revisao){return _c('option',{domProps:{"value":revisao.id}},[_vm._v(_vm._s(revisao.tipo)+"\n                    ")])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                    _vm.permissoes.indexOf('os.trocar-revisao') > -1 ||
                      !_vm.os.revisoes.length
                  ),expression:"\n                    permissoes.indexOf('os.trocar-revisao') > -1 ||\n                      !os.revisoes.length\n                  "}],staticClass:"input-field col s12 m6"},[_c('button',{staticClass:"btn waves-effect waves-light blue",attrs:{"type":"button"},on:{"click":_vm.adicionarRevisao}},[_vm._v("\n                    Iniciar\n                  ")])])]),_vm._v(" "),(_vm.os.revisoes.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(17),_vm._v(" "),_vm._l((_vm.os.revisoes),function(revisao,index){return _c('tr',[_c('td',[_vm._v("\n                        "+_vm._s(revisao && revisao.item && revisao.item.inspecao
                            ? revisao.item.inspecao
                            : "-")+"\n                      ")]),_vm._v(" "),_c('td',[_vm._v("\n                        "+_vm._s(revisao && revisao.item && revisao.item.ordem
                            ? revisao.item.ordem
                            : "-")+"\n                      ")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(revisao.aprovado),expression:"revisao.aprovado"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(revisao, "aprovado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":1}},[_vm._v("Aprovado")]),_vm._v(" "),_c('option',{domProps:{"value":0}},[_vm._v("Reprovado")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("Não aplicável")])])])])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.revisoes && _vm.os.revisoes.length > 0),expression:"os.revisoes && os.revisoes.length > 0"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.revisao_aprovada),expression:"os.revisao_aprovada"}],attrs:{"name":"revisao_aprovada","id":"revisao_aprovada"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "revisao_aprovada", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecione Status da Revisão")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Reprovada")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Aprovada")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Cancelada")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Recusada Pelo Cliente")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Cliente Ausente")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.revisoes && _vm.os.revisoes.length > 0),expression:"os.revisoes && os.revisoes.length > 0"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.gerar_texto),expression:"os.gerar_texto"}],attrs:{"name":"os.gerar_texto","id":"os.gerar_texto","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.gerar_texto)?_vm._i(_vm.os.gerar_texto,null)>-1:(_vm.os.gerar_texto)},on:{"change":function($event){var $$a=_vm.os.gerar_texto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "gerar_texto", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "gerar_texto", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "gerar_texto", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"os.gerar_texto"}},[_vm._v("Gerar Texto Revisão")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.revisoes && _vm.os.revisoes.length > 0),expression:"os.revisoes && os.revisoes.length > 0"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.gerar_orcamento),expression:"os.gerar_orcamento"}],attrs:{"name":"orcamento_revisao","id":"orcamento_revisao","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.gerar_orcamento)?_vm._i(_vm.os.gerar_orcamento,null)>-1:(_vm.os.gerar_orcamento)},on:{"change":function($event){var $$a=_vm.os.gerar_orcamento,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "gerar_orcamento", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "gerar_orcamento", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "gerar_orcamento", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento_revisao"}},[_vm._v("Gerar Orçamento")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.gerar_orcamento),expression:"os.gerar_orcamento"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.mesmo_cliente),expression:"os.mesmo_cliente"}],attrs:{"name":"mesmo_cliente","id":"mesmo_cliente","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.mesmo_cliente)?_vm._i(_vm.os.mesmo_cliente,null)>-1:(_vm.os.mesmo_cliente)},on:{"change":function($event){var $$a=_vm.os.mesmo_cliente,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "mesmo_cliente", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "mesmo_cliente", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "mesmo_cliente", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"mesmo_cliente"}},[_vm._v("Manter Cliente")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.orcamentos.length),expression:"os.orcamentos.length"}]},[_vm._m(18),_vm._v(" "),_vm._l((_vm.os.orcamentos),function(orc){return _c('span',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.form', params: { id: orc.id } }}},[_vm._v(_vm._s(orc.id))]),_vm._v(",\n                ")],1)})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.gerar_orcamento && !_vm.os.mesmo_cliente),expression:"os.gerar_orcamento && !os.mesmo_cliente"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.responsavel),expression:"os.responsavel"},{name:"validate",rawName:"v-validate",value:(
                        _vm.os.gerar_orcamento && !_vm.os.mesmo_cliente
                          ? 'required'
                          : ''
                      ),expression:"\n                        os.gerar_orcamento && !os.mesmo_cliente\n                          ? 'required'\n                          : ''\n                      "}],class:{ invalid: _vm.errors.has('responsavel') },attrs:{"name":"responsavel","id":"responsavel","type":"text"},domProps:{"value":(_vm.os.responsavel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "responsavel", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"responsavel"}},[_vm._v("*Responsável")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("responsavel")))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(
                        _vm.os.gerar_orcamento && !_vm.os.mesmo_cliente
                          ? 'required'
                          : ''
                      ),expression:"\n                        os.gerar_orcamento && !os.mesmo_cliente\n                          ? 'required'\n                          : ''\n                      "},{name:"model",rawName:"v-model.number",value:(_vm.os.tipo),expression:"os.tipo",modifiers:{"number":true}}],class:{ invalid: _vm.errors.has('tipo') },attrs:{"name":"tipo","id":"tipo","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.os, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Pessoa Jurídica")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Pessoa Física")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("tipo")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.razao_social),expression:"os.razao_social"}],attrs:{"name":"razao_social","id":"razao_social","type":"text"},domProps:{"value":(_vm.os.razao_social)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "razao_social", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"razao_social"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("razao_social")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.tipo === 1),expression:"os.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99.999.999/9999-99'),expression:"'99.999.999/9999-99'"},{name:"validate",rawName:"v-validate",value:(
                        _vm.os.gerar_orcamento &&
                        _vm.os.tipo === 1 &&
                        !_vm.os.mesmo_cliente
                          ? 'required'
                          : ''
                      ),expression:"\n                        os.gerar_orcamento &&\n                        os.tipo === 1 &&\n                        !os.mesmo_cliente\n                          ? 'required'\n                          : ''\n                      "},{name:"model",rawName:"v-model",value:(_vm.os.cnpj),expression:"os.cnpj"}],class:{ invalid: _vm.errors.has('cnpj') },attrs:{"name":"cnpj","id":"cnpj","type":"text","data-vv-rules":"required|min:18"},domProps:{"value":(_vm.os.cnpj)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "cnpj", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cnpj"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("cnpj")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.tipo === 1),expression:"os.tipo === 1"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.ie),expression:"os.ie"}],class:{ invalid: _vm.errors.has('ie') },attrs:{"name":"ie","id":"ie","type":"text"},domProps:{"value":(_vm.os.ie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "ie", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ie"}},[_vm._v("Inscrição Estadual")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("ie")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.tipo === 2),expression:"os.tipo === 2"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('999.999.999-99'),expression:"'999.999.999-99'"},{name:"validate",rawName:"v-validate",value:(
                        _vm.os.gerar_orcamento &&
                        _vm.os.tipo === 2 &&
                        !_vm.os.mesmo_cliente
                          ? 'required'
                          : ''
                      ),expression:"\n                        os.gerar_orcamento &&\n                        os.tipo === 2 &&\n                        !os.mesmo_cliente\n                          ? 'required'\n                          : ''\n                      "},{name:"model",rawName:"v-model",value:(_vm.os.cpf),expression:"os.cpf"}],class:{ invalid: _vm.errors.has('cpf') },attrs:{"name":"cpf","id":"cpf","type":"text","data-vv-rules":"min:14"},domProps:{"value":(_vm.os.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "cpf", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cpf"}},[_vm._v("*CPF")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("cpf")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate",value:(
                        _vm.os.gerar_orcamento && !_vm.os.mesmo_cliente
                          ? 'required'
                          : ''
                      ),expression:"\n                        os.gerar_orcamento && !os.mesmo_cliente\n                          ? 'required'\n                          : ''\n                      "},{name:"model",rawName:"v-model",value:(_vm.os.telefone),expression:"os.telefone"}],class:{ invalid: _vm.errors.has('telefone') },attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.os.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("telefone")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.os.telefone2),expression:"os.telefone2"}],class:{ invalid: _vm.errors.has('telefone2') },attrs:{"name":"telefone2","id":"telefone2","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.os.telefone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "telefone2", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone2"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("telefone2")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.os.telefone3),expression:"os.telefone3"}],class:{ invalid: _vm.errors.has('telefone3') },attrs:{"name":"telefone3","id":"telefone3","type":"text","data-vv-rules":"min:13"},domProps:{"value":(_vm.os.telefone3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "telefone3", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"telefone3"}},[_vm._v("Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("telefone3")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(
                        _vm.os.gerar_orcamento && !_vm.os.mesmo_cliente
                          ? 'required'
                          : ''
                      ),expression:"\n                        os.gerar_orcamento && !os.mesmo_cliente\n                          ? 'required'\n                          : ''\n                      "},{name:"model",rawName:"v-model",value:(_vm.os.email),expression:"os.email"}],class:{ invalid: _vm.errors.has('email') },attrs:{"name":"email","id":"email","type":"text","data-vv-rules":"email"},domProps:{"value":(_vm.os.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("E-mail")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("email")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('99999-999'),expression:"'99999-999'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.os.cep),expression:"os.cep"}],class:{ invalid: _vm.errors.has('cep') },attrs:{"name":"cep","id":"cep","type":"text","data-vv-rules":"min:9"},domProps:{"value":(_vm.os.cep)},on:{"blur":_vm.setEndereco,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "cep", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cep"}},[_vm._v("CEP")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("cep")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.logradouro),expression:"os.logradouro"}],attrs:{"name":"logradouro","id":"logradouro","type":"text"},domProps:{"value":(_vm.os.logradouro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "logradouro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"logradouro"}},[_vm._v("Logradouro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("logradouro")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.numero),expression:"os.numero"}],attrs:{"name":"numero","id":"numero","type":"text"},domProps:{"value":(_vm.os.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"numero"}},[_vm._v("Nº")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("numero")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.complemento),expression:"os.complemento"}],attrs:{"name":"complemento","id":"complemento","type":"text"},domProps:{"value":(_vm.os.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "complemento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"complemento"}},[_vm._v("Compl.")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("complemento")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.bairro),expression:"os.bairro"}],attrs:{"name":"bairro","id":"bairro","type":"text"},domProps:{"value":(_vm.os.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "bairro", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"bairro"}},[_vm._v("Bairro")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("bairro")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.cidade),expression:"os.cidade"}],attrs:{"name":"cidade","id":"cidade","type":"text"},domProps:{"value":(_vm.os.cidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "cidade", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cidade"}},[_vm._v("Cidade")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("cidade")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.estado),expression:"os.estado"}],attrs:{"name":"estado","id":"estado","type":"text"},domProps:{"value":(_vm.os.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "estado", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"estado"}},[_vm._v("Estado")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("estado")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.referencia),expression:"os.referencia"}],attrs:{"name":"referencia","id":"referencia","type":"text"},domProps:{"value":(_vm.os.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "referencia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"referencia"}},[_vm._v("Ponto de Referência")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("referencia")))])])])])])]),_vm._v(" "),_c('li',[_vm._m(19),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_vm._l((_vm.os.tarefas),function(tarefa,indexTarefa){return _c('div',{staticClass:"z-depth-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(tarefa.tarefa),expression:"tarefa.tarefa"}],class:{ invalid: _vm.errors.has('tarefa') },attrs:{"name":"tarefa","type":"text","data-vv-rules":"required"},domProps:{"value":(tarefa.tarefa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tarefa, "tarefa", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("*Tarefa")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("tarefa")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(tarefa.dia),expression:"tarefa.dia"}],class:{ invalid: _vm.errors.has('dia') },attrs:{"name":"dia","type":"date","data-vv-rules":"required","data-value":tarefa.dia},domProps:{"value":(tarefa.dia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tarefa, "dia", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active"},[_vm._v("*Prazo dia")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("dia")))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("alarm")]),_vm._v(" "),_c('input',{directives:[{name:"time",rawName:"v-time"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(tarefa.hora),expression:"tarefa.hora"}],class:{ invalid: _vm.errors.has('hora') },attrs:{"name":"hora","type":"text","id":("hora" + indexTarefa),"data-vv-rules":"required","data-value":tarefa.hora},domProps:{"value":(tarefa.hora)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tarefa, "hora", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("hora" + indexTarefa)}},[_vm._v("*hora")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("hora")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m9"},[_c('label',[_vm._v("Usuários Envolvidos na Tarefa")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"nome_completo","track-by":"id","options":_vm.usuarios},model:{value:(tarefa.usuarios),callback:function ($$v) {_vm.$set(tarefa, "usuarios", $$v)},expression:"tarefa.usuarios"}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(tarefa.status_id),expression:"tarefa.status_id"}],attrs:{"name":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tarefa, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Agendada")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Em execução")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Finalizada")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("status_id")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(tarefa.descricao),expression:"tarefa.descricao"}],staticClass:"materialize-textarea",attrs:{"name":"descricao"},domProps:{"value":(tarefa.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tarefa, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("descricao")))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyTarefa(indexTarefa)}}},[_c('i',{staticClass:"material-icons red-text right"},[_vm._v("delete_forever")])])])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 right-align"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":_vm.addTarefa}},[_vm._v("\n                    Adicionar Tarefa\n                  ")])])])],2)]),_vm._v(" "),_c('li',[_vm._m(20),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('vue-clip',{attrs:{"options":_vm.options4,"on-complete":_vm.completePagamento,"on-total-progress":_vm.totalProgressPagamento}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[(_vm.os.comprovante_pagamento)?_c('img',{staticStyle:{"max-width":"90%","max-height":"80px"},attrs:{"src":(_vm.api_url + "/os/" + (_vm.os.comprovante_pagamento))}}):_c('div',[_c('img',{staticStyle:{"max-width":"90%","max-height":"50px"},attrs:{"src":__webpack_require__("5ljW")}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir uma imagem")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress2 + "%"))})]),_vm._v(" "),(_vm.errorFile2)?_c('div',{staticClass:"center-align"},[_vm._v("\n                            Tipo de arquivo inválido\n                          ")]):_vm._e(),_vm._v(" "),(_vm.os.comprovante_pagamento)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyPagamento()}}},[_vm._v("delete_forever")])]):_vm._e()])])])],2)],1)])])]),_vm._v(" "),_c('li',[_vm._m(21),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"z-depth-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',[_vm._m(22),_vm._v(" "),_vm._l((_vm.os.historico),function(registro,indexRegistro){return _c('tr',[_c('td',[_vm._v(_vm._s(registro.data))]),_vm._v(" "),_c('td',[_vm._v("\n                          "+_vm._s(registro.usuario ? registro.usuario.nome : "-")+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(registro.conteudo))]),_vm._v(" "),_c('td',{staticClass:"center"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyHistorico(indexRegistro)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.historico.conteudo),expression:"historico.conteudo"}],staticClass:"materialize-textarea",attrs:{"name":"historico_conteudo","id":"historico_conteudo","type":"text","placeholder":"Conteúdo"},domProps:{"value":(_vm.historico.conteudo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.historico, "conteudo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"le_dados"}},[_vm._v("Adicionar Registro")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button"},on:{"click":_vm.addHistorico}},[_vm._v("\n                      Adicionar Registro\n                    ")]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])])])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"status_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.os.status_id),expression:"os.status_id"}],attrs:{"name":"status_id","id":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.status),function(status){return _c('option',{domProps:{"value":status.id}},[_vm._v(_vm._s(status.status))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first("status_id")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.financeiro && _vm.os.financeiro.length === 0),expression:"os.financeiro && os.financeiro.length === 0"}],staticClass:"col s12 m3"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lancar_financeiro),expression:"lancar_financeiro"}],attrs:{"name":"lancar_financeiro","id":"lancar_financeiro","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.lancar_financeiro)?_vm._i(_vm.lancar_financeiro,null)>-1:(_vm.lancar_financeiro)},on:{"change":function($event){var $$a=_vm.lancar_financeiro,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.lancar_financeiro=$$a.concat([$$v]))}else{$$i>-1&&(_vm.lancar_financeiro=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.lancar_financeiro=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"lancar_financeiro"}},[_vm._v("Lançar Financeiro")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_vm._v("\n              Salvar\n            ")])])])])])])])}
var os_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Informações Gerais\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_vm._v(" Descrição dos Serviços\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment_turned_in")]),_vm._v(" Lista de\n              Materiais\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Materiais Utilizados")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("list")]),_vm._v(" Permissões de Trabalho\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Procedimento")]),_vm._v(" "),_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('p',[_c('strong',[_vm._v("Acompanhamento da Obra")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("receipt")]),_vm._v(" Laudo de Estanqueidade\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('strong',[_vm._v("Teste 1")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('strong',[_vm._v("Teste 2")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3 "},[_c('i',{staticClass:"material-icons"},[_vm._v("local_hospital")]),_vm._v(" Anexo de Emergência\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("add_a_photo")]),_vm._v(" Isométrico\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("add_a_photo")]),_vm._v(" Fotos\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("video_library")]),_vm._v(" Vídeos\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")]),_vm._v(" Documento Assinado\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_money")]),_vm._v(" Financeiro\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("assessment")]),_vm._v(" Revisão\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Inspeção")]),_vm._v(" "),_c('th',[_vm._v("Ordem")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Os orçamentos abaixo foram gerados a partir dessa\n                    OS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("alarm_on")]),_vm._v(" Tarefas\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("add_a_photo")]),_vm._v(" Comprovante de Pagamento\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("history")]),_vm._v(" Histórico\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Usuário")]),_vm._v(" "),_c('th',[_vm._v("Conteúdo")]),_vm._v(" "),_c('th',{staticClass:"center"},[_vm._v("Ação")])])}]
var os_form_esExports = { render: os_form_render, staticRenderFns: os_form_staticRenderFns }
/* harmony default export */ var os_os_form = (os_form_esExports);
// CONCATENATED MODULE: ./src/features/os/os/form.vue
var os_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var os_form___vue_template_functional__ = false
/* styles */
var os_form___vue_styles__ = null
/* scopeId */
var os_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var os_form___vue_module_identifier__ = null
var os_form_Component = os_form_normalizeComponent(
  os_form,
  os_os_form,
  os_form___vue_template_functional__,
  os_form___vue_styles__,
  os_form___vue_scopeId__,
  os_form___vue_module_identifier__
)

/* harmony default export */ var features_os_os_form = (os_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/os/os/formNovo.vue








/* harmony default export */ var formNovo = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      usuarios: [],
      orcamento: {},
      revisoes: [],
      os: {
        id: '',
        massa: false,
        andares: '',
        finais: '',
        estrutura_numeros: 'centena',
        bloco: '',
        cliente_id: '',
        orcamento_id: '',
        revisao_id: null,
        proposta_id: '',
        servico: '',
        apartamento: '',
        medidor: '',
        medidor_marca: '',
        medidor_numero: '',
        medidor_leitura: '',
        descricao: '',
        dificuldades: '',
        solucao: '',
        valor: '',
        inicio: '',
        tempo_execucao: '',
        responsavel_id: ''
      },
      editorDescricao: {
        placeholder: 'Descrição',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['clean']]
        }
      },
      editorDificuldades: {
        placeholder: 'Dificuldades Encontradas',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['clean']]
        }
      },
      editorSolucao: {
        placeholder: 'Solução Proposta',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['clean']]
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.clear();
                id = _this.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 5;
                return service_http.get('/os/' + id + '/orcamento');

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                if (data && data.orcamento && data.orcamento.proposta) {
                  _this.orcamento = data.orcamento;
                  _this.os.cliente_id = _this.orcamento.cliente_id;
                  _this.os.orcamento_id = _this.orcamento.id;
                  _this.os.proposta_id = _this.orcamento.proposta.id;
                  _this.os.valor = _this.orcamento.proposta.valor_total;
                  // this.os.descricao = data.servicos
                  _this.os.apartamento = _this.orcamento.complemento;
                  if (_this.orcamento.revisao_id) {
                    _this.os.revisao_id = _this.orcamento.revisao_id;
                  }
                } else {
                  _this.$router.push({ name: 'orcamentos.index' });
                }
                _this.usuarios = data.usuarios;
                _this.revisoes = data.revisoes;

              case 10:
                setTimeout(function () {
                  $('.collapsible').collapsible();
                  $('.collapsible').collapsible('close', 0);
                  $('.collapsible').collapsible('close', 1);
                  $('.collapsible').collapsible('close', 2);
                  $('.collapsible').collapsible('open', 0);
                  window.Materialize.updateTextFields();
                }, 0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this2.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        }
        _this2.submit();
      });
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = 'post';
                url = '/os';
                _context2.next = 4;
                return service_http[verb](url, _this3.os);

              case 4:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this3.$emit('update-os-list', { os: data.os });
                  if (_this3.os.massa === true) {
                    _this3.$router.push({ name: 'os.index' });
                  } else {
                    _this3.$router.push({ name: 'os.form', params: { id: data.os[0].id } });
                  }
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.os = {
        id: '',
        massa: false,
        andares: '',
        finais: '',
        estrutura_numeros: 'centena',
        bloco: '',
        cliente_id: '',
        orcamento_id: '',
        proposta_id: '',
        revisao_id: null,
        servico: '',
        apartamento: '',
        medidor: '',
        medidor_marca: '',
        medidor_numero: '',
        medidor_leitura: '',
        descricao: '',
        dificuldades: '',
        solucao: '',
        valor: '',
        inicio: '',
        tempo_execucao: '',
        responsavel_id: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6f3df4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/os/os/formNovo.vue
var formNovo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('ul',{staticClass:"collapsible popout",attrs:{"data-collapsible":"accordion"}},[_c('li',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{attrs:{"name":"orcamento","id":"orcamento","type":"text","disabled":""},domProps:{"value":("#" + (_vm.orcamento.id))}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento"}},[_vm._v("Orçamento")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.massa),expression:"os.massa"}],attrs:{"name":"massa","id":"massa","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.os.massa)?_vm._i(_vm.os.massa,null)>-1:(_vm.os.massa)},on:{"change":function($event){var $$a=_vm.os.massa,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.os, "massa", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.os, "massa", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.os, "massa", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"massa"}},[_vm._v("OS em Massa")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.massa),expression:"os.massa"}],staticClass:"input-field col s12 m8"},[_c('br'),_vm._v(" "),_c('label',{staticClass:"red-text"},[_vm._v("obs: para OS's em massa talvez seja necessário fracionar o valor")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.os.massa),expression:"os.massa"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.os.massa === true ? 'required' : ''),expression:"os.massa === true ? 'required' : ''"},{name:"model",rawName:"v-model",value:(_vm.os.andares),expression:"os.andares"}],class:{invalid: _vm.errors.has('andares')},attrs:{"name":"andares","id":"andares","type":"text"},domProps:{"value":(_vm.os.andares)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "andares", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"andares"}},[_vm._v("Andares (ex: 10,1 ou 10,0)")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('andares')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.os.massa === true ? 'required' : ''),expression:"os.massa === true ? 'required' : ''"},{name:"model",rawName:"v-model",value:(_vm.os.finais),expression:"os.finais"}],class:{invalid: _vm.errors.has('finais')},attrs:{"name":"finais","id":"finais","type":"text"},domProps:{"value":(_vm.os.finais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "finais", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"finais"}},[_vm._v("Finais (ex: 1,2,3 ..., 10)")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('finais')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"estrutura_numeros"}},[_vm._v("Padrão de Números")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.estrutura_numeros),expression:"os.estrutura_numeros"}],attrs:{"name":"estrutura_numeros","id":"estrutura_numeros"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "estrutura_numeros", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"decimal"}},[_vm._v("Decimal (ex: 13)")]),_vm._v(" "),_c('option',{attrs:{"value":"centena"}},[_vm._v("Centena (ex 138)")]),_vm._v(" "),_c('option',{attrs:{"value":"milhar"}},[_vm._v("Milhar (ex: 1308)")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('estrutura_numeros')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.bloco),expression:"os.bloco"}],attrs:{"name":"bloco","id":"bloco","type":"text"},domProps:{"value":(_vm.os.bloco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "bloco", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"bloco"}},[_vm._v("Bloco (ex: Bloco A)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"responsavel_id"}},[_vm._v("*Responsável Técnico")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.responsavel_id),expression:"os.responsavel_id"}],attrs:{"name":"responsavel_id","id":"responsavel_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "responsavel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(responsavel){return _c('option',{domProps:{"value":responsavel.id}},[_vm._v(_vm._s(responsavel.nome_completo)+"\n                    ")])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('responsavel_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"revisao_id"}},[_vm._v("Revisão")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.revisao_id),expression:"os.revisao_id"}],attrs:{"name":"revisao_id","id":"revisao_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.os, "revisao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.revisoes),function(revisao){return _c('option',{domProps:{"value":revisao.id}},[_vm._v(_vm._s(revisao.tipo))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.os.massa),expression:"!os.massa"}],staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.apartamento),expression:"os.apartamento"}],attrs:{"name":"apartamento","id":"apartamento","type":"text"},domProps:{"value":(_vm.os.apartamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "apartamento", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"apartamento"}},[_vm._v("Apartamento (não preencher para OS's em massa)")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.os.massa),expression:"!os.massa"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor),expression:"os.medidor"}],attrs:{"name":"medidor","id":"medidor","type":"text"},domProps:{"value":(_vm.os.medidor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor"}},[_vm._v("Medidor de Gás")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor_marca),expression:"os.medidor_marca"}],attrs:{"name":"medidor_marca","id":"medidor_marca","type":"text"},domProps:{"value":(_vm.os.medidor_marca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor_marca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor_marca"}},[_vm._v("Marca do Medidor")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor_numero),expression:"os.medidor_numero"}],attrs:{"name":"medidor_numero","id":"medidor_numero","type":"text"},domProps:{"value":(_vm.os.medidor_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor_numero", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor_numero"}},[_vm._v("Número do Medidor")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.medidor_leitura),expression:"os.medidor_leitura"}],attrs:{"name":"medidor_leitura","id":"medidor_leitura","type":"text"},domProps:{"value":(_vm.os.medidor_leitura)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "medidor_leitura", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"medidor_leitura"}},[_vm._v("Leitura do Medidor")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.valor),expression:"os.valor"}],attrs:{"name":"valor","id":"valor","type":"number","step":"any","min":"0"},domProps:{"value":(_vm.os.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor"}},[_vm._v("*R$ da Obra")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.inicio),expression:"os.inicio"}],attrs:{"name":"inicio","id":"icon_inicio","type":"date","data-value":_vm.os.inicio},domProps:{"value":(_vm.os.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Data de Início")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('inicio')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.os.tempo_execucao),expression:"os.tempo_execucao"}],attrs:{"name":"tempo_execucao","id":"tempo_execucao","type":"number"},domProps:{"value":(_vm.os.tempo_execucao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.os, "tempo_execucao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"tempo_execucao"}},[_vm._v("Tempo de Execução (dias)")])])])])]),_vm._v(" "),_c('li',[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('quill-editor',{ref:"os.descricao",attrs:{"options":_vm.editorDescricao},model:{value:(_vm.os.descricao),callback:function ($$v) {_vm.$set(_vm.os, "descricao", $$v)},expression:"os.descricao"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Dificuldades Encontradas")]),_vm._v(" "),_c('quill-editor',{ref:"os.dificuldades",attrs:{"options":_vm.editorDificuldades},model:{value:(_vm.os.dificuldades),callback:function ($$v) {_vm.$set(_vm.os, "dificuldades", $$v)},expression:"os.dificuldades"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('dificuldades')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Solução Proposta")]),_vm._v(" "),_c('quill-editor',{ref:"os.solucao",attrs:{"options":_vm.editorSolucao},model:{value:(_vm.os.solucao),callback:function ($$v) {_vm.$set(_vm.os, "solucao", $$v)},expression:"os.solucao"}}),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('solucao')))])],1)])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_vm._v("\n              Gerar OS\n            ")])])])])])])])}
var formNovo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v(" Informações Gerais\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_vm._v(" Descrição dos Serviços\n            ")])}]
var formNovo_esExports = { render: formNovo_render, staticRenderFns: formNovo_staticRenderFns }
/* harmony default export */ var os_formNovo = (formNovo_esExports);
// CONCATENATED MODULE: ./src/features/os/os/formNovo.vue
var formNovo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var formNovo___vue_template_functional__ = false
/* styles */
var formNovo___vue_styles__ = null
/* scopeId */
var formNovo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var formNovo___vue_module_identifier__ = null
var formNovo_Component = formNovo_normalizeComponent(
  formNovo,
  os_formNovo,
  formNovo___vue_template_functional__,
  formNovo___vue_styles__,
  formNovo___vue_scopeId__,
  formNovo___vue_module_identifier__
)

/* harmony default export */ var os_os_formNovo = (formNovo_Component.exports);

// CONCATENATED MODULE: ./src/features/os/os/routes.js





/* harmony default export */ var os_routes = ([{
  path: '/os/:status?/:revisao?',
  name: 'os.index',
  component: src_features_os_os,
  children: [{
    path: 'form/:id?',
    name: 'os.form',
    component: features_os_os_form
  }, {
    path: 'orcamento/:id?',
    name: 'os.orcamento',
    component: os_os_formNovo
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/tarefas/tarefas/index.vue









/* harmony default export */ var tarefas = ({
  name: 'Tarefas',
  data: function data() {
    return {
      list: [],
      usuarios: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      },
      filtro: {
        inicio: '',
        termino: '',
        status: '',
        usuario: ''
      },
      show: {
        filtro: false
      }
    };
  },
  mounted: function mounted() {
    var filtro = this.$route.params.filtro;

    if (filtro !== undefined) {
      this.show.filtro = true;
      if (filtro === 'hoje') {
        this.filtro.inicio = moment_default()().format('DD/MM/YYYY');
        this.filtro.termino = moment_default()().format('DD/MM/YYYY');
      }
      if (filtro === 'pendentes') {
        this.filtro.inicio = moment_default()().format('DD/MM/YYYY');
        this.filtro.termino = moment_default()().format('DD/MM/YYYY');
        this.filtro.status = 'pendente';
      }
      if (filtro === 'execucao') {
        this.filtro.status = 2;
      }
      if (filtro === 'atraso') {
        this.filtro.status = 'atrasada';
      }
      this.filtrar();
    } else {
      this.fetch();
    }
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY HH:mm');
    },
    chipAtraso: function chipAtraso(data) {
      var vencimento = moment_default()(data).format('YYYY-MM-DD HH:mm');
      var hoje = moment_default()().format('YYYY-MM-DD HH:mm');
      if (hoje > vencimento) {
        return true;
      }
    },
    fetch: function fetch(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/tarefas?page=' + _this.pagination.current_page);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.rows.data;
                  _this.pagination.current_page = data.rows.current_page;
                  _this.pagination.last_page = data.rows.last_page;
                  _this.filtro = data.filtro;
                  _this.usuarios = data.usuarios;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    paginate: function paginate(page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (page) {
                  _this2.pagination.current_page = page;
                }
                _context2.next = 3;
                return service_http.get('/tarefas?page=' + _this2.pagination.current_page + '&busca=' + _this2.busca + '&inicio=' + _this2.filtro.inicio + '&termino=' + _this2.filtro.termino + '&status=' + _this2.filtro.status + '&usuario=' + _this2.filtro.usuario);

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.rows.data;
                  _this2.pagination.current_page = data.rows.current_page;
                  _this2.pagination.last_page = data.rows.last_page;
                  _this2.filtro = data.filtro;
                  _this2.usuarios = data.usuarios;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    buscar: function buscar() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref3, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.show.filtro = false;
                _context3.next = 3;
                return service_http.get('/tarefas?&busca=' + _this3.busca);

              case 3:
                _ref3 = _context3.sent;
                data = _ref3.data;

                if (data != null) {
                  _this3.list = data.rows.data;
                  _this3.pagination.current_page = data.rows.current_page;
                  _this3.pagination.last_page = data.rows.last_page;
                  _this3.filtro = data.filtro;
                  _this3.usuarios = data.usuarios;
                  setTimeout(function () {
                    window.Materialize.updateTextFields();
                  }, 0);
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    filtrar: function filtrar() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.busca = '';
                _context4.next = 3;
                return service_http.get('/tarefas?inicio=' + _this4.filtro.inicio + '&termino=' + _this4.filtro.termino + '&status=' + _this4.filtro.status + '&usuario=' + _this4.filtro.usuario);

              case 3:
                _ref4 = _context4.sent;
                data = _ref4.data;

                _this4.list = data.rows.data;
                _this4.pagination.current_page = data.rows.current_page;
                _this4.pagination.last_page = data.rows.last_page;
                _this4.filtro = data.filtro;
                _this4.usuarios = data.usuarios;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var tarefa, index;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tarefa = obj.tarefa;
                _context5.next = 3;
                return findIndex_default()(_this5.list, { id: tarefa.id });

              case 3:
                index = _context5.sent;

                if (index > -1) {
                  _this5.list[index] = extends_default()({}, tarefa);
                } else {
                  _this5.list.unshift(tarefa);
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    destroy: function destroy(tarefa) {
      var _this6 = this;

      this.$swal({
        title: 'Deseja remover ' + tarefa.tarefa + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _ref6, data, index;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return service_http.delete('/tarefas/' + tarefa.id);

              case 2:
                _ref6 = _context6.sent;
                data = _ref6.data;

                if (!(data != null)) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 7;
                return findIndex_default()(_this6.list, { id: tarefa.id });

              case 7:
                index = _context6.sent;

                if (index > -1) {
                  _this6.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this6.checkListTotal();
                }

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'tarefas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'tarefas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c45affb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/tarefas/tarefas/index.vue
var tarefas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('tarefa.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('tarefa.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'tarefas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'tarefas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-tarefas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn-floating waves-effect waves-light",on:{"click":function($event){$event.preventDefault();_vm.show.filtro = !_vm.show.filtro}}},[_c('i',{staticClass:"material-icons"},[_vm._v("filter_list")])])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.filtrar.apply(null, arguments)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show.filtro && _vm.showBtNovo),expression:"show.filtro && showBtNovo"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"filtro_status"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.status),expression:"filtro.status"}],attrs:{"name":"status","id":"filtro_status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Agendada")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Em execução")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Finalizada")]),_vm._v(" "),_c('option',{attrs:{"value":"pendente"}},[_vm._v("Pendente")]),_vm._v(" "),_c('option',{attrs:{"value":"atrasada"}},[_vm._v("Atrasada")])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"filtro_usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"name":"usuario","id":"filtro_usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(usuario){return _c('option',{domProps:{"value":usuario.id}},[_vm._v(_vm._s((usuario.id) ? usuario.nome_completo : 'Todos'))])}),0)]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(tarefa){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('tarefa.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'tarefas.form', params: { id: tarefa.id } }}},[_vm._v("\n                              "+_vm._s(tarefa.id)+"\n                          ")]):_c('span',[_vm._v(_vm._s(tarefa.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(tarefa.tarefa))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((tarefa.usuario) ? tarefa.usuario.nome_completo : '-'))]),_vm._v(" "),_c('td',[(tarefa.usuarios.length > 0)?_c('select',{attrs:{"id":"usuarios"}},_vm._l((tarefa.usuarios),function(usuario){return _c('option',[_vm._v(_vm._s(usuario.nome_completo))])}),0):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[(tarefa.os)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: tarefa.os_id } }}},[_vm._v("\n                          "+_vm._s(tarefa.os_id)+"\n                        ")]):_c('span',[_vm._v("-")])],1),_vm._v(" "),_c('td',[(tarefa.orcamento)?_c('router-link',{attrs:{"to":{ name: 'orcamentos.form', params: { id: tarefa.orcamento_id } }}},[_vm._v("\n                          "+_vm._s(tarefa.orcamento_id)+"\n                        ")]):_c('span',[_vm._v("-")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(tarefa.prazo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tarefa.status.status))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[(tarefa.status_id === 3)?_c('span',{staticClass:"new badge green",attrs:{"data-badge-caption":"concluída"}}):_vm._e(),_vm._v(" "),(tarefa.status_id < 3 && _vm.chipAtraso(tarefa.prazo) === true)?_c('span',{staticClass:"new badge red",attrs:{"data-badge-caption":"atrasada"}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tarefa.editar') > -1),expression:"permissoes.indexOf('tarefa.editar') > -1"}],attrs:{"to":{ name: 'tarefas.form', params: { id: tarefa.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tarefa.excluir') > -1),expression:"permissoes.indexOf('tarefa.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(tarefa)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var tarefas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Tarefas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m3"},[_c('button',{staticClass:"waves-effect waves-light btn"},[_c('i',{staticClass:"material-icons left"},[_vm._v("filter_list")]),_vm._v(" Filtrar")]),_vm._v(" "),_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Tarefa")]),_vm._v(" "),_c('th',[_vm._v("Solicitante")]),_vm._v(" "),_c('th',[_vm._v("Responsáveis")]),_vm._v(" "),_c('th',[_vm._v("# OS")]),_vm._v(" "),_c('th',[_vm._v("# Orçamento")]),_vm._v(" "),_c('th',[_vm._v("Prazo")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var tarefas_esExports = { render: tarefas_render, staticRenderFns: tarefas_staticRenderFns }
/* harmony default export */ var tarefas_tarefas = (tarefas_esExports);
// CONCATENATED MODULE: ./src/features/tarefas/tarefas/index.vue
var tarefas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tarefas___vue_template_functional__ = false
/* styles */
var tarefas___vue_styles__ = null
/* scopeId */
var tarefas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tarefas___vue_module_identifier__ = null
var tarefas_Component = tarefas_normalizeComponent(
  tarefas,
  tarefas_tarefas,
  tarefas___vue_template_functional__,
  tarefas___vue_styles__,
  tarefas___vue_scopeId__,
  tarefas___vue_module_identifier__
)

/* harmony default export */ var features_tarefas_tarefas = (tarefas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/tarefas/tarefas/form.vue







/* harmony default export */ var tarefas_form = ({
  name: 'Form',
  data: function data() {
    return {
      usuarios: [{}],
      tarefa: {
        id: '',
        tarefa: '',
        dia: '',
        hora: '',
        usuario_id: '',
        orcamento_id: '',
        descricao: '',
        os_id: '',
        status_id: 1,
        envolvidos: [],
        anexos: []
      },
      progress: 0,
      errorFile: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-file',
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'tarefa',
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete: function complete(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.tarefa.anexos.push({ anexo: xhr.response, legenda: files.name });
        this.$nextTick(function () {
          window.Materialize.updateTextFields();
        });
        this.progress = 0;
      }
    },
    destroyAnexo: function destroyAnexo(indexAnexo) {
      var _this = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma anexo \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this.tarefa.anexos[indexAnexo].id) {
          _this.tarefa.anexos.splice(indexAnexo, 1);
          window.Materialize.toast('Anexo excluído!', 4000);
        } else {
          service_http.delete('tarefas/anexo/' + _this.tarefa.anexos[indexAnexo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Anexo excluído!', 4000);
            _this.tarefa.anexos.splice(indexAnexo, 1);
          });
        }
      });
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this2.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this2.submit();
        }
      });
    },

    selectStatus: function selectStatus(value) {
      this.tarefa.status_id = parseInt(value);
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this3.isNew ? 'post' : 'put';
                url = _this3.isNew ? '/tarefas' : '/tarefas/' + _this3.tarefa.id;
                _context.next = 4;
                return service_http[verb](url, _this3.tarefa);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this3.$emit('update-tarefas-list', { tarefa: data.tarefa });
                  _this3.$router.push({ name: 'tarefas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fecth: function fecth() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.clear();
                id = _this4.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/tarefas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this4.tarefa = data.tarefa;
                _this4.usuarios = data.usuarios;
                _context2.next = 16;
                break;

              case 11:
                _context2.next = 13;
                return service_http.get('/tarefas/create');

              case 13:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this4.usuarios = _data.usuarios;

              case 16:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    clear: function clear() {
      this.tarefa = {
        id: '',
        tarefa: '',
        dia: '',
        hora: '',
        usuario_id: '',
        orcamento_id: '',
        descricao: '',
        os_id: '',
        status_id: 1,
        anexos: [],
        envolvidos: []
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.tarefa.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },

    tarefaEnvolvidos: {
      get: function get() {
        var _this5 = this;

        return this.usuarios.filter(function (option) {
          return _this5.tarefa.envolvidos.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.tarefa.envolvidos = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e97cfea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/tarefas/tarefas/form.vue
var tarefas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tarefa.tarefa),expression:"tarefa.tarefa"}],class:{invalid: _vm.errors.has('tarefa')},attrs:{"name":"tarefa","id":"tarefa","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.tarefa.tarefa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarefa, "tarefa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"tarefa"}},[_vm._v("*Tarefa")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tarefa')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tarefa.dia),expression:"tarefa.dia"}],class:{invalid: _vm.errors.has('dia')},attrs:{"name":"dia","id":"icon_dia","type":"date","data-vv-rules":"required","data-value":_vm.tarefa.dia},domProps:{"value":(_vm.tarefa.dia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarefa, "dia", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_dia"}},[_vm._v("*Prazo dia")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('dia')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("alarm")]),_vm._v(" "),_c('input',{directives:[{name:"time",rawName:"v-time"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tarefa.hora),expression:"tarefa.hora"}],class:{invalid: _vm.errors.has('hora')},attrs:{"name":"hora","id":"icon_hora","type":"text","data-vv-rules":"required","data-value":_vm.tarefa.hora},domProps:{"value":(_vm.tarefa.hora)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarefa, "hora", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"icon_hora"}},[_vm._v("*hora")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('hora')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tarefa.os_id),expression:"tarefa.os_id"}],class:{invalid: _vm.errors.has('os_id')},attrs:{"name":"os_id","id":"os_id","type":"number","data-vv-rules":"integer"},domProps:{"value":(_vm.tarefa.os_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarefa, "os_id", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"os_id"}},[_vm._v("# OS")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('os_id')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tarefa.orcamento_id),expression:"tarefa.orcamento_id"}],class:{invalid: _vm.errors.has('orcamento_id')},attrs:{"name":"os_id","id":"orcamento_id","type":"number","data-vv-rules":"integer"},domProps:{"value":(_vm.tarefa.orcamento_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarefa, "orcamento_id", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"orcamento_id"}},[_vm._v("# Orçamento")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('orcamento_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m6"},[_c('label',[_vm._v("Usuários Envolvidos na Tarefa")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"nome_completo","track-by":"id","options":_vm.usuarios},model:{value:(_vm.tarefaEnvolvidos),callback:function ($$v) {_vm.tarefaEnvolvidos=$$v},expression:"tarefaEnvolvidos"}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"status_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tarefa.status_id),expression:"tarefa.status_id"}],attrs:{"name":"status_id","id":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tarefa, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Agendada")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Em execução")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Finalizada")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('status_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.tarefa.descricao),expression:"tarefa.descricao"}],staticClass:"materialize-textarea",attrs:{"name":"descricao","id":"descricao"},domProps:{"value":(_vm.tarefa.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarefa, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"descricao"}},[_vm._v("Descrição")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('descricao')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.tarefa.anexos),function(anexo,indexAnexo){return _c('div',{key:indexAnexo,staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/tarefa/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyAnexo(indexAnexo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card center"},[_c('span',{staticClass:"card-title"},[_vm._v("Anexo")])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.tarefa.anexo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")]),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/tarefa/" + (_vm.tarefa.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons pointer"},[_vm._v("search")])])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var tarefas_form_staticRenderFns = []
var tarefas_form_esExports = { render: tarefas_form_render, staticRenderFns: tarefas_form_staticRenderFns }
/* harmony default export */ var tarefas_tarefas_form = (tarefas_form_esExports);
// CONCATENATED MODULE: ./src/features/tarefas/tarefas/form.vue
var tarefas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tarefas_form___vue_template_functional__ = false
/* styles */
var tarefas_form___vue_styles__ = null
/* scopeId */
var tarefas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tarefas_form___vue_module_identifier__ = null
var tarefas_form_Component = tarefas_form_normalizeComponent(
  tarefas_form,
  tarefas_tarefas_form,
  tarefas_form___vue_template_functional__,
  tarefas_form___vue_styles__,
  tarefas_form___vue_scopeId__,
  tarefas_form___vue_module_identifier__
)

/* harmony default export */ var features_tarefas_tarefas_form = (tarefas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/tarefas/tarefas/routes.js




/* harmony default export */ var tarefas_routes = ([{
  path: '/tarefas/:filtro?',
  name: 'tarefas.index',
  component: features_tarefas_tarefas,
  children: [{
    path: 'form/:id?',
    name: 'tarefas.form',
    component: features_tarefas_tarefas_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/marcas/index.vue








/* harmony default export */ var marcas = ({
  name: 'Marcas',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/marcas?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/marcas?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var marca, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                marca = obj.marca;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: marca.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, marca);
                } else {
                  _this3.list.unshift(marca);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(marca) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + marca.marca + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/marcas/' + marca.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: marca.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'marcas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'marcas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5432e6ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/marcas/index.vue
var marcas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('marca.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('marca.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'marcas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'marcas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-marcas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(marca){return _c('tr',[_c('td',[_vm._v(_vm._s(marca.id))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('marca.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'marcas.form', params: { id: marca.id } }}},[_vm._v("\n                "+_vm._s(marca.marca)+"\n                "),(marca.tipo === 1)?_c('small',[_c('br'),_vm._v(_vm._s(marca.responsavel))]):_vm._e()]):_c('span',[_vm._v(_vm._s(marca.marca))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('marca.editar') > -1),expression:"permissoes.indexOf('marca.editar') > -1"}],attrs:{"to":{ name: 'marcas.form', params: { id: marca.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('marca.excluir') > -1),expression:"permissoes.indexOf('marca.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(marca)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var marcas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Marcas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Marca")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var marcas_esExports = { render: marcas_render, staticRenderFns: marcas_staticRenderFns }
/* harmony default export */ var features_marcas = (marcas_esExports);
// CONCATENATED MODULE: ./src/features/marcas/index.vue
var marcas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marcas___vue_template_functional__ = false
/* styles */
var marcas___vue_styles__ = null
/* scopeId */
var marcas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var marcas___vue_module_identifier__ = null
var marcas_Component = marcas_normalizeComponent(
  marcas,
  features_marcas,
  marcas___vue_template_functional__,
  marcas___vue_styles__,
  marcas___vue_scopeId__,
  marcas___vue_module_identifier__
)

/* harmony default export */ var src_features_marcas = (marcas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/marcas/form.vue







/* harmony default export */ var marcas_form = ({
  name: 'Form',
  data: function data() {
    return {
      unidades: [{}],
      marca: {
        id: '',
        marca: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/marcas' : '/marcas/' + _this2.marca.id;
                _context.next = 4;
                return service_http[verb](url, _this2.marca);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-marcas-list', { marca: data.marca });
                  _this2.$router.push({ name: 'marcas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/marcas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.marca = data.marca;
                _this3.unidades = data.unidades;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.marca = {
        id: '',
        marca: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.marca.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8410e33e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/marcas/form.vue
var marcas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.marca.marca),expression:"marca.marca"}],class:{invalid: _vm.errors.has('marca')},attrs:{"name":"marca","id":"marca","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.marca.marca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.marca, "marca", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"marca"}},[_vm._v("*Marca")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('marca')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var marcas_form_staticRenderFns = []
var marcas_form_esExports = { render: marcas_form_render, staticRenderFns: marcas_form_staticRenderFns }
/* harmony default export */ var features_marcas_form = (marcas_form_esExports);
// CONCATENATED MODULE: ./src/features/marcas/form.vue
var marcas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var marcas_form___vue_template_functional__ = false
/* styles */
var marcas_form___vue_styles__ = null
/* scopeId */
var marcas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var marcas_form___vue_module_identifier__ = null
var marcas_form_Component = marcas_form_normalizeComponent(
  marcas_form,
  features_marcas_form,
  marcas_form___vue_template_functional__,
  marcas_form___vue_styles__,
  marcas_form___vue_scopeId__,
  marcas_form___vue_module_identifier__
)

/* harmony default export */ var src_features_marcas_form = (marcas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/marcas/routes.js



/* harmony default export */ var marcas_routes = ([{
  path: '/marcas',
  name: 'marcas.index',
  component: src_features_marcas,
  children: [{
    path: 'form/:id?',
    name: 'marcas.form',
    component: src_features_marcas_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/vendas/vendas/index.vue









/* harmony default export */ var vendas = ({
  name: 'Vendas',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY HH:mm');
    },
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/vendas?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/vendas?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var venda, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                venda = obj.venda;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: venda.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, venda);
                } else {
                  _this3.list.unshift(venda);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(venda) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + venda.id + '?',
        html: 'Esta operação é irreversível, vai apagar registros financeiros e restabelecer estoques',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/vendas/' + venda.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: venda.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'vendas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'vendas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17068b3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/vendas/vendas/index.vue
var vendas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('venda.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('venda.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'vendas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'vendas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-vendas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(venda){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('venda.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'vendas.form', params: { id: venda.id } }}},[_vm._v("\n                "+_vm._s(venda.id)+"\n              ")]):_c('span',[_vm._v(_vm._s(venda.id))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(venda.created_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.canal ? venda.canal.canal : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.usuario ? venda.usuario.nome_completo : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.valor))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/venda/" + (venda.id) + "/pdf"),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('venda.editar') > -1),expression:"permissoes.indexOf('venda.editar') > -1"}],attrs:{"to":{ name: 'vendas.form', params: { id: venda.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('venda.excluir') > -1),expression:"permissoes.indexOf('venda.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(venda)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var vendas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Vendas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Canal")]),_vm._v(" "),_c('th',[_vm._v("Usuário")]),_vm._v(" "),_c('th',[_vm._v("R$ Valor")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var vendas_esExports = { render: vendas_render, staticRenderFns: vendas_staticRenderFns }
/* harmony default export */ var vendas_vendas = (vendas_esExports);
// CONCATENATED MODULE: ./src/features/vendas/vendas/index.vue
var vendas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var vendas___vue_template_functional__ = false
/* styles */
var vendas___vue_styles__ = null
/* scopeId */
var vendas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vendas___vue_module_identifier__ = null
var vendas_Component = vendas_normalizeComponent(
  vendas,
  vendas_vendas,
  vendas___vue_template_functional__,
  vendas___vue_styles__,
  vendas___vue_scopeId__,
  vendas___vue_module_identifier__
)

/* harmony default export */ var features_vendas_vendas = (vendas_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__("RyI1");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/vendas/vendas/form.vue









/* harmony default export */ var vendas_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      produtos: [],
      produtosSearch: [],
      familias: [],
      contas: [],
      canais: [],
      familia_id: '',
      venda: {
        id: '',
        venda: '',
        desconto: 0,
        canal_id: '',
        produtos: [],
        pagamentos: []
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    valor_total: function valor_total() {
      this.venda.valor = this.valor_total;
    },
    familia_id: function familia_id() {
      if (this.familia_id) {
        this.produtosSearch = filter_default()(this.produtos, { 'familia_id': this.familia_id });
      } else {
        this.produtosSearch = this.produtos;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/vendas' : '/vendas/' + _this2.venda.id;
                _context.next = 4;
                return service_http[verb](url, _this2.venda);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-vendas-list', { venda: data.venda });
                  _this2.$router.push({ name: 'vendas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/vendas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.venda = data.venda;
                _this3.produtos = data.produtos;
                _this3.produtosSearch = data.produtos;
                _this3.familias = data.familias;
                _this3.contas = data.contas;
                _this3.canais = data.canais;
                _context2.next = 24;
                break;

              case 15:
                _context2.next = 17;
                return service_http.get('/vendas/create');

              case 17:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.produtos = _data.produtos;
                _this3.produtosSearch = _data.produtos;
                _this3.familias = _data.familias;
                _this3.contas = _data.contas;
                _this3.canais = _data.canais;

              case 24:
                setTimeout(function () {
                  $('select').material_select();
                  window.Materialize.updateTextFields();
                }, 0);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.venda = {
        id: '',
        venda: '',
        desconto: 0,
        canal_id: '',
        produtos: [],
        pagamentos: []
      };
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        var produto = {
          produto_id: item.id,
          produto: item,
          valor: item.valor_venda,
          qtd: 1
        };
        this.addProduto(produto);
      }
    },
    addProduto: function addProduto(produto) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (typeof _this4.venda.produtos === 'undefined') {
                  _this4.venda.produtos = [];
                }
                _context3.next = 3;
                return _this4.venda.produtos.push(produto);

              case 3:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    destroyProduto: function destroyProduto(indexProduto) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um Produto \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this5.venda.produtos[indexProduto].id) {
          _this5.venda.produtos.splice(indexProduto, 1);
          window.Materialize.toast('Produto excluído!', 4000);
        } else {
          service_http.delete('vendas/produto/' + _this5.venda.produtos[indexProduto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Produto excluído!', 4000);
            _this5.venda.produtos.splice(indexProduto, 1);
          });
        }
      });
    },
    destroyPagamento: function destroyPagamento(index) {
      var _this6 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um forma de pagamento \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        _this6.venda.pagamentos.splice(index, 1);
        window.Materialize.toast('Pagamento excluído!', 4000);
      });
    },
    addPagamento: function addPagamento() {
      var pagamento = {
        forma_id: '',
        conta_id: '',
        valor: parseFloat(this.valor_total - this.pagamentoTotal).toFixed(2),
        parcelas: 1
      };
      this.venda.pagamentos.push(pagamento);
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 0);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.venda.id === '';
    },
    valor_total: function valor_total() {
      var valor = 0;
      var desconto = this.venda.desconto ? this.venda.desconto : 0;
      this.venda.produtos.forEach(function (produto) {
        valor += parseFloat(produto.valor) * parseInt(produto.qtd);
      });
      return parseFloat(parseFloat(valor).toFixed(2) - parseFloat(desconto).toFixed(2)).toFixed(2);
    },
    pagamentoTotal: function pagamentoTotal() {
      var valor = 0;
      if (this.venda.pagamentos.length > 0) {
        this.venda.pagamentos.forEach(function (item) {
          if (item.valor) {
            valor += parseFloat(item.valor);
          }
        });
      }
      return parseFloat(valor).toFixed(2);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc677214","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/vendas/vendas/form.vue
var vendas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.venda.canal_id),expression:"venda.canal_id"},{name:"validate",rawName:"v-validate"}],staticClass:"browser-default",class:{invalid: _vm.errors.has('canal_id')},attrs:{"disabled":!_vm.isNew,"name":"canal_id","id":"canal_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.venda, "canal_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Canal de Venda")]),_vm._v(" "),_vm._l((_vm.canais),function(canal){return _c('option',{domProps:{"value":canal.id}},[_vm._v(_vm._s(canal.canal))])})],2),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('canal_id')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.familia_id),expression:"familia_id"}],staticClass:"browser-default",attrs:{"name":"familia_id","id":"familia_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.familia_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Família")]),_vm._v(" "),_vm._l((_vm.familias),function(familia){return _c('option',{domProps:{"value":familia.id}},[_vm._v(_vm._s(familia.familia))])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.produtosSearch,"option-value":"id","option-text":"produto","placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.venda.produtos && _vm.venda.produtos.length > 0),expression:"venda.produtos && venda.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_c('tr',[_c('th',[_vm._v("Produtos ")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"right-align"},[_vm._v("Excluir")])]),_vm._v(" "),_vm._l((_vm.venda.produtos),function(produto,indexProduto){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((produto.produto) ? produto.produto.produto : '-'))])]),_vm._v(" "),_c('td',[(!produto.hasOwnProperty('id'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1"},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1","readonly":""},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[(!produto.hasOwnProperty('id'))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.valor),expression:"produto.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","step":"any","id":("valorProduto" + indexProduto),"min":"1"},domProps:{"value":(produto.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "valor", $event.target.value)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.valor),expression:"produto.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","step":"any","id":("valorProduto" + indexProduto),"min":"1","readonly":""},domProps:{"value":(produto.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","step":"any","id":("valorTotalProduto" + indexProduto),"readonly":""},domProps:{"value":parseFloat(produto.valor * produto.qtd).toFixed(2)}})]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}]},[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(indexProduto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.venda.valor),expression:"venda.valor"}],attrs:{"name":"valor","id":"valor","type":"hidden"},domProps:{"value":(_vm.venda.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.venda, "valor", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('p',[_vm._v("Total Venda")]),_vm._v(" "),_c('h2',[_vm._v("R$ "+_vm._s(_vm.venda.valor ? _vm.venda.valor : '0,00'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.venda.produtos.length),expression:"venda.produtos.length"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.venda.desconto),expression:"venda.desconto"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('desconto')},attrs:{"disabled":!_vm.isNew,"type":"number","step":"0.01","name":"desconto","id":"desconto","data-vv-rules":"required"},domProps:{"value":(_vm.venda.desconto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.venda, "desconto", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"`desconto`"}},[_vm._v("Desconto")])])]),_vm._v(" "),_vm._l((_vm.venda.pagamentos),function(pagamento,index){return _c('div',{staticClass:"row z-depth-1"},[_c('div',{staticClass:"input-field col s12 m6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(pagamento.forma_id),expression:"pagamento.forma_id"},{name:"validate",rawName:"v-validate"}],staticClass:"browser-default",class:{invalid: _vm.errors.has('forma' + index)},attrs:{"disabled":!_vm.isNew,"name":("forma" + index),"id":"forma{index}","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(pagamento, "forma_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Forma de Pagamento")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Dinheiro")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("Crédito")]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v("Débito")]),_vm._v(" "),_c('option',{domProps:{"value":4}},[_vm._v("Cheque")]),_vm._v(" "),_c('option',{domProps:{"value":5}},[_vm._v("Transferência")]),_vm._v(" "),_c('option',{domProps:{"value":6}},[_vm._v("Boleto")])]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('forma'+index)))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(pagamento.valor),expression:"pagamento.valor"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('valor' + index)},attrs:{"disabled":!_vm.isNew,"type":"number","step":"any","name":("valor" + index),"id":("valor" + index),"data-vv-rules":"required"},domProps:{"value":(pagamento.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pagamento, "valor", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("valor" + index)}},[_vm._v("Valor")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor'+index)))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(pagamento.conta_id),expression:"pagamento.conta_id"},{name:"validate",rawName:"v-validate"}],staticClass:"browser-default",class:{invalid: _vm.errors.has('conta' + index)},attrs:{"disabled":!_vm.isNew,"name":("conta" + index),"id":"conta{index}","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(pagamento, "conta_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Conta Bancária")]),_vm._v(" "),_vm._l((_vm.contas),function(conta){return _c('option',{domProps:{"value":conta.id}},[_vm._v(_vm._s(conta.conta))])})],2),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('conta'+index)))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m6"},[(pagamento.forma_id !== 1 && pagamento.forma_id !== 3 && pagamento.forma_id !== 5)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(pagamento.parcelas),expression:"pagamento.parcelas"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('parcelas' + index)},attrs:{"disabled":!_vm.isNew,"type":"number","min":"1","name":("parcelas" + index),"id":("parcelas" + index),"data-vv-rules":"required"},domProps:{"value":(pagamento.parcelas)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pagamento, "parcelas", $event.target.value)}}}):_vm._e(),_vm._v(" "),(pagamento.forma_id === 1 || pagamento.forma_id === 3 || pagamento.forma_id === 5)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(pagamento.parcelas),expression:"pagamento.parcelas"}],attrs:{"readonly":"","type":"number","name":("parcelas" + index),"id":("parcelas" + index),"value":"1"},domProps:{"value":(pagamento.parcelas)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pagamento, "parcelas", $event.target.value)}}}):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":("parcelas" + index)}},[_vm._v("N. Parcelas")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('parcelas'+index)))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"col s12 right-align"},[_c('i',{staticClass:"pointer material-icons red-text",on:{"click":function($event){$event.preventDefault();return _vm.destroyPagamento(index)}}},[_vm._v("delete_forever")])])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(parseFloat(_vm.valor_total) !== parseFloat(_vm.pagamentoTotal)),expression:"parseFloat(valor_total) !== parseFloat(pagamentoTotal)"}],staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('span',{staticClass:"red-text"},[_vm._v("Valor total das parcelas "),_c('strong',[_vm._v("R$ "+_vm._s(parseFloat(_vm.pagamentoTotal).toFixed(2)))]),_vm._v(" não corresponde com o valor da Venda "),_c('strong',[_vm._v("R$ "+_vm._s(parseFloat(_vm.valor_total).toFixed(2)))])])])]),_vm._v(" "),(parseFloat(_vm.valor_total) > _vm.pagamentoTotal)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",on:{"click":function($event){$event.preventDefault();return _vm.addPagamento.apply(null, arguments)}}},[_vm._v("Adicionar Forma de Pagamento")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNew),expression:"isNew"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":parseFloat(_vm.valor_total) !== parseFloat(_vm.pagamentoTotal)}},[_vm._v("Salvar")])])])],2)])])])])])])}
var vendas_form_staticRenderFns = []
var vendas_form_esExports = { render: vendas_form_render, staticRenderFns: vendas_form_staticRenderFns }
/* harmony default export */ var vendas_vendas_form = (vendas_form_esExports);
// CONCATENATED MODULE: ./src/features/vendas/vendas/form.vue
var vendas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var vendas_form___vue_template_functional__ = false
/* styles */
var vendas_form___vue_styles__ = null
/* scopeId */
var vendas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vendas_form___vue_module_identifier__ = null
var vendas_form_Component = vendas_form_normalizeComponent(
  vendas_form,
  vendas_vendas_form,
  vendas_form___vue_template_functional__,
  vendas_form___vue_styles__,
  vendas_form___vue_scopeId__,
  vendas_form___vue_module_identifier__
)

/* harmony default export */ var features_vendas_vendas_form = (vendas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/vendas/vendas/routes.js



/* harmony default export */ var vendas_routes = ([{
  path: '/vendas',
  name: 'vendas.index',
  component: features_vendas_vendas,
  children: [{
    path: 'form/:id?',
    name: 'vendas.form',
    component: features_vendas_vendas_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/compras/compras/index.vue









moment_default.a.locale('pt-br');
/* harmony default export */ var compras = ({
  name: 'Compras',
  data: function data() {
    return {
      list: [],
      modal: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/compras?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/compras?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var compra, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                compra = obj.compra;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: compra.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, compra);
                } else {
                  _this3.list.unshift(compra);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(compra) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + compra.nome + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/compras/' + compra.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: compra.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM HH:mm');
    },
    formatDateFrom: function formatDateFrom(date) {
      return moment_default()(date).fromNow();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'compras.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'compras.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a88e191c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/compras/compras/index.vue
var compras_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('compra.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('compra.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'compras.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'compras.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-compras-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(compra){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('compra.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'compras.form', params: { id: compra.id } }}},[_vm._v(_vm._s(compra.id)+"\n              ")]):_c('span',[_vm._v(_vm._s(compra.id))])],1),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(_vm.formatDate(compra.created_at))+"\n              "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.formatDateFrom(compra.created_at)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s((compra.usuario) ? compra.usuario.nome_completo : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((compra.fornecedor) ? compra.fornecedor.fornecedor : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((compra.status) ? compra.status.status : '-'))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/compra/" + (compra.id) + "/pdf"),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('compra.editar') > -1),expression:"permissoes.indexOf('compra.editar') > -1"}],attrs:{"to":{ name: 'compras.form', params: { id: compra.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('compra.excluir') > -1),expression:"permissoes.indexOf('compra.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(compra)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var compras_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Compras")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Solicitante")]),_vm._v(" "),_c('th',[_vm._v("Fornecedor")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var compras_esExports = { render: compras_render, staticRenderFns: compras_staticRenderFns }
/* harmony default export */ var compras_compras = (compras_esExports);
// CONCATENATED MODULE: ./src/features/compras/compras/index.vue
var compras_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var compras___vue_template_functional__ = false
/* styles */
var compras___vue_styles__ = null
/* scopeId */
var compras___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var compras___vue_module_identifier__ = null
var compras_Component = compras_normalizeComponent(
  compras,
  compras_compras,
  compras___vue_template_functional__,
  compras___vue_styles__,
  compras___vue_scopeId__,
  compras___vue_module_identifier__
)

/* harmony default export */ var features_compras_compras = (compras_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/compras/compras/form.vue



//




/* harmony default export */ var compras_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      fornecedores: [],
      status: [],
      pagamentos: [],
      produtos: [],
      itemProduto: {
        id: '',
        produto: '',
        valor: '',
        qtd: ''
      },
      itemFornecedor: {
        id: '',
        fornecedor: ''
      },
      compra: {
        id: '',
        fornecedor_id: '',
        valor_frete: '',
        pagamento_id: '',
        prazo_entrega: '',
        obs: '',
        norma: '',
        status_id: 1,
        produtos: [],
        anexos: []
      },
      progress3: 0,
      errorFile3: false,
      options3: {
        url: "https://sistemakgb.com.br/v1" + '/upload-file',
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'compras',
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    }
  },
  methods: {
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data, _ref2, _data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.clear();
                id = _this.$route.params.id;

                if (!(id !== undefined)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 5;
                return service_http.get('/compras/' + id + '/edit');

              case 5:
                _ref = _context.sent;
                data = _ref.data;

                _this.compra = data.compra;
                _this.status = data.status;
                _this.pagamentos = data.pagamentos;
                _this.produtos = data.produtos;
                _this.fornecedores = data.fornecedores;
                _context.next = 22;
                break;

              case 14:
                _context.next = 16;
                return service_http.get('/compras/create');

              case 16:
                _ref2 = _context.sent;
                _data = _ref2.data;

                _this.status = _data.status;
                _this.pagamentos = _data.pagamentos;
                _this.produtos = _data.produtos;
                _this.fornecedores = _data.fornecedores;

              case 22:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this2.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        }
        _this2.submit();
      });
    },
    submit: function submit() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var verb, url, _ref3, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verb = _this3.isNew ? 'post' : 'put';
                url = _this3.isNew ? '/compras' : '/compras/' + _this3.compra.id;
                _context2.next = 4;
                return service_http[verb](url, _this3.compra);

              case 4:
                _ref3 = _context2.sent;
                data = _ref3.data;

                if (data != null) {
                  if (_this3.gerar_os === true && _this3.compra.status_id === 5) {
                    _this3.$router.push({ name: 'os.compra', params: { id: data.compra.id } });
                  } else {
                    _this3.$emit('update-compras-list', { compra: data.compra });
                    _this3.$router.push({ name: 'compras.index' });
                  }
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.compra = {
        id: '',
        fornecedor_id: '',
        valor_frete: '',
        pagamento_id: '',
        prazo_entrega: '',
        obs: '',
        norma: '',
        status_id: 1,
        produtos: [],
        anexos: []
      };
    },
    totalProgress3: function totalProgress3(progress, totalBytes, bytesSent) {
      this.progress3 = progress;
    },
    complete3: function complete3(files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        this.compra.anexos.push({ anexo: xhr.response, legenda: files.name });
        this.$nextTick(function () {
          window.Materialize.updateTextFields();
        });
        this.progress = 0;
      }
    },
    destroyAnexo: function destroyAnexo(indexAnexo) {
      var _this4 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma anexo \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this4.compra.anexos[indexAnexo].id) {
          _this4.compra.anexos.splice(indexAnexo, 1);
          window.Materialize.toast('Anexo excluído!', 4000);
        } else {
          service_http.delete('compras/anexo/' + _this4.compra.anexos[indexAnexo].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Anexo excluído!', 4000);
            _this4.compra.anexos.splice(indexAnexo, 1);
          });
        }
      });
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        var produto = {
          produto_id: item.id,
          produto: item,
          valor: item.valor_compra,
          qtd: 1
        };
        this.addProduto(produto);
      }
    },
    addProduto: function addProduto(produto) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.compra.produtos.push(produto);

              case 2:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    destroyProduto: function destroyProduto(indexProduto) {
      var _this6 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um Produto \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this6.compra.produtos[indexProduto].id) {
          _this6.compra.produtos.splice(indexProduto, 1);
          window.Materialize.toast('Produto excluído!', 4000);
        } else {
          service_http.delete('compras/produto/' + _this6.compra.produtos[indexProduto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Produto excluído!', 4000);
            _this6.compra.produtos.splice(indexProduto, 1);
          });
        }
      });
    },
    valor_total: function valor_total() {
      var valor = 0;
      var frete = this.compra.valor_frete ? this.compra.valor_frete : 0;
      if (typeof this.compra.produtos !== 'undefined') {
        this.compra.produtos.forEach(function (produto) {
          valor += parseFloat(produto.valor) * parseInt(produto.qtd);
        });
      }
      return parseFloat(parseFloat(valor) + parseFloat(frete)).toFixed(2);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    isNew: function isNew() {
      return this.compra.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    url_app: function url_app() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c73640a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/compras/compras/form.vue
var compras_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"pagamento_id"}},[_vm._v("Fornecedor")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.compra.fornecedor_id),expression:"compra.fornecedor_id"}],attrs:{"name":"fornecedor","id":"fornecedor"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.compra, "fornecedor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.fornecedores),function(fornecedor){return _c('option',{domProps:{"value":fornecedor.id}},[_vm._v(_vm._s(fornecedor.fornecedor))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('pagamento_id')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m3"},[_c('label',{attrs:{"for":"pagamento_id"}},[_vm._v("Condição de Pagamento")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.compra.pagamento_id),expression:"compra.pagamento_id"}],attrs:{"name":"pagamento_id","id":"pagamento_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.compra, "pagamento_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.pagamentos),function(pagamento){return _c('option',{domProps:{"value":pagamento.id}},[_vm._v(_vm._s(pagamento.pagamento))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('pagamento_id')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.compra.prazo_entrega),expression:"compra.prazo_entrega"}],attrs:{"name":"prazo_entrega","id":"prazo_entrega","type":"text"},domProps:{"value":(_vm.compra.prazo_entrega)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.compra, "prazo_entrega", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"prazo_entrega"}},[_vm._v("Prazo de Entrega")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('prazo_entrega')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.compra.valor_frete),expression:"compra.valor_frete"}],attrs:{"name":"valor_frete","id":"valor_frete","type":"number","step":"any"},domProps:{"value":(_vm.compra.valor_frete)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.compra, "valor_frete", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_frete"}},[_vm._v("R$ Frete")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('valor_frete')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12",on:{"click":function($event){return _vm.setPropostaIndex(_vm.indexProposta)}}},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","selected-item":_vm.itemProduto,"placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.compra.produtos && _vm.compra.produtos.length > 0),expression:"compra.produtos && compra.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.compra.produtos),function(produto,indexProduto){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((produto.produto) ? produto.produto.produto : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.ipi),expression:"produto.ipi"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","step":"any","id":("ipi" + indexProduto),"min":"1"},domProps:{"value":(produto.ipi)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "ipi", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1"},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.valor),expression:"produto.valor"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","step":"any","id":("valorProduto" + indexProduto),"min":"1"},domProps:{"value":(produto.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "valor", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","step":"any","id":("valorTotalProduto" + indexProduto),"readonly":""},domProps:{"value":parseFloat(produto.valor * produto.qtd).toFixed(2)}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(indexProduto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3 offset-m9"},[_c('input',{attrs:{"name":"valor_total","id":"valor_total","type":"number","step":"any","min":"0","readonly":""},domProps:{"value":_vm.valor_total()}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_total"}},[_vm._v("Valor Total")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.compra.obs),expression:"compra.obs"}],staticClass:"materialize-textarea",attrs:{"name":"obs","id":"obs"},domProps:{"value":(_vm.compra.obs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.compra, "obs", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_total"}},[_vm._v("Obs")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('obs')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.compra.norma),expression:"compra.norma"}],staticClass:"materialize-textarea",attrs:{"name":"norma","id":"norma"},domProps:{"value":(_vm.compra.norma)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.compra, "norma", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"valor_total"}},[_vm._v("Conforme Norma")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('norma')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('vue-clip',{attrs:{"options":_vm.options3,"on-complete":_vm.complete3,"on-total-progress":_vm.totalProgress3}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card center"},[_c('span',{staticClass:"card-title"},[_vm._v("Anexos")])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress3 + "%"))})]),_vm._v(" "),(_vm.errorFile3)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e(),_vm._v(" "),(_vm.compra.anexo)?_c('div',{staticClass:"center-align"},[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")]),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/compras/" + (_vm.compra.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons pointer"},[_vm._v("search")])])]):_vm._e()])])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.compra.anexos),function(anexo,indexAnexo){return _c('div',{staticClass:"col s12 m6 center-align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":(_vm.api_url + "/compras/" + (anexo.anexo)),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(anexo.legenda),expression:"anexo.legenda"}],attrs:{"name":"legenda","id":("legenda-" + indexAnexo),"type":"text"},domProps:{"value":(anexo.legenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(anexo, "legenda", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":("legenda-" + indexAnexo)}},[_vm._v("Legenda")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyAnexo(indexAnexo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])]),_vm._v(" "),_c('br',{attrs:{"clear":"all"}})])}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"status_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.compra.status_id),expression:"compra.status_id"}],attrs:{"name":"status_id","id":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.compra, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.status),function(status){return _c('option',{domProps:{"value":status.id}},[_vm._v(_vm._s(status.status))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('status_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_vm._v("Salvar")])])])])])])])}
var compras_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Produtos da Compra")]),_vm._v(" "),_c('th',[_vm._v("% IPI")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])}]
var compras_form_esExports = { render: compras_form_render, staticRenderFns: compras_form_staticRenderFns }
/* harmony default export */ var compras_compras_form = (compras_form_esExports);
// CONCATENATED MODULE: ./src/features/compras/compras/form.vue
var compras_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var compras_form___vue_template_functional__ = false
/* styles */
var compras_form___vue_styles__ = null
/* scopeId */
var compras_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var compras_form___vue_module_identifier__ = null
var compras_form_Component = compras_form_normalizeComponent(
  compras_form,
  compras_compras_form,
  compras_form___vue_template_functional__,
  compras_form___vue_styles__,
  compras_form___vue_scopeId__,
  compras_form___vue_module_identifier__
)

/* harmony default export */ var features_compras_compras_form = (compras_form_Component.exports);

// CONCATENATED MODULE: ./src/features/compras/compras/routes.js




/* harmony default export */ var compras_routes = ([{
  path: '/compras',
  name: 'compras.index',
  component: features_compras_compras,
  children: [{
    path: 'form/:id?',
    name: 'compras.form',
    component: features_compras_compras_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/os/revisao-tipo/index.vue








/* harmony default export */ var revisao_tipo = ({
  name: 'TipoRevisao',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/revisao-tipos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/revisao-tipos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var revisao, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                revisao = obj.revisao;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: revisao.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, revisao);
                } else {
                  _this3.list.unshift(revisao);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(revisao) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + revisao.tipo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/revisao-tipos/' + revisao.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: revisao.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'revisao-tipos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'revisao-tipos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3992d20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/os/revisao-tipo/index.vue
var revisao_tipo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('revisao-tipo.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('revisao-tipo.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'revisao-tipos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'revisao-tipos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-revisao-tipos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(revisao){return _c('tr',[_c('td',[_vm._v(_vm._s(revisao.id))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('revisao-tipo.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'revisao-tipos.form', params: { id: revisao.id } }}},[_vm._v("\n                "+_vm._s(revisao.tipo)+"\n              ")]):_c('span',[_vm._v(_vm._s(revisao.tipo))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('revisao-tipo.editar') > -1),expression:"permissoes.indexOf('revisao-tipo.editar') > -1"}],attrs:{"to":{ name: 'revisao-tipos.form', params: { id: revisao.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('revisao-tipo.excluir') > -1),expression:"permissoes.indexOf('revisao-tipo.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(revisao)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var revisao_tipo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Tipo Revisão")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Marca")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var revisao_tipo_esExports = { render: revisao_tipo_render, staticRenderFns: revisao_tipo_staticRenderFns }
/* harmony default export */ var os_revisao_tipo = (revisao_tipo_esExports);
// CONCATENATED MODULE: ./src/features/os/revisao-tipo/index.vue
var revisao_tipo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var revisao_tipo___vue_template_functional__ = false
/* styles */
var revisao_tipo___vue_styles__ = null
/* scopeId */
var revisao_tipo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var revisao_tipo___vue_module_identifier__ = null
var revisao_tipo_Component = revisao_tipo_normalizeComponent(
  revisao_tipo,
  os_revisao_tipo,
  revisao_tipo___vue_template_functional__,
  revisao_tipo___vue_styles__,
  revisao_tipo___vue_scopeId__,
  revisao_tipo___vue_module_identifier__
)

/* harmony default export */ var features_os_revisao_tipo = (revisao_tipo_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var lodash_clone = __webpack_require__("rezj");
var clone_default = /*#__PURE__*/__webpack_require__.n(lodash_clone);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/os/revisao-tipo/form.vue










/* harmony default export */ var revisao_tipo_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      servicos: [],
      revisao: {
        id: '',
        tipo: '',
        itens: []
      },
      item: {
        inspecao: '',
        criterio: '',
        ocorrencia: '',
        ordem: null,
        servico_id: '',
        servico: {}
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/revisao-tipos' : '/revisao-tipos/' + _this2.revisao.id;
                _context.next = 4;
                return service_http[verb](url, _this2.revisao);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-revisao-tipos-list', { revisao: data.revisao });
                  _this2.$router.push({ name: 'revisao-tipos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/revisao-tipos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.revisao = data.revisao;
                _this3.servicos = data.servicos;
                _context2.next = 16;
                break;

              case 11:
                _context2.next = 13;
                return service_http.get('/revisao-tipos/create');

              case 13:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.servicos = _data.servicos;

              case 16:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.revisao = {
        id: '',
        tipo: '',
        itens: []
      };
    },

    validateItem: function validateItem() {
      var _this4 = this;

      this.$validator.validateAll('form-item').then(function (result) {
        if (result) {
          _this4.revisao.itens.push(clone_default()(_this4.item));
          _this4.$nextTick(function () {
            for (var key in _this4.item) {
              if (_this4.item.hasOwnProperty(key)) {
                _this4.item[key] = '';
              }
            }
            _this4.$validator.pause();
            _this4.$nextTick(function () {
              _this4.$validator.reset();
              _this4.$validator.errors.clear();
              _this4.$validator.resume();
              window.Materialize.updateTextFields();
            });
          });
          _this4.item = {
            inspecao: '',
            ordem: null,
            servico_id: '',
            servico: {}
          };
        }
      });
    },
    destroyItem: function destroyItem(index) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um Item \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this5.revisao.itens[index].id) {
          _this5.revisao.itens.splice(index, 1);
          window.Materialize.toast('Item excluído!', 4000);
        } else {
          service_http.delete('/revisao-itens/' + _this5.revisao.itens[index].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Item excluído!', 4000);
            _this5.revisao.itens.splice(index, 1);
          });
        }
      });
    },

    truncate: function truncate() {
      var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return truncate_default()(string);
    },
    onSelectServico: function onSelectServico(servico) {
      if (servico) {
        this.item.servico_id = servico.id;
        this.item.servico = servico;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.revisao.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91d72bce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/os/revisao-tipo/form.vue
var revisao_tipo_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.revisao.tipo),expression:"revisao.tipo"}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.revisao.tipo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.revisao, "tipo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.revisao.itens),function(item,index){return (_vm.revisao.itens.length > 0)?_c('tr',[_c('td',[_vm._v(_vm._s(item.inspecao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.truncate(item.criterio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.truncate(item.ocorrencia)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ordem))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.servico ? item.servico.servico : '-'))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"material-icons pointer red-text",on:{"click":function($event){$event.preventDefault();return _vm.destroyItem(index)}}},[_vm._v("delete_forever")])])]):_vm._e()}),_vm._v(" "),(_vm.revisao.itens.length === 0)?_c('tr',[_c('td',{staticClass:"center-align",attrs:{"colspan":"6"}},[_vm._v("Nenhum item cadastrado!")])]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])]),_vm._v(" "),_c('form',{staticClass:"col s12 m10 offset-m1",attrs:{"data-vv-scope":"form-item"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.inspecao),expression:"item.inspecao"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('form-item.inspecao')},attrs:{"name":"inspecao","id":"inspecao","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.item.inspecao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "inspecao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"inspecao"}},[_vm._v("*Inspeção")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('form-item.inspecao')),expression:"errors.has('form-item.inspecao')"}],staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('form-item.inspecao'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2 input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.ordem),expression:"item.ordem"},{name:"validate",rawName:"v-validate"}],class:{invalid: _vm.errors.has('form-item.ordem')},attrs:{"name":"ordem","id":"ordem","type":"number","min":"1","data-vv-rules":"required"},domProps:{"value":(_vm.item.ordem)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "ordem", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ordem"}},[_vm._v("*Ordem")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('form-item.ordem')),expression:"errors.has('form-item.ordem')"}],staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('form-item.ordem')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 input-field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.criterio),expression:"item.criterio"},{name:"validate",rawName:"v-validate"}],staticClass:"materialize-textarea",class:{invalid: _vm.errors.has('form-item.criterio')},attrs:{"name":"criterio","id":"criterio","data-vv-rules":"required"},domProps:{"value":(_vm.item.criterio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "criterio", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"criterio"}},[_vm._v("*Critério")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('form-item.criterio')),expression:"errors.has('form-item.criterio')"}],staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('form-item.criterio'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col s12 input-field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.ocorrencia),expression:"item.ocorrencia"},{name:"validate",rawName:"v-validate"}],staticClass:"materialize-textarea",class:{invalid: _vm.errors.has('form-item.ocorrencia')},attrs:{"name":"ocorrencia","id":"ocorrencia","data-vv-rules":"required"},domProps:{"value":(_vm.item.ocorrencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "ocorrencia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ocorrencia"}},[_vm._v("*Ocorrência")]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('form-item.ocorrencia')),expression:"errors.has('form-item.ocorrencia')"}],staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('form-item.ocorrencia'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.servico.servico),expression:"item.servico.servico"}],attrs:{"name":"servico","id":"servico","type":"text","placeholder":"Serviço","disabled":""},domProps:{"value":(_vm.item.servico.servico)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item.servico, "servico", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('list-select',{attrs:{"list":_vm.servicos,"option-value":"id","option-text":"servico","selected-item":_vm.item,"placeholder":"Adicionar Serviço"},on:{"select":_vm.onSelectServico}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect blue waves-light btn",attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.validateItem.apply(null, arguments)}}},[_vm._v("Adicionar")]),_vm._v(" "),_c('small',[_vm._v("*Para persistir o item adicionado é necessario salvar")])])])])])}
var revisao_tipo_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Inspeção")]),_vm._v(" "),_c('th',[_vm._v("Critério")]),_vm._v(" "),_c('th',[_vm._v("Ocorrência")]),_vm._v(" "),_c('th',[_vm._v("Ordem")]),_vm._v(" "),_c('th',[_vm._v("Serviço")]),_vm._v(" "),_c('th')])}]
var revisao_tipo_form_esExports = { render: revisao_tipo_form_render, staticRenderFns: revisao_tipo_form_staticRenderFns }
/* harmony default export */ var os_revisao_tipo_form = (revisao_tipo_form_esExports);
// CONCATENATED MODULE: ./src/features/os/revisao-tipo/form.vue
var revisao_tipo_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var revisao_tipo_form___vue_template_functional__ = false
/* styles */
var revisao_tipo_form___vue_styles__ = null
/* scopeId */
var revisao_tipo_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var revisao_tipo_form___vue_module_identifier__ = null
var revisao_tipo_form_Component = revisao_tipo_form_normalizeComponent(
  revisao_tipo_form,
  os_revisao_tipo_form,
  revisao_tipo_form___vue_template_functional__,
  revisao_tipo_form___vue_styles__,
  revisao_tipo_form___vue_scopeId__,
  revisao_tipo_form___vue_module_identifier__
)

/* harmony default export */ var features_os_revisao_tipo_form = (revisao_tipo_form_Component.exports);

// CONCATENATED MODULE: ./src/features/os/revisao-tipo/routes.js



/* harmony default export */ var revisao_tipo_routes = ([{
  path: '/revisao-tipos',
  name: 'revisao-tipos.index',
  component: features_os_revisao_tipo,
  children: [{
    path: 'form/:id?',
    name: 'revisao-tipos.form',
    component: features_os_revisao_tipo_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/relatorios/index.vue


//



/* harmony default export */ var relatorios = ({
  name: 'relatorios',
  data: function data() {
    return {
      orcamento_id: '',
      inicio: moment_default()().format('YYYY-MM-01'),
      termino: moment_default()().format('YYYY-MM-DD'),
      filtro: {
        inicio: moment_default()().format('YYYY-MM-01'),
        termino: moment_default()().format('YYYY-MM-DD'),
        usuario: '',
        imposto: ''
      },
      usuarios: []
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  methods: {
    formRevisao: function formRevisao() {
      this.$router.push({ name: 'relatorios.revisao', params: { id: this.orcamento_id } });
    },
    formContatosOrcamentos: function formContatosOrcamentos() {
      this.$router.push({ name: 'relatorios.contatos-orcamentos', params: { inicio: this.inicio, termino: this.termino } });
    },
    formComissaoVendas: function formComissaoVendas() {
      this.$router.push({ name: 'relatorios.contatos-orcamentos', params: { inicio: this.inicio, termino: this.termino } });
    },
    fecth: function fecth() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service_http.get('/orcamentos/relatorios');

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.usuarios = data.usuarios;
                }
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa94a10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/relatorios/index.vue
var relatorios_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"row",on:{"submit":function($event){$event.preventDefault();return _vm.formContatosOrcamentos.apply(null, arguments)}}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col 12"},[_c('h6',[_vm._v("Revisão por orçamento")]),_vm._v(" "),_c('form',{staticClass:"row",on:{"submit":function($event){$event.preventDefault();return _vm.formRevisao.apply(null, arguments)}}},[_c('div',{staticClass:"col s12 m5"},[_c('div',{staticClass:"input-field inline"},[_c('label',{attrs:{"for":"orcamento"}},[_vm._v("Orcamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orcamento_id),expression:"orcamento_id"}],attrs:{"type":"number","id":"orcamento","required":""},domProps:{"value":(_vm.orcamento_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orcamento_id=$event.target.value}}})])]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('h6',[_vm._v("Comissões de Vendas")]),_vm._v(" "),_c('form',{attrs:{"action":(_vm.api_url + "/comissao-vendas/pdf"),"method":"get","id":"form-pdf","target":"_blank"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","name":"inicio","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","name":"termino","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"name":"usuario","id":"usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(usuario){return _c('option',{domProps:{"value":usuario.id}},[_vm._v(_vm._s((usuario.id) ? usuario.nome_completo : 'Todos'))])}),0)]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('h6',[_vm._v("Comissões de Serviços")]),_vm._v(" "),_c('form',{attrs:{"action":(_vm.api_url + "/comissao-servicos/pdf"),"method":"get","id":"form-pdf","target":"_blank"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","name":"inicio","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","name":"termino","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"name":"usuario","id":"usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(usuario){return _c('option',{domProps:{"value":usuario.id}},[_vm._v(_vm._s((usuario.id) ? usuario.nome_completo : 'Todos'))])}),0)]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('h6',[_vm._v("Lucro")]),_vm._v(" "),_c('form',{attrs:{"action":(_vm.api_url + "/lucro/pdf"),"method":"get","id":"form-pdf","target":"_blank"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.inicio),expression:"filtro.inicio"}],attrs:{"id":"icon_inicio","type":"date","name":"inicio","data-value":_vm.filtro.inicio},domProps:{"value":(_vm.filtro.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "inicio", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.termino),expression:"filtro.termino"}],attrs:{"id":"icon_termino","type":"date","name":"termino","data-value":_vm.filtro.termino},domProps:{"value":(_vm.filtro.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "termino", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.imposto),expression:"filtro.imposto"}],attrs:{"id":"imposto","type":"number","step":"0.01","name":"imposto","data-value":_vm.filtro.imposto},domProps:{"value":(_vm.filtro.imposto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "imposto", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"imposto"}},[_vm._v("% Imposto")])]),_vm._v(" "),_c('div',{staticClass:"col s12 m2"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],attrs:{"name":"usuario","id":"usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.usuarios),function(usuario){return _c('option',{domProps:{"value":usuario.id}},[_vm._v(_vm._s((usuario.id) ? usuario.nome_completo : 'Todos'))])}),0)]),_vm._v(" "),_vm._m(5)])])])])}
var relatorios_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Relatórios")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('h6',[_vm._v("Contatos X Orçamentos")]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m5"},[_c('button',{staticClass:"btn"},[_vm._v("Visualizar")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m5"},[_c('button',{staticClass:"btn"},[_vm._v("Visualizar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m5"},[_c('button',{staticClass:"btn"},[_vm._v("Visualizar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m5"},[_c('button',{staticClass:"btn"},[_vm._v("Visualizar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m5"},[_c('button',{staticClass:"btn"},[_vm._v("Visualizar")])])}]
var relatorios_esExports = { render: relatorios_render, staticRenderFns: relatorios_staticRenderFns }
/* harmony default export */ var features_relatorios = (relatorios_esExports);
// CONCATENATED MODULE: ./src/features/relatorios/index.vue
var relatorios_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var relatorios___vue_template_functional__ = false
/* styles */
var relatorios___vue_styles__ = null
/* scopeId */
var relatorios___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var relatorios___vue_module_identifier__ = null
var relatorios_Component = relatorios_normalizeComponent(
  relatorios,
  features_relatorios,
  relatorios___vue_template_functional__,
  relatorios___vue_styles__,
  relatorios___vue_scopeId__,
  relatorios___vue_module_identifier__
)

/* harmony default export */ var src_features_relatorios = (relatorios_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-google-charts/index.js
var vue_google_charts = __webpack_require__("kXf/");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/relatorios/revisao.vue









moment_default.a.locale('pt-br');

/* harmony default export */ var relatorios_revisao = ({
  name: 'revisao',
  components: {
    GChart: vue_google_charts["GChart"]
  },
  data: function data() {
    return {
      orcamento: {},
      revisao: {},
      itens: [],
      pendentes: [],
      aprovados: [],
      regularizados: [],
      reprovados: [],
      canceladas: [],
      recusadas: [],
      ausentes: [],
      tipoRevisao: [],
      vistoriasRealizadas: [],
      vistoriasPendentes: [],
      itensAprovados: [],
      itensReprovados: [],
      itensNaoAplicados: [],
      osApartamentos: [],
      osReprovadasItem: [],
      blocos: [],
      bloco: 'Todos'
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _this.$route.params.id;

                _this.orcamento.id = id;
                _context.next = 4;
                return service_http.get('/orcamentos/relatorios/revisao/' + id);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                _this.revisao = data.revisao;
                if (_this.revisao.itens.length) {
                  _this.itens = _this.revisao.itens;
                }
                _this.itensAprovados = data.itensAprovados;
                _this.itensReprovados = data.itensReprovados;
                _this.itensNaoAplicados = data.itensNaoAplicados;
                _this.osApartamentos = data.osApartamentos;
                _this.osReprovadasItem = data.osReprovadasItem;
                _this.pendentes = data.pendentes;
                _this.aprovados = data.aprovados;
                _this.regularizados = data.regularizados;
                _this.reprovados = data.reprovados;
                _this.canceladas = data.canceladas;
                _this.recusadas = data.recusadas;
                _this.ausentes = data.ausentes;
                _this.tipoRevisao = data.tipoRevisao;
                _this.vistoriasRealizadas = data.vistoriasRealizadas;
                _this.vistoriasPendentes = data.vistoriasPendentes;
                _this.blocos = data.blocos;
                setTimeout(function () {
                  $('.collapsible').collapsible();
                  $('.collapsible').collapsible('close', 0);
                  $('.collapsible').collapsible('close', 1);
                  $('.collapsible').collapsible('close', 2);
                  $('.collapsible').collapsible('close', 3);
                  $('.collapsible').collapsible('close', 4);
                  $('.collapsible').collapsible('close', 5);
                  window.Materialize.updateTextFields();
                }, 0);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM HH:mm');
    },
    formatDateFrom: function formatDateFrom(date) {
      return moment_default()(date).fromNow();
    },
    getData: function getData(data, index) {
      if (typeof data[index] !== 'undefined') {
        return data[index];
      } else {
        return [];
      }
    },

    /**
     * @return {number}
     */
    countObj: function countObj(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    },
    api_root: function api_root() {
      return "https://sistemakgb.com.br";
    },
    id: function id() {
      var id = this.$route.params.id;

      return id;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abe86f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/relatorios/revisao.vue
var revisao_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h5',[_vm._v("Relatórios Revisão")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m3"},[_c('label',[_vm._v("Blocos, selecione quais blocos devem sair nos PDFs")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bloco),expression:"bloco"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bloco=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.blocos),function(row){return _c('option',[_vm._v(_vm._s(row))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.api_url+'/relatorios/'+_vm.id+'/pdf?bloco='+_vm.bloco}},[_vm._v("Baixar PDF")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.tipoRevisao),function(tipo,index){return _c('div',{staticClass:"col s12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h5',[_vm._v(_vm._s(tipo))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 12"},[_c('table',{staticClass:"bordered highlight responsive-table"},[_vm._m(0,true),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.getData(_vm.aprovados, index).length))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getData(_vm.reprovados, index).length))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getData(_vm.canceladas, index).length))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getData(_vm.recusadas, index).length))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getData(_vm.ausentes, index).length))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.countObj(_vm.pendentes)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.countObj(_vm.vistoriasRealizadas)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.countObj(_vm.vistoriasPendentes)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.countObj(_vm.regularizados)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('h5',[_vm._v("Status Geral")]),_vm._v(" "),_c('GChart',{staticStyle:{"height":"300px"},attrs:{"settings":{ packages: ['corechart'] },"type":"PieChart","resizeDebounce":500,"data":[
                ['Status', 'OSs'],
                ['Realizado',  _vm.getData(_vm.aprovados, index).length + _vm.getData(_vm.reprovados, index).length + _vm.getData(_vm.canceladas, index).length + _vm.getData(_vm.recusadas, index).length + _vm.getData(_vm.ausentes, index).length],
                ['Pendente', _vm.countObj(_vm.pendentes)]
              ]}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('h5',[_vm._v("Status Aprovação")]),_vm._v(" "),_c('GChart',{staticStyle:{"height":"250px"},attrs:{"settings":{ packages: ['corechart'] },"type":"PieChart","data":[
                ['Status', 'OSs'],
                ['Aprovado',  _vm.getData(_vm.aprovados, index).length],
                ['Reprovado', _vm.getData(_vm.reprovados,index).length],
                ['Cancelado', _vm.getData(_vm.canceladas,index).length],
                ['Recusado', _vm.getData(_vm.recusadas,index).length],
                ['Ausente', _vm.getData(_vm.ausentes,index).length] ]}})],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('h5',[_vm._v("Vistorias")]),_vm._v(" "),_c('GChart',{staticStyle:{"height":"250px"},attrs:{"settings":{ packages: ['corechart'] },"type":"PieChart","resizeDebounce":500,"data":[
                ['Status', 'OSs'],
                ['Realizado',  _vm.countObj(_vm.vistoriasRealizadas)],
                ['Pendente', _vm.countObj(_vm.vistoriasPendentes)]
              ]}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 12"},[_c('table',{staticClass:"bordered highlight responsive-table"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((_vm.itens),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.inspecao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.itensAprovados[item.id]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.itensReprovados[item.id]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.itensNaoAplicados[item.id]))])])}),0)])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"bordered highlight responsive-table"},[_vm._m(2,true),_vm._v(" "),_c('tbody',_vm._l((_vm.itens),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.inspecao))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},_vm._l((_vm.osReprovadasItem[item.id]),function(row,index){return _c('div',{staticClass:"col s12 m4"},[_vm._v("\n                      "+_vm._s(_vm.osApartamentos[row])+"\n                    ")])}),0)])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',[_vm._v("Blocos, selecione quais blocos devem sair nos PDFs")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bloco),expression:"bloco"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bloco=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.blocos),function(row){return _c('option',[_vm._v(_vm._s(row))])}),0)])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/todas/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n              "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=todas"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('ul',{staticClass:"collapsible popout",attrs:{"data-collapsible":"accordion"}},[_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Regularizados\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=regularizados"),"target":"_blank","title":"Regularizados"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(3,true),_vm._v(" "),_c('tbody',_vm._l((_vm.regularizados),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.status ? ("" + (os.status.status)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Pendentes\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/pendentes/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n                    "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=pendente"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(4,true),_vm._v(" "),_c('tbody',_vm._l((_vm.pendentes),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisao/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Reprovadas\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/reprovadas/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n                    "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=reprovadas"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(5,true),_vm._v(" "),_c('tbody',_vm._l((_vm.getData(_vm.reprovados, index)),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisao/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Revisões Canceladas\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/canceladas/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n                    "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=canceladas"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(6,true),_vm._v(" "),_c('tbody',_vm._l((_vm.getData(_vm.canceladas, index)),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisao/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Recusadas\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/recusadas/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n                    "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=recusadas"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(7,true),_vm._v(" "),_c('tbody',_vm._l((_vm.getData(_vm.recusadas, index)),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisao/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Cliente Ausente\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/ausentes/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n                    "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=ausentes"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(8,true),_vm._v(" "),_c('tbody',_vm._l((_vm.getData(_vm.ausentes, index)),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisao/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"collapsible-header green-text text-darken-3"},[_vm._v("\n                  Aprovadas\n                ")]),_vm._v(" "),_c('div',{staticClass:"collapsible-body"},[_c('p',[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisoes/" + (_vm.orcamento.id) + "/aprovadas/pdf?bloco=" + _vm.bloco),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" Imprimir Revisões"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloco !== 'Todos'),expression:"bloco !== 'Todos'"}]},[_vm._v(", "+_vm._s(_vm.bloco))]),_vm._v(" |\n                    "),_c('a',{attrs:{"href":(_vm.api_root + "/revisao/" + (_vm.orcamento.id) + "/relatorio?status=aprovadas"),"target":"_blank","title":"PDF REVISÃO"}},[_vm._v(" Listagem para o Cliente")])]),_vm._v(" "),_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(9,true),_vm._v(" "),_c('tbody',_vm._l((_vm.getData(_vm.aprovados, index)),function(os){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('os.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_vm._v(_vm._s(os.id))]):_c('span',[_vm._v(_vm._s(os.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(os.apartamento ? ("" + (os.apartamento)) : ''))]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons blue-text",attrs:{"href":(_vm.api_url + "/revisao/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF REVISÃO"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/os/" + (os.id) + "/pdf"),"target":"_blank","title":"PDF OS"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('os.editar') > -1),expression:"permissoes.indexOf('os.editar') > -1"}],attrs:{"to":{ name: 'os.form', params: { id: os.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])])],1)])}),0)])])])])])])])}),0)])])}
var revisao_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Aprovados")]),_vm._v(" "),_c('th',[_vm._v("Reprovados")]),_vm._v(" "),_c('th',[_vm._v("Canceladas")]),_vm._v(" "),_c('th',[_vm._v("Recusadas")]),_vm._v(" "),_c('th',[_vm._v("Clientes Ausentes")]),_vm._v(" "),_c('th',[_vm._v("Pendentes")]),_vm._v(" "),_c('th',[_vm._v("Vistorias Realizadas")]),_vm._v(" "),_c('th',[_vm._v("Vistorias Pendentes")]),_vm._v(" "),_c('th',[_vm._v("Regularizados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Itens da Revisão")]),_vm._v(" "),_c('th',[_vm._v("Aprovados")]),_vm._v(" "),_c('th',[_vm._v("Reprovados")]),_vm._v(" "),_c('th',[_vm._v("Não Aplicável")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Reprovações por Item")]),_vm._v(" "),_c('th',[_vm._v("Apartamentos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Apartamento")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var revisao_esExports = { render: revisao_render, staticRenderFns: revisao_staticRenderFns }
/* harmony default export */ var features_relatorios_revisao = (revisao_esExports);
// CONCATENATED MODULE: ./src/features/relatorios/revisao.vue
var revisao_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var revisao___vue_template_functional__ = false
/* styles */
var revisao___vue_styles__ = null
/* scopeId */
var revisao___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var revisao___vue_module_identifier__ = null
var revisao_Component = revisao_normalizeComponent(
  relatorios_revisao,
  features_relatorios_revisao,
  revisao___vue_template_functional__,
  revisao___vue_styles__,
  revisao___vue_scopeId__,
  revisao___vue_module_identifier__
)

/* harmony default export */ var src_features_relatorios_revisao = (revisao_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/relatorios/contatosOrcamentos.vue








moment_default.a.locale('pt-br');

/* harmony default export */ var contatosOrcamentos = ({
  name: 'contatos-orcamentos',
  data: function data() {
    return {
      inicio: moment_default()().format('YYYY-MM-01'),
      termino: moment_default()().format('YYYY-MM-DD'),
      contatos: [],
      orcamentos: [],
      valores: []
    };
  },
  mounted: function mounted() {
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service_http.post('/orcamentos/relatorios/contatos-orcamentos', { inicio: _this.inicio, termino: _this.termino });

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                _this.contatos = data.contatos;
                _this.orcamentos = data.orcamentos;
                _this.valores = data.valores;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM HH:mm');
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357ae15e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/relatorios/contatosOrcamentos.vue
var contatosOrcamentos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"row",on:{"submit":function($event){$event.preventDefault();return _vm.fetch.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('h6',[_vm._v("Contatos X Orçamentos")]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inicio),expression:"inicio"}],attrs:{"id":"icon_inicio","type":"date","data-value":_vm.inicio},domProps:{"value":(_vm.inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inicio=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_inicio"}},[_vm._v("Início")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m2"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termino),expression:"termino"}],attrs:{"id":"icon_termino","type":"date","data-value":_vm.termino},domProps:{"value":(_vm.termino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.termino=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_termino"}},[_vm._v("Término")])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"row z-depth-1"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(3),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("\n                  "+_vm._s(_vm.contatos[0] ? _vm.contatos[0] : 0)+"\n              ")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'contatos.index', params:{status: 'Novo'} },"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.contatos[1] ? _vm.contatos[1] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'contatos.index', params:{status: 'Em Contato'} },"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.contatos[2] ? _vm.contatos[2] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'contatos.index', params:{status: 'Finalizado com Orçamento'} },"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.contatos[3] ? _vm.contatos[3] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'contatos.index', params:{status: 'Finalizado sem Orçamento'} },"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.contatos[4] ? _vm.contatos[4] : 0)+"\n                ")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"row z-depth-1"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(5),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("R$ "+_vm._s(_vm.valores[0] ? _vm.valores[0] : 0))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.index', params:{status: 'novo'} },"target":"_blank"}},[_vm._v("\n                  R$ "+_vm._s(_vm.valores[1] ? _vm.valores[1] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.index', params:{status: 'Aguardando Visita'} },"target":"_blank"}},[_vm._v("\n                  R$ "+_vm._s(_vm.valores[2] ? _vm.valores[2] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.index', params:{status: 'Proposta Enviada'} },"target":"_blank"}},[_vm._v("\n                  R$ "+_vm._s(_vm.valores[3] ? _vm.valores[3] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.index', params:{status: 'Em Negociação'} },"target":"_blank"}},[_vm._v("\n                  R$ "+_vm._s(_vm.valores[4] ? _vm.valores[4] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.index', params:{status: 'Aprovado'} },"target":"_blank"}},[_vm._v("\n                  R$ "+_vm._s(_vm.valores[5] ? _vm.valores[5] : 0)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'orcamentos.index', params:{status: 'Reprovado'} },"target":"_blank"}},[_vm._v("\n                  R$ "+_vm._s(_vm.valores[6] ? _vm.valores[6] : 0)+"\n                ")])],1)])])])])])])])}
var contatosOrcamentos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Relatórios Contatos X Orçamentos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field col s12 m5"},[_c('button',{staticClass:"btn"},[_vm._v("Filtrar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Contatos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Total no Período")]),_vm._v(" "),_c('th',[_vm._v("Novo")]),_vm._v(" "),_c('th',[_vm._v("Em Contato")]),_vm._v(" "),_c('th',[_vm._v("Finalizado com Orçamento")]),_vm._v(" "),_c('th',[_vm._v("Finalizado sem Orçamento")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12"},[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Orçamentos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Total no Período")]),_vm._v(" "),_c('th',[_vm._v("Novo")]),_vm._v(" "),_c('th',[_vm._v("Aguardando Visita")]),_vm._v(" "),_c('th',[_vm._v("Proposta Enviada")]),_vm._v(" "),_c('th',[_vm._v("Em Negociação")]),_vm._v(" "),_c('th',[_vm._v("Aprovado")]),_vm._v(" "),_c('th',[_vm._v("Reprovado")])])])}]
var contatosOrcamentos_esExports = { render: contatosOrcamentos_render, staticRenderFns: contatosOrcamentos_staticRenderFns }
/* harmony default export */ var relatorios_contatosOrcamentos = (contatosOrcamentos_esExports);
// CONCATENATED MODULE: ./src/features/relatorios/contatosOrcamentos.vue
var contatosOrcamentos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contatosOrcamentos___vue_template_functional__ = false
/* styles */
var contatosOrcamentos___vue_styles__ = null
/* scopeId */
var contatosOrcamentos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var contatosOrcamentos___vue_module_identifier__ = null
var contatosOrcamentos_Component = contatosOrcamentos_normalizeComponent(
  contatosOrcamentos,
  relatorios_contatosOrcamentos,
  contatosOrcamentos___vue_template_functional__,
  contatosOrcamentos___vue_styles__,
  contatosOrcamentos___vue_scopeId__,
  contatosOrcamentos___vue_module_identifier__
)

/* harmony default export */ var features_relatorios_contatosOrcamentos = (contatosOrcamentos_Component.exports);

// CONCATENATED MODULE: ./src/features/relatorios/routes.js





/* harmony default export */ var relatorios_routes = ([{
  path: '/relatorios',
  name: 'relatorios.index',
  component: src_features_relatorios
}, {
  path: '/relatorios/revisao/:id',
  name: 'relatorios.revisao',
  component: src_features_relatorios_revisao
}, {
  path: '/relatorios/contatos-orcamentos/:inicio/:termino',
  name: 'relatorios.contatos-orcamentos',
  component: features_relatorios_contatosOrcamentos
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/viaturas/index.vue



//




/* harmony default export */ var viaturas = ({
  name: 'Viaturas',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/viaturas?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/viaturas?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var viatura, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                viatura = obj.viatura;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: viatura.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, viatura);
                } else {
                  _this3.list.unshift(viatura);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(viatura) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + viatura.viatura + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/viaturas/' + viatura.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: viatura.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'viaturas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'viaturas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5eb7d1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/viaturas/index.vue
var viaturas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('viatura.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('viatura.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'viaturas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'viaturas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-viaturas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(viatura){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('viatura.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'viaturas.form', params: { id: viatura.id } }}},[_vm._v(_vm._s(viatura.id))]):_c('span',[_vm._v(_vm._s(viatura.id))])],1),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('viatura.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'viaturas.form', params: { id: viatura.id } }}},[_vm._v(_vm._s(viatura.viatura))]):_c('span',[_vm._v(_vm._s(viatura.viatura))])],1),_vm._v(" "),_c('td',_vm._l((viatura.usuarios),function(usuario){return _c('span',{attrs:{"value":usuario.id}},[_vm._v(_vm._s(usuario.nome_completo)+", ")])}),0),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/viatura/" + (viatura.id) + "/pdf"),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('viatura.editar') > -1),expression:"permissoes.indexOf('viatura.editar') > -1"}],attrs:{"to":{ name: 'viaturas.form', params: { id: viatura.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('viatura.excluir') > -1),expression:"permissoes.indexOf('viatura.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(viatura)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var viaturas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Viaturas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Viatura")]),_vm._v(" "),_c('th',[_vm._v("Responsáveis")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var viaturas_esExports = { render: viaturas_render, staticRenderFns: viaturas_staticRenderFns }
/* harmony default export */ var features_viaturas = (viaturas_esExports);
// CONCATENATED MODULE: ./src/features/viaturas/index.vue
var viaturas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var viaturas___vue_template_functional__ = false
/* styles */
var viaturas___vue_styles__ = null
/* scopeId */
var viaturas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var viaturas___vue_module_identifier__ = null
var viaturas_Component = viaturas_normalizeComponent(
  viaturas,
  features_viaturas,
  viaturas___vue_template_functional__,
  viaturas___vue_styles__,
  viaturas___vue_scopeId__,
  viaturas___vue_module_identifier__
)

/* harmony default export */ var src_features_viaturas = (viaturas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/viaturas/form.vue








/* harmony default export */ var viaturas_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      usuarios: [{}],
      produtos: [],
      viatura: {
        id: '',
        viatura: '',
        envolvidos: [],
        produtos: []
      },
      item: {
        id: '',
        produto: '',
        valor: '',
        qtd: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/viaturas' : '/viaturas/' + _this2.viatura.id;
                _context.next = 4;
                return service_http[verb](url, _this2.viatura);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-viaturas-list', { viatura: data.viatura });
                  _this2.$router.push({ name: 'viaturas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/viaturas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.viatura = data.viatura;
                _this3.usuarios = data.usuarios;
                _this3.produtos = data.produtos;
                _context2.next = 18;
                break;

              case 12:
                _context2.next = 14;
                return service_http.get('/viaturas/create');

              case 14:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.usuarios = _data.usuarios;
                _this3.produtos = _data.produtos;

              case 18:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.viatura = {
        id: '',
        viatura: '',
        envolvidos: [],
        produtos: []
      };
    },
    onSelectProduto: function onSelectProduto(item) {
      if (item) {
        var produto = {
          produto_id: item.id,
          produto: item,
          qtd: 1
        };
        this.addProduto(produto);
      }
    },
    addProduto: function addProduto(produto) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (typeof _this4.viatura.produtos === 'undefined') {
                  _this4.viatura.produtos = [];
                }
                _context3.next = 3;
                return _this4.viatura.produtos.push(produto);

              case 3:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    destroyProduto: function destroyProduto(indexProduto) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um Produto \xE9 uma opera\xE7\xE3o irrevers\xEDvel e vai restabelecer estoques',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this5.viatura.produtos[indexProduto].id) {
          _this5.viatura.produtos.splice(indexProduto, 1);
          window.Materialize.toast('Produto excluído!', 4000);
        } else {
          service_http.delete('viaturas/produto/' + _this5.viatura.produtos[indexProduto].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Produto excluído!', 4000);
            _this5.viatura.produtos.splice(indexProduto, 1);
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.viatura.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },

    viaturaEnvolvidos: {
      get: function get() {
        var _this6 = this;

        return this.usuarios.filter(function (option) {
          return _this6.viatura.envolvidos.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.viatura.envolvidos = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11918e6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/viaturas/form.vue
var viaturas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m5"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.viatura.viatura),expression:"viatura.viatura"}],class:{invalid: _vm.errors.has('viatura')},attrs:{"name":"viatura","id":"viatura","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.viatura.viatura)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viatura, "viatura", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"viatura"}},[_vm._v("*Viatura")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('viatura')))])]),_vm._v(" "),_c('div',{staticClass:"col s12 m7"},[_c('label',[_vm._v("Usuários Envolvidos")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"nome_completo","track-by":"id","options":_vm.usuarios},model:{value:(_vm.viaturaEnvolvidos),callback:function ($$v) {_vm.viaturaEnvolvidos=$$v},expression:"viaturaEnvolvidos"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","selected-item":_vm.item,"placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viatura.produtos && _vm.viatura.produtos.length > 0),expression:"viatura.produtos && viatura.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.viatura.produtos),function(produto,indexProduto){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((produto.produto) ? produto.produto.produto : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1","readonly":produto.hasOwnProperty('id')},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(indexProduto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var viaturas_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Materiais Utilizados")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])}]
var viaturas_form_esExports = { render: viaturas_form_render, staticRenderFns: viaturas_form_staticRenderFns }
/* harmony default export */ var features_viaturas_form = (viaturas_form_esExports);
// CONCATENATED MODULE: ./src/features/viaturas/form.vue
var viaturas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var viaturas_form___vue_template_functional__ = false
/* styles */
var viaturas_form___vue_styles__ = null
/* scopeId */
var viaturas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var viaturas_form___vue_module_identifier__ = null
var viaturas_form_Component = viaturas_form_normalizeComponent(
  viaturas_form,
  features_viaturas_form,
  viaturas_form___vue_template_functional__,
  viaturas_form___vue_styles__,
  viaturas_form___vue_scopeId__,
  viaturas_form___vue_module_identifier__
)

/* harmony default export */ var src_features_viaturas_form = (viaturas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/viaturas/routes.js



/* harmony default export */ var viaturas_routes = ([{
  path: '/viaturas',
  name: 'viaturas.index',
  component: src_features_viaturas,
  children: [{
    path: 'form/:id?',
    name: 'viaturas.form',
    component: src_features_viaturas_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/reclamacoes/index.vue



//




/* harmony default export */ var reclamacoes = ({
  name: 'Reclamações',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/reclamacoes?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/reclamacoes?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var reclamacao, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                reclamacao = obj.reclamacao;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: reclamacao.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, reclamacao);
                } else {
                  _this3.list.unshift(reclamacao);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(reclamacao) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + reclamacao.titulo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/reclamacoes/' + reclamacao.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: reclamacao.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'reclamacoes.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'reclamacoes.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e04e525","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/reclamacoes/index.vue
var reclamacoes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('reclamacao.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('reclamacao.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'reclamacoes.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'reclamacoes.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-reclamacoes-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(reclamacao){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('reclamacao.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'reclamacoes.form', params: { id: reclamacao.id } }}},[_vm._v(_vm._s(reclamacao.id))]):_c('span',[_vm._v(_vm._s(reclamacao.id))])],1),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('reclamacao.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'reclamacoes.form', params: { id: reclamacao.id } }}},[_vm._v(_vm._s(reclamacao.titulo))]):_c('span',[_vm._v(_vm._s(reclamacao.titulo))])],1),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(reclamacao.nome)+" ")])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(reclamacao.telefone)+" ")])]),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('reclamacao.editar') > -1),expression:"permissoes.indexOf('reclamacao.editar') > -1"}],attrs:{"to":{ name: 'reclamacoes.form', params: { id: reclamacao.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('reclamacao.excluir') > -1),expression:"permissoes.indexOf('reclamacao.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(reclamacao)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var reclamacoes_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Reclamações")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Título")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var reclamacoes_esExports = { render: reclamacoes_render, staticRenderFns: reclamacoes_staticRenderFns }
/* harmony default export */ var features_reclamacoes = (reclamacoes_esExports);
// CONCATENATED MODULE: ./src/features/reclamacoes/index.vue
var reclamacoes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var reclamacoes___vue_template_functional__ = false
/* styles */
var reclamacoes___vue_styles__ = null
/* scopeId */
var reclamacoes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var reclamacoes___vue_module_identifier__ = null
var reclamacoes_Component = reclamacoes_normalizeComponent(
  reclamacoes,
  features_reclamacoes,
  reclamacoes___vue_template_functional__,
  reclamacoes___vue_styles__,
  reclamacoes___vue_scopeId__,
  reclamacoes___vue_module_identifier__
)

/* harmony default export */ var src_features_reclamacoes = (reclamacoes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/reclamacoes/form.vue







/* harmony default export */ var reclamacoes_form = ({
  name: 'Form',
  data: function data() {
    return {
      status: [],
      reclamacao: {
        id: '',
        nome: '',
        telefone: '',
        titulo: '',
        reclamacao: '',
        status_id: 1
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/reclamacoes' : '/reclamacoes/' + _this2.reclamacao.id;
                _context.next = 4;
                return service_http[verb](url, _this2.reclamacao);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-reclamacoes-list', { reclamacao: data.reclamacao });
                  _this2.$router.push({ name: 'reclamacoes.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/reclamacoes/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.reclamacao = data.reclamacao;
                _this3.status = data.status;
                _context2.next = 16;
                break;

              case 11:
                _context2.next = 13;
                return service_http.get('/reclamacoes/create');

              case 13:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.status = _data.status;

              case 16:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.reclamacao = {
        id: '',
        nome: '',
        telefone: '',
        titulo: '',
        reclamacao: '',
        status_id: 1
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.reclamacao.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42943abb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/reclamacoes/form.vue
var reclamacoes_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s8"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.reclamacao.nome),expression:"reclamacao.nome"}],class:{invalid: _vm.errors.has('nome')},attrs:{"name":"nome","id":"nome","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.reclamacao.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reclamacao, "nome", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"nome"}},[_vm._v("*Nome")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('nome')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s4"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(99) 99999999[9]'),expression:"'(99) 99999999[9]'"},{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.reclamacao.telefone),expression:"reclamacao.telefone"}],class:{invalid: _vm.errors.has('telefone')},attrs:{"name":"telefone","id":"telefone","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.reclamacao.telefone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reclamacao, "telefone", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"nome"}},[_vm._v("*Telefone")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('reclamacao')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.reclamacao.titulo),expression:"reclamacao.titulo"}],class:{invalid: _vm.errors.has('titulo')},attrs:{"name":"titulo","id":"titulo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.reclamacao.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reclamacao, "titulo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"titulo"}},[_vm._v("*Título")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('titulo')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reclamacao.reclamacao),expression:"reclamacao.reclamacao"}],staticClass:"materialize-textarea",attrs:{"name":"reclamacao","id":"reclamacao","type":"text"},domProps:{"value":(_vm.reclamacao.reclamacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reclamacao, "reclamacao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"reclamacao"}},[_vm._v("*Reclamação")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('label',{attrs:{"for":"status_id"}},[_vm._v("*Status")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.reclamacao.status_id),expression:"reclamacao.status_id"}],attrs:{"name":"status_id","id":"status_id","data-vv-rules":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reclamacao, "status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.status),function(status){return _c('option',{domProps:{"value":status.id}},[_vm._v(_vm._s(status.status))])}),0),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('status_id')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var reclamacoes_form_staticRenderFns = []
var reclamacoes_form_esExports = { render: reclamacoes_form_render, staticRenderFns: reclamacoes_form_staticRenderFns }
/* harmony default export */ var features_reclamacoes_form = (reclamacoes_form_esExports);
// CONCATENATED MODULE: ./src/features/reclamacoes/form.vue
var reclamacoes_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var reclamacoes_form___vue_template_functional__ = false
/* styles */
var reclamacoes_form___vue_styles__ = null
/* scopeId */
var reclamacoes_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var reclamacoes_form___vue_module_identifier__ = null
var reclamacoes_form_Component = reclamacoes_form_normalizeComponent(
  reclamacoes_form,
  features_reclamacoes_form,
  reclamacoes_form___vue_template_functional__,
  reclamacoes_form___vue_styles__,
  reclamacoes_form___vue_scopeId__,
  reclamacoes_form___vue_module_identifier__
)

/* harmony default export */ var src_features_reclamacoes_form = (reclamacoes_form_Component.exports);

// CONCATENATED MODULE: ./src/features/reclamacoes/routes.js



/* harmony default export */ var reclamacoes_routes = ([{
  path: '/reclamacoes',
  name: 'reclamacoes.index',
  component: src_features_reclamacoes,
  children: [{
    path: 'form/:id?',
    name: 'reclamacoes.form',
    component: src_features_reclamacoes_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/orcamentos/motivos/index.vue








/* harmony default export */ var motivos = ({
  name: 'Motivos',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/motivos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/motivos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var motivo, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                motivo = obj.motivo;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: motivo.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, motivo);
                } else {
                  _this3.list.unshift(motivo);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(motivo) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + motivo.motivo_recusa + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/motivos/' + motivo.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: motivo.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'motivos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'motivos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3def772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/orcamentos/motivos/index.vue
var motivos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('motivo.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('motivo.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'motivos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'motivos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-motivos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(motivo){return _c('tr',[_c('td',[_vm._v(_vm._s(motivo.id))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('motivo.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'motivos.form', params: { id: motivo.id } }}},[_vm._v("\n                "+_vm._s(motivo.motivo_recusa)+"\n              ")]):_c('span',[_vm._v(_vm._s(motivo.motivo_recusa))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('motivo.editar') > -1),expression:"permissoes.indexOf('motivo.editar') > -1"}],attrs:{"to":{ name: 'motivos.form', params: { id: motivo.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('motivo.excluir') > -1),expression:"permissoes.indexOf('motivo.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(motivo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var motivos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Motivos de Recusa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Motivo")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var motivos_esExports = { render: motivos_render, staticRenderFns: motivos_staticRenderFns }
/* harmony default export */ var orcamentos_motivos = (motivos_esExports);
// CONCATENATED MODULE: ./src/features/orcamentos/motivos/index.vue
var motivos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var motivos___vue_template_functional__ = false
/* styles */
var motivos___vue_styles__ = null
/* scopeId */
var motivos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var motivos___vue_module_identifier__ = null
var motivos_Component = motivos_normalizeComponent(
  motivos,
  orcamentos_motivos,
  motivos___vue_template_functional__,
  motivos___vue_styles__,
  motivos___vue_scopeId__,
  motivos___vue_module_identifier__
)

/* harmony default export */ var features_orcamentos_motivos = (motivos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/orcamentos/motivos/form.vue







/* harmony default export */ var motivos_form = ({
  name: 'Form',
  data: function data() {
    return {
      motivo: {
        id: '',
        motivo_recusa: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/motivos' : '/motivos/' + _this2.motivo.id;
                _context.next = 4;
                return service_http[verb](url, _this2.motivo);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-motivos-list', { motivo: data.motivo });
                  _this2.$router.push({ name: 'motivos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/motivos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.motivo = data.motivo;
                _this3.unidades = data.unidades;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.motivo = {
        id: '',
        motivo_recusa: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.motivo.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a6042a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/orcamentos/motivos/form.vue
var motivos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.motivo.motivo_recusa),expression:"motivo.motivo_recusa"}],class:{invalid: _vm.errors.has('motivo_recusa')},attrs:{"name":"motivo_recusa","id":"motivo_recusa","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.motivo.motivo_recusa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.motivo, "motivo_recusa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"motivo_recusa"}},[_vm._v("*Motivo de Recusa")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('motivo_recusa')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var motivos_form_staticRenderFns = []
var motivos_form_esExports = { render: motivos_form_render, staticRenderFns: motivos_form_staticRenderFns }
/* harmony default export */ var orcamentos_motivos_form = (motivos_form_esExports);
// CONCATENATED MODULE: ./src/features/orcamentos/motivos/form.vue
var motivos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var motivos_form___vue_template_functional__ = false
/* styles */
var motivos_form___vue_styles__ = null
/* scopeId */
var motivos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var motivos_form___vue_module_identifier__ = null
var motivos_form_Component = motivos_form_normalizeComponent(
  motivos_form,
  orcamentos_motivos_form,
  motivos_form___vue_template_functional__,
  motivos_form___vue_styles__,
  motivos_form___vue_scopeId__,
  motivos_form___vue_module_identifier__
)

/* harmony default export */ var features_orcamentos_motivos_form = (motivos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/orcamentos/motivos/routes.js



/* harmony default export */ var motivos_routes = ([{
  path: '/motivos',
  name: 'motivos.index',
  component: features_orcamentos_motivos,
  children: [{
    path: 'form/:id?',
    name: 'motivos.form',
    component: features_orcamentos_motivos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/grupos/index.vue








/* harmony default export */ var grupos = ({
  name: 'grupo',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/grupos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/grupos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var grupo, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                grupo = obj.grupo;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: grupo.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, grupo);
                } else {
                  _this3.list.unshift(grupo);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(grupo) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + grupo.grupo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/grupos/' + grupo.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: grupo.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'grupos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'grupos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7363e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/grupos/index.vue
var grupos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('grupo.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('grupo.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'grupos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'grupos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-grupos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(grupo){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('grupo.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'grupos.form', params: { id: grupo.id } }}},[_vm._v("\n                                "+_vm._s(grupo.grupo)+"\n                            ")]):_c('span',[_vm._v(_vm._s(grupo.grupo))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('grupo.editar') > -1),expression:"permissoes.indexOf('grupo.editar') > -1"}],attrs:{"to":{ name: 'grupos.form', params: { id: grupo.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('grupo.excluir') > -1),expression:"permissoes.indexOf('grupo.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(grupo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var grupos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Grupos de Serviço")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Grupo")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var grupos_esExports = { render: grupos_render, staticRenderFns: grupos_staticRenderFns }
/* harmony default export */ var features_grupos = (grupos_esExports);
// CONCATENATED MODULE: ./src/features/grupos/index.vue
var grupos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grupos___vue_template_functional__ = false
/* styles */
var grupos___vue_styles__ = null
/* scopeId */
var grupos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grupos___vue_module_identifier__ = null
var grupos_Component = grupos_normalizeComponent(
  grupos,
  features_grupos,
  grupos___vue_template_functional__,
  grupos___vue_styles__,
  grupos___vue_scopeId__,
  grupos___vue_module_identifier__
)

/* harmony default export */ var src_features_grupos = (grupos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/grupos/form.vue








/* harmony default export */ var grupos_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      tiposEstabelecimento: [],
      servicos: [],
      grupo: {
        id: '',
        grupo: '',
        pf: false,
        pj: false,
        servicos: [],
        estabelecimentos: [],
        perguntas: []
      },
      item: {
        id: '',
        servico: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/grupos' : '/grupos/' + _this2.grupo.id;
                _context.next = 4;
                return service_http[verb](url, _this2.grupo);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-grupos-list', { grupo: data.grupo });
                  _this2.$router.push({ name: 'grupos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/grupos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.grupo = data.grupo;
                _this3.servicos = data.servicos;
                _this3.tiposEstabelecimento = data.tipos;
                _context2.next = 18;
                break;

              case 12:
                _context2.next = 14;
                return service_http.get('/grupos/create');

              case 14:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.servicos = _data.servicos;
                _this3.tiposEstabelecimento = _data.tipos;

              case 18:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.grupo = {
        id: '',
        grupo: '',
        pf: false,
        pj: false,
        servicos: [],
        estabelecimentos: [],
        perguntas: []
      };
    },
    onSelectServico: function onSelectServico(item) {
      if (item) {
        var servico = {
          servico_id: item.id,
          servico: item,
          valor: item.valor
        };
        this.addServico(servico);
      }
    },
    addServico: function addServico(servico) {
      if (typeof this.grupo.servicos === 'undefined') {
        this.grupo.servicos = [];
      }
      this.grupo.servicos.push(servico);
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 0);
    },
    addPergunta: function addPergunta() {
      this.grupo.perguntas.push({
        id: '',
        etapa: '',
        pergunta: ''
      });
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 0);
    },
    destroyServico: function destroyServico(indexServico) {
      var _this4 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir um servi\xE7o \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this4.grupo.servicos[indexServico].id) {
          _this4.grupo.servicos.splice(indexServico, 1);
          window.Materialize.toast('Servico excluído!', 4000);
        } else {
          service_http.delete('grupos/servico/' + _this4.grupo.servicos[indexServico].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Servico excluído!', 4000);
            _this4.grupo.servicos.splice(indexServico, 1);
          });
        }
      });
    },
    destroyPergunta: function destroyPergunta(indexPergunta) {
      var _this5 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma pergunta \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(function () {
        if (!_this5.grupo.perguntas[indexPergunta].id) {
          _this5.grupo.perguntas.splice(indexPergunta, 1);
          window.Materialize.toast('Pergunta excluída!', 4000);
        } else {
          service_http.delete('grupos/servico/' + _this5.grupo.perguntas[indexPergunta].id).then(function (response) {
            return response.data;
          }).then(function (data) {
            window.Materialize.toast('Pergunta excluída!', 4000);
            _this5.grupo.perguntas.splice(indexPergunta, 1);
          });
        }
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.grupo.id === '';
    },

    grupoEstabelecimentos: {
      get: function get() {
        var _this6 = this;

        return this.tiposEstabelecimento.filter(function (option) {
          return _this6.grupo.estabelecimentos.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.grupo.estabelecimentos = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0736ef80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/grupos/form.vue
var grupos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.grupo.grupo),expression:"grupo.grupo"}],class:{invalid: _vm.errors.has('grupo')},attrs:{"name":"grupo","id":"grupo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.grupo.grupo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.grupo, "grupo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"grupo"}},[_vm._v("*Grupo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('grupo')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo.pf),expression:"grupo.pf"}],attrs:{"name":"pf","id":"pf","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.grupo.pf)?_vm._i(_vm.grupo.pf,null)>-1:(_vm.grupo.pf)},on:{"change":function($event){var $$a=_vm.grupo.pf,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.grupo, "pf", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.grupo, "pf", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.grupo, "pf", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pf"}},[_vm._v("Pessoa Física")])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo.pj),expression:"grupo.pj"}],attrs:{"name":"pj","id":"pj","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.grupo.pj)?_vm._i(_vm.grupo.pj,null)>-1:(_vm.grupo.pj)},on:{"change":function($event){var $$a=_vm.grupo.pj,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.grupo, "pj", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.grupo, "pj", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.grupo, "pj", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pj"}},[_vm._v("Pessoa Jurídica")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grupo.pj),expression:"grupo.pj"}]},[_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_vm._v("Tipos de Estabelecimento")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"tipo","track-by":"id","options":_vm.tiposEstabelecimento},model:{value:(_vm.grupoEstabelecimentos),callback:function ($$v) {_vm.grupoEstabelecimentos=$$v},expression:"grupoEstabelecimentos"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.servicos,"option-value":"id","option-text":"servico","selected-item":_vm.item,"placeholder":"Adicionar Serviço"},on:{"select":_vm.onSelectServico}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grupo.servicos && _vm.grupo.servicos.length),expression:"grupo.servicos && grupo.servicos.length"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.grupo.servicos),function(servico,indexServico){return _c('tr',{key:indexServico},[_c('td',[_c('p',[_vm._v(_vm._s((servico.servico) ? servico.servico.servico : '-'))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyServico(indexServico)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.grupo.perguntas && _vm.grupo.perguntas.length),expression:"grupo.perguntas && grupo.perguntas.length"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.grupo.perguntas),function(pergunta,indexPergunta){return _c('tr',{key:indexPergunta},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(pergunta.etapa),expression:"pergunta.etapa"}],attrs:{"name":"etapa","id":"etapa","type":"text"},domProps:{"value":(pergunta.etapa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pergunta, "etapa", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(pergunta.pergunta),expression:"pergunta.pergunta"}],attrs:{"name":"pergunta","id":"pergunta","type":"text"},domProps:{"value":(pergunta.pergunta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pergunta, "pergunta", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyPergunta(indexPergunta)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.addPergunta}},[_vm._v("Add Pergunta")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var grupos_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Serviço")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('strong',[_vm._v("Perguntas Chatbot")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v("Etapa")]),_vm._v(" "),_c('th',{attrs:{"width":"80%"}},[_vm._v("Pergunta")]),_vm._v(" "),_c('th',{staticClass:"right-align",attrs:{"with":"10%"}},[_vm._v("Excluir")])])}]
var grupos_form_esExports = { render: grupos_form_render, staticRenderFns: grupos_form_staticRenderFns }
/* harmony default export */ var features_grupos_form = (grupos_form_esExports);
// CONCATENATED MODULE: ./src/features/grupos/form.vue
var grupos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grupos_form___vue_template_functional__ = false
/* styles */
var grupos_form___vue_styles__ = null
/* scopeId */
var grupos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grupos_form___vue_module_identifier__ = null
var grupos_form_Component = grupos_form_normalizeComponent(
  grupos_form,
  features_grupos_form,
  grupos_form___vue_template_functional__,
  grupos_form___vue_styles__,
  grupos_form___vue_scopeId__,
  grupos_form___vue_module_identifier__
)

/* harmony default export */ var src_features_grupos_form = (grupos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/grupos/routes.js




/* harmony default export */ var grupos_routes = ([{
  path: '/grupos',
  name: 'grupos.index',
  component: src_features_grupos,
  children: [{
    path: 'form/:id?',
    name: 'grupos.form',
    component: src_features_grupos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/objetivos/index.vue








/* harmony default export */ var objetivos = ({
  name: 'Objetivos',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/objetivos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/objetivos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var objetivo, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                objetivo = obj.objetivo;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: objetivo.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, objetivo);
                } else {
                  _this3.list.unshift(objetivo);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(objetivo) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + objetivo.titulo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/objetivos/' + objetivo.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: objetivo.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'objetivos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'objetivos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4402f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/objetivos/index.vue
var objetivos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('objetivo.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('objetivo.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'objetivos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'objetivos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-objetivos-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(objetivo){return _c('tr',[_c('td',[_vm._v(_vm._s(objetivo.id))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('objetivo.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'objetivos.form', params: { id: objetivo.id } }}},[_vm._v("\n                "+_vm._s(objetivo.titulo)+"\n              ")]):_c('span',[_vm._v(_vm._s(objetivo.objetivo))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('objetivo.editar') > -1),expression:"permissoes.indexOf('objetivo.editar') > -1"}],attrs:{"to":{ name: 'objetivos.form', params: { id: objetivo.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('objetivo.excluir') > -1),expression:"permissoes.indexOf('objetivo.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(objetivo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var objetivos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Objetivos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Título")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var objetivos_esExports = { render: objetivos_render, staticRenderFns: objetivos_staticRenderFns }
/* harmony default export */ var features_objetivos = (objetivos_esExports);
// CONCATENATED MODULE: ./src/features/objetivos/index.vue
var objetivos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var objetivos___vue_template_functional__ = false
/* styles */
var objetivos___vue_styles__ = null
/* scopeId */
var objetivos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var objetivos___vue_module_identifier__ = null
var objetivos_Component = objetivos_normalizeComponent(
  objetivos,
  features_objetivos,
  objetivos___vue_template_functional__,
  objetivos___vue_styles__,
  objetivos___vue_scopeId__,
  objetivos___vue_module_identifier__
)

/* harmony default export */ var src_features_objetivos = (objetivos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/objetivos/form.vue







/* harmony default export */ var objetivos_form = ({
  name: 'Form',
  data: function data() {
    return {
      objetivo: {
        id: '',
        titulo: '',
        objetivo: '',
        resp_kitgas: '',
        resp_cliente: '',
        disposicoes_finais: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/objetivos' : '/objetivos/' + _this2.objetivo.id;
                _context.next = 4;
                return service_http[verb](url, _this2.objetivo);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-objetivos-list', { objetivo: data.objetivo });
                  _this2.$router.push({ name: 'objetivos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/objetivos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.objetivo = data.objetivo;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.objetivo = {
        id: '',
        titulo: '',
        objetivo: '',
        resp_kitgas: '',
        resp_cliente: '',
        disposicoes_finais: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.objetivo.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551ed303","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/objetivos/form.vue
var objetivos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.objetivo.titulo),expression:"objetivo.titulo"}],class:{invalid: _vm.errors.has('titulo')},attrs:{"name":"titulo","id":"titulo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.objetivo.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivo, "titulo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"titulo"}},[_vm._v("*Título")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('titulo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.objetivo.objetivo),expression:"objetivo.objetivo"}],staticClass:"materialize-textarea",attrs:{"name":"objetivo","id":"objetivo","type":"text"},domProps:{"value":(_vm.objetivo.objetivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivo, "objetivo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"objetivo"}},[_vm._v("Objetivo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('objetivo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.objetivo.resp_kitgas),expression:"objetivo.resp_kitgas"}],staticClass:"materialize-textarea",attrs:{"name":"resp_kitgas","id":"resp_kitgas","type":"text"},domProps:{"value":(_vm.objetivo.resp_kitgas)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivo, "resp_kitgas", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"resp_kitgas"}},[_vm._v("Responsabilidade Kit Gás")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('resp_kitgas')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.objetivo.resp_cliente),expression:"objetivo.resp_cliente"}],staticClass:"materialize-textarea",attrs:{"name":"resp_cliente","id":"resp_cliente","type":"text"},domProps:{"value":(_vm.objetivo.resp_cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivo, "resp_cliente", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"resp_cliente"}},[_vm._v("Responsabilidade Cliente")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('resp_cliente')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.objetivo.disposicoes_finais),expression:"objetivo.disposicoes_finais"}],staticClass:"materialize-textarea",attrs:{"name":"disposicoes_finais","id":"disposicoes_finais","type":"text"},domProps:{"value":(_vm.objetivo.disposicoes_finais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivo, "disposicoes_finais", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"disposicoes_finais"}},[_vm._v("Disposições Finais")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('disposicoes_finais')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var objetivos_form_staticRenderFns = []
var objetivos_form_esExports = { render: objetivos_form_render, staticRenderFns: objetivos_form_staticRenderFns }
/* harmony default export */ var features_objetivos_form = (objetivos_form_esExports);
// CONCATENATED MODULE: ./src/features/objetivos/form.vue
var objetivos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var objetivos_form___vue_template_functional__ = false
/* styles */
var objetivos_form___vue_styles__ = null
/* scopeId */
var objetivos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var objetivos_form___vue_module_identifier__ = null
var objetivos_form_Component = objetivos_form_normalizeComponent(
  objetivos_form,
  features_objetivos_form,
  objetivos_form___vue_template_functional__,
  objetivos_form___vue_styles__,
  objetivos_form___vue_scopeId__,
  objetivos_form___vue_module_identifier__
)

/* harmony default export */ var src_features_objetivos_form = (objetivos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/objetivos/routes.js



/* harmony default export */ var objetivos_routes = ([{
  path: '/objetivos',
  name: 'objetivos.index',
  component: src_features_objetivos,
  children: [{
    path: 'form/:id?',
    name: 'objetivos.form',
    component: src_features_objetivos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/clientes/cargos/index.vue








/* harmony default export */ var cargos = ({
  name: 'Cargos',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/cargos?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/cargos?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var cargo, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cargo = obj.cargo;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: cargo.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, cargo);
                } else {
                  _this3.list.unshift(cargo);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(cargo) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + cargo.cargo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/cargos/' + cargo.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: cargo.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'cargos.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'cargos.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1be5f107","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/clientes/cargos/index.vue
var cargos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('cargo.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('cargo.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'cargos.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'cargos.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-cargo-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(cargo){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('cargo.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'cargos.form', params: { id: cargo.id } }}},[_vm._v("\n                                "+_vm._s(cargo.cargo)+"\n                            ")]):_c('span',[_vm._v(_vm._s(cargo.cargo))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cargo.editar') > -1),expression:"permissoes.indexOf('cargo.editar') > -1"}],attrs:{"to":{ name: 'cargos.form', params: { id: cargo.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('cargo.excluir') > -1),expression:"permissoes.indexOf('cargo.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(cargo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var cargos_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Clientes :: Cargos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Cargo")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var cargos_esExports = { render: cargos_render, staticRenderFns: cargos_staticRenderFns }
/* harmony default export */ var clientes_cargos = (cargos_esExports);
// CONCATENATED MODULE: ./src/features/clientes/cargos/index.vue
var cargos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cargos___vue_template_functional__ = false
/* styles */
var cargos___vue_styles__ = null
/* scopeId */
var cargos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cargos___vue_module_identifier__ = null
var cargos_Component = cargos_normalizeComponent(
  cargos,
  clientes_cargos,
  cargos___vue_template_functional__,
  cargos___vue_styles__,
  cargos___vue_scopeId__,
  cargos___vue_module_identifier__
)

/* harmony default export */ var features_clientes_cargos = (cargos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/clientes/cargos/form.vue







/* harmony default export */ var cargos_form = ({
  name: 'Form',
  data: function data() {
    return {
      cargo: {
        id: '',
        cargo: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/cargos' : '/cargos/' + _this2.cargo.id;
                _context.next = 4;
                return service_http[verb](url, _this2.cargo);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-cargo-list', { cargo: data.cargo });
                  _this2.$router.push({ name: 'cargos.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/cargos/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.cargo = data.cargo;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.cargo = {
        id: '',
        cargo: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.cargo.id === '';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa6d53b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/clientes/cargos/form.vue
var cargos_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.cargo.cargo),expression:"cargo.cargo"}],class:{invalid: _vm.errors.has('cargo')},attrs:{"name":"cargo","id":"cargo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.cargo.cargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cargo, "cargo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"cargo"}},[_vm._v("*Cargo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('cargo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var cargos_form_staticRenderFns = []
var cargos_form_esExports = { render: cargos_form_render, staticRenderFns: cargos_form_staticRenderFns }
/* harmony default export */ var clientes_cargos_form = (cargos_form_esExports);
// CONCATENATED MODULE: ./src/features/clientes/cargos/form.vue
var cargos_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cargos_form___vue_template_functional__ = false
/* styles */
var cargos_form___vue_styles__ = null
/* scopeId */
var cargos_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cargos_form___vue_module_identifier__ = null
var cargos_form_Component = cargos_form_normalizeComponent(
  cargos_form,
  clientes_cargos_form,
  cargos_form___vue_template_functional__,
  cargos_form___vue_styles__,
  cargos_form___vue_scopeId__,
  cargos_form___vue_module_identifier__
)

/* harmony default export */ var features_clientes_cargos_form = (cargos_form_Component.exports);

// CONCATENATED MODULE: ./src/features/clientes/cargos/routes.js




/* harmony default export */ var cargos_routes = ([{
  path: '/clientes/cargos',
  name: 'cargos.index',
  component: features_clientes_cargos,
  children: [{
    path: 'form/:id?',
    name: 'cargos.form',
    component: features_clientes_cargos_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/familias/index.vue








/* harmony default export */ var familias = ({
  name: 'Familias',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/familias?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/familias?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var familia, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                familia = obj.familia;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: familia.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, familia);
                } else {
                  _this3.list.unshift(familia);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(familia) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + familia.familia + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/familias/' + familia.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: familia.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'familias.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'familias.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-558e347b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/familias/index.vue
var familias_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('familia.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('familia.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'familias.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'familias.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-familias-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(familia){return _c('tr',[_c('td',[_vm._v(_vm._s(familia.id))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('familia.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'familias.form', params: { id: familia.id } }}},[_vm._v("\n                "+_vm._s(familia.familia)+"\n                "),(familia.tipo === 1)?_c('small',[_c('br'),_vm._v(_vm._s(familia.responsavel))]):_vm._e()]):_c('span',[_vm._v(_vm._s(familia.familia))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('familia.editar') > -1),expression:"permissoes.indexOf('familia.editar') > -1"}],attrs:{"to":{ name: 'familias.form', params: { id: familia.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('familia.excluir') > -1),expression:"permissoes.indexOf('familia.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(familia)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var familias_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Famílias")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Família")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var familias_esExports = { render: familias_render, staticRenderFns: familias_staticRenderFns }
/* harmony default export */ var features_familias = (familias_esExports);
// CONCATENATED MODULE: ./src/features/familias/index.vue
var familias_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var familias___vue_template_functional__ = false
/* styles */
var familias___vue_styles__ = null
/* scopeId */
var familias___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var familias___vue_module_identifier__ = null
var familias_Component = familias_normalizeComponent(
  familias,
  features_familias,
  familias___vue_template_functional__,
  familias___vue_styles__,
  familias___vue_scopeId__,
  familias___vue_module_identifier__
)

/* harmony default export */ var src_features_familias = (familias_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/familias/form.vue







/* harmony default export */ var familias_form = ({
  name: 'Form',
  data: function data() {
    return {
      unidades: [{}],
      familia: {
        id: '',
        familia: '',
        categorias: []
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/familias' : '/familias/' + _this2.familia.id;
                _context.next = 4;
                return service_http[verb](url, _this2.familia);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-familias-list', { familia: data.familia });
                  _this2.$router.push({ name: 'familias.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/familias/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.familia = data.familia;
                _this3.unidades = data.unidades;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.familia = {
        id: '',
        familia: '',
        categorias: []
      };
    },
    addCategoria: function addCategoria() {
      this.familia.categorias.push({ categoria: '' });
      setTimeout(function () {
        window.Materialize.updateTextFields();
      }, 0);
    },
    destroyCategoria: function destroyCategoria(index) {
      var _this4 = this;

      this.$swal({
        title: 'Atenção',
        text: 'excluir uma categoria \xE9 uma opera\xE7\xE3o irrevers\xEDvel',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.familia.categorias[index].id) {
                  _context3.next = 5;
                  break;
                }

                _this4.familia.categorias.splice(index, 1);
                window.Materialize.toast('Categoria excluído!', 4000);
                _context3.next = 9;
                break;

              case 5:
                _context3.next = 7;
                return service_http.delete('familias/categorias/' + _this4.familia.categorias[index].id);

              case 7:
                _this4.familia.categorias.splice(index, 1);
                window.Materialize.toast('Categoria excluído!', 4000);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.familia.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14454525","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/familias/form.vue
var familias_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.familia.familia),expression:"familia.familia"}],class:{invalid: _vm.errors.has('familia')},attrs:{"name":"familia","id":"familia","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.familia.familia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.familia, "familia", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"familia"}},[_vm._v("*Família")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('familia')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.familia.categorias.length > 0),expression:"familia.categorias.length > 0"}],staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s12"},_vm._l((_vm.familia.categorias),function(categoria,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m11"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(categoria.categoria),expression:"categoria.categoria"}],class:{invalid: _vm.errors.has('categoria')},attrs:{"name":"categoria","id":("categoria" + index),"type":"text","data-vv-rules":"required"},domProps:{"value":(categoria.categoria)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(categoria, "categoria", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m1"},[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyCategoria(index)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.addCategoria()}}},[_vm._v("Add Categoria")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var familias_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Categorias")])])}]
var familias_form_esExports = { render: familias_form_render, staticRenderFns: familias_form_staticRenderFns }
/* harmony default export */ var features_familias_form = (familias_form_esExports);
// CONCATENATED MODULE: ./src/features/familias/form.vue
var familias_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var familias_form___vue_template_functional__ = false
/* styles */
var familias_form___vue_styles__ = null
/* scopeId */
var familias_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var familias_form___vue_module_identifier__ = null
var familias_form_Component = familias_form_normalizeComponent(
  familias_form,
  features_familias_form,
  familias_form___vue_template_functional__,
  familias_form___vue_styles__,
  familias_form___vue_scopeId__,
  familias_form___vue_module_identifier__
)

/* harmony default export */ var src_features_familias_form = (familias_form_Component.exports);

// CONCATENATED MODULE: ./src/features/familias/routes.js



/* harmony default export */ var familias_routes = ([{
  path: '/familias',
  name: 'familias.index',
  component: src_features_familias,
  children: [{
    path: 'form/:id?',
    name: 'familias.form',
    component: src_features_familias_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/canais/index.vue








/* harmony default export */ var canais = ({
  name: 'Canais',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/canais?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/canais?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var canal, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                canal = obj.canal;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: canal.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, canal);
                } else {
                  _this3.list.unshift(canal);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(canal) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + canal.canal + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/canais/' + canal.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: canal.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'canais.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'canais.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0193c6f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/canais/index.vue
var canais_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('canal.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('canal.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'canais.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'canais.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-canais-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(canal){return _c('tr',[_c('td',[_vm._v(_vm._s(canal.id))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('canal.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'canais.form', params: { id: canal.id } }}},[_vm._v("\n                "+_vm._s(canal.canal)+"\n                "),(canal.tipo === 1)?_c('small',[_c('br'),_vm._v(_vm._s(canal.responsavel))]):_vm._e()]):_c('span',[_vm._v(_vm._s(canal.canal))]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('canal.editar') > -1),expression:"permissoes.indexOf('canal.editar') > -1"}],attrs:{"to":{ name: 'canais.form', params: { id: canal.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('canal.excluir') > -1),expression:"permissoes.indexOf('canal.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(canal)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var canais_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Canais de Venda")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Canal")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var canais_esExports = { render: canais_render, staticRenderFns: canais_staticRenderFns }
/* harmony default export */ var features_canais = (canais_esExports);
// CONCATENATED MODULE: ./src/features/canais/index.vue
var canais_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var canais___vue_template_functional__ = false
/* styles */
var canais___vue_styles__ = null
/* scopeId */
var canais___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var canais___vue_module_identifier__ = null
var canais_Component = canais_normalizeComponent(
  canais,
  features_canais,
  canais___vue_template_functional__,
  canais___vue_styles__,
  canais___vue_scopeId__,
  canais___vue_module_identifier__
)

/* harmony default export */ var src_features_canais = (canais_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/canais/form.vue







/* harmony default export */ var canais_form = ({
  name: 'Form',
  data: function data() {
    return {
      unidades: [{}],
      canal: {
        id: '',
        canal: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/canais' : '/canais/' + _this2.canal.id;
                _context.next = 4;
                return service_http[verb](url, _this2.canal);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-canais-list', { canal: data.canal });
                  _this2.$router.push({ name: 'canais.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/canais/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.canal = data.canal;
                _this3.unidades = data.unidades;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.canal = {
        id: '',
        canal: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.canal.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695a45a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/canais/form.vue
var canais_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.canal.canal),expression:"canal.canal"}],class:{invalid: _vm.errors.has('canal')},attrs:{"name":"canal","id":"canal","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.canal.canal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.canal, "canal", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"canal"}},[_vm._v("*Canal")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('canal')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var canais_form_staticRenderFns = []
var canais_form_esExports = { render: canais_form_render, staticRenderFns: canais_form_staticRenderFns }
/* harmony default export */ var features_canais_form = (canais_form_esExports);
// CONCATENATED MODULE: ./src/features/canais/form.vue
var canais_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var canais_form___vue_template_functional__ = false
/* styles */
var canais_form___vue_styles__ = null
/* scopeId */
var canais_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var canais_form___vue_module_identifier__ = null
var canais_form_Component = canais_form_normalizeComponent(
  canais_form,
  features_canais_form,
  canais_form___vue_template_functional__,
  canais_form___vue_styles__,
  canais_form___vue_scopeId__,
  canais_form___vue_module_identifier__
)

/* harmony default export */ var src_features_canais_form = (canais_form_Component.exports);

// CONCATENATED MODULE: ./src/features/canais/routes.js



/* harmony default export */ var canais_routes = ([{
  path: '/canais',
  name: 'canais.index',
  component: src_features_canais,
  children: [{
    path: 'form/:id?',
    name: 'canais.form',
    component: src_features_canais_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/artes/index.vue








/* harmony default export */ var artes = ({
  name: 'Artes',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/artes?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/artes?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var arte, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                arte = obj.arte;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: arte.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, arte);
                } else {
                  _this3.list.unshift(arte);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(arte) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + arte.arte + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/artes/' + arte.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: arte.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'artes.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'artes.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07927faa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/artes/index.vue
var artes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('arte.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('arte.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'artes.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'artes.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-artes-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(arte){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('arte.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'artes.form', params: { id: arte.id } }}},[_vm._v("\n                "+_vm._s(arte.arte)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('arte.editar') > -1),expression:"permissoes.indexOf('arte.editar') > -1"}],attrs:{"to":{ name: 'artes.form', params: { id: arte.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('arte.excluir') > -1),expression:"permissoes.indexOf('arte.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(arte)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var artes_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Artes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Arte")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var artes_esExports = { render: artes_render, staticRenderFns: artes_staticRenderFns }
/* harmony default export */ var features_artes = (artes_esExports);
// CONCATENATED MODULE: ./src/features/artes/index.vue
var artes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var artes___vue_template_functional__ = false
/* styles */
var artes___vue_styles__ = null
/* scopeId */
var artes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var artes___vue_module_identifier__ = null
var artes_Component = artes_normalizeComponent(
  artes,
  features_artes,
  artes___vue_template_functional__,
  artes___vue_styles__,
  artes___vue_scopeId__,
  artes___vue_module_identifier__
)

/* harmony default export */ var src_features_artes = (artes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/artes/form.vue







/* harmony default export */ var artes_form = ({
  name: 'Form',
  data: function data() {
    return {
      arte: {
        id: '',
        arte: '',
        descricao: '',
        imagem: ''
      },
      progress: 0,
      progress2: 0,
      errorFile: false,
      errorFile2: false,
      options: {
        url: "https://sistemakgb.com.br/v1" + '/upload-file',
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
          path: 'artes',
          width: 6000,
          height: 6000,
          accept: 'all'
        }
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/artes' : '/artes/' + _this2.arte.id;
                _context.next = 4;
                return service_http[verb](url, _this2.arte);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-artes-list', { arte: data.arte });
                  _this2.$router.push({ name: 'artes.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/artes/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.arte = data.arte;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.arte = {
        id: '',
        arte: '',
        descricao: '',
        imagem: ''
      };
    },
    totalProgress: function totalProgress(progress, totalBytes, bytesSent) {
      this.progress = progress;
    },
    complete2: function complete2(file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true;
      } else {
        this.errorFile = false;
        file.addAttribute('id', xhr.response.id);
        this.arte.imagem = xhr.response;
        this.progress = 0;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.arte.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },
    url_app: function url_app() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50840a22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/artes/form.vue
var artes_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.arte.arte),expression:"arte.arte"}],class:{invalid: _vm.errors.has('arte')},attrs:{"name":"arte","id":"arte","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.arte.arte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.arte, "arte", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"arte"}},[_vm._v("*Arte")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('arte')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.arte.descricao),expression:"arte.descricao"}],staticClass:"materialize-textarea",attrs:{"name":"descricao","id":"descricao"},domProps:{"value":(_vm.arte.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.arte, "descricao", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"arte"}},[_vm._v("Descrição")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('vue-clip',{attrs:{"options":_vm.options,"on-complete":_vm.complete2,"on-total-progress":_vm.totalProgress}},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"dz-message"},[_c('div',{staticClass:"card"},[_c('span',{staticClass:"card-title"},[_vm._v("Arquivo")]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"height":"100px","width":"100%"}},[_c('div',[_c('small',{staticClass:"center-align"},[_vm._v("clique para inserir um arquivo")])])])])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"determinate",style:(("width: " + _vm.progress + "%"))})]),_vm._v(" "),(_vm.errorFile)?_c('div',{staticClass:"center-align"},[_vm._v("Tipo de arquivo inválido")]):_vm._e()])])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[(_vm.arte.imagem)?_c('div',{staticClass:"col s12 center"},[_c('p',{staticClass:" center"},[_vm._v("Clique para baixar")]),_vm._v(" "),_c('a',{staticClass:"btn-floating waves-effect waves-light",attrs:{"href":(_vm.api_url + "/artes/" + (_vm.arte.imagem)),"download":"","target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('div',{staticClass:"center-align",staticStyle:{"display":"none"}},[_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('br',{attrs:{"clear":"all"}}),_vm._v(" "),_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){$event.preventDefault();return _vm.destroyImage()}}},[_vm._v("delete_forever")])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var artes_form_staticRenderFns = []
var artes_form_esExports = { render: artes_form_render, staticRenderFns: artes_form_staticRenderFns }
/* harmony default export */ var features_artes_form = (artes_form_esExports);
// CONCATENATED MODULE: ./src/features/artes/form.vue
var artes_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var artes_form___vue_template_functional__ = false
/* styles */
var artes_form___vue_styles__ = null
/* scopeId */
var artes_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var artes_form___vue_module_identifier__ = null
var artes_form_Component = artes_form_normalizeComponent(
  artes_form,
  features_artes_form,
  artes_form___vue_template_functional__,
  artes_form___vue_styles__,
  artes_form___vue_scopeId__,
  artes_form___vue_module_identifier__
)

/* harmony default export */ var src_features_artes_form = (artes_form_Component.exports);

// CONCATENATED MODULE: ./src/features/artes/routes.js




/* harmony default export */ var artes_routes = ([{
  path: '/artes',
  name: 'artes.index',
  component: src_features_artes,
  children: [{
    path: 'form/:id?',
    name: 'artes.form',
    component: src_features_artes_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/tipos-estabelecimento/index.vue








/* harmony default export */ var tipos_estabelecimento = ({
  name: 'TiposEstabelecimento',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/tipos-estabelecimento?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/tipos-estabelecimento?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var tipo, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tipo = obj.tipo;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: tipo.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, tipo);
                } else {
                  _this3.list.unshift(tipo);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(tipo) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + tipo.tipo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/tipos-estabelecimento/' + tipo.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: tipo.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'tipos-estabelecimento.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'tipos-estabelecimento.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f536d62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/tipos-estabelecimento/index.vue
var tipos_estabelecimento_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('tipo-estabelecimento.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('tipo-estabelecimento.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'tipos-estabelecimento.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'tipos-estabelecimento.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-tipos-estabelecimento-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(tipo){return _c('tr',[_c('td',[(_vm.permissoes.indexOf('tipo-estabelecimento.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'tipos-estabelecimento.form', params: { id: tipo.id } }}},[_vm._v("\n                "+_vm._s(tipo.tipo)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tipo-estabelecimento.editar') > -1),expression:"permissoes.indexOf('tipo-estabelecimento.editar') > -1"}],attrs:{"to":{ name: 'tipos-estabelecimento.form', params: { id: tipo.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('tipo-estabelecimento.excluir') > -1),expression:"permissoes.indexOf('tipo-estabelecimento.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(tipo)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var tipos_estabelecimento_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("Tipos de Estabelecimento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Arte")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var tipos_estabelecimento_esExports = { render: tipos_estabelecimento_render, staticRenderFns: tipos_estabelecimento_staticRenderFns }
/* harmony default export */ var features_tipos_estabelecimento = (tipos_estabelecimento_esExports);
// CONCATENATED MODULE: ./src/features/tipos-estabelecimento/index.vue
var tipos_estabelecimento_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tipos_estabelecimento___vue_template_functional__ = false
/* styles */
var tipos_estabelecimento___vue_styles__ = null
/* scopeId */
var tipos_estabelecimento___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tipos_estabelecimento___vue_module_identifier__ = null
var tipos_estabelecimento_Component = tipos_estabelecimento_normalizeComponent(
  tipos_estabelecimento,
  features_tipos_estabelecimento,
  tipos_estabelecimento___vue_template_functional__,
  tipos_estabelecimento___vue_styles__,
  tipos_estabelecimento___vue_scopeId__,
  tipos_estabelecimento___vue_module_identifier__
)

/* harmony default export */ var src_features_tipos_estabelecimento = (tipos_estabelecimento_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/tipos-estabelecimento/form.vue







/* harmony default export */ var tipos_estabelecimento_form = ({
  name: 'Form',
  data: function data() {
    return {
      tipo: {
        id: '',
        tipo: ''
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/tipos-estabelecimento' : '/tipos-estabelecimento/' + _this2.tipo.id;
                _context.next = 4;
                return service_http[verb](url, _this2.tipo);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-tipos-estabelecimento-list', { tipo: data.tipo });
                  _this2.$router.push({ name: 'tipos-estabelecimento.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/tipos-estabelecimento/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.tipo = data.tipo;
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.tipo = {
        id: '',
        tipo: ''
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.tipo.id === '';
    },
    url_app: function url_app() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1827d859","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/tipos-estabelecimento/form.vue
var tipos_estabelecimento_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.tipo.tipo),expression:"tipo.tipo"}],class:{invalid: _vm.errors.has('tipo')},attrs:{"name":"tipo","id":"tipo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.tipo.tipo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tipo, "tipo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"tipo"}},[_vm._v("*Tipo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('tipo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var tipos_estabelecimento_form_staticRenderFns = []
var tipos_estabelecimento_form_esExports = { render: tipos_estabelecimento_form_render, staticRenderFns: tipos_estabelecimento_form_staticRenderFns }
/* harmony default export */ var features_tipos_estabelecimento_form = (tipos_estabelecimento_form_esExports);
// CONCATENATED MODULE: ./src/features/tipos-estabelecimento/form.vue
var tipos_estabelecimento_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tipos_estabelecimento_form___vue_template_functional__ = false
/* styles */
var tipos_estabelecimento_form___vue_styles__ = null
/* scopeId */
var tipos_estabelecimento_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tipos_estabelecimento_form___vue_module_identifier__ = null
var tipos_estabelecimento_form_Component = tipos_estabelecimento_form_normalizeComponent(
  tipos_estabelecimento_form,
  features_tipos_estabelecimento_form,
  tipos_estabelecimento_form___vue_template_functional__,
  tipos_estabelecimento_form___vue_styles__,
  tipos_estabelecimento_form___vue_scopeId__,
  tipos_estabelecimento_form___vue_module_identifier__
)

/* harmony default export */ var src_features_tipos_estabelecimento_form = (tipos_estabelecimento_form_Component.exports);

// CONCATENATED MODULE: ./src/features/tipos-estabelecimento/routes.js




/* harmony default export */ var tipos_estabelecimento_routes = ([{
  path: '/tipos-estabelecimento',
  name: 'tipos-estabelecimento.index',
  component: src_features_tipos_estabelecimento,
  children: [{
    path: 'form/:id?',
    name: 'tipos-estabelecimento.form',
    component: src_features_tipos_estabelecimento_form
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/atas/index.vue



//





/* harmony default export */ var atas = ({
  name: 'Ata',
  data: function data() {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    };
  },
  mounted: function mounted() {
    this.paginate();
  },

  methods: {
    formatDate: function formatDate(date) {
      return moment_default()(date).format('DD/MM/YYYY');
    },
    paginate: function paginate(page) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (page) {
                  _this.pagination.current_page = page;
                }
                _context.next = 3;
                return service_http.get('/atas?page=' + _this.pagination.current_page + '&busca=' + _this.busca);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this.list = data.data;
                  _this.pagination.current_page = data.current_page;
                  _this.pagination.last_page = data.last_page;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buscar: function buscar($page) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return service_http.get('/atas?&busca=' + _this2.busca);

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;

                if (data != null) {
                  _this2.list = data.data;
                  _this2.pagination.current_page = data.current_page;
                  _this2.pagination.last_page = data.last_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkListTotal: function checkListTotal() {
      if (this.list.length === 0) {
        this.pagination.current_page = 1;
        this.busca = '';
        this.paginate();
      }
    },
    updateList: function updateList(obj) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var ata, index;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ata = obj.ata;
                _context3.next = 3;
                return findIndex_default()(_this3.list, { id: ata.id });

              case 3:
                index = _context3.sent;

                if (index > -1) {
                  _this3.list[index] = extends_default()({}, ata);
                } else {
                  _this3.list.unshift(ata);
                }
                window.Materialize.toast('Registro salvo com sucesso!!', 4000);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    destroy: function destroy(ata) {
      var _this4 = this;

      this.$swal({
        title: 'Deseja remover ' + ata.titulo + '?',
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _ref4, data, index;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return service_http.delete('/atas/' + ata.id);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;

                if (!(data != null)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return findIndex_default()(_this4.list, { id: ata.id });

              case 7:
                index = _context4.sent;

                if (index > -1) {
                  _this4.list.splice(index, 1);
                  window.Materialize.toast('Registro removido com sucesso!!', 4000);
                  _this4.checkListTotal();
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      })));
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), Object(vuex_esm["c" /* mapGetters */])(['permissoes']), {
    showBtNovo: function showBtNovo() {
      return this.$route.name === 'atas.index';
    },
    showBtVoltar: function showBtVoltar() {
      return this.$route.name === 'atas.form';
    },
    hasItens: function hasItens() {
      return this.list.length > 0;
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/v1";
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0330c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/atas/index.vue
var atas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-field col s9 m4"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo),expression:"showBtNovo"}],on:{"submit":function($event){$event.preventDefault();return _vm.buscar.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],attrs:{"id":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"busca"}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{staticClass:"col s3 m1 input-field right-align"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.permissoes.indexOf('ata.inserir') > -1),expression:"showBtNovo && permissoes.indexOf('ata.inserir') > -1"}],staticClass:"btn-floating btn-large waves-effect waves-light",attrs:{"to":{ name: 'atas.form' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtVoltar),expression:"showBtVoltar"}],staticClass:"btn-floating btn-large waves-effect waves-light red",attrs:{"to":{ name: 'atas.index' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('router-view',{on:{"update-atas-list":_vm.updateList}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && !_vm.hasItens && !_vm.loading),expression:"showBtNovo && !hasItens && !loading"}],staticClass:"center-align"},[_c('p',[_vm._v("Nenhum registro encontrado!")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row z-depth-1"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(ata){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDate(ata.data)))]),_vm._v(" "),_c('td',[(_vm.permissoes.indexOf('ata.editar') > -1)?_c('router-link',{attrs:{"to":{ name: 'atas.form', params: { id: ata.id } }}},[_vm._v(_vm._s(ata.titulo))]):_c('span',[_vm._v(_vm._s(ata.titulo))])],1),_vm._v(" "),_c('td',{staticClass:"right-align"},[_c('a',{staticClass:"material-icons green-text",attrs:{"href":(_vm.api_url + "/ata/" + (ata.id) + "/pdf"),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('ata.editar') > -1),expression:"permissoes.indexOf('ata.editar') > -1"}],attrs:{"to":{ name: 'atas.form', params: { id: ata.id } }}},[_c('i',{staticClass:"material-icons blue-text"},[_vm._v("edit")])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.permissoes.indexOf('ata.excluir') > -1),expression:"permissoes.indexOf('ata.excluir') > -1"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroy(ata)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])],1)])}),0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtNovo && _vm.hasItens),expression:"showBtNovo && hasItens"}],staticClass:"row"},[_c('div',{staticClass:"col s12 center-align"},[_c('paginate',{attrs:{"page-count":_vm.pagination.last_page,"click-handler":_vm.paginate,"prev-text":'chevron_left',"next-text":'chevron_right',"container-class":'pagination',"page-class":'waves-effect',"prev-class":'material-icons',"next-class":'material-icons',"force-page":_vm.pagination.current_page-1}})],1)])])])}
var atas_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m7"},[_c('h5',[_vm._v("ATA's")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Título")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Ações")])])])}]
var atas_esExports = { render: atas_render, staticRenderFns: atas_staticRenderFns }
/* harmony default export */ var features_atas = (atas_esExports);
// CONCATENATED MODULE: ./src/features/atas/index.vue
var atas_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var atas___vue_template_functional__ = false
/* styles */
var atas___vue_styles__ = null
/* scopeId */
var atas___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var atas___vue_module_identifier__ = null
var atas_Component = atas_normalizeComponent(
  atas,
  features_atas,
  atas___vue_template_functional__,
  atas___vue_styles__,
  atas___vue_scopeId__,
  atas___vue_module_identifier__
)

/* harmony default export */ var src_features_atas = (atas_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/atas/form.vue








/* harmony default export */ var atas_form = ({
  name: 'Form',
  components: {
    ListSelect: VueSearchSelect_common["ListSelect"]
  },
  data: function data() {
    return {
      usuarios: [{}],
      ata: {
        id: '',
        data: '',
        titulo: '',
        conteudo: '',
        envolvidos: []
      }
    };
  },
  mounted: function mounted() {
    this.fecth();
  },

  watch: {
    '$route': function $route() {
      if (this.$route.params.id != null) {
        this.fecth();
      }
    },
    hasAll: function hasAll() {
      if (this.hasAll) {
        this.all = true;
      } else {
        this.all = false;
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (success) {
        if (!success) {
          _this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          });
          return false;
        } else {
          _this.submit();
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var verb, url, _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                verb = _this2.isNew ? 'post' : 'put';
                url = _this2.isNew ? '/atas' : '/atas/' + _this2.ata.id;
                _context.next = 4;
                return service_http[verb](url, _this2.ata);

              case 4:
                _ref = _context.sent;
                data = _ref.data;

                if (data != null) {
                  _this2.$emit('update-atas-list', { ata: data.ata });
                  _this2.$router.push({ name: 'atas.index' });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fecth: function fecth() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var id, _ref2, data, _ref3, _data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.clear();
                id = _this3.$route.params.id;

                if (!(id !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return service_http.get('/atas/' + id + '/edit');

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this3.ata = data.ata;
                _this3.usuarios = data.usuarios;
                _context2.next = 16;
                break;

              case 11:
                _context2.next = 13;
                return service_http.get('/atas/create');

              case 13:
                _ref3 = _context2.sent;
                _data = _ref3.data;

                _this3.usuarios = _data.usuarios;

              case 16:
                setTimeout(function () {
                  window.Materialize.updateTextFields();
                }, 0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    clear: function clear() {
      this.ata = {
        id: '',
        data: '',
        titulo: '',
        conteudo: '',
        envolvidos: []
      };
    }
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])(['loading']), {
    isNew: function isNew() {
      return this.ata.id === '';
    },
    api_url: function api_url() {
      return "https://sistemakgb.com.br/uploads";
    },

    ataEnvolvidos: {
      get: function get() {
        var _this4 = this;

        return this.usuarios.filter(function (option) {
          return _this4.ata.envolvidos.includes(option.id);
        });
      },
      set: function set(newSelectedOptions) {
        this.ata.envolvidos = newSelectedOptions.map(function (option) {
          return option.id;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5036519b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/atas/form.vue
var atas_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m10 offset-m1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m3"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v("event")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.ata.data),expression:"ata.data"}],class:{invalid: _vm.errors.has('data')},attrs:{"name":"data","id":"icon_data","type":"date","data-vv-rules":"required","data-value":_vm.ata.data},domProps:{"value":(_vm.ata.data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ata, "data", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"active",attrs:{"for":"icon_data"}},[_vm._v("*Data")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('data')))])]),_vm._v(" "),_c('div',{staticClass:"input-field col s12 m9"},[_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.ata.titulo),expression:"ata.titulo"}],class:{invalid: _vm.errors.has('titulo')},attrs:{"name":"titulo","id":"titulo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.ata.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ata, "titulo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"titulo"}},[_vm._v("*Título")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('titulo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m12"},[_c('label',[_vm._v("Usuários Envolvidos")]),_vm._v(" "),_c('multiselect',{attrs:{"multiple":"","placeholder":"Selecione","closeOnSelect":false,"label":"nome_completo","track-by":"id","options":_vm.usuarios},model:{value:(_vm.ataEnvolvidos),callback:function ($$v) {_vm.ataEnvolvidos=$$v},expression:"ataEnvolvidos"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12 m12"},[_c('textarea',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.ata.conteudo),expression:"ata.conteudo"}],staticClass:"materialize-textarea",class:{invalid: _vm.errors.has('conteudo')},attrs:{"name":"conteudo","id":"conteudo","type":"text","data-vv-rules":"required"},domProps:{"value":(_vm.ata.conteudo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ata, "conteudo", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"conteudo"}},[_vm._v("Conteúdo")]),_vm._v(" "),_c('small',{staticClass:"red-text"},[_vm._v(_vm._s(_vm.errors.first('conteudo')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('list-select',{attrs:{"list":_vm.produtos,"option-value":"id","option-text":"produto","selected-item":_vm.item,"placeholder":"Adicionar Produto"},on:{"select":_vm.onSelectProduto}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ata.produtos && _vm.ata.produtos.length > 0),expression:"ata.produtos && ata.produtos.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('table',{staticClass:"responsive-table bordered highlight"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.ata.produtos),function(produto,indexProduto){return _c('tr',[_c('td',[_c('p',[_vm._v(_vm._s((produto.produto) ? produto.produto.produto : '-'))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(produto.qtd),expression:"produto.qtd"}],staticStyle:{"margin-bottom":"0"},attrs:{"type":"number","id":("qtdProduto" + indexProduto),"min":"1","readonly":produto.hasOwnProperty('id')},domProps:{"value":(produto.qtd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(produto, "qtd", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"right-align"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.destroyProduto(indexProduto)}}},[_c('i',{staticClass:"material-icons red-text"},[_vm._v("delete_forever")])])])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.loading}},[_vm._v("Salvar")])])])])])])])}
var atas_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Materiais Utilizados")]),_vm._v(" "),_c('th',[_vm._v("Qtd")]),_vm._v(" "),_c('th',{staticClass:"right-align"},[_vm._v("Excluir")])])}]
var atas_form_esExports = { render: atas_form_render, staticRenderFns: atas_form_staticRenderFns }
/* harmony default export */ var features_atas_form = (atas_form_esExports);
// CONCATENATED MODULE: ./src/features/atas/form.vue
var atas_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var atas_form___vue_template_functional__ = false
/* styles */
var atas_form___vue_styles__ = null
/* scopeId */
var atas_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var atas_form___vue_module_identifier__ = null
var atas_form_Component = atas_form_normalizeComponent(
  atas_form,
  features_atas_form,
  atas_form___vue_template_functional__,
  atas_form___vue_styles__,
  atas_form___vue_scopeId__,
  atas_form___vue_module_identifier__
)

/* harmony default export */ var src_features_atas_form = (atas_form_Component.exports);

// CONCATENATED MODULE: ./src/features/atas/routes.js



/* harmony default export */ var atas_routes = ([{
  path: '/atas',
  name: 'atas.index',
  component: src_features_atas,
  children: [{
    path: 'form/:id?',
    name: 'atas.form',
    component: src_features_atas_form
  }]
}]);
// CONCATENATED MODULE: ./src/router/index.js




var router__this = this;














































var router_routes = [].concat(toConsumableArray_default()(routes), toConsumableArray_default()(usuarios_routes), toConsumableArray_default()(logs_routes), toConsumableArray_default()(perfis_routes), toConsumableArray_default()(dashboard_routes), toConsumableArray_default()(clientes_routes), toConsumableArray_default()(como_conheceu_routes), toConsumableArray_default()(fornecedores_routes), toConsumableArray_default()(contas_routes), toConsumableArray_default()(categorias_routes), toConsumableArray_default()(formas_routes), toConsumableArray_default()(pagar_routes), toConsumableArray_default()(receber_routes), toConsumableArray_default()(extrato_routes), toConsumableArray_default()(contatos_routes), toConsumableArray_default()(servicos_routes), toConsumableArray_default()(produtos_routes), toConsumableArray_default()(estoque_routes), toConsumableArray_default()(orcamentos_routes), toConsumableArray_default()(pagamentos_routes), toConsumableArray_default()(equipamentos_routes), toConsumableArray_default()(os_routes), toConsumableArray_default()(tarefas_routes), toConsumableArray_default()(marcas_routes), toConsumableArray_default()(vendas_routes), toConsumableArray_default()(compras_routes), toConsumableArray_default()(revisao_tipo_routes), toConsumableArray_default()(relatorios_routes), toConsumableArray_default()(viaturas_routes), toConsumableArray_default()(reclamacoes_routes), toConsumableArray_default()(motivos_routes), toConsumableArray_default()(grupos_routes), toConsumableArray_default()(objetivos_routes), toConsumableArray_default()(cargos_routes), toConsumableArray_default()(familias_routes), toConsumableArray_default()(artes_routes), toConsumableArray_default()(canais_routes), toConsumableArray_default()(tipos_estabelecimento_routes), toConsumableArray_default()(atas_routes));

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: router_routes
});

var checkAuth = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
    var token, permissoes, imagem;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return localforage_default.a.getItem('token');

          case 2:
            token = _context.sent;
            _context.next = 5;
            return localforage_default.a.getItem('permissoes');

          case 5:
            permissoes = _context.sent;
            _context.next = 8;
            return localforage_default.a.getItem('imagem');

          case 8:
            imagem = _context.sent;

            store.dispatch('setToken', { token: token });
            store.dispatch('setPermissoes', { permissoes: permissoes });
            store.dispatch('setImagem', { imagem: imagem });
            if (to.name !== 'auth.index' && to.name !== 'auth.recuperar-senha' && to.name !== 'auth.redefinir-senha' && token === null) {
              next({ name: 'auth.index' });
            }

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, router__this);
  }));

  return function checkAuth(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

router.beforeEach(function () {
  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(to, from, next) {
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            checkAuth(to, from, next);
            next();

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, router__this);
  }));

  return function (_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vue-sweetalert/build/vue-sweetalert.js
var vue_sweetalert = __webpack_require__("f1Fh");
var vue_sweetalert_default = /*#__PURE__*/__webpack_require__.n(vue_sweetalert);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/inputmask/index.js
var inputmask = __webpack_require__("7mJ/");
var inputmask_default = /*#__PURE__*/__webpack_require__.n(inputmask);

// EXTERNAL MODULE: ./node_modules/vue-clip/dist/vue-clip.js
var vue_clip = __webpack_require__("qJAx");
var vue_clip_default = /*#__PURE__*/__webpack_require__.n(vue_clip);

// EXTERNAL MODULE: ./node_modules/vuejs-paginate/dist/index.js
var dist = __webpack_require__("kBYy");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-quill-editor/dist/vue-quill-editor.js
var vue_quill_editor = __webpack_require__("G0J2");
var vue_quill_editor_default = /*#__PURE__*/__webpack_require__.n(vue_quill_editor);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.core.css
var quill_core = __webpack_require__("3f40");
var quill_core_default = /*#__PURE__*/__webpack_require__.n(quill_core);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.snow.css
var quill_snow = __webpack_require__("4qOc");
var quill_snow_default = /*#__PURE__*/__webpack_require__.n(quill_snow);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.bubble.css
var quill_bubble = __webpack_require__("+cgv");
var quill_bubble_default = /*#__PURE__*/__webpack_require__.n(quill_bubble);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












// require styles





vue_esm["a" /* default */].component('paginate', dist_default.a);
vue_esm["a" /* default */].component('multiselect', vue_multiselect_min_default.a);
vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(install);
vue_esm["a" /* default */].use(vue_sweetalert_default.a);
vue_esm["a" /* default */].use(vee_validate_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_clip_default.a);
vue_esm["a" /* default */].use(vue_quill_editor_default.a);

vue_esm["a" /* default */].directive('mask', {
  bind: function bind(el, binding) {
    var im = new inputmask_default.a(binding.value, { jitMasking: true, showMaskOnHover: false, greedy: false });
    im.mask($(el));
  }
});

vue_esm["a" /* default */].directive('valor', {
  bind: function bind(el, binding) {
    var im = new inputmask_default.a('currency', {
      showMaskOnHover: false,
      greedy: false,
      prefix: '',
      digits: 2,
      DecimalProtect: false,
      groupSize: 255
    });
    im.mask($(el));
  }
});

vue_esm["a" /* default */].directive('time', {
  bind: function bind(el, binding) {
    var im = new inputmask_default.a('99:99', {
      showMaskOnHover: false,
      greedy: false,
      prefix: ''
    });
    im.mask($(el));
  }
});

window.$ = window.jQuery = __webpack_require__("7t+N");
__webpack_require__("0lrd");

vue_esm["a" /* default */].filter('slugable', function (value) {
  value = value.toLowerCase();
  value = value.replace(/[á|ã|â|à]/gi, 'a');
  value = value.replace(/[é|ê|è]/gi, 'e');
  value = value.replace(/[í|ì|î]/gi, 'i');
  value = value.replace(/[õ|ò|ó|ô]/gi, 'o');
  value = value.replace(/[ú|ù|û]/gi, 'u');
  value = value.replace(/[ç]/gi, 'c');
  value = value.replace(/[ñ]/gi, 'n');
  value = value.replace(/[á|ã|â]/gi, 'a');
  value = value.replace(/\W/gi, '-');
  value = value.replace(/\1+/gi, '-');
  return value;
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  store: store,
  template: '<the-container/>',
  components: { TheContainer: src_the_container }
});

/***/ }),

/***/ "UDbD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-login.e64b984.png";

/***/ }),

/***/ "dxl2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ev9a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNhs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQH9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.bba3ae1.png";

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xvOB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/office.8d5169e.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b36590b09b04b625e9c8.js